(() => {
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2790"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2790"] = parcelRequire;
}
parcelRequire.register("2Jeaf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PureComponent", () => $1fcac57a3c749c8b$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $1fcac57a3c749c8b$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $1fcac57a3c749c8b$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $1fcac57a3c749c8b$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $1fcac57a3c749c8b$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $1fcac57a3c749c8b$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $1fcac57a3c749c8b$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $1fcac57a3c749c8b$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $1fcac57a3c749c8b$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $1fcac57a3c749c8b$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1fcac57a3c749c8b$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $1fcac57a3c749c8b$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $1fcac57a3c749c8b$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $1fcac57a3c749c8b$export$a8257692ac88316c);
$parcel$export(module.exports, "cloneElement", () => $1fcac57a3c749c8b$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $1fcac57a3c749c8b$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $1fcac57a3c749c8b$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $1fcac57a3c749c8b$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $1fcac57a3c749c8b$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $1fcac57a3c749c8b$export$5f8d39834fd61797);
$parcel$export(module.exports, "default", () => $1fcac57a3c749c8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createElement", () => (parcelRequire("joJRn")).createElement);
$parcel$export(module.exports, "createContext", () => (parcelRequire("joJRn")).createContext);
$parcel$export(module.exports, "createRef", () => (parcelRequire("joJRn")).createRef);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("joJRn")).Fragment);
$parcel$export(module.exports, "Component", () => (parcelRequire("joJRn")).Component);

var $iJ7ah = parcelRequire("iJ7ah");

var $joJRn = parcelRequire("joJRn");
function $1fcac57a3c749c8b$var$C(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $1fcac57a3c749c8b$var$S(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $1fcac57a3c749c8b$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $1fcac57a3c749c8b$export$7c73462e0d25e514(n, t) {
    function e(n) {
        var e = this.props.ref, r = e == n.ref;
        return !r && e && (e.call ? e(null) : e.current = null), t ? !t(this.props, n) || !r : $1fcac57a3c749c8b$var$S(this.props, n);
    }
    function r(t) {
        return this.shouldComponentUpdate = e, (0, $joJRn.createElement)(n, t);
    }
    return r.displayName = "Memo(" + (n.displayName || n.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
($1fcac57a3c749c8b$export$221d75b3f55bb0bd.prototype = new (0, $joJRn.Component)).isPureReactComponent = !0, $1fcac57a3c749c8b$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $1fcac57a3c749c8b$var$S(this.props, n) || $1fcac57a3c749c8b$var$S(this.state, t);
};
var $1fcac57a3c749c8b$var$w = (0, $joJRn.options).__b;
(0, $joJRn.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $1fcac57a3c749c8b$var$w && $1fcac57a3c749c8b$var$w(n);
};
var $1fcac57a3c749c8b$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $1fcac57a3c749c8b$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $1fcac57a3c749c8b$var$C({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $1fcac57a3c749c8b$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $1fcac57a3c749c8b$var$N = function(n, t) {
    return null == n ? null : (0, $joJRn.toChildArray)((0, $joJRn.toChildArray)(n).map(t));
}, $1fcac57a3c749c8b$export$dca3b0875bd9a954 = {
    map: $1fcac57a3c749c8b$var$N,
    forEach: $1fcac57a3c749c8b$var$N,
    count: function(n) {
        return n ? (0, $joJRn.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $joJRn.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $joJRn.toChildArray)
}, $1fcac57a3c749c8b$var$A = (0, $joJRn.options).__e;
(0, $joJRn.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $1fcac57a3c749c8b$var$A(n, t, e, r);
};
var $1fcac57a3c749c8b$var$O = (0, $joJRn.options).unmount;
function $1fcac57a3c749c8b$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $1fcac57a3c749c8b$var$U(n) {
    var t = n.__.__c;
    return t && t.__e && t.__e(n);
}
function $1fcac57a3c749c8b$export$488013bae63b21da(n) {
    var t, e, r;
    function u(u) {
        if (t || (t = n()).then(function(n) {
            e = n.default || n;
        }, function(n) {
            r = n;
        }), r) throw r;
        if (!e) throw t;
        return (0, $joJRn.createElement)(e, u);
    }
    return u.displayName = "Lazy", u.__f = !0, u;
}
function $1fcac57a3c749c8b$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $joJRn.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $1fcac57a3c749c8b$var$O && $1fcac57a3c749c8b$var$O(n);
}, ($1fcac57a3c749c8b$export$74bf444e3cd11ea5.prototype = new (0, $joJRn.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $1fcac57a3c749c8b$var$U(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__e) {
                var n = r.state.__e;
                r.__v.__k[0] = function n(t, e, r) {
                    return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(t) {
                        return n(t, e, r);
                    }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
                }(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __e: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, f = !0 === t.__h;
    r.__u++ || f || r.setState({
        __e: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $1fcac57a3c749c8b$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $1fcac57a3c749c8b$export$74bf444e3cd11ea5.prototype.render = function(n, t) {
    if (this.__b) {
        if (this.__v.__k) {
            var e = document.createElement("div"), r = this.__v.__k[0].__c;
            this.__v.__k[0] = function n(t, e, r) {
                return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(n) {
                    "function" == typeof n.__c && n.__c();
                }), t.__c.__H = null), null != (t = $1fcac57a3c749c8b$var$C({}, t)).__c && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(t) {
                    return n(t, e, r);
                })), t;
            }(this.__b, e, r.__O = r.__P);
        }
        this.__b = null;
    }
    var u = t.__e && (0, $joJRn.createElement)((0, $joJRn.Fragment), null, n.fallback);
    return u && (u.__h = null), [
        (0, $joJRn.createElement)((0, $joJRn.Fragment), null, t.__e ? null : n.children),
        u
    ];
};
var $1fcac57a3c749c8b$var$T = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $1fcac57a3c749c8b$var$D(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $1fcac57a3c749c8b$var$I(n) {
    var t = this, e = n.i;
    t.componentWillUnmount = function() {
        (0, $joJRn.render)(null, t.l), t.l = null, t.i = null;
    }, t.i && t.i !== e && t.componentWillUnmount(), n.__v ? (t.l || (t.i = e, t.l = {
        nodeType: 1,
        parentNode: e,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        insertBefore: function(n, e) {
            this.childNodes.push(n), t.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), t.i.removeChild(n);
        }
    }), (0, $joJRn.render)((0, $joJRn.createElement)($1fcac57a3c749c8b$var$D, {
        context: t.context
    }, n.__v), t.l)) : t.l && t.componentWillUnmount();
}
function $1fcac57a3c749c8b$export$d39a5bbd09211389(n, t) {
    var e = (0, $joJRn.createElement)($1fcac57a3c749c8b$var$I, {
        __v: n,
        i: t
    });
    return e.containerInfo = t, e;
}
($1fcac57a3c749c8b$export$998bcd577473dd93.prototype = new (0, $joJRn.Component)).__e = function(n) {
    var t = this, e = $1fcac57a3c749c8b$var$U(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $1fcac57a3c749c8b$var$T(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $1fcac57a3c749c8b$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $joJRn.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $1fcac57a3c749c8b$export$998bcd577473dd93.prototype.componentDidUpdate = $1fcac57a3c749c8b$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $1fcac57a3c749c8b$var$T(n, e, t);
    });
};
var $1fcac57a3c749c8b$var$P = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $1fcac57a3c749c8b$var$V = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|shape|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $1fcac57a3c749c8b$var$$ = "undefined" != typeof document, $1fcac57a3c749c8b$var$j = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/i : /fil|che|ra/i).test(n);
};
function $1fcac57a3c749c8b$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $joJRn.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $1fcac57a3c749c8b$export$fa8d919ba61d84db(n, t, e) {
    return (0, $joJRn.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $joJRn.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(n) {
    Object.defineProperty((0, $joJRn.Component).prototype, n, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + n];
        },
        set: function(t) {
            Object.defineProperty(this, n, {
                configurable: !0,
                writable: !0,
                value: t
            });
        }
    });
});
var $1fcac57a3c749c8b$var$H = (0, $joJRn.options).event;
function $1fcac57a3c749c8b$var$Z() {}
function $1fcac57a3c749c8b$var$Y() {
    return this.cancelBubble;
}
function $1fcac57a3c749c8b$var$q() {
    return this.defaultPrevented;
}
(0, $joJRn.options).event = function(n) {
    return $1fcac57a3c749c8b$var$H && (n = $1fcac57a3c749c8b$var$H(n)), n.persist = $1fcac57a3c749c8b$var$Z, n.isPropagationStopped = $1fcac57a3c749c8b$var$Y, n.isDefaultPrevented = $1fcac57a3c749c8b$var$q, n.nativeEvent = n;
};
var $1fcac57a3c749c8b$var$G, $1fcac57a3c749c8b$var$J = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $1fcac57a3c749c8b$var$K = (0, $joJRn.options).vnode;
(0, $joJRn.options).vnode = function(n) {
    var t = n.type, e = n.props, r = e;
    if ("string" == typeof t) {
        var u = -1 === t.indexOf("-");
        for(var o in r = {}, e){
            var i = e[o];
            $1fcac57a3c749c8b$var$$ && "children" === o && "noscript" === t || "value" === o && "defaultValue" in e && null == i || ("defaultValue" === o && "value" in e && null == e.value ? o = "value" : "download" === o && !0 === i ? i = "" : /ondoubleclick/i.test(o) ? o = "ondblclick" : /^onchange(textarea|input)/i.test(o + t) && !$1fcac57a3c749c8b$var$j(e.type) ? o = "oninput" : /^onfocus$/i.test(o) ? o = "onfocusin" : /^onblur$/i.test(o) ? o = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(o) ? o = o.toLowerCase() : u && $1fcac57a3c749c8b$var$V.test(o) ? o = o.replace(/[A-Z0-9]/, "-$&").toLowerCase() : null === i && (i = void 0), /^oninput$/i.test(o) && (o = o.toLowerCase(), r[o] && (o = "oninputCapture")), r[o] = i);
        }
        "select" == t && r.multiple && Array.isArray(r.value) && (r.value = (0, $joJRn.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = -1 != r.value.indexOf(n.props.value);
        })), "select" == t && null != r.defaultValue && (r.value = (0, $joJRn.toChildArray)(e.children).forEach(function(n) {
            n.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(n.props.value) : r.defaultValue == n.props.value;
        })), n.props = r, e.class != e.className && ($1fcac57a3c749c8b$var$J.enumerable = "className" in e, null != e.className && (r.class = e.className), Object.defineProperty(r, "className", $1fcac57a3c749c8b$var$J));
    }
    n.$$typeof = $1fcac57a3c749c8b$var$P, $1fcac57a3c749c8b$var$K && $1fcac57a3c749c8b$var$K(n);
};
var $1fcac57a3c749c8b$var$Q = (0, $joJRn.options).__r;
(0, $joJRn.options).__r = function(n) {
    $1fcac57a3c749c8b$var$Q && $1fcac57a3c749c8b$var$Q(n), $1fcac57a3c749c8b$var$G = n.__c;
};
var $1fcac57a3c749c8b$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $1fcac57a3c749c8b$var$G.__n[n.__c].props.value;
            }
        }
    }
}, $1fcac57a3c749c8b$export$83d89fbfd8236492 = "17.0.2";
function $1fcac57a3c749c8b$export$d38cd72104c1f0e9(n) {
    return (0, $joJRn.createElement).bind(null, n);
}
function $1fcac57a3c749c8b$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $1fcac57a3c749c8b$var$P;
}
function $1fcac57a3c749c8b$export$e530037191fcd5d7(n) {
    return $1fcac57a3c749c8b$export$a8257692ac88316c(n) ? (0, $joJRn.cloneElement).apply(null, arguments) : n;
}
function $1fcac57a3c749c8b$export$502457920280e6be(n) {
    return !!n.__k && ((0, $joJRn.render)(null, n), !0);
}
function $1fcac57a3c749c8b$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $1fcac57a3c749c8b$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $1fcac57a3c749c8b$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $1fcac57a3c749c8b$export$5f8d39834fd61797 = (0, $joJRn.Fragment);
var $1fcac57a3c749c8b$export$2e2bcd8739ae039 = {
    useState: (0, $iJ7ah.useState),
    useReducer: (0, $iJ7ah.useReducer),
    useEffect: (0, $iJ7ah.useEffect),
    useLayoutEffect: (0, $iJ7ah.useLayoutEffect),
    useRef: (0, $iJ7ah.useRef),
    useImperativeHandle: (0, $iJ7ah.useImperativeHandle),
    useMemo: (0, $iJ7ah.useMemo),
    useCallback: (0, $iJ7ah.useCallback),
    useContext: (0, $iJ7ah.useContext),
    useDebugValue: (0, $iJ7ah.useDebugValue),
    version: "17.0.2",
    Children: $1fcac57a3c749c8b$export$dca3b0875bd9a954,
    render: $1fcac57a3c749c8b$export$b3890eb0ae9dca99,
    hydrate: $1fcac57a3c749c8b$export$fa8d919ba61d84db,
    unmountComponentAtNode: $1fcac57a3c749c8b$export$502457920280e6be,
    createPortal: $1fcac57a3c749c8b$export$d39a5bbd09211389,
    createElement: (0, $joJRn.createElement),
    createContext: (0, $joJRn.createContext),
    createFactory: $1fcac57a3c749c8b$export$d38cd72104c1f0e9,
    cloneElement: $1fcac57a3c749c8b$export$e530037191fcd5d7,
    createRef: (0, $joJRn.createRef),
    Fragment: (0, $joJRn.Fragment),
    isValidElement: $1fcac57a3c749c8b$export$a8257692ac88316c,
    findDOMNode: $1fcac57a3c749c8b$export$466bfc07425424d5,
    Component: (0, $joJRn.Component),
    PureComponent: $1fcac57a3c749c8b$export$221d75b3f55bb0bd,
    memo: $1fcac57a3c749c8b$export$7c73462e0d25e514,
    forwardRef: $1fcac57a3c749c8b$export$257a8862b851cb5b,
    flushSync: $1fcac57a3c749c8b$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $1fcac57a3c749c8b$export$c78a37762a8d58e1,
    StrictMode: (0, $joJRn.Fragment),
    Suspense: $1fcac57a3c749c8b$export$74bf444e3cd11ea5,
    SuspenseList: $1fcac57a3c749c8b$export$998bcd577473dd93,
    lazy: $1fcac57a3c749c8b$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $1fcac57a3c749c8b$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $iJ7ah);

});
parcelRequire.register("iJ7ah", function(module, exports) {

$parcel$export(module.exports, "useState", () => $da21fcc504ad0a2c$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $da21fcc504ad0a2c$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $da21fcc504ad0a2c$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $da21fcc504ad0a2c$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $da21fcc504ad0a2c$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $da21fcc504ad0a2c$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $da21fcc504ad0a2c$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $da21fcc504ad0a2c$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $da21fcc504ad0a2c$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $da21fcc504ad0a2c$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $da21fcc504ad0a2c$export$c052f6604b7d51fe);

var $joJRn = parcelRequire("joJRn");
var $da21fcc504ad0a2c$var$t, $da21fcc504ad0a2c$var$u, $da21fcc504ad0a2c$var$r, $da21fcc504ad0a2c$var$o, $da21fcc504ad0a2c$var$i = 0, $da21fcc504ad0a2c$var$c = [], $da21fcc504ad0a2c$var$f = [], $da21fcc504ad0a2c$var$e = (0, $joJRn.options).__b, $da21fcc504ad0a2c$var$a = (0, $joJRn.options).__r, $da21fcc504ad0a2c$var$v = (0, $joJRn.options).diffed, $da21fcc504ad0a2c$var$l = (0, $joJRn.options).__c, $da21fcc504ad0a2c$var$m = (0, $joJRn.options).unmount;
function $da21fcc504ad0a2c$var$p(t, r) {
    (0, $joJRn.options).__h && (0, $joJRn.options).__h($da21fcc504ad0a2c$var$u, t, $da21fcc504ad0a2c$var$i || r), $da21fcc504ad0a2c$var$i = 0;
    var o = $da21fcc504ad0a2c$var$u.__H || ($da21fcc504ad0a2c$var$u.__H = {
        __: [],
        __h: []
    });
    return t >= o.__.length && o.__.push({
        __V: $da21fcc504ad0a2c$var$f
    }), o.__[t];
}
function $da21fcc504ad0a2c$export$60241385465d0a34(n) {
    return $da21fcc504ad0a2c$var$i = 1, $da21fcc504ad0a2c$export$13e3392192263954($da21fcc504ad0a2c$var$z, n);
}
function $da21fcc504ad0a2c$export$13e3392192263954(n, r, o) {
    var i = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 2);
    return i.t = n, i.__c || (i.__ = [
        o ? o(r) : $da21fcc504ad0a2c$var$z(void 0, r),
        function(n) {
            var t = i.t(i.__[0], n);
            i.__[0] !== t && (i.__ = [
                t,
                i.__[1]
            ], i.__c.setState({}));
        }
    ], i.__c = $da21fcc504ad0a2c$var$u), i.__;
}
function $da21fcc504ad0a2c$export$6d9c69b0de29b591(r, o) {
    var i = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 3);
    !(0, $joJRn.options).__s && $da21fcc504ad0a2c$var$w(i.__H, o) && (i.__ = r, i.u = o, $da21fcc504ad0a2c$var$u.__H.__h.push(i));
}
function $da21fcc504ad0a2c$export$e5c5a5f917a5871c(r, o) {
    var i = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 4);
    !(0, $joJRn.options).__s && $da21fcc504ad0a2c$var$w(i.__H, o) && (i.__ = r, i.u = o, $da21fcc504ad0a2c$var$u.__h.push(i));
}
function $da21fcc504ad0a2c$export$b8f5890fc79d6aca(n) {
    return $da21fcc504ad0a2c$var$i = 5, $da21fcc504ad0a2c$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $da21fcc504ad0a2c$export$d5a552a76deda3c2(n, t, u) {
    $da21fcc504ad0a2c$var$i = 6, $da21fcc504ad0a2c$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == u ? u : u.concat(n));
}
function $da21fcc504ad0a2c$export$1538c33de8887b59(n, u) {
    var r = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 7);
    return $da21fcc504ad0a2c$var$w(r.__H, u) ? (r.__V = n(), r.u = u, r.__h = n, r.__V) : r.__;
}
function $da21fcc504ad0a2c$export$35808ee640e87ca7(n, t) {
    return $da21fcc504ad0a2c$var$i = 8, $da21fcc504ad0a2c$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $da21fcc504ad0a2c$export$fae74005e78b1a27(n) {
    var r = $da21fcc504ad0a2c$var$u.context[n.__c], o = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 9);
    return o.c = n, r ? (null == o.__ && (o.__ = !0, r.sub($da21fcc504ad0a2c$var$u)), r.props.value) : n.__;
}
function $da21fcc504ad0a2c$export$dc8fbce3eb94dc1e(t, u) {
    (0, $joJRn.options).useDebugValue && (0, $joJRn.options).useDebugValue(u ? u(t) : t);
}
function $da21fcc504ad0a2c$export$c052f6604b7d51fe(n) {
    var r = $da21fcc504ad0a2c$var$p($da21fcc504ad0a2c$var$t++, 10), o = $da21fcc504ad0a2c$export$60241385465d0a34();
    return r.__ = n, $da21fcc504ad0a2c$var$u.componentDidCatch || ($da21fcc504ad0a2c$var$u.componentDidCatch = function(n) {
        r.__ && r.__(n), o[1](n);
    }), [
        o[0],
        function() {
            o[1](void 0);
        }
    ];
}
function $da21fcc504ad0a2c$var$b() {
    for(var t; t = $da21fcc504ad0a2c$var$c.shift();)if (t.__P) try {
        t.__H.__h.forEach($da21fcc504ad0a2c$var$j), t.__H.__h.forEach($da21fcc504ad0a2c$var$k), t.__H.__h = [];
    } catch (u) {
        t.__H.__h = [], (0, $joJRn.options).__e(u, t.__v);
    }
}
(0, $joJRn.options).__b = function(n) {
    $da21fcc504ad0a2c$var$u = null, $da21fcc504ad0a2c$var$e && $da21fcc504ad0a2c$var$e(n);
}, (0, $joJRn.options).__r = function(n) {
    $da21fcc504ad0a2c$var$a && $da21fcc504ad0a2c$var$a(n), $da21fcc504ad0a2c$var$t = 0;
    var o = ($da21fcc504ad0a2c$var$u = n.__c).__H;
    o && ($da21fcc504ad0a2c$var$r === $da21fcc504ad0a2c$var$u ? (o.__h = [], $da21fcc504ad0a2c$var$u.__h = [], o.__.forEach(function(n) {
        n.__V = $da21fcc504ad0a2c$var$f, n.u = void 0;
    })) : (o.__h.forEach($da21fcc504ad0a2c$var$j), o.__h.forEach($da21fcc504ad0a2c$var$k), o.__h = [])), $da21fcc504ad0a2c$var$r = $da21fcc504ad0a2c$var$u;
}, (0, $joJRn.options).diffed = function(t) {
    $da21fcc504ad0a2c$var$v && $da21fcc504ad0a2c$var$v(t);
    var i = t.__c;
    i && i.__H && (i.__H.__h.length && (1 !== $da21fcc504ad0a2c$var$c.push(i) && $da21fcc504ad0a2c$var$o === (0, $joJRn.options).requestAnimationFrame || (($da21fcc504ad0a2c$var$o = (0, $joJRn.options).requestAnimationFrame) || function(n) {
        var t, u = function() {
            clearTimeout(r), $da21fcc504ad0a2c$var$g && cancelAnimationFrame(t), setTimeout(n);
        }, r = setTimeout(u, 100);
        $da21fcc504ad0a2c$var$g && (t = requestAnimationFrame(u));
    })($da21fcc504ad0a2c$var$b)), i.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.__V !== $da21fcc504ad0a2c$var$f && (n.__ = n.__V), n.u = void 0, n.__V = $da21fcc504ad0a2c$var$f;
    })), $da21fcc504ad0a2c$var$r = $da21fcc504ad0a2c$var$u = null;
}, (0, $joJRn.options).__c = function(t, u) {
    u.some(function(t) {
        try {
            t.__h.forEach($da21fcc504ad0a2c$var$j), t.__h = t.__h.filter(function(n) {
                return !n.__ || $da21fcc504ad0a2c$var$k(n);
            });
        } catch (r) {
            u.some(function(n) {
                n.__h && (n.__h = []);
            }), u = [], (0, $joJRn.options).__e(r, t.__v);
        }
    }), $da21fcc504ad0a2c$var$l && $da21fcc504ad0a2c$var$l(t, u);
}, (0, $joJRn.options).unmount = function(t) {
    $da21fcc504ad0a2c$var$m && $da21fcc504ad0a2c$var$m(t);
    var u, r = t.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $da21fcc504ad0a2c$var$j(n);
        } catch (n) {
            u = n;
        }
    }), u && (0, $joJRn.options).__e(u, r.__v));
};
var $da21fcc504ad0a2c$var$g = "function" == typeof requestAnimationFrame;
function $da21fcc504ad0a2c$var$j(n) {
    var t = $da21fcc504ad0a2c$var$u, r = n.__c;
    "function" == typeof r && (n.__c = void 0, r()), $da21fcc504ad0a2c$var$u = t;
}
function $da21fcc504ad0a2c$var$k(n) {
    var t = $da21fcc504ad0a2c$var$u;
    n.__c = n.__(), $da21fcc504ad0a2c$var$u = t;
}
function $da21fcc504ad0a2c$var$w(n, t) {
    return !n || n.length !== t.length || t.some(function(t, u) {
        return t !== n[u];
    });
}
function $da21fcc504ad0a2c$var$z(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});
parcelRequire.register("joJRn", function(module, exports) {

$parcel$export(module.exports, "options", () => $e1f3d502d4ee33bd$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $e1f3d502d4ee33bd$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $e1f3d502d4ee33bd$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $e1f3d502d4ee33bd$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $e1f3d502d4ee33bd$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $e1f3d502d4ee33bd$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $e1f3d502d4ee33bd$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $e1f3d502d4ee33bd$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $e1f3d502d4ee33bd$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $e1f3d502d4ee33bd$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $e1f3d502d4ee33bd$export$c8a8987d4410bf2d);
var $e1f3d502d4ee33bd$var$n, $e1f3d502d4ee33bd$export$41c562ebe57d11e2, $e1f3d502d4ee33bd$var$u, $e1f3d502d4ee33bd$export$a8257692ac88316c, $e1f3d502d4ee33bd$var$t, $e1f3d502d4ee33bd$var$o, $e1f3d502d4ee33bd$var$r, $e1f3d502d4ee33bd$var$f, $e1f3d502d4ee33bd$var$e = {}, $e1f3d502d4ee33bd$var$c = [], $e1f3d502d4ee33bd$var$s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $e1f3d502d4ee33bd$var$a(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $e1f3d502d4ee33bd$var$h(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $e1f3d502d4ee33bd$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $e1f3d502d4ee33bd$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $e1f3d502d4ee33bd$var$y(l, f, t, o, null);
}
function $e1f3d502d4ee33bd$var$y(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$e1f3d502d4ee33bd$var$u : r
    };
    return null == r && null != $e1f3d502d4ee33bd$export$41c562ebe57d11e2.vnode && $e1f3d502d4ee33bd$export$41c562ebe57d11e2.vnode(f), f;
}
function $e1f3d502d4ee33bd$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $e1f3d502d4ee33bd$export$ffb0004e005737fa(n) {
    return n.children;
}
function $e1f3d502d4ee33bd$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $e1f3d502d4ee33bd$var$k(n, l) {
    if (null == l) return n.__ ? $e1f3d502d4ee33bd$var$k(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $e1f3d502d4ee33bd$var$k(n) : null;
}
function $e1f3d502d4ee33bd$var$b(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $e1f3d502d4ee33bd$var$b(n);
    }
}
function $e1f3d502d4ee33bd$var$m(n) {
    (!n.__d && (n.__d = !0) && $e1f3d502d4ee33bd$var$t.push(n) && !$e1f3d502d4ee33bd$var$g.__r++ || $e1f3d502d4ee33bd$var$r !== $e1f3d502d4ee33bd$export$41c562ebe57d11e2.debounceRendering) && (($e1f3d502d4ee33bd$var$r = $e1f3d502d4ee33bd$export$41c562ebe57d11e2.debounceRendering) || $e1f3d502d4ee33bd$var$o)($e1f3d502d4ee33bd$var$g);
}
function $e1f3d502d4ee33bd$var$g() {
    for(var n; $e1f3d502d4ee33bd$var$g.__r = $e1f3d502d4ee33bd$var$t.length;)n = $e1f3d502d4ee33bd$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $e1f3d502d4ee33bd$var$t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $e1f3d502d4ee33bd$var$a({}, t)).__v = t.__v + 1, $e1f3d502d4ee33bd$var$j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $e1f3d502d4ee33bd$var$k(t) : o, t.__h), $e1f3d502d4ee33bd$var$z(u, t), t.__e != o && $e1f3d502d4ee33bd$var$b(t)));
    });
}
function $e1f3d502d4ee33bd$var$w(n, l, u, i, t, o, r, f, s, a) {
    var h, v, p, _, b, m, g, w = i && i.__k || $e1f3d502d4ee33bd$var$c, A = w.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $e1f3d502d4ee33bd$var$y(null, _, null, null, _) : Array.isArray(_) ? $e1f3d502d4ee33bd$var$y($e1f3d502d4ee33bd$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $e1f3d502d4ee33bd$var$y(_.type, _.props, _.key, null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (p = w[h]) || p && _.key == p.key && _.type === p.type) w[h] = void 0;
        else for(v = 0; v < A; v++){
            if ((p = w[v]) && _.key == p.key && _.type === p.type) {
                w[v] = void 0;
                break;
            }
            p = null;
        }
        $e1f3d502d4ee33bd$var$j(n, _, p = p || $e1f3d502d4ee33bd$var$e, t, o, r, f, s, a), b = _.__e, (v = _.ref) && p.ref != v && (g || (g = []), p.ref && g.push(p.ref, null, _), g.push(v, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === p.__k ? _.__d = s = $e1f3d502d4ee33bd$var$x(_, s, n) : s = $e1f3d502d4ee33bd$var$P(n, _, p, w, b, s), "function" == typeof u.type && (u.__d = s)) : s && p.__e == s && s.parentNode != n && (s = $e1f3d502d4ee33bd$var$k(p));
    }
    for(u.__e = m, h = A; h--;)null != w[h] && ("function" == typeof u.type && null != w[h].__e && w[h].__e == u.__d && (u.__d = $e1f3d502d4ee33bd$var$k(i, h + 1)), $e1f3d502d4ee33bd$var$N(w[h], w[h]));
    if (g) for(h = 0; h < g.length; h++)$e1f3d502d4ee33bd$var$M(g[h], g[++h], g[++h]);
}
function $e1f3d502d4ee33bd$var$x(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $e1f3d502d4ee33bd$var$x(i, l, u) : $e1f3d502d4ee33bd$var$P(u, i, i, t, i.__e, l));
    return l;
}
function $e1f3d502d4ee33bd$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $e1f3d502d4ee33bd$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $e1f3d502d4ee33bd$var$P(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $e1f3d502d4ee33bd$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $e1f3d502d4ee33bd$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $e1f3d502d4ee33bd$var$H(n, o, l[o], u[o], i);
}
function $e1f3d502d4ee33bd$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $e1f3d502d4ee33bd$var$s.test(l) ? u : u + "px";
}
function $e1f3d502d4ee33bd$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $e1f3d502d4ee33bd$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $e1f3d502d4ee33bd$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $e1f3d502d4ee33bd$var$T : $e1f3d502d4ee33bd$var$I, o) : n.removeEventListener(l, o ? $e1f3d502d4ee33bd$var$T : $e1f3d502d4ee33bd$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $e1f3d502d4ee33bd$var$I(n) {
    this.l[n.type + !1]($e1f3d502d4ee33bd$export$41c562ebe57d11e2.event ? $e1f3d502d4ee33bd$export$41c562ebe57d11e2.event(n) : n);
}
function $e1f3d502d4ee33bd$var$T(n) {
    this.l[n.type + !0]($e1f3d502d4ee33bd$export$41c562ebe57d11e2.event ? $e1f3d502d4ee33bd$export$41c562ebe57d11e2.event(n) : n);
}
function $e1f3d502d4ee33bd$var$j(n, u, i, t, o, r, f, e, c) {
    var s, h, v, y, p, k, b, m, g, x, A, P, C, $ = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (s = $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof $) {
            if (m = u.props, g = (s = $.contextType) && t[s.__c], x = s ? g ? g.props.value : s.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in $ && $.prototype.render ? u.__c = h = new $(m, x) : (u.__c = h = new $e1f3d502d4ee33bd$export$16fa2f45be04daa8(m, x), h.constructor = $, h.render = $e1f3d502d4ee33bd$var$O), g && g.sub(h), h.props = m, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != $.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $e1f3d502d4ee33bd$var$a({}, h.__s)), $e1f3d502d4ee33bd$var$a(h.__s, $.getDerivedStateFromProps(m, h.__s))), y = h.props, p = h.state, v) null == $.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == $.getDerivedStateFromProps && m !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, x) || u.__v === i.__v) {
                    h.props = m, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, p, k);
                });
            }
            if (h.context = x, h.props = m, h.__v = u, h.__P = n, A = $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__r, P = 0, "prototype" in $ && $.prototype.render) h.state = h.__s, h.__d = !1, A && A(u), s = h.render(h.props, h.state, h.context);
            else do h.__d = !1, A && A(u), s = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++P < 25);
            h.state = h.__s, null != h.getChildContext && (t = $e1f3d502d4ee33bd$var$a($e1f3d502d4ee33bd$var$a({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, p)), C = null != s && s.type === $e1f3d502d4ee33bd$export$ffb0004e005737fa && null == s.key ? s.props.children : s, $e1f3d502d4ee33bd$var$w(n, Array.isArray(C) ? C : [
                C
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $e1f3d502d4ee33bd$var$L(i.__e, u, i, t, o, r, f, c);
        (s = $e1f3d502d4ee33bd$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $e1f3d502d4ee33bd$var$z(n, u) {
    $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__c && $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $e1f3d502d4ee33bd$var$L(l, u, i, t, o, r, f, c) {
    var s, a, v, y = i.props, p = u.props, d = u.type, _ = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; _ < r.length; _++)if ((s = r[_]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[_] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $e1f3d502d4ee33bd$var$n.call(l.childNodes), a = (y = i.props || $e1f3d502d4ee33bd$var$e).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, _ = 0; _ < l.attributes.length; _++)y[l.attributes[_].name] = l.attributes[_].value;
            (v || a) && (v && (a && v.__html == a.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($e1f3d502d4ee33bd$var$C(l, p, y, o, c), v) u.__k = [];
        else if (_ = u.props.children, $e1f3d502d4ee33bd$var$w(l, Array.isArray(_) ? _ : [
            _
        ], u, i, t, o && "foreignObject" !== d, r, f, r ? r[0] : i.__k && $e1f3d502d4ee33bd$var$k(i, 0), c), null != r) for(_ = r.length; _--;)null != r[_] && $e1f3d502d4ee33bd$var$h(r[_]);
        c || ("value" in p && void 0 !== (_ = p.value) && (_ !== l.value || "progress" === d && !_ || "option" === d && _ !== y.value) && $e1f3d502d4ee33bd$var$H(l, "value", _, y.value, !1), "checked" in p && void 0 !== (_ = p.checked) && _ !== l.checked && $e1f3d502d4ee33bd$var$H(l, "checked", _, y.checked, !1));
    }
    return l;
}
function $e1f3d502d4ee33bd$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $e1f3d502d4ee33bd$var$N(n, u, i) {
    var t, o;
    if ($e1f3d502d4ee33bd$export$41c562ebe57d11e2.unmount && $e1f3d502d4ee33bd$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $e1f3d502d4ee33bd$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $e1f3d502d4ee33bd$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $e1f3d502d4ee33bd$var$h(n.__e), n.__e = n.__d = void 0;
}
function $e1f3d502d4ee33bd$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $e1f3d502d4ee33bd$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, f;
    $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__ && $e1f3d502d4ee33bd$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $e1f3d502d4ee33bd$var$j(i, u = (!o && t || i).__k = $e1f3d502d4ee33bd$export$c8a8987d4410bf2d($e1f3d502d4ee33bd$export$ffb0004e005737fa, null, [
        u
    ]), r || $e1f3d502d4ee33bd$var$e, $e1f3d502d4ee33bd$var$e, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $e1f3d502d4ee33bd$var$n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), $e1f3d502d4ee33bd$var$z(f, u);
}
function $e1f3d502d4ee33bd$export$fa8d919ba61d84db(n, l) {
    $e1f3d502d4ee33bd$export$b3890eb0ae9dca99(n, l, $e1f3d502d4ee33bd$export$fa8d919ba61d84db);
}
function $e1f3d502d4ee33bd$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f = $e1f3d502d4ee33bd$var$a({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $e1f3d502d4ee33bd$var$n.call(arguments, 2) : i), $e1f3d502d4ee33bd$var$y(l.type, f, t || l.key, o || l.ref, null);
}
function $e1f3d502d4ee33bd$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $e1f3d502d4ee33bd$var$f++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($e1f3d502d4ee33bd$var$m);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$e1f3d502d4ee33bd$var$n = $e1f3d502d4ee33bd$var$c.slice, $e1f3d502d4ee33bd$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $e1f3d502d4ee33bd$var$u = 0, $e1f3d502d4ee33bd$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $e1f3d502d4ee33bd$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $e1f3d502d4ee33bd$var$a({}, this.state), "function" == typeof n && (n = n($e1f3d502d4ee33bd$var$a({}, u), this.props)), n && $e1f3d502d4ee33bd$var$a(u, n), null != n && this.__v && (l && this.__h.push(l), $e1f3d502d4ee33bd$var$m(this));
}, $e1f3d502d4ee33bd$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $e1f3d502d4ee33bd$var$m(this));
}, $e1f3d502d4ee33bd$export$16fa2f45be04daa8.prototype.render = $e1f3d502d4ee33bd$export$ffb0004e005737fa, $e1f3d502d4ee33bd$var$t = [], $e1f3d502d4ee33bd$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $e1f3d502d4ee33bd$var$g.__r = 0, $e1f3d502d4ee33bd$var$f = 0;

});



parcelRequire.register("jgC7D", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $e06d1531800fbf4a$export$a7c73072b1a182ae, (v) => $e06d1531800fbf4a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $e06d1531800fbf4a$export$9f27bc3417b4524d, (v) => $e06d1531800fbf4a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $e06d1531800fbf4a$export$db77ccec0bb4ccac, (v) => $e06d1531800fbf4a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $e06d1531800fbf4a$export$8392c0c9d3dcbd35, (v) => $e06d1531800fbf4a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $e06d1531800fbf4a$export$ffb0004e005737fa, (v) => $e06d1531800fbf4a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $e06d1531800fbf4a$export$b624eff549462981, (v) => $e06d1531800fbf4a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $e06d1531800fbf4a$export$7897aa7841a5380c, (v) => $e06d1531800fbf4a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $e06d1531800fbf4a$export$602eac185826482c, (v) => $e06d1531800fbf4a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $e06d1531800fbf4a$export$e2c29f18771995cb, (v) => $e06d1531800fbf4a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $e06d1531800fbf4a$export$5f8d39834fd61797, (v) => $e06d1531800fbf4a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e06d1531800fbf4a$export$74bf444e3cd11ea5, (v) => $e06d1531800fbf4a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $e06d1531800fbf4a$export$998bcd577473dd93, (v) => $e06d1531800fbf4a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $e06d1531800fbf4a$export$92387174baf9b227, (v) => $e06d1531800fbf4a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $e06d1531800fbf4a$export$ec112efeb987d9c6, (v) => $e06d1531800fbf4a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $e06d1531800fbf4a$export$b706b080d889d2c9, (v) => $e06d1531800fbf4a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $e06d1531800fbf4a$export$5be5a87408f70ddc, (v) => $e06d1531800fbf4a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $e06d1531800fbf4a$export$45a5e7f76e0caa8d, (v) => $e06d1531800fbf4a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $e06d1531800fbf4a$export$455c2e768291efa6, (v) => $e06d1531800fbf4a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $e06d1531800fbf4a$export$9522e17588c12572, (v) => $e06d1531800fbf4a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $e06d1531800fbf4a$export$2110ac352bb060b9, (v) => $e06d1531800fbf4a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $e06d1531800fbf4a$export$56885ab8b9c456ab, (v) => $e06d1531800fbf4a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $e06d1531800fbf4a$export$d927fcb6adf8f9de, (v) => $e06d1531800fbf4a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $e06d1531800fbf4a$export$b82d16f27459e05a, (v) => $e06d1531800fbf4a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $e06d1531800fbf4a$export$522c17b4f5e123e8, (v) => $e06d1531800fbf4a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $e06d1531800fbf4a$export$1aabd8a0274ecfd6, (v) => $e06d1531800fbf4a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $e06d1531800fbf4a$export$3d6c20d97e46b957, (v) => $e06d1531800fbf4a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $e06d1531800fbf4a$export$9b621391a187a31a, (v) => $e06d1531800fbf4a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $e06d1531800fbf4a$export$f5bbd400c2f4426f, (v) => $e06d1531800fbf4a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e06d1531800fbf4a$export$a7c73072b1a182ae;
var $e06d1531800fbf4a$export$9f27bc3417b4524d;
var $e06d1531800fbf4a$export$db77ccec0bb4ccac;
var $e06d1531800fbf4a$export$8392c0c9d3dcbd35;
var $e06d1531800fbf4a$export$ffb0004e005737fa;
var $e06d1531800fbf4a$export$b624eff549462981;
var $e06d1531800fbf4a$export$7897aa7841a5380c;
var $e06d1531800fbf4a$export$602eac185826482c;
var $e06d1531800fbf4a$export$e2c29f18771995cb;
var $e06d1531800fbf4a$export$5f8d39834fd61797;
var $e06d1531800fbf4a$export$74bf444e3cd11ea5;
var $e06d1531800fbf4a$export$998bcd577473dd93;
var $e06d1531800fbf4a$export$92387174baf9b227;
var $e06d1531800fbf4a$export$ec112efeb987d9c6;
var $e06d1531800fbf4a$export$b706b080d889d2c9;
var $e06d1531800fbf4a$export$5be5a87408f70ddc;
var $e06d1531800fbf4a$export$45a5e7f76e0caa8d;
var $e06d1531800fbf4a$export$455c2e768291efa6;
var $e06d1531800fbf4a$export$9522e17588c12572;
var $e06d1531800fbf4a$export$2110ac352bb060b9;
var $e06d1531800fbf4a$export$56885ab8b9c456ab;
var $e06d1531800fbf4a$export$d927fcb6adf8f9de;
var $e06d1531800fbf4a$export$b82d16f27459e05a;
var $e06d1531800fbf4a$export$522c17b4f5e123e8;
var $e06d1531800fbf4a$export$1aabd8a0274ecfd6;
var $e06d1531800fbf4a$export$3d6c20d97e46b957;
var $e06d1531800fbf4a$export$9b621391a187a31a;
var $e06d1531800fbf4a$export$f5bbd400c2f4426f;
"use strict";
var $e06d1531800fbf4a$var$b = Symbol.for("react.element"), $e06d1531800fbf4a$var$c = Symbol.for("react.portal"), $e06d1531800fbf4a$var$d = Symbol.for("react.fragment"), $e06d1531800fbf4a$var$e = Symbol.for("react.strict_mode"), $e06d1531800fbf4a$var$f = Symbol.for("react.profiler"), $e06d1531800fbf4a$var$g = Symbol.for("react.provider"), $e06d1531800fbf4a$var$h = Symbol.for("react.context"), $e06d1531800fbf4a$var$k = Symbol.for("react.server_context"), $e06d1531800fbf4a$var$l = Symbol.for("react.forward_ref"), $e06d1531800fbf4a$var$m = Symbol.for("react.suspense"), $e06d1531800fbf4a$var$n = Symbol.for("react.suspense_list"), $e06d1531800fbf4a$var$p = Symbol.for("react.memo"), $e06d1531800fbf4a$var$q = Symbol.for("react.lazy"), $e06d1531800fbf4a$var$t = Symbol.for("react.offscreen"), $e06d1531800fbf4a$var$u;
$e06d1531800fbf4a$var$u = Symbol.for("react.module.reference");
function $e06d1531800fbf4a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $e06d1531800fbf4a$var$b:
                switch(a = a.type, a){
                    case $e06d1531800fbf4a$var$d:
                    case $e06d1531800fbf4a$var$f:
                    case $e06d1531800fbf4a$var$e:
                    case $e06d1531800fbf4a$var$m:
                    case $e06d1531800fbf4a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e06d1531800fbf4a$var$k:
                            case $e06d1531800fbf4a$var$h:
                            case $e06d1531800fbf4a$var$l:
                            case $e06d1531800fbf4a$var$q:
                            case $e06d1531800fbf4a$var$p:
                            case $e06d1531800fbf4a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $e06d1531800fbf4a$var$c:
                return r;
        }
    }
}
$e06d1531800fbf4a$export$a7c73072b1a182ae = $e06d1531800fbf4a$var$h;
$e06d1531800fbf4a$export$9f27bc3417b4524d = $e06d1531800fbf4a$var$g;
$e06d1531800fbf4a$export$db77ccec0bb4ccac = $e06d1531800fbf4a$var$b;
$e06d1531800fbf4a$export$8392c0c9d3dcbd35 = $e06d1531800fbf4a$var$l;
$e06d1531800fbf4a$export$ffb0004e005737fa = $e06d1531800fbf4a$var$d;
$e06d1531800fbf4a$export$b624eff549462981 = $e06d1531800fbf4a$var$q;
$e06d1531800fbf4a$export$7897aa7841a5380c = $e06d1531800fbf4a$var$p;
$e06d1531800fbf4a$export$602eac185826482c = $e06d1531800fbf4a$var$c;
$e06d1531800fbf4a$export$e2c29f18771995cb = $e06d1531800fbf4a$var$f;
$e06d1531800fbf4a$export$5f8d39834fd61797 = $e06d1531800fbf4a$var$e;
$e06d1531800fbf4a$export$74bf444e3cd11ea5 = $e06d1531800fbf4a$var$m;
$e06d1531800fbf4a$export$998bcd577473dd93 = $e06d1531800fbf4a$var$n;
$e06d1531800fbf4a$export$92387174baf9b227 = function() {
    return !1;
};
$e06d1531800fbf4a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$e06d1531800fbf4a$export$b706b080d889d2c9 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$h;
};
$e06d1531800fbf4a$export$5be5a87408f70ddc = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$g;
};
$e06d1531800fbf4a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e06d1531800fbf4a$var$b;
};
$e06d1531800fbf4a$export$455c2e768291efa6 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$l;
};
$e06d1531800fbf4a$export$9522e17588c12572 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$d;
};
$e06d1531800fbf4a$export$2110ac352bb060b9 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$q;
};
$e06d1531800fbf4a$export$56885ab8b9c456ab = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$p;
};
$e06d1531800fbf4a$export$d927fcb6adf8f9de = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$c;
};
$e06d1531800fbf4a$export$b82d16f27459e05a = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$f;
};
$e06d1531800fbf4a$export$522c17b4f5e123e8 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$e;
};
$e06d1531800fbf4a$export$1aabd8a0274ecfd6 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$m;
};
$e06d1531800fbf4a$export$3d6c20d97e46b957 = function(a) {
    return $e06d1531800fbf4a$var$v(a) === $e06d1531800fbf4a$var$n;
};
$e06d1531800fbf4a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e06d1531800fbf4a$var$d || a === $e06d1531800fbf4a$var$f || a === $e06d1531800fbf4a$var$e || a === $e06d1531800fbf4a$var$m || a === $e06d1531800fbf4a$var$n || a === $e06d1531800fbf4a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $e06d1531800fbf4a$var$q || a.$$typeof === $e06d1531800fbf4a$var$p || a.$$typeof === $e06d1531800fbf4a$var$g || a.$$typeof === $e06d1531800fbf4a$var$h || a.$$typeof === $e06d1531800fbf4a$var$l || a.$$typeof === $e06d1531800fbf4a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$e06d1531800fbf4a$export$f5bbd400c2f4426f = $e06d1531800fbf4a$var$v;

});

parcelRequire.register("jVBOo", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $e820abd78d8fa07f$export$2b8d127b894957b9, (v) => $e820abd78d8fa07f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $e820abd78d8fa07f$export$cea3a54a6425200c, (v) => $e820abd78d8fa07f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $e820abd78d8fa07f$export$a7c73072b1a182ae, (v) => $e820abd78d8fa07f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $e820abd78d8fa07f$export$9f27bc3417b4524d, (v) => $e820abd78d8fa07f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $e820abd78d8fa07f$export$db77ccec0bb4ccac, (v) => $e820abd78d8fa07f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $e820abd78d8fa07f$export$8392c0c9d3dcbd35, (v) => $e820abd78d8fa07f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $e820abd78d8fa07f$export$ffb0004e005737fa, (v) => $e820abd78d8fa07f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $e820abd78d8fa07f$export$b624eff549462981, (v) => $e820abd78d8fa07f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $e820abd78d8fa07f$export$7897aa7841a5380c, (v) => $e820abd78d8fa07f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $e820abd78d8fa07f$export$602eac185826482c, (v) => $e820abd78d8fa07f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $e820abd78d8fa07f$export$e2c29f18771995cb, (v) => $e820abd78d8fa07f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $e820abd78d8fa07f$export$5f8d39834fd61797, (v) => $e820abd78d8fa07f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e820abd78d8fa07f$export$74bf444e3cd11ea5, (v) => $e820abd78d8fa07f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $e820abd78d8fa07f$export$92387174baf9b227, (v) => $e820abd78d8fa07f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $e820abd78d8fa07f$export$ec112efeb987d9c6, (v) => $e820abd78d8fa07f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $e820abd78d8fa07f$export$b706b080d889d2c9, (v) => $e820abd78d8fa07f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $e820abd78d8fa07f$export$5be5a87408f70ddc, (v) => $e820abd78d8fa07f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $e820abd78d8fa07f$export$45a5e7f76e0caa8d, (v) => $e820abd78d8fa07f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $e820abd78d8fa07f$export$455c2e768291efa6, (v) => $e820abd78d8fa07f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $e820abd78d8fa07f$export$9522e17588c12572, (v) => $e820abd78d8fa07f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $e820abd78d8fa07f$export$2110ac352bb060b9, (v) => $e820abd78d8fa07f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $e820abd78d8fa07f$export$56885ab8b9c456ab, (v) => $e820abd78d8fa07f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $e820abd78d8fa07f$export$d927fcb6adf8f9de, (v) => $e820abd78d8fa07f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $e820abd78d8fa07f$export$b82d16f27459e05a, (v) => $e820abd78d8fa07f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $e820abd78d8fa07f$export$522c17b4f5e123e8, (v) => $e820abd78d8fa07f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $e820abd78d8fa07f$export$1aabd8a0274ecfd6, (v) => $e820abd78d8fa07f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $e820abd78d8fa07f$export$9b621391a187a31a, (v) => $e820abd78d8fa07f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $e820abd78d8fa07f$export$f5bbd400c2f4426f, (v) => $e820abd78d8fa07f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e820abd78d8fa07f$export$2b8d127b894957b9;
var $e820abd78d8fa07f$export$cea3a54a6425200c;
var $e820abd78d8fa07f$export$a7c73072b1a182ae;
var $e820abd78d8fa07f$export$9f27bc3417b4524d;
var $e820abd78d8fa07f$export$db77ccec0bb4ccac;
var $e820abd78d8fa07f$export$8392c0c9d3dcbd35;
var $e820abd78d8fa07f$export$ffb0004e005737fa;
var $e820abd78d8fa07f$export$b624eff549462981;
var $e820abd78d8fa07f$export$7897aa7841a5380c;
var $e820abd78d8fa07f$export$602eac185826482c;
var $e820abd78d8fa07f$export$e2c29f18771995cb;
var $e820abd78d8fa07f$export$5f8d39834fd61797;
var $e820abd78d8fa07f$export$74bf444e3cd11ea5;
var $e820abd78d8fa07f$export$92387174baf9b227;
var $e820abd78d8fa07f$export$ec112efeb987d9c6;
var $e820abd78d8fa07f$export$b706b080d889d2c9;
var $e820abd78d8fa07f$export$5be5a87408f70ddc;
var $e820abd78d8fa07f$export$45a5e7f76e0caa8d;
var $e820abd78d8fa07f$export$455c2e768291efa6;
var $e820abd78d8fa07f$export$9522e17588c12572;
var $e820abd78d8fa07f$export$2110ac352bb060b9;
var $e820abd78d8fa07f$export$56885ab8b9c456ab;
var $e820abd78d8fa07f$export$d927fcb6adf8f9de;
var $e820abd78d8fa07f$export$b82d16f27459e05a;
var $e820abd78d8fa07f$export$522c17b4f5e123e8;
var $e820abd78d8fa07f$export$1aabd8a0274ecfd6;
var $e820abd78d8fa07f$export$9b621391a187a31a;
var $e820abd78d8fa07f$export$f5bbd400c2f4426f;
"use strict";
var $e820abd78d8fa07f$var$b = "function" === typeof Symbol && Symbol.for, $e820abd78d8fa07f$var$c = $e820abd78d8fa07f$var$b ? Symbol.for("react.element") : 60103, $e820abd78d8fa07f$var$d = $e820abd78d8fa07f$var$b ? Symbol.for("react.portal") : 60106, $e820abd78d8fa07f$var$e = $e820abd78d8fa07f$var$b ? Symbol.for("react.fragment") : 60107, $e820abd78d8fa07f$var$f = $e820abd78d8fa07f$var$b ? Symbol.for("react.strict_mode") : 60108, $e820abd78d8fa07f$var$g = $e820abd78d8fa07f$var$b ? Symbol.for("react.profiler") : 60114, $e820abd78d8fa07f$var$h = $e820abd78d8fa07f$var$b ? Symbol.for("react.provider") : 60109, $e820abd78d8fa07f$var$k = $e820abd78d8fa07f$var$b ? Symbol.for("react.context") : 60110, $e820abd78d8fa07f$var$l = $e820abd78d8fa07f$var$b ? Symbol.for("react.async_mode") : 60111, $e820abd78d8fa07f$var$m = $e820abd78d8fa07f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $e820abd78d8fa07f$var$n = $e820abd78d8fa07f$var$b ? Symbol.for("react.forward_ref") : 60112, $e820abd78d8fa07f$var$p = $e820abd78d8fa07f$var$b ? Symbol.for("react.suspense") : 60113, $e820abd78d8fa07f$var$q = $e820abd78d8fa07f$var$b ? Symbol.for("react.suspense_list") : 60120, $e820abd78d8fa07f$var$r = $e820abd78d8fa07f$var$b ? Symbol.for("react.memo") : 60115, $e820abd78d8fa07f$var$t = $e820abd78d8fa07f$var$b ? Symbol.for("react.lazy") : 60116, $e820abd78d8fa07f$var$v = $e820abd78d8fa07f$var$b ? Symbol.for("react.block") : 60121, $e820abd78d8fa07f$var$w = $e820abd78d8fa07f$var$b ? Symbol.for("react.fundamental") : 60117, $e820abd78d8fa07f$var$x = $e820abd78d8fa07f$var$b ? Symbol.for("react.responder") : 60118, $e820abd78d8fa07f$var$y = $e820abd78d8fa07f$var$b ? Symbol.for("react.scope") : 60119;
function $e820abd78d8fa07f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $e820abd78d8fa07f$var$c:
                switch(a = a.type, a){
                    case $e820abd78d8fa07f$var$l:
                    case $e820abd78d8fa07f$var$m:
                    case $e820abd78d8fa07f$var$e:
                    case $e820abd78d8fa07f$var$g:
                    case $e820abd78d8fa07f$var$f:
                    case $e820abd78d8fa07f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e820abd78d8fa07f$var$k:
                            case $e820abd78d8fa07f$var$n:
                            case $e820abd78d8fa07f$var$t:
                            case $e820abd78d8fa07f$var$r:
                            case $e820abd78d8fa07f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $e820abd78d8fa07f$var$d:
                return u;
        }
    }
}
function $e820abd78d8fa07f$var$A(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$m;
}
$e820abd78d8fa07f$export$2b8d127b894957b9 = $e820abd78d8fa07f$var$l;
$e820abd78d8fa07f$export$cea3a54a6425200c = $e820abd78d8fa07f$var$m;
$e820abd78d8fa07f$export$a7c73072b1a182ae = $e820abd78d8fa07f$var$k;
$e820abd78d8fa07f$export$9f27bc3417b4524d = $e820abd78d8fa07f$var$h;
$e820abd78d8fa07f$export$db77ccec0bb4ccac = $e820abd78d8fa07f$var$c;
$e820abd78d8fa07f$export$8392c0c9d3dcbd35 = $e820abd78d8fa07f$var$n;
$e820abd78d8fa07f$export$ffb0004e005737fa = $e820abd78d8fa07f$var$e;
$e820abd78d8fa07f$export$b624eff549462981 = $e820abd78d8fa07f$var$t;
$e820abd78d8fa07f$export$7897aa7841a5380c = $e820abd78d8fa07f$var$r;
$e820abd78d8fa07f$export$602eac185826482c = $e820abd78d8fa07f$var$d;
$e820abd78d8fa07f$export$e2c29f18771995cb = $e820abd78d8fa07f$var$g;
$e820abd78d8fa07f$export$5f8d39834fd61797 = $e820abd78d8fa07f$var$f;
$e820abd78d8fa07f$export$74bf444e3cd11ea5 = $e820abd78d8fa07f$var$p;
$e820abd78d8fa07f$export$92387174baf9b227 = function(a) {
    return $e820abd78d8fa07f$var$A(a) || $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$l;
};
$e820abd78d8fa07f$export$ec112efeb987d9c6 = $e820abd78d8fa07f$var$A;
$e820abd78d8fa07f$export$b706b080d889d2c9 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$k;
};
$e820abd78d8fa07f$export$5be5a87408f70ddc = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$h;
};
$e820abd78d8fa07f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e820abd78d8fa07f$var$c;
};
$e820abd78d8fa07f$export$455c2e768291efa6 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$n;
};
$e820abd78d8fa07f$export$9522e17588c12572 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$e;
};
$e820abd78d8fa07f$export$2110ac352bb060b9 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$t;
};
$e820abd78d8fa07f$export$56885ab8b9c456ab = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$r;
};
$e820abd78d8fa07f$export$d927fcb6adf8f9de = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$d;
};
$e820abd78d8fa07f$export$b82d16f27459e05a = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$g;
};
$e820abd78d8fa07f$export$522c17b4f5e123e8 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$f;
};
$e820abd78d8fa07f$export$1aabd8a0274ecfd6 = function(a) {
    return $e820abd78d8fa07f$var$z(a) === $e820abd78d8fa07f$var$p;
};
$e820abd78d8fa07f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e820abd78d8fa07f$var$e || a === $e820abd78d8fa07f$var$m || a === $e820abd78d8fa07f$var$g || a === $e820abd78d8fa07f$var$f || a === $e820abd78d8fa07f$var$p || a === $e820abd78d8fa07f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $e820abd78d8fa07f$var$t || a.$$typeof === $e820abd78d8fa07f$var$r || a.$$typeof === $e820abd78d8fa07f$var$h || a.$$typeof === $e820abd78d8fa07f$var$k || a.$$typeof === $e820abd78d8fa07f$var$n || a.$$typeof === $e820abd78d8fa07f$var$w || a.$$typeof === $e820abd78d8fa07f$var$x || a.$$typeof === $e820abd78d8fa07f$var$y || a.$$typeof === $e820abd78d8fa07f$var$v);
};
$e820abd78d8fa07f$export$f5bbd400c2f4426f = $e820abd78d8fa07f$var$z;

});

parcelRequire.register("aYNNv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fe622b6c27233b2$var$_react = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("2Jeaf")));

var $7fe622b6c27233b2$var$_classnames = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("grfkD")));


var $7fe622b6c27233b2$var$_aspectRatioBox = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("e4EW3")));

var $7fe622b6c27233b2$var$_image = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("lWBAI")));

var $7fe622b6c27233b2$var$_ssrIcon = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("eAODm")));

var $7fe622b6c27233b2$var$_arrowRight = $7fe622b6c27233b2$var$_interopRequireDefault((parcelRequire("1FFmS")));
function $7fe622b6c27233b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7fe622b6c27233b2$var$_extends() {
    $7fe622b6c27233b2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7fe622b6c27233b2$var$_extends.apply(this, arguments);
}
const $7fe622b6c27233b2$var$Card = (_ref)=>{
    let { prefix: prefix = "", className: className, title: title, label: label, body: body, ctaLabel: ctaLabel, children: children, href: href, backgroundColor: backgroundColor, imageProps: imageProps, textColor: textColor, titleHeadingTag: titleHeadingTag = "h2", emphasised: emphasised, compact: compact, imagePosition: imagePosition = "trailing", buttonVariant: buttonVariant = "primary", large: large, ...other } = _ref;
    const backgroundColorStyle = backgroundColor ? {
        backgroundColor: backgroundColor
    } : null;
    const textColorStyle = textColor ? {
        color: textColor
    } : null;
    const cardClasses = (0, $7fe622b6c27233b2$var$_classnames.default)(`${prefix}card`, !imageProps && `${prefix}card--without-image`, emphasised && `${prefix}card--emphasised`, large && `${prefix}card--large`, compact && `${prefix}card--compact`, imagePosition === "trailing" && `${prefix}card--trailing-image`, className);
    const cardInfoClasses = (0, $7fe622b6c27233b2$var$_classnames.default)(`${prefix}card__info`);
    const HeadingTag = titleHeadingTag;
    const textContent = $7fe622b6c27233b2$var$_react.default.createElement("div", {
        className: `${prefix}card__text-wrapper`
    }, label && $7fe622b6c27233b2$var$_react.default.createElement("span", {
        style: textColorStyle,
        className: `${prefix}card__label`
    }, label), title && $7fe622b6c27233b2$var$_react.default.createElement(HeadingTag, {
        style: textColorStyle,
        className: `${prefix}card__title`
    }, title), body && $7fe622b6c27233b2$var$_react.default.createElement("p", {
        style: textColorStyle,
        className: `${prefix}card__body`
    }, body), children);
    return $7fe622b6c27233b2$var$_react.default.createElement("a", $7fe622b6c27233b2$var$_extends({
        className: cardClasses,
        href: href,
        style: backgroundColorStyle
    }, other), imageProps && $7fe622b6c27233b2$var$_react.default.createElement("div", {
        className: `${prefix}card__image`
    }, $7fe622b6c27233b2$var$_react.default.createElement($7fe622b6c27233b2$var$_aspectRatioBox.default, {
        ratio: "wide",
        prefix: prefix,
        className: `${prefix}card__image-aspect-ratio`
    }, $7fe622b6c27233b2$var$_react.default.createElement($7fe622b6c27233b2$var$_image.default, $7fe622b6c27233b2$var$_extends({
        prefix: prefix
    }, imageProps)))), $7fe622b6c27233b2$var$_react.default.createElement("div", {
        className: cardInfoClasses
    }, textContent, $7fe622b6c27233b2$var$_react.default.createElement("span", {
        style: textColorStyle,
        className: (0, $7fe622b6c27233b2$var$_classnames.default)(`${prefix}card__cta`, ctaLabel && `${prefix}card__cta--with-button`)
    }, ctaLabel || emphasised ? $7fe622b6c27233b2$var$_react.default.createElement("span", {
        className: `${prefix}card__btn ${prefix}btn ${prefix}btn--${buttonVariant} ${prefix}btn--small`
    }, $7fe622b6c27233b2$var$_react.default.createElement("span", {
        className: `${prefix}btn__inner`
    }, emphasised && buttonVariant.indexOf("icon") !== -1 && $7fe622b6c27233b2$var$_react.default.createElement($7fe622b6c27233b2$var$_ssrIcon.default, {
        className: `${prefix}card__icon`,
        prefix: prefix,
        paths: $7fe622b6c27233b2$var$_arrowRight.default
    }), ctaLabel && $7fe622b6c27233b2$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, ctaLabel))) : $7fe622b6c27233b2$var$_react.default.createElement($7fe622b6c27233b2$var$_ssrIcon.default, {
        className: `${prefix}card__icon`,
        prefix: prefix,
        paths: $7fe622b6c27233b2$var$_arrowRight.default
    }))));
};
var $7fe622b6c27233b2$var$_default = $7fe622b6c27233b2$var$Card;
module.exports.default = $7fe622b6c27233b2$var$_default;

});
parcelRequire.register("grfkD", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("e4EW3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3f1314d37758b65$var$_AspectRatioBox = $a3f1314d37758b65$var$_interopRequireDefault((parcelRequire("3Ye8x")));
function $a3f1314d37758b65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a3f1314d37758b65$var$_default = $a3f1314d37758b65$var$_AspectRatioBox.default;
module.exports.default = $a3f1314d37758b65$var$_default;

});
parcelRequire.register("3Ye8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e41f0ee8aa6c9e4$var$_react = $2e41f0ee8aa6c9e4$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $2e41f0ee8aa6c9e4$var$_classnames = $2e41f0ee8aa6c9e4$var$_interopRequireDefault((parcelRequire("grfkD")));
function $2e41f0ee8aa6c9e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2e41f0ee8aa6c9e4$var$_extends() {
    $2e41f0ee8aa6c9e4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e41f0ee8aa6c9e4$var$_extends.apply(this, arguments);
}
const $2e41f0ee8aa6c9e4$var$AspectRatioBox = (_ref)=>{
    let { tagType: tagType, prefix: prefix, className: className, ratio: ratio, children: children, ...others } = _ref;
    const classes = (0, $2e41f0ee8aa6c9e4$var$_classnames.default)(`${prefix}aspect-ratio-box`, ratio && `${prefix}aspect-ratio-box--${ratio}`, className);
    const SpanOrDiv = tagType;
    return $2e41f0ee8aa6c9e4$var$_react.default.createElement(SpanOrDiv, $2e41f0ee8aa6c9e4$var$_extends({
        className: `${classes}`
    }, others), children);
};
$2e41f0ee8aa6c9e4$var$AspectRatioBox.defaultProps = {
    prefix: "",
    tagType: "span",
    ratio: "standard"
};
var $2e41f0ee8aa6c9e4$var$_default = $2e41f0ee8aa6c9e4$var$AspectRatioBox;
module.exports.default = $2e41f0ee8aa6c9e4$var$_default;

});


parcelRequire.register("lWBAI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff9c2c90709f776b$var$_Image = $ff9c2c90709f776b$var$_interopRequireDefault((parcelRequire("8suOa")));
function $ff9c2c90709f776b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ff9c2c90709f776b$var$_default = $ff9c2c90709f776b$var$_Image.default;
module.exports.default = $ff9c2c90709f776b$var$_default;

});
parcelRequire.register("8suOa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6288d61c5195987a$var$_react = $6288d61c5195987a$var$_interopRequireWildcard((parcelRequire("2Jeaf")));


var $6288d61c5195987a$var$_ssrIcon = $6288d61c5195987a$var$_interopRequireDefault((parcelRequire("eAODm")));

var $6288d61c5195987a$var$_imageStrikethrough = $6288d61c5195987a$var$_interopRequireDefault((parcelRequire("jdDeW")));

var $6288d61c5195987a$var$_image = $6288d61c5195987a$var$_interopRequireDefault((parcelRequire("aefdd")));

var $6288d61c5195987a$var$_classnames = $6288d61c5195987a$var$_interopRequireDefault((parcelRequire("grfkD")));
function $6288d61c5195987a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6288d61c5195987a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6288d61c5195987a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6288d61c5195987a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6288d61c5195987a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6288d61c5195987a$var$_extends() {
    $6288d61c5195987a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6288d61c5195987a$var$_extends.apply(this, arguments);
}
const $6288d61c5195987a$var$Image = (_ref)=>{
    let { src: src, alt: alt, className: className, prefix: prefix, srcSet: srcSet, sizes: sizes, loading: loading, fallback: fallback, ...otherProps } = _ref;
    const [error, setError] = (0, $6288d61c5195987a$var$_react.useState)(false);
    const classes = (0, $6288d61c5195987a$var$_classnames.default)(`${prefix}image`, (error || fallback) && `${prefix}image--fallback`, className);
    const onError = ()=>{
        setError(true);
    };
    (0, $6288d61c5195987a$var$_react.useEffect)(()=>{
        if (src) setError(false);
    }, [
        src
    ]);
    let paths = $6288d61c5195987a$var$_image.default;
    if (error) paths = $6288d61c5195987a$var$_imageStrikethrough.default;
    const image = $6288d61c5195987a$var$_react.default.createElement("img", $6288d61c5195987a$var$_extends({
        className: !error && !fallback ? classes : undefined,
        onError: onError,
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        loading: loading
    }, otherProps));
    return error || fallback ? $6288d61c5195987a$var$_react.default.createElement("span", {
        className: classes
    }, $6288d61c5195987a$var$_react.default.createElement($6288d61c5195987a$var$_ssrIcon.default, {
        paths: paths,
        className: `${prefix}image__icon`,
        prefix: prefix
    }), image) : image;
};
$6288d61c5195987a$var$Image.defaultProps = {
    prefix: "",
    loading: "lazy"
};
var $6288d61c5195987a$var$_default = $6288d61c5195987a$var$Image;
module.exports.default = $6288d61c5195987a$var$_default;

});
parcelRequire.register("eAODm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9fbb45255d8931e$var$_SSRIcon = $a9fbb45255d8931e$var$_interopRequireDefault((parcelRequire("ikCyZ")));
function $a9fbb45255d8931e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a9fbb45255d8931e$var$_default = $a9fbb45255d8931e$var$_SSRIcon.default;
module.exports.default = $a9fbb45255d8931e$var$_default;

});
parcelRequire.register("ikCyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d58802273bb865cd$var$_react = $d58802273bb865cd$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $d58802273bb865cd$var$_classnames = $d58802273bb865cd$var$_interopRequireDefault((parcelRequire("grfkD")));
function $d58802273bb865cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d58802273bb865cd$var$_extends() {
    $d58802273bb865cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d58802273bb865cd$var$_extends.apply(this, arguments);
}
const $d58802273bb865cd$var$SSRIcon = (_ref)=>{
    let { prefix: prefix, viewBox: viewBox, paths: paths, className: className, modifier: modifier, alt: alt, ariaHidden: ariaHidden, ...otherProps } = _ref;
    const cssStyles = (0, $d58802273bb865cd$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $d58802273bb865cd$var$_react.default.createElement("svg", $d58802273bb865cd$var$_extends({
        focusable: "false",
        viewBox: viewBox
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $d58802273bb865cd$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
$d58802273bb865cd$var$SSRIcon.defaultProps = {
    prefix: "",
    viewBox: "0 0 24 24",
    ariaHidden: true
};
var $d58802273bb865cd$var$_default = $d58802273bb865cd$var$SSRIcon;
module.exports.default = $d58802273bb865cd$var$_default;

});


parcelRequire.register("jdDeW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfddab719a754369$var$_react = $dfddab719a754369$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $dfddab719a754369$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dfddab719a754369$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $dfddab719a754369$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965-3.0002-3.0011H3V5.8113L1 3.8106l1.3979-1.3965zM15.185 18.0002l-1.9994-2H6.5l2.6748-4.0122L5 7.8119V18h10.1851z"
        }),
        $dfddab719a754369$var$_react.default.createElement("path", {
            d: "m6.8114 4.0001 1.9994 2H19v10.1924l2 2.0006V4.0001H6.8114z"
        }),
        $dfddab719a754369$var$_react.default.createElement("path", {
            d: "M14 9.5001c0 .8284.6716 1.5 1.5 1.5s1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5z"
        })
    ];
};
module.exports.default = $dfddab719a754369$var$_default;

});

parcelRequire.register("aefdd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77270304f01b8ad5$var$_react = $77270304f01b8ad5$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $77270304f01b8ad5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $77270304f01b8ad5$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $77270304f01b8ad5$var$_react.default.createElement("path", {
            d: "M15.5 11c-.8284 0-1.5-.6716-1.5-1.5S14.6716 8 15.5 8s1.5.6716 1.5 1.5-.6716 1.5-1.5 1.5zM13 15.25l-3-4.5L6.5 16h11L15 12.25l-2 3z"
        }),
        $77270304f01b8ad5$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 4v16h18V4H3zm2 14V6h14v12H5z"
        })
    ];
};
module.exports.default = $77270304f01b8ad5$var$_default;

});



parcelRequire.register("1FFmS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1379b59b3ef99da1$var$_react = $1379b59b3ef99da1$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $1379b59b3ef99da1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1379b59b3ef99da1$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $1379b59b3ef99da1$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m20.0008 12.0001-8-8.001-1.4143 1.414L16.1727 11H4v2h12.1723l-5.5868 5.5866 1.4141 1.4142 8.0012-8.0007z"
        })
    ];
};
module.exports.default = $1379b59b3ef99da1$var$_default;

});


parcelRequire.register("le1f6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $8sOvO = parcelRequire("8sOvO");
function $f73bde8efa703221$var$emptyFunction() {}
function $f73bde8efa703221$var$emptyFunctionWithReset() {}
$f73bde8efa703221$var$emptyFunctionWithReset.resetWarningCache = $f73bde8efa703221$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8sOvO) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f73bde8efa703221$var$emptyFunctionWithReset,
        resetWarningCache: $f73bde8efa703221$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("8sOvO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $62981ee399617b50$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $62981ee399617b50$var$ReactPropTypesSecret;

});


parcelRequire.register("98y91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a6f58ca6ec5fd07$var$_react = $6a6f58ca6ec5fd07$var$_interopRequireWildcard((parcelRequire("2Jeaf")));

var $6a6f58ca6ec5fd07$var$_button = $6a6f58ca6ec5fd07$var$_interopRequireDefault((parcelRequire("dcraR")));


var $6a6f58ca6ec5fd07$var$_classnames = $6a6f58ca6ec5fd07$var$_interopRequireDefault((parcelRequire("grfkD")));

var $fcQtu = parcelRequire("fcQtu");
function $6a6f58ca6ec5fd07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6a6f58ca6ec5fd07$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6a6f58ca6ec5fd07$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6a6f58ca6ec5fd07$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6a6f58ca6ec5fd07$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6a6f58ca6ec5fd07$var$_extends() {
    $6a6f58ca6ec5fd07$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a6f58ca6ec5fd07$var$_extends.apply(this, arguments);
}
const $6a6f58ca6ec5fd07$var$ModalFooter = (_ref)=>{
    let { prefix: prefix, children: children, closeBtnClick: closeBtnClick, renderBorder: renderBorder, className: className, ...other } = _ref;
    let childrenArr = $6a6f58ca6ec5fd07$var$_react.Children.toArray(children);
    if (childrenArr.length && childrenArr[0].type === $6a6f58ca6ec5fd07$var$_react.Fragment) childrenArr = $6a6f58ca6ec5fd07$var$_react.Children.toArray(children.props.children);
    const breakpoint = (0, $fcQtu.useBreakpoint)("sm", "md");
    const classes = (0, $6a6f58ca6ec5fd07$var$_classnames.default)(`${prefix}modal-footer`, !renderBorder && `${prefix}modal-footer--borderless`, childrenArr.length === 2 && `${prefix}modal-footer--dual-action`, className);
    const buttons = childrenArr.map((item, i)=>{
        const clickHandlerWrapper = item.props.onClick ? (ev)=>item.props.onClick(ev, closeBtnClick) : ()=>closeBtnClick();
        return $6a6f58ca6ec5fd07$var$_react.default.cloneElement(item, {
            prefix: prefix,
            small: breakpoint === "sm",
            key: i,
            onClick: clickHandlerWrapper
        });
    });
    return $6a6f58ca6ec5fd07$var$_react.default.createElement("div", $6a6f58ca6ec5fd07$var$_extends({
        className: classes
    }, other), buttons);
};
$6a6f58ca6ec5fd07$var$ModalFooter.defaultProps = {
    prefix: "",
    renderBorder: false
};
var $6a6f58ca6ec5fd07$var$_default = $6a6f58ca6ec5fd07$var$ModalFooter;
module.exports.default = $6a6f58ca6ec5fd07$var$_default;

});
parcelRequire.register("dcraR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99c1799292c29375$var$_Button = $99c1799292c29375$var$_interopRequireDefault((parcelRequire("9SIMB")));
function $99c1799292c29375$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $99c1799292c29375$var$_default = $99c1799292c29375$var$_Button.default;
module.exports.default = $99c1799292c29375$var$_default;

});
parcelRequire.register("9SIMB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $heqSb = parcelRequire("heqSb");

var $731be52e17ecbb51$var$_react = $731be52e17ecbb51$var$_interopRequireWildcard((parcelRequire("2Jeaf")));

var $731be52e17ecbb51$var$_ssrIcon = $731be52e17ecbb51$var$_interopRequireDefault((parcelRequire("hjaGG")));

var $731be52e17ecbb51$var$_classnames = $731be52e17ecbb51$var$_interopRequireDefault((parcelRequire("grfkD")));

var $731be52e17ecbb51$var$_warningTriangle = $731be52e17ecbb51$var$_interopRequireDefault((parcelRequire("cdwKe")));
function $731be52e17ecbb51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $731be52e17ecbb51$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($731be52e17ecbb51$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $731be52e17ecbb51$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $731be52e17ecbb51$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $731be52e17ecbb51$var$_extends() {
    $731be52e17ecbb51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $731be52e17ecbb51$var$_extends.apply(this, arguments);
}
const $731be52e17ecbb51$var$inverseTypes = [
    "primary",
    "emphasised",
    "secondary",
    "tertiary"
];
const $731be52e17ecbb51$var$propTypes = {
    children: (0, $heqSb.oneOfType)([
        (0, $heqSb.arrayOf)($heqSb.node),
        $heqSb.node
    ]),
    className: $heqSb.string,
    disabled: $heqSb.bool,
    expanding: $heqSb.bool,
    fluid: $heqSb.bool,
    href: $heqSb.string,
    htmlType: $heqSb.string,
    iconOnly: $heqSb.bool,
    iconPosition: (0, $heqSb.oneOf)([
        "leading",
        "trailing"
    ]),
    inverseTheme: (props, propName, componentName)=>{
        if ($731be52e17ecbb51$var$inverseTypes.indexOf(props.type) === -1 && props.inverseTheme) return new Error(`The property: \'inverseTheme\' provided to Button is not applicable to the Button of the type \'${props.type}\'. Please remove it or set it to false`);
        return (0, $heqSb.checkPropTypes)({
            inverseTheme: $heqSb.bool
        }, props, "prop", componentName);
    },
    loading: $heqSb.bool,
    loadingSrText: (0, $heqSb.oneOfType)([
        $heqSb.string,
        $heqSb.element
    ]),
    newWindow: $heqSb.bool,
    onClick: $heqSb.func,
    prefix: $heqSb.string,
    small: $heqSb.bool,
    ssrIcon: $heqSb.func,
    text: (0, $heqSb.oneOfType)([
        $heqSb.string,
        $heqSb.element
    ]),
    type: (0, $heqSb.oneOf)([
        "primary",
        "emphasised",
        "secondary",
        "tertiary",
        "danger",
        "plain",
        "image-overlay"
    ]),
    xsmallIconOnly: $heqSb.bool,
    expandedOnTouchDevice: $heqSb.bool
};
const $731be52e17ecbb51$var$Button = (0, $731be52e17ecbb51$var$_react.forwardRef)((props, ref)=>{
    const { small: small, xsmallIconOnly: xsmallIconOnly, href: href, newWindow: newWindow, loadingSrText: loadingSrText, ssrIcon: ssrIcon, iconOnly: iconOnly, prefix: prefix, htmlType: htmlType, disabled: disabled, className: className, onClick: onClick, text: text, type: type, expanding: expanding, loading: loading, iconPosition: iconPosition, fluid: fluid, inverseTheme: inverseTheme, children: children, expandedOnTouchDevice: expandedOnTouchDevice, ...others } = props;
    function onKeyUpHandler(e) {
        if (disabled || loading || e.key !== " ") return true;
        e.target.click();
    }
    let btnType = type ? type : "secondary";
    if (iconOnly && ssrIcon) btnType = `icon-${btnType}`;
    if (inverseTheme && $731be52e17ecbb51$var$inverseTypes.indexOf(type) > -1) btnType = `${btnType}-inverse`;
    const innerClasses = (0, $731be52e17ecbb51$var$_classnames.default)(`${prefix}btn__inner`);
    let iconTag;
    const iconClass = `${prefix}btn__icon`;
    const icon = type === "danger" ? $731be52e17ecbb51$var$_warningTriangle.default : ssrIcon;
    if (icon) iconTag = $731be52e17ecbb51$var$_react.default.createElement($731be52e17ecbb51$var$_ssrIcon.default, {
        className: iconClass,
        prefix: prefix,
        paths: icon
    });
    const classes = (0, $731be52e17ecbb51$var$_classnames.default)(`${prefix}btn`, loading && `${prefix}btn--loading`, small && `${prefix}btn--small`, iconOnly && xsmallIconOnly && `${prefix}btn--xsmall`, !iconOnly && icon && iconPosition && `${prefix}${iconPosition}-icon`, type && `${prefix}btn--${btnType}`, fluid && !iconOnly && `${prefix}btn--fluid`, expanding && `${prefix}btn--expanding`, expanding && expandedOnTouchDevice && `${prefix}btn--touch-device-expanded`, className);
    const handleClick = (ev)=>{
        if (loading || disabled) {
            ev.stopPropagation();
            return;
        }
        if (onClick && typeof onClick === "function") onClick(ev);
    };
    const ButtonTag = href ? "a" : "button";
    const onKeyUp = ButtonTag === "a" ? onKeyUpHandler : null;
    const role = href ? "button" : null;
    const linkProps = {
        ...!disabled && {
            href: href
        },
        ...newWindow && {
            target: "_blank"
        }
    };
    const button = $731be52e17ecbb51$var$_react.default.createElement(ButtonTag, $731be52e17ecbb51$var$_extends({
        ref: ref,
        "aria-disabled": loading,
        type: !href ? htmlType : null,
        role: role,
        disabled: href ? null : disabled,
        className: classes,
        onClick: handleClick,
        onKeyUp: onKeyUp
    }, linkProps, others), $731be52e17ecbb51$var$_react.default.createElement("span", {
        className: innerClasses
    }, iconTag, text && $731be52e17ecbb51$var$_react.default.createElement("span", {
        className: `${prefix}btn__label`
    }, text), children, loading && $731be52e17ecbb51$var$_react.default.createElement("span", {
        className: `${prefix}btn__loader`
    }, loadingSrText)));
    return button;
});
$731be52e17ecbb51$var$Button.defaultProps = {
    disabled: false,
    htmlType: "button",
    type: "secondary",
    prefix: "",
    iconOnly: false,
    iconPosition: "leading",
    loadingSrText: "Loading…"
};
$731be52e17ecbb51$var$Button.propTypes = $731be52e17ecbb51$var$propTypes;
$731be52e17ecbb51$var$Button.displayName = "Button";
var $731be52e17ecbb51$var$_default = $731be52e17ecbb51$var$Button;
module.exports.default = $731be52e17ecbb51$var$_default;

});
parcelRequire.register("heqSb", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c8b896e207c32b9e$var$ReactIs, $c8b896e207c32b9e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("le1f6"))();

});

parcelRequire.register("hjaGG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c99c80545e3eb144$var$_SSRIcon = $c99c80545e3eb144$var$_interopRequireDefault((parcelRequire("e0kwq")));
function $c99c80545e3eb144$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c99c80545e3eb144$var$_default = $c99c80545e3eb144$var$_SSRIcon.default;
module.exports.default = $c99c80545e3eb144$var$_default;

});
parcelRequire.register("e0kwq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a320fc01afd09d17$var$_react = $a320fc01afd09d17$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $a320fc01afd09d17$var$_classnames = $a320fc01afd09d17$var$_interopRequireDefault((parcelRequire("grfkD")));
function $a320fc01afd09d17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a320fc01afd09d17$var$_extends() {
    $a320fc01afd09d17$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a320fc01afd09d17$var$_extends.apply(this, arguments);
}
const $a320fc01afd09d17$var$SSRIcon = (_ref)=>{
    let { prefix: prefix, viewBox: viewBox, paths: paths, className: className, modifier: modifier, alt: alt, ariaHidden: ariaHidden, ...otherProps } = _ref;
    const cssStyles = (0, $a320fc01afd09d17$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $a320fc01afd09d17$var$_react.default.createElement("svg", $a320fc01afd09d17$var$_extends({
        focusable: "false",
        viewBox: viewBox
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $a320fc01afd09d17$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
$a320fc01afd09d17$var$SSRIcon.defaultProps = {
    prefix: "",
    viewBox: "0 0 24 24",
    ariaHidden: true
};
var $a320fc01afd09d17$var$_default = $a320fc01afd09d17$var$SSRIcon;
module.exports.default = $a320fc01afd09d17$var$_default;

});


parcelRequire.register("cdwKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e501956230fd04a$var$_react = $8e501956230fd04a$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $8e501956230fd04a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8e501956230fd04a$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $8e501956230fd04a$var$_react.default.createElement("path", {
            d: "M11.0036 14.1337h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5597-1.25 1.25 0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25 0-.6903-.5597-1.25-1.25-1.25z"
        }),
        $8e501956230fd04a$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657zm2.5413-.5343h16.6873L12.0002 4.0308 3.6565 19.8837z"
        })
    ];
};
module.exports.default = $8e501956230fd04a$var$_default;

});



parcelRequire.register("fcQtu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "useBreakpoint", {
    enumerable: true,
    get: function() {
        return $b120ae63dac54b89$var$_useBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "useWindowSize", {
    enumerable: true,
    get: function() {
        return $b120ae63dac54b89$var$_useWindowSize.default;
    }
});

var $b120ae63dac54b89$var$_useBreakpoints = $b120ae63dac54b89$var$_interopRequireDefault((parcelRequire("6mSgB")));

var $b120ae63dac54b89$var$_useWindowSize = $b120ae63dac54b89$var$_interopRequireDefault((parcelRequire("aqt7L")));
function $b120ae63dac54b89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("6mSgB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mediaWidth = module.exports.default = void 0;

var $4a2ee4641ad869e9$var$_react = $4a2ee4641ad869e9$var$_interopRequireDefault((parcelRequire("2Jeaf")));

var $i7P1Y = parcelRequire("i7P1Y");
function $4a2ee4641ad869e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
if (!$i7P1Y.breakpointM || !$i7P1Y.breakpointL || !$i7P1Y.breakpointXl) throw Error("Undefined essential design tokens! Check breakpoint references at @ingka/variables");
const $4a2ee4641ad869e9$var$mediaRules = {};
const $4a2ee4641ad869e9$var$createRules = ()=>{
    if ($4a2ee4641ad869e9$var$mediaRules.small) return;
    $4a2ee4641ad869e9$var$mediaRules.small = window.matchMedia(`(min-width: ${$i7P1Y.breakpointM})`);
    $4a2ee4641ad869e9$var$mediaRules.medium = window.matchMedia(`(min-width: ${$i7P1Y.breakpointL})`);
    $4a2ee4641ad869e9$var$mediaRules.large = window.matchMedia(`(min-width: ${$i7P1Y.breakpointXl})`);
    $4a2ee4641ad869e9$var$mediaRules.all = [
        $4a2ee4641ad869e9$var$mediaRules.small,
        $4a2ee4641ad869e9$var$mediaRules.medium,
        $4a2ee4641ad869e9$var$mediaRules.large
    ];
};
const $4a2ee4641ad869e9$var$cleanUpOnDestroy = ()=>{
    $4a2ee4641ad869e9$var$mediaRules.all.length = 0;
    delete $4a2ee4641ad869e9$var$mediaRules.all;
    Object.keys($4a2ee4641ad869e9$var$mediaRules).map((key)=>delete $4a2ee4641ad869e9$var$mediaRules[key]);
};
const $4a2ee4641ad869e9$var$stateSetters = [];
const $4a2ee4641ad869e9$var$getMediaWidth = ()=>{
    let breakpoint;
    if ($4a2ee4641ad869e9$var$mediaRules.large.matches) breakpoint = $4a2ee4641ad869e9$var$mediaWidth.XLARGE;
    else if ($4a2ee4641ad869e9$var$mediaRules.medium.matches) breakpoint = $4a2ee4641ad869e9$var$mediaWidth.LARGE;
    else if ($4a2ee4641ad869e9$var$mediaRules.small.matches) breakpoint = $4a2ee4641ad869e9$var$mediaWidth.MEDIUM;
    else breakpoint = $4a2ee4641ad869e9$var$mediaWidth.SMALL;
    return breakpoint;
};
const $4a2ee4641ad869e9$var$bpIndex = (bp)=>$4a2ee4641ad869e9$var$breakpointsOrder.indexOf(bp);
const $4a2ee4641ad869e9$var$signalBreakpointChange = ()=>{
    let breakpoint = $4a2ee4641ad869e9$var$getMediaWidth();
    $4a2ee4641ad869e9$var$stateSetters.forEach((_ref)=>{
        let { current: { breakpointStateSetter: breakpointStateSetter, triggerPoints: triggerPoints } } = _ref;
        return breakpointStateSetter((previousBreakpoint)=>{
            if (triggerPoints.find((triggerpoint)=>$4a2ee4641ad869e9$var$bpIndex(previousBreakpoint) < $4a2ee4641ad869e9$var$bpIndex(triggerpoint) !== $4a2ee4641ad869e9$var$bpIndex(breakpoint) < $4a2ee4641ad869e9$var$bpIndex(triggerpoint))) return breakpoint;
            return previousBreakpoint;
        });
    });
};
const $4a2ee4641ad869e9$var$addBreakpointListeners = ()=>{
    $4a2ee4641ad869e9$var$mediaRules.all.forEach((rule)=>$4a2ee4641ad869e9$var$mediaRules.small.addEventListener ? rule.addEventListener("change", $4a2ee4641ad869e9$var$signalBreakpointChange) : rule.addListener($4a2ee4641ad869e9$var$signalBreakpointChange));
};
const $4a2ee4641ad869e9$var$removeBreakpointListeners = ()=>{
    $4a2ee4641ad869e9$var$mediaRules.all.forEach((rule)=>$4a2ee4641ad869e9$var$mediaRules.small.removeEventListener ? rule.removeEventListener("change", $4a2ee4641ad869e9$var$signalBreakpointChange) : rule.removeListener($4a2ee4641ad869e9$var$signalBreakpointChange));
};
const $4a2ee4641ad869e9$var$useBreakpoint = function() {
    for(var _len = arguments.length, triggerPoints = new Array(_len), _key = 0; _key < _len; _key++)triggerPoints[_key] = arguments[_key];
    const [currentBreakpoint, setCurrentBreakpoint] = $4a2ee4641ad869e9$var$_react.default.useState();
    const config = $4a2ee4641ad869e9$var$_react.default.useRef();
    $4a2ee4641ad869e9$var$_react.default.useEffect(()=>{
        config.current = {
            breakpointStateSetter: setCurrentBreakpoint,
            triggerPoints: triggerPoints
        };
        if (triggerPoints.length) {
            $4a2ee4641ad869e9$var$stateSetters.push(config);
            if ($4a2ee4641ad869e9$var$stateSetters.length === 1) {
                $4a2ee4641ad869e9$var$createRules();
                $4a2ee4641ad869e9$var$addBreakpointListeners();
            }
            setCurrentBreakpoint($4a2ee4641ad869e9$var$getMediaWidth());
        }
        return ()=>{
            if ($4a2ee4641ad869e9$var$stateSetters.indexOf(config) > -1) $4a2ee4641ad869e9$var$stateSetters.splice($4a2ee4641ad869e9$var$stateSetters.indexOf(config), 1);
            if ($4a2ee4641ad869e9$var$stateSetters.length === 0) {
                $4a2ee4641ad869e9$var$removeBreakpointListeners();
                $4a2ee4641ad869e9$var$cleanUpOnDestroy();
            }
        };
    }, triggerPoints);
    return currentBreakpoint;
};
const $4a2ee4641ad869e9$var$mediaWidth = {
    SMALL: "sm",
    MEDIUM: "md",
    LARGE: "lg",
    XLARGE: "xl"
};
module.exports.mediaWidth = $4a2ee4641ad869e9$var$mediaWidth;
const $4a2ee4641ad869e9$var$breakpointsOrder = [
    $4a2ee4641ad869e9$var$mediaWidth.SMALL,
    $4a2ee4641ad869e9$var$mediaWidth.MEDIUM,
    $4a2ee4641ad869e9$var$mediaWidth.LARGE,
    $4a2ee4641ad869e9$var$mediaWidth.XLARGE
];
var $4a2ee4641ad869e9$var$_default = $4a2ee4641ad869e9$var$useBreakpoint;
module.exports.default = $4a2ee4641ad869e9$var$_default;

});
parcelRequire.register("i7P1Y", function(module, exports) {

var $hS9E3 = parcelRequire("hS9E3");

var $23icq = parcelRequire("23icq");
var $d3207717496100d0$var$legacyTokens = {
    "$colour-ikea-coworker-blue": "#151e44",
    "$colour-ikea-coworker-yellow": "#ffcd3f",
    "$thickness-thick-rem": ".125rem",
    "$thickness-thin-rem": ".0625rem",
    "$body-line-height": "1.7142",
    "$body-line-height-s": "1.5",
    "$form-input-label-offset": "1.4375rem",
    "$form-input-label-size-default": "1rem",
    "$form-input-label-size-small": ".75rem",
    "$grid-max-width": "112rem",
    "$layer-1": "100",
    "$layer-2": "200",
    "$layer-3": "300",
    "$layer-4": "400"
};
function $d3207717496100d0$var$copyObject(source, target) {
    for(var i in source)if (Object.prototype.hasOwnProperty.call(source, i)) target[i] = source[i];
}
var $d3207717496100d0$var$mergedTokens = {};
$d3207717496100d0$var$copyObject($hS9E3, $d3207717496100d0$var$mergedTokens);
$d3207717496100d0$var$copyObject($d3207717496100d0$var$legacyTokens, $d3207717496100d0$var$mergedTokens);
$d3207717496100d0$var$copyObject($23icq, $d3207717496100d0$var$mergedTokens);
module.exports = $d3207717496100d0$var$mergedTokens;

});
parcelRequire.register("hS9E3", function(module, exports) {
// Do not make edits in this file!
// This file is automatically generated and any changes will be overwritten.
// To fetch new design tokens check the design-system/README.md
module.exports = {
    /**
  * 0.6875rem
  */ fontSize25: "0.6875rem",
    /**
  * 0.75rem
  */ fontSize50: "0.75rem",
    /**
  * 0.875rem
  */ fontSize75: "0.875rem",
    /**
  * 1rem
  */ fontSize100: "1rem",
    /**
  * 1.125rem
  */ fontSize200: "1.125rem",
    /**
  * 1.25rem
  */ fontSize300: "1.25rem",
    /**
  * 1.375rem
  */ fontSize400: "1.375rem",
    /**
  * 1.5rem
  */ fontSize500: "1.5rem",
    /**
  * 1.75rem
  */ fontSize600: "1.75rem",
    /**
  * 2rem
  */ fontSize700: "2rem",
    /**
  * 2.25rem
  */ fontSize800: "2.25rem",
    /**
  * 2.5rem
  */ fontSize900: "2.5rem",
    /**
  * 2.875rem
  */ fontSize1000: "2.875rem",
    /**
  * 3.125rem
  */ fontSize1100: "3.125rem",
    /**
  * 3.5rem
  */ fontSize1200: "3.5rem",
    /**
  * 4rem
  */ fontSize1300: "4rem",
    /**
  * 4.4375rem
  */ fontSize1400: "4.4375rem",
    /**
  * 5rem
  */ fontSize1500: "5rem",
    /**
  * 700
  */ fontWeightBold: 700,
    /**
  * 400
  */ fontWeightRegular: 400,
    /**
  * 1px
  */ thicknessThin: "1px",
    /**
  * 2px
  */ thicknessThick: "2px",
    /**
  * 0px
  */ radiusNone: "0px",
    /**
  * 4px
  */ radiusS: "4px",
    /**
  * 8px
  */ radiusM: "8px",
    /**
  * 12px
  */ radiusL: "12px",
    /**
  * 20px
  */ radiusXl: "20px",
    /**
  * 64px
  */ radiusCap: "64px",
    /**
  * 0.25rem
  */ space25: "0.25rem",
    /**
  * 0.5rem
  */ space50: "0.5rem",
    /**
  * 0.75rem
  */ space75: "0.75rem",
    /**
  * 1rem
  */ space100: "1rem",
    /**
  * 1.25rem
  */ space125: "1.25rem",
    /**
  * 1.5rem
  */ space150: "1.5rem",
    /**
  * 2rem
  */ space200: "2rem",
    /**
  * 2.5rem
  */ space250: "2.5rem",
    /**
  * 3rem
  */ space300: "3rem",
    /**
  * 4rem
  */ space400: "4rem",
    /**
  * 5.5rem
  */ space550: "5.5rem",
    /**
  * 7.5rem
  */ space750: "7.5rem",
    /**
  * 10rem
  */ space1000: "10rem",
    /**
  * 13.5rem
  */ space1350: "13.5rem",
    /**
  * 0px 4px 16px rgba(0, 0, 0, 0.1)
  */ shadowSizeDefault: "0px 4px 16px rgba(0, 0, 0, 0.1)",
    /**
  * 800ms
  */ durationSlowXlScreen: "800ms",
    /**
  * 400ms
  */ durationSlowMobileNative: "400ms",
    /**
  * 250ms
  */ durationSlowWeb: "250ms",
    /**
  * 600ms
  */ durationStandardXlScreen: "600ms",
    /**
  * 300ms
  */ durationStandardMobileNative: "300ms",
    /**
  * 200ms
  */ durationStandardWeb: "200ms",
    /**
  * 300ms
  */ durationQuickXlScreen: "300ms",
    /**
  * 150ms
  */ durationQuickMobileNative: "150ms",
    /**
  * 100ms
  */ durationQuickWeb: "100ms",
    /**
  * 0
  */ durationInstantXlScreen: 0,
    /**
  * 0
  */ durationInstantMobileNative: 0,
    /**
  * 0
  */ durationInstantWeb: 0,
    /**
  * cubic-bezier(0,0,1,1)
  */ easeLinear: "cubic-bezier(0,0,1,1)",
    /**
  * cubic-bezier(0.45, 1.45, 0.65, 1.0)
  */ easeBob: "cubic-bezier(0.45, 1.45, 0.65, 1.0)",
    /**
  * cubic-bezier(0.9, 0.0, 1.0, 1.0)
  */ easeExit: "cubic-bezier(0.9, 0.0, 1.0, 1.0)",
    /**
  * cubic-bezier(0.0, 0.0, 0.1, 1.0)
  */ easeEnter: "cubic-bezier(0.0, 0.0, 0.1, 1.0)",
    /**
  * cubic-bezier(0.8, 0.0, 0.0, 1.0)
  */ easeExpressive: "cubic-bezier(0.8, 0.0, 0.0, 1.0)",
    /**
  * cubic-bezier(0.4, 0.0, 0.4, 1.0)
  */ easeEasy: "cubic-bezier(0.4, 0.0, 0.4, 1.0)",
    /**
  * 150ms
  */ delayEmphasised: "150ms",
    /**
  * 100ms
  */ delayStandard: "100ms",
    /**
  * 33ms
  */ delayTight: "33ms",
    /**
  * 75em
  */ breakpointXl: "75em",
    /**
  * 56.25em
  */ breakpointL: "56.25em",
    /**
  * 37.5em
  */ breakpointM: "37.5em",
    /**
  * 1.450
  */ lineHeight25Short: "1.450",
    /**
  * 1.450
  */ lineHeight25Long: "1.450",
    /**
  * 1.500
  */ lineHeight50Short: "1.500",
    /**
  * 1.500
  */ lineHeight50Long: "1.500",
    /**
  * 1.571
  */ lineHeight75Short: "1.571",
    /**
  * 1.571
  */ lineHeight75Long: "1.571",
    /**
  * 1.500
  */ lineHeight100Short: "1.500",
    /**
  * 1.625
  */ lineHeight100Long: "1.625",
    /**
  * 1.444
  */ lineHeight200Short: "1.444",
    /**
  * 1.555
  */ lineHeight200Long: "1.555",
    /**
  * 1.400
  */ lineHeight300Short: "1.400",
    /**
  * 1.600
  */ lineHeight300Long: "1.600",
    /**
  * 1.364
  */ lineHeight400Short: "1.364",
    /**
  * 1.545
  */ lineHeight400Long: "1.545",
    /**
  * 1.450
  */ lineHeight500Short: "1.450",
    /**
  * 1.670
  */ lineHeight500Long: "1.670",
    /**
  * 1.357
  */ lineHeight600Short: "1.357",
    /**
  * 1.570
  */ lineHeight600Long: "1.570",
    /**
  * 1.375
  */ lineHeight700Short: "1.375",
    /**
  * 1.500
  */ lineHeight700Long: "1.500",
    /**
  * 1.333
  */ lineHeight800Short: "1.333",
    /**
  * 1.500
  */ lineHeight800Long: "1.500",
    /**
  * 1.300
  */ lineHeight900Short: "1.300",
    /**
  * 1.500
  */ lineHeight900Long: "1.500",
    /**
  * 1.300
  */ lineHeight1000Short: "1.300",
    /**
  * 1.460
  */ lineHeight1000Long: "1.460",
    /**
  * 1.300
  */ lineHeight1500Short: "1.300",
    /**
  * 1.500
  */ lineHeight1500Long: "1.500",
    /**
  * 1.280
  */ lineHeight1400Short: "1.280",
    /**
  * 1.500
  */ lineHeight1400Long: "1.500",
    /**
  * 1.300
  */ lineHeight1300Short: "1.300",
    /**
  * 1.500
  */ lineHeight1300Long: "1.500",
    /**
  * 1.357
  */ lineHeight1200Short: "1.357",
    /**
  * 1.500
  */ lineHeight1200Long: "1.500",
    /**
  * 1.320
  */ lineHeight1100Short: "1.320",
    /**
  * 1.520
  */ lineHeight1100Long: "1.520",
    /**
  * 0em
  */ letterSpacing25: "0em",
    /**
  * 0em
  */ letterSpacing50: "0em",
    /**
  * 0em
  */ letterSpacing75: "0em",
    /**
  * 0em
  */ letterSpacing100: "0em",
    /**
  * 0em
  */ letterSpacing200: "0em",
    /**
  * 0em
  */ letterSpacing300: "0em",
    /**
  * -0.0039em
  */ letterSpacing400: "-0.0039em",
    /**
  * -0.0042em
  */ letterSpacing500: "-0.0042em",
    /**
  * -0.0049em
  */ letterSpacing600: "-0.0049em",
    /**
  * -0.0056em
  */ letterSpacing700: "-0.0056em",
    /**
  * -0.0063em
  */ letterSpacing800: "-0.0063em",
    /**
  * -0.007em
  */ letterSpacing900: "-0.007em",
    /**
  * -0.0078em
  */ letterSpacing1000: "-0.0078em",
    /**
  * -0.0087em
  */ letterSpacing1100: "-0.0087em",
    /**
  * -0.0098em
  */ letterSpacing1200: "-0.0098em",
    /**
  * -0.011em
  */ letterSpacing1300: "-0.011em",
    /**
  * -0.0124em
  */ letterSpacing1400: "-0.0124em",
    /**
  * -0.014em
  */ letterSpacing1500: "-0.014em"
};

});

parcelRequire.register("23icq", function(module, exports) {
module.exports = {};

});



parcelRequire.register("aqt7L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7972ec93376ce8a4$var$_react = $7972ec93376ce8a4$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $7972ec93376ce8a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7972ec93376ce8a4$var$getClientSize = ()=>({
        w: window.innerWidth,
        h: window.innerHeight
    });
const $7972ec93376ce8a4$var$resizeListeners = [];
let $7972ec93376ce8a4$var$debounceID;
const $7972ec93376ce8a4$var$debouncedUpdate = ()=>{
    clearTimeout($7972ec93376ce8a4$var$debounceID);
    $7972ec93376ce8a4$var$debounceID = setTimeout(()=>{
        const clientSize = $7972ec93376ce8a4$var$getClientSize();
        $7972ec93376ce8a4$var$resizeListeners.forEach((setter)=>setter(clientSize));
    }, 40);
};
const $7972ec93376ce8a4$var$addResizeListener = ()=>{
    $7972ec93376ce8a4$var$removeResizeListener();
    window.addEventListener("resize", $7972ec93376ce8a4$var$debouncedUpdate);
};
const $7972ec93376ce8a4$var$removeResizeListener = ()=>{
    clearTimeout($7972ec93376ce8a4$var$debouncedUpdate);
    window.removeEventListener("resize", $7972ec93376ce8a4$var$debouncedUpdate);
};
const $7972ec93376ce8a4$var$useWindowSize = (listen)=>{
    const [clientSize, setClientSize] = $7972ec93376ce8a4$var$_react.default.useState(listen && typeof window !== "undefined" && $7972ec93376ce8a4$var$getClientSize());
    $7972ec93376ce8a4$var$_react.default.useEffect(()=>{
        if (listen) {
            $7972ec93376ce8a4$var$resizeListeners.push(setClientSize);
            if ($7972ec93376ce8a4$var$resizeListeners.length === 1) $7972ec93376ce8a4$var$addResizeListener();
        }
        return ()=>{
            let index = $7972ec93376ce8a4$var$resizeListeners.indexOf(setClientSize);
            if (index > -1) $7972ec93376ce8a4$var$resizeListeners.splice(index, 1);
            if ($7972ec93376ce8a4$var$resizeListeners.length === 0) $7972ec93376ce8a4$var$removeResizeListener();
        };
    }, [
        listen
    ]);
    return clientSize;
};
var $7972ec93376ce8a4$var$_default = $7972ec93376ce8a4$var$useWindowSize;
module.exports.default = $7972ec93376ce8a4$var$_default;

});



parcelRequire.register("b0eip", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $802ac8ac731684c8$var$_react = $802ac8ac731684c8$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $802ac8ac731684c8$var$_classnames = $802ac8ac731684c8$var$_interopRequireDefault((parcelRequire("grfkD")));

var $802ac8ac731684c8$var$_button = $802ac8ac731684c8$var$_interopRequireDefault((parcelRequire("dcraR")));

var $802ac8ac731684c8$var$_cross = $802ac8ac731684c8$var$_interopRequireDefault((parcelRequire("6DP6z")));

var $802ac8ac731684c8$var$_arrowLeft = $802ac8ac731684c8$var$_interopRequireDefault((parcelRequire("icMxZ")));
function $802ac8ac731684c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $802ac8ac731684c8$var$_extends() {
    $802ac8ac731684c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $802ac8ac731684c8$var$_extends.apply(this, arguments);
}
const $802ac8ac731684c8$var$ModalHeader = (props)=>{
    const { title: title, titleId: titleId, prefix: prefix, className: className, closeBtnClick: closeBtnClick, ariaCloseTxt: ariaCloseTxt, backBtnClick: backBtnClick, ariaBackBtnTxt: ariaBackBtnTxt, floating: floating, ...other } = props;
    const wrapperClasses = (0, $802ac8ac731684c8$var$_classnames.default)(`${prefix}modal-header__title-wrapper`, !backBtnClick && `${prefix}modal-header__title-wrapper--padded`);
    const headerClasses = (0, $802ac8ac731684c8$var$_classnames.default)(`${prefix}modal-header`, floating && `${prefix}modal-header--floating-header`, className);
    return $802ac8ac731684c8$var$_react.default.createElement("div", $802ac8ac731684c8$var$_extends({
        className: headerClasses
    }, other), $802ac8ac731684c8$var$_react.default.createElement($802ac8ac731684c8$var$_button.default, {
        prefix: prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: $802ac8ac731684c8$var$_cross.default,
        onClick: closeBtnClick,
        className: `${prefix}modal-header__close`,
        "aria-label": ariaCloseTxt
    }), !floating && title && $802ac8ac731684c8$var$_react.default.createElement("div", {
        className: wrapperClasses
    }, $802ac8ac731684c8$var$_react.default.createElement("span", {
        id: titleId,
        className: `${prefix}modal-header__title`
    }, title)), backBtnClick && $802ac8ac731684c8$var$_react.default.createElement($802ac8ac731684c8$var$_button.default, {
        prefix: prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: $802ac8ac731684c8$var$_arrowLeft.default,
        onClick: backBtnClick,
        className: `${prefix}modal-header__back-button`,
        "aria-label": ariaBackBtnTxt
    }));
};
$802ac8ac731684c8$var$ModalHeader.defaultProps = {
    prefix: "",
    floating: false,
    ariaBackBtnTxt: "Back",
    ariaCloseTxt: "Close"
};
var $802ac8ac731684c8$var$_default = $802ac8ac731684c8$var$ModalHeader;
module.exports.default = $802ac8ac731684c8$var$_default;

});
parcelRequire.register("6DP6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d5e06f5dd095874$var$_react = $4d5e06f5dd095874$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $4d5e06f5dd095874$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d5e06f5dd095874$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $4d5e06f5dd095874$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m11.9997 13.4149 4.9498 4.9497 1.4142-1.4142-4.9498-4.9497 4.9498-4.9498-1.4142-1.4142-4.9498 4.9498L7.05 5.6367 5.6357 7.051l4.9498 4.9498-4.9497 4.9497L7.05 18.3646l4.9497-4.9497z"
        })
    ];
};
module.exports.default = $4d5e06f5dd095874$var$_default;

});

parcelRequire.register("icMxZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d40f0179b68540d9$var$_react = $d40f0179b68540d9$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $d40f0179b68540d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d40f0179b68540d9$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $d40f0179b68540d9$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m3.999 11.9997 8 8.0011 1.4143-1.4141-5.5859-5.5866H20v-2H7.8273l5.5871-5.5868-1.4142-1.4143-8.0012 8.0007z"
        })
    ];
};
module.exports.default = $d40f0179b68540d9$var$_default;

});


parcelRequire.register("foFt4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3594395c8029253$var$_react = $b3594395c8029253$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $b3594395c8029253$var$_classnames = $b3594395c8029253$var$_interopRequireDefault((parcelRequire("grfkD")));
function $b3594395c8029253$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3594395c8029253$var$_extends() {
    $b3594395c8029253$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b3594395c8029253$var$_extends.apply(this, arguments);
}
const $b3594395c8029253$var$ModalBody = (_ref)=>{
    let { prefix: prefix, children: children, className: className, ...other } = _ref;
    return $b3594395c8029253$var$_react.default.createElement("div", $b3594395c8029253$var$_extends({}, other, {
        className: (0, $b3594395c8029253$var$_classnames.default)(`${prefix}modal-body`, className)
    }), children);
};
$b3594395c8029253$var$ModalBody.defaultProps = {
    prefix: ""
};
var $b3594395c8029253$var$_default = $b3594395c8029253$var$ModalBody;
module.exports.default = $b3594395c8029253$var$_default;

});

parcelRequire.register("2eefu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $19f7f11fd81a686c$var$_react = $19f7f11fd81a686c$var$_interopRequireDefault((parcelRequire("2Jeaf")));

var $19f7f11fd81a686c$var$_classnames = $19f7f11fd81a686c$var$_interopRequireDefault((parcelRequire("grfkD")));

var $19f7f11fd81a686c$var$_headerPropTypeValidation = $19f7f11fd81a686c$var$_interopRequireDefault((parcelRequire("94aES")));

var $19f7f11fd81a686c$var$_AutoFocusOnMount = $19f7f11fd81a686c$var$_interopRequireDefault((parcelRequire("7wTkD")));
function $19f7f11fd81a686c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19f7f11fd81a686c$var$_extends() {
    $19f7f11fd81a686c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19f7f11fd81a686c$var$_extends.apply(this, arguments);
}
const $19f7f11fd81a686c$var$Sheets = (_ref)=>{
    let { className: className, fullSize: fullSize, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, header: header, alignment: alignment, preserveAlignment: preserveAlignment, footer: footer, size: size, describedById: describedById, labelledById: labelledById, ariaLabel: ariaLabel, ...other } = _ref;
    const classes = (0, $19f7f11fd81a686c$var$_classnames.default)(`${prefix}sheets`, `${prefix}sheets--${size}`, fullSize && `${prefix}sheets--mobile-full-size`, alignment === "left" && `${prefix}sheets--mirrored`, preserveAlignment && `${prefix}sheets--preserve-alignment`, open ? `${prefix}sheets--enter` : `${prefix}sheets--close`, className);
    const hookedHeader = header ? $19f7f11fd81a686c$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix
    }) : null;
    const hookedFooter = footer && $19f7f11fd81a686c$var$_react.default.cloneElement(footer, {
        prefix: prefix,
        closeBtnClick: closeBtnClick
    }) || null;
    const hookedBody = $19f7f11fd81a686c$var$_react.default.Children.map(children, (child)=>child.props ? $19f7f11fd81a686c$var$_react.default.cloneElement(child, {
            prefix: prefix
        }) : child);
    const [wrapperFocus, contentRef] = (0, $19f7f11fd81a686c$var$_AutoFocusOnMount.default)();
    return $19f7f11fd81a686c$var$_react.default.createElement("div", $19f7f11fd81a686c$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": labelledById,
        "aria-label": ariaLabel
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), hookedHeader && !hookedHeader.props.floating && hookedHeader, $19f7f11fd81a686c$var$_react.default.createElement("div", {
        className: `${prefix}sheets__content-wrapper`,
        role: "document",
        tabIndex: "0",
        ref: contentRef,
        "data-autofocus": wrapperFocus
    }, $19f7f11fd81a686c$var$_react.default.createElement("div", null, " ", hookedHeader && hookedHeader.props.floating && hookedHeader, hookedBody)), hookedFooter);
};
$19f7f11fd81a686c$var$Sheets.defaultProps = {
    open: false,
    prefix: "",
    size: "small",
    alignment: "right",
    preserveAlignment: false
};
var $19f7f11fd81a686c$var$_default = $19f7f11fd81a686c$var$Sheets;
module.exports.default = $19f7f11fd81a686c$var$_default;

});
parcelRequire.register("94aES", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $heqSb = parcelRequire("heqSb");

var $9CtqL = parcelRequire("9CtqL");
const $699cc14584778536$var$headerPropTypeValidation = (props, propName, componentName)=>{
    if (props[propName] !== null && [
        $9CtqL.ModalHeader
    ].indexOf(props[propName]?.type) < 0) return new Error("header propType only accepts ModalHeader component instance or null. If null is provided, additional CSS must be added to ensure a minimum top-padding for the content.");
    return (0, $heqSb.checkPropTypes)({
        header: (0, $heqSb.oneOfType)([
            (0, $heqSb.oneOf)([
                null
            ]).isRequired,
            $heqSb.node
        ])
    }, props, "prop", componentName);
};
var $699cc14584778536$var$_default = $699cc14584778536$var$headerPropTypeValidation;
module.exports.default = $699cc14584778536$var$_default;

});
parcelRequire.register("9CtqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ModalBody", {
    enumerable: true,
    get: function() {
        return $6aXDC.ModalBody;
    }
});
Object.defineProperty(module.exports, "ModalFooter", {
    enumerable: true,
    get: function() {
        return $6aXDC.ModalFooter;
    }
});
Object.defineProperty(module.exports, "ModalHeader", {
    enumerable: true,
    get: function() {
        return $6aXDC.ModalHeader;
    }
});
Object.defineProperty(module.exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $b2qPy.Prompt;
    }
});
Object.defineProperty(module.exports, "Sheets", {
    enumerable: true,
    get: function() {
        return $b2qPy.Sheets;
    }
});
Object.defineProperty(module.exports, "Theatre", {
    enumerable: true,
    get: function() {
        return $b2qPy.Theatre;
    }
});
module.exports.default = void 0;

var $6aXDC = parcelRequire("6aXDC");

var $b2qPy = parcelRequire("b2qPy");

var $700e7dfe8f90c45a$var$_Modal = $700e7dfe8f90c45a$var$_interopRequireDefault((parcelRequire("gWDRY")));
function $700e7dfe8f90c45a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $700e7dfe8f90c45a$var$_default = $700e7dfe8f90c45a$var$_Modal.default;
module.exports.default = $700e7dfe8f90c45a$var$_default;

});
parcelRequire.register("6aXDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "ModalBody", {
    enumerable: true,
    get: function() {
        return $47f1f0203164cfee$var$_ModalBody.default;
    }
});
Object.defineProperty(module.exports, "ModalFooter", {
    enumerable: true,
    get: function() {
        return $47f1f0203164cfee$var$_Footer.default;
    }
});
Object.defineProperty(module.exports, "ModalHeader", {
    enumerable: true,
    get: function() {
        return $47f1f0203164cfee$var$_Header.default;
    }
});

var $47f1f0203164cfee$var$_Footer = $47f1f0203164cfee$var$_interopRequireDefault((parcelRequire("98y91")));

var $47f1f0203164cfee$var$_Header = $47f1f0203164cfee$var$_interopRequireDefault((parcelRequire("b0eip")));

var $47f1f0203164cfee$var$_ModalBody = $47f1f0203164cfee$var$_interopRequireDefault((parcelRequire("foFt4")));
function $47f1f0203164cfee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRequire.register("b2qPy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $8094b197483ddc91$var$_Prompt.default;
    }
});
Object.defineProperty(module.exports, "Sheets", {
    enumerable: true,
    get: function() {
        return $8094b197483ddc91$var$_Sheets.default;
    }
});
Object.defineProperty(module.exports, "Theatre", {
    enumerable: true,
    get: function() {
        return $8094b197483ddc91$var$_Theatre.default;
    }
});

var $8094b197483ddc91$var$_Sheets = $8094b197483ddc91$var$_interopRequireDefault((parcelRequire("2eefu")));

var $8094b197483ddc91$var$_Prompt = $8094b197483ddc91$var$_interopRequireDefault((parcelRequire("8YT8X")));

var $8094b197483ddc91$var$_Theatre = $8094b197483ddc91$var$_interopRequireDefault((parcelRequire("4whqW")));
function $8094b197483ddc91$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("8YT8X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $689eb3a6f3864ed7$var$_react = $689eb3a6f3864ed7$var$_interopRequireDefault((parcelRequire("2Jeaf")));

var $689eb3a6f3864ed7$var$_classnames = $689eb3a6f3864ed7$var$_interopRequireDefault((parcelRequire("grfkD")));

var $689eb3a6f3864ed7$var$_headerPropTypeValidation = $689eb3a6f3864ed7$var$_interopRequireDefault((parcelRequire("94aES")));

var $689eb3a6f3864ed7$var$_AutoFocusOnMount = $689eb3a6f3864ed7$var$_interopRequireDefault((parcelRequire("7wTkD")));
function $689eb3a6f3864ed7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $689eb3a6f3864ed7$var$_extends() {
    $689eb3a6f3864ed7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $689eb3a6f3864ed7$var$_extends.apply(this, arguments);
}
const $689eb3a6f3864ed7$var$Prompt = (_ref)=>{
    let { className: className, titleId: titleId, header: header, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, title: title, footer: footer, describedById: describedById, ...other } = _ref;
    const classes = (0, $689eb3a6f3864ed7$var$_classnames.default)(`${prefix}prompt`, open ? `${prefix}prompt--enter` : `${prefix}prompt--close`, className);
    const hookedHeader = header ? $689eb3a6f3864ed7$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix,
        backBtnClick: null
    }) : null;
    const hookedFooter = footer && $689eb3a6f3864ed7$var$_react.default.cloneElement(footer, {
        prefix: prefix,
        closeBtnClick: closeBtnClick
    }) || null;
    const [wrapperFocus, contentRef] = (0, $689eb3a6f3864ed7$var$_AutoFocusOnMount.default)();
    return $689eb3a6f3864ed7$var$_react.default.createElement("div", $689eb3a6f3864ed7$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": titleId
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), hookedHeader, $689eb3a6f3864ed7$var$_react.default.createElement("div", {
        className: `${prefix}prompt__content-wrapper`
    }, $689eb3a6f3864ed7$var$_react.default.createElement("div", {
        ref: contentRef,
        "data-autofocus": wrapperFocus,
        tabIndex: "0",
        role: "document",
        className: `${prefix}prompt__content`
    }, $689eb3a6f3864ed7$var$_react.default.createElement("h2", {
        id: titleId,
        className: `${prefix}prompt__heading`
    }, title), children), hookedFooter));
};
$689eb3a6f3864ed7$var$Prompt.defaultProps = {
    open: false,
    prefix: ""
};
var $689eb3a6f3864ed7$var$_default = $689eb3a6f3864ed7$var$Prompt;
module.exports.default = $689eb3a6f3864ed7$var$_default;

});
parcelRequire.register("7wTkD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");

var $57b67150dcfbb359$var$_ShouldAutoFocus = $57b67150dcfbb359$var$_interopRequireDefault((parcelRequire("lI2zu")));
function $57b67150dcfbb359$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $57b67150dcfbb359$var$AutoFocusOnMount = ()=>{
    const contentRef = (0, $iJ7ah.useRef)(null);
    const [wrapperFocus, setWrapperFocus] = (0, $iJ7ah.useState)(undefined);
    (0, $iJ7ah.useEffect)(()=>{
        if (contentRef.current) {
            const wrapper = contentRef.current;
            setWrapperFocus((0, $57b67150dcfbb359$var$_ShouldAutoFocus.default)(wrapper));
        }
    }, []);
    return [
        wrapperFocus,
        contentRef
    ];
};
var $57b67150dcfbb359$var$_default = $57b67150dcfbb359$var$AutoFocusOnMount;
module.exports.default = $57b67150dcfbb359$var$_default;

});
parcelRequire.register("lI2zu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $fcdfb3a94a148d0e$var$ShouldAutoFocus = (refElement)=>{
    if (!refElement) return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll("*[data-autofocus],*[autofocus]").length);
    return !autoFocusSet;
};
module.exports.default = $fcdfb3a94a148d0e$var$ShouldAutoFocus;

});



parcelRequire.register("4whqW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $34a7ac82861f6528$var$_react = $34a7ac82861f6528$var$_interopRequireDefault((parcelRequire("2Jeaf")));

var $34a7ac82861f6528$var$_classnames = $34a7ac82861f6528$var$_interopRequireDefault((parcelRequire("grfkD")));

var $34a7ac82861f6528$var$_headerPropTypeValidation = $34a7ac82861f6528$var$_interopRequireDefault((parcelRequire("94aES")));
function $34a7ac82861f6528$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34a7ac82861f6528$var$_extends() {
    $34a7ac82861f6528$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34a7ac82861f6528$var$_extends.apply(this, arguments);
}
const $34a7ac82861f6528$var$Theatre = (_ref)=>{
    let { className: className, prefix: prefix, children: children, open: open, closeBtnClick: closeBtnClick, header: header, labelledById: labelledById, describedById: describedById, ariaLabel: ariaLabel, ...other } = _ref;
    const classes = (0, $34a7ac82861f6528$var$_classnames.default)(`${prefix}theatre`, open ? `${prefix}theatre--enter` : `${prefix}theatre--close`, className);
    const hookedHeader = header ? $34a7ac82861f6528$var$_react.default.cloneElement(header, {
        closeBtnClick: closeBtnClick,
        prefix: prefix
    }) : null;
    const hookedBody = $34a7ac82861f6528$var$_react.default.Children.map(children, (child)=>child.props ? $34a7ac82861f6528$var$_react.default.cloneElement(child, {
            prefix: prefix
        }) : child);
    return $34a7ac82861f6528$var$_react.default.createElement("div", $34a7ac82861f6528$var$_extends({
        "aria-describedby": describedById,
        "aria-labelledby": labelledById,
        "aria-label": ariaLabel
    }, other, {
        className: classes,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: "-1"
    }), $34a7ac82861f6528$var$_react.default.createElement("div", {
        className: `${prefix}theatre__content-wrapper`
    }, hookedHeader, hookedBody));
};
$34a7ac82861f6528$var$Theatre.defaultProps = {
    open: false,
    prefix: ""
};
var $34a7ac82861f6528$var$_default = $34a7ac82861f6528$var$Theatre;
module.exports.default = $34a7ac82861f6528$var$_default;

});


parcelRequire.register("gWDRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $c560fd629d80bb93$var$_react = $c560fd629d80bb93$var$_interopRequireWildcard((parcelRequire("2Jeaf")));

var $c560fd629d80bb93$var$_reactFocusLock = $c560fd629d80bb93$var$_interopRequireDefault((parcelRequire("kfJyy")));

var $c560fd629d80bb93$var$_classnames = $c560fd629d80bb93$var$_interopRequireDefault((parcelRequire("grfkD")));

var $hTItt = parcelRequire("hTItt");
function $c560fd629d80bb93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c560fd629d80bb93$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c560fd629d80bb93$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c560fd629d80bb93$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c560fd629d80bb93$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c560fd629d80bb93$var$_extends() {
    $c560fd629d80bb93$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c560fd629d80bb93$var$_extends.apply(this, arguments);
}
const $c560fd629d80bb93$var$modalTypes = [
    "Sheets",
    "Prompt",
    "Theatre"
];
const $c560fd629d80bb93$var$elx = function() {
    for(var _len = arguments.length, listeners = new Array(_len), _key = 0; _key < _len; _key++)listeners[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return listeners.map((l)=>l && l(...args));
    };
};
const $c560fd629d80bb93$var$Modal = (_ref)=>{
    let { className: className, visible: visible, prefix: prefix, children: children, handleCloseBtn: handleCloseBtn, focusLockProps: focusLockProps, keepContentMounted: keepContentMounted, escapable: escapable, onModalClosed: onModalClosed, onModalOpened: onModalOpened, scrollLock: scrollLock, ...other } = _ref;
    const [isOpen, setIsOpen] = $c560fd629d80bb93$var$_react.default.useState(visible);
    const [animationMountHelper, setAnimationMountHelper] = $c560fd629d80bb93$var$_react.default.useState(false);
    const animationFrameRef = $c560fd629d80bb93$var$_react.default.useRef(-1);
    const baseClass = `${prefix}modal-wrapper`;
    (0, $c560fd629d80bb93$var$_react.useEffect)(()=>{
        (0, $hTItt.onVisibleChanged)(prefix, visible, scrollLock, isOpen, setIsOpen, setAnimationMountHelper);
    }, [
        visible
    ]);
    (0, $c560fd629d80bb93$var$_react.useEffect)(()=>{
        if (visible) (0, $hTItt.enter)(setIsOpen, scrollLock, prefix);
        return ()=>{
            if (scrollLock) (0, $hTItt.releaseBody)(prefix);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []);
    const overlayStyle = (0, $c560fd629d80bb93$var$_classnames.default)(baseClass, isOpen ? `${baseClass}--open` : `${baseClass}--close`, className);
    const backdropStyle = (0, $c560fd629d80bb93$var$_classnames.default)(`${baseClass}__backdrop`, `${baseClass}__backdrop--dark`);
    const hookedModal = $c560fd629d80bb93$var$_react.default.Children.map(children, (child)=>$c560fd629d80bb93$var$_react.default.cloneElement(child, {
            open: isOpen,
            closeBtnClick: handleCloseBtn,
            prefix: prefix
        }));
    return $c560fd629d80bb93$var$_react.default.createElement("div", $c560fd629d80bb93$var$_extends({}, other, {
        onKeyDown: (e)=>{
            $c560fd629d80bb93$var$elx(other.onKeyDown, (0, $hTItt.escFunction)(e, baseClass, escapable, handleCloseBtn, setIsOpen, setAnimationMountHelper));
        },
        className: overlayStyle,
        tabIndex: "-1"
    }), $c560fd629d80bb93$var$_react.default.createElement("div", {
        className: backdropStyle,
        onMouseDown: (e)=>{
            (0, $hTItt.onBackdropClick)(e, escapable, handleCloseBtn);
        },
        onAnimationEnd: (e)=>{
            (0, $hTItt.handleAnimationEnd)(e, animationFrameRef.current, isOpen, onModalOpened, onModalClosed, scrollLock, animationMountHelper, setAnimationMountHelper, prefix);
        }
    }), (keepContentMounted || isOpen || animationMountHelper) && $c560fd629d80bb93$var$_react.default.createElement($c560fd629d80bb93$var$_reactFocusLock.default, $c560fd629d80bb93$var$_extends({
        returnFocus: true,
        autoFocus: true
    }, focusLockProps, {
        children: hookedModal
    })));
};
$c560fd629d80bb93$var$Modal.defaultProps = {
    prefix: "",
    focusLockProps: {},
    keepContentMounted: false,
    escapable: true,
    scrollLock: true
};
var $c560fd629d80bb93$var$_default = $c560fd629d80bb93$var$Modal;
module.exports.default = $c560fd629d80bb93$var$_default;

});
parcelRequire.register("kfJyy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ebe88be833995a6a$export$2e2bcd8739ae039);

var $fEZw3 = parcelRequire("fEZw3");

var $jTbuX = parcelRequire("jTbuX");
var $ebe88be833995a6a$export$2e2bcd8739ae039 = (0, $fEZw3.default);
$parcel$exportWildcard(module.exports, $jTbuX);

});
parcelRequire.register("fEZw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b66a4f3c5703a3ad$export$2e2bcd8739ae039);

var $1QKw9 = parcelRequire("1QKw9");

var $bX8Xg = parcelRequire("bX8Xg");

var $2Jeaf = parcelRequire("2Jeaf");
var $joJRn = parcelRequire("joJRn");

var $8Qimm = parcelRequire("8Qimm");

var $fJF4Y = parcelRequire("fJF4Y");
/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/ var $b66a4f3c5703a3ad$var$FocusLockCombination = /*#__PURE__*/ $2Jeaf.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $joJRn.createElement((0, $8Qimm.default), (0, $bX8Xg.default)({
        sideCar: (0, $fJF4Y.default),
        ref: ref
    }, props));
});
var $b66a4f3c5703a3ad$var$_ref = (0, $8Qimm.default).propTypes || {}, $b66a4f3c5703a3ad$var$sideCar = $b66a4f3c5703a3ad$var$_ref.sideCar, $b66a4f3c5703a3ad$var$propTypes = (0, $1QKw9.default)($b66a4f3c5703a3ad$var$_ref, [
    "sideCar"
]);
$b66a4f3c5703a3ad$var$FocusLockCombination.propTypes = {};
var $b66a4f3c5703a3ad$export$2e2bcd8739ae039 = $b66a4f3c5703a3ad$var$FocusLockCombination;

});
parcelRequire.register("1QKw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $158ebb2d202baebb$export$2e2bcd8739ae039);
function $158ebb2d202baebb$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("bX8Xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b3c26aa819822ed$export$2e2bcd8739ae039);
function $8b3c26aa819822ed$export$2e2bcd8739ae039() {
    $8b3c26aa819822ed$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b3c26aa819822ed$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("8Qimm", function(module, exports) {

$parcel$export(module.exports, "default", () => $67016be0ec59bbb5$export$2e2bcd8739ae039);

var $bX8Xg = parcelRequire("bX8Xg");

var $2Jeaf = parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
var $joJRn = parcelRequire("joJRn");


var $9yErJ = parcelRequire("9yErJ");

var $oFSoI = parcelRequire("oFSoI");

var $lyfi4 = parcelRequire("lyfi4");

var $1B6c0 = parcelRequire("1B6c0");
var $67016be0ec59bbb5$var$emptyArray = [];
var $67016be0ec59bbb5$var$FocusLock = /*#__PURE__*/ $2Jeaf.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $iJ7ah.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $iJ7ah.useRef();
    var isActive = $iJ7ah.useRef(false);
    var originalFocusedElement = $iJ7ah.useRef(null);
    var children = props.children, disabled = props.disabled, noFocusGuards = props.noFocusGuards, persistentFocus = props.persistentFocus, crossFrame = props.crossFrame, autoFocus = props.autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $67016be0ec59bbb5$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, shouldReturnFocus = props.returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState2 = $iJ7ah.useState({}), id = _React$useState2[0]; // SIDE EFFECT CALLBACKS
    var onActivation = $iJ7ah.useCallback(function() {
        originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $iJ7ah.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
    }, [
        onDeactivationCallback
    ]);
    (0, $iJ7ah.useEffect)(function() {
        if (!disabled) // cleanup return focus on trap deactivation
        // sideEffect/returnFocus should happen by this time
        originalFocusedElement.current = null;
    }, []);
    var returnFocus = $iJ7ah.useCallback(function(allowDefer) {
        var returnFocusTo = originalFocusedElement.current;
        if (returnFocusTo && returnFocusTo.focus) {
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) // React might return focus after update
                // it's safer to defer the action
                Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]); // MEDIUM CALLBACKS
    var onFocus = $iJ7ah.useCallback(function(event) {
        if (isActive.current) (0, $1B6c0.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $1B6c0.mediumBlur).useMedium; // REF PROPAGATION
    // not using real refs due to race conditions
    var setObserveNode = $iJ7ah.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $bX8Xg.default)((_extends2 = {}, _extends2[$9yErJ.FOCUS_DISABLED] = disabled && "disabled", _extends2[$9yErJ.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $oFSoI.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    return /*#__PURE__*/ $joJRn.createElement($joJRn.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ // nearest focus guard
        $joJRn.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $lyfi4.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $joJRn.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $lyfi4.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $joJRn.createElement(SideCar, {
        id: id,
        sideCar: (0, $1B6c0.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $joJRn.createElement(Container, (0, $bX8Xg.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), children), hasTailingGuards && /*#__PURE__*/ $joJRn.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $lyfi4.hiddenGuard)
    }));
});
$67016be0ec59bbb5$var$FocusLock.propTypes = {};
$67016be0ec59bbb5$var$FocusLock.defaultProps = {
    children: undefined,
    disabled: false,
    returnFocus: false,
    focusOptions: undefined,
    noFocusGuards: false,
    autoFocus: true,
    persistentFocus: false,
    crossFrame: true,
    hasPositiveIndices: undefined,
    allowTextSelection: undefined,
    group: undefined,
    className: undefined,
    whiteList: undefined,
    shards: undefined,
    as: "div",
    lockProps: {},
    onActivation: undefined,
    onDeactivation: undefined
};
var $67016be0ec59bbb5$export$2e2bcd8739ae039 = $67016be0ec59bbb5$var$FocusLock;

});
parcelRequire.register("9yErJ", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", () => $6f56a9d76606d669$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $6f56a9d76606d669$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $6f56a9d76606d669$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $6f56a9d76606d669$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $6f56a9d76606d669$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $6f56a9d76606d669$export$4f9a06cb7441a087 = "data-focus-lock";
var $6f56a9d76606d669$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $6f56a9d76606d669$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $6f56a9d76606d669$export$70e9b4a1820af101 = "data-autofocus-inside";
var $6f56a9d76606d669$export$134ebef29fd94853 = "data-no-autofocus";

});

parcelRequire.register("oFSoI", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $04a2b9c861144c54$export$74665b213cb5c4cf);

var $b73z4 = parcelRequire("b73z4");

var $8KM7C = parcelRequire("8KM7C");
function $04a2b9c861144c54$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $8KM7C.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b73z4.assignRef)(ref, newValue);
        });
    });
}

});
parcelRequire.register("b73z4", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $02168077c6e5b3d0$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $02168077c6e5b3d0$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRequire.register("8KM7C", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $65f7f2a22045fcca$export$25bec8c6f54ee79a);
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
function $65f7f2a22045fcca$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $iJ7ah.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRequire.register("lyfi4", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", () => $fb08a24de59460a5$export$b8c7b07253306600);
$parcel$export(module.exports, "default", () => $fb08a24de59460a5$export$2e2bcd8739ae039);
parcelRequire("2Jeaf");
var $joJRn = parcelRequire("joJRn");

var $fb08a24de59460a5$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $fb08a24de59460a5$var$InFocusGuard = function InFocusGuard(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $joJRn.createElement($joJRn.Fragment, null, /*#__PURE__*/ $joJRn.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $fb08a24de59460a5$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $joJRn.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $fb08a24de59460a5$export$b8c7b07253306600
    }));
};
$fb08a24de59460a5$var$InFocusGuard.propTypes = {};
$fb08a24de59460a5$var$InFocusGuard.defaultProps = {
    children: null
};
var $fb08a24de59460a5$export$2e2bcd8739ae039 = $fb08a24de59460a5$var$InFocusGuard;

});

parcelRequire.register("1B6c0", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", () => $129e0ce3c6a70024$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $129e0ce3c6a70024$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $129e0ce3c6a70024$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $129e0ce3c6a70024$export$892cbf28e5518020);

var $gu5Sl = parcelRequire("gu5Sl");
var $129e0ce3c6a70024$export$5733e022b1d538cb = (0, $gu5Sl.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $129e0ce3c6a70024$export$b3e9a9312f73723c = (0, $gu5Sl.createMedium)();
var $129e0ce3c6a70024$export$3a1d52767cbc07b8 = (0, $gu5Sl.createMedium)();
var $129e0ce3c6a70024$export$892cbf28e5518020 = (0, $gu5Sl.createSidecarMedium)({
    async: true // focus-lock sidecar is not required on the server
});

});
parcelRequire.register("gu5Sl", function(module, exports) {

$parcel$export(module.exports, "createMedium", () => $c004016b3e6c30d1$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $c004016b3e6c30d1$export$e13ec7dd7a14088d);

var $2HFIh = parcelRequire("2HFIh");
function $c004016b3e6c30d1$var$ItoI(a) {
    return a;
}
function $c004016b3e6c30d1$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $c004016b3e6c30d1$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $c004016b3e6c30d1$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $c004016b3e6c30d1$var$ItoI;
    return $c004016b3e6c30d1$var$innerCreateMedium(defaults, middleware);
}
function $c004016b3e6c30d1$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $c004016b3e6c30d1$var$innerCreateMedium(null);
    medium.options = (0, $2HFIh.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});
parcelRequire.register("2HFIh", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $1f7ff44977ae2925$export$18ce0697a983be9b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $1f7ff44977ae2925$var$extendStatics = function(d, b) {
    $1f7ff44977ae2925$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1f7ff44977ae2925$var$extendStatics(d, b);
};
function $1f7ff44977ae2925$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1f7ff44977ae2925$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1f7ff44977ae2925$export$18ce0697a983be9b = function() {
    $1f7ff44977ae2925$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1f7ff44977ae2925$export$18ce0697a983be9b.apply(this, arguments);
};
function $1f7ff44977ae2925$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1f7ff44977ae2925$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1f7ff44977ae2925$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1f7ff44977ae2925$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1f7ff44977ae2925$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1f7ff44977ae2925$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1f7ff44977ae2925$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1f7ff44977ae2925$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1f7ff44977ae2925$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1f7ff44977ae2925$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1f7ff44977ae2925$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1f7ff44977ae2925$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1f7ff44977ae2925$export$45d3717a4c69092e(o, m, p);
}
function $1f7ff44977ae2925$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1f7ff44977ae2925$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1f7ff44977ae2925$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1f7ff44977ae2925$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1f7ff44977ae2925$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1f7ff44977ae2925$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1f7ff44977ae2925$export$10c90e4f7922046c(v) {
    return this instanceof $1f7ff44977ae2925$export$10c90e4f7922046c ? (this.v = v, this) : new $1f7ff44977ae2925$export$10c90e4f7922046c(v);
}
function $1f7ff44977ae2925$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1f7ff44977ae2925$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1f7ff44977ae2925$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1f7ff44977ae2925$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1f7ff44977ae2925$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1f7ff44977ae2925$export$19a8beecd37a4c45 === "function" ? $1f7ff44977ae2925$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1f7ff44977ae2925$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1f7ff44977ae2925$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1f7ff44977ae2925$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1f7ff44977ae2925$export$45d3717a4c69092e(result, mod, k);
    }
    $1f7ff44977ae2925$var$__setModuleDefault(result, mod);
    return result;
}
function $1f7ff44977ae2925$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1f7ff44977ae2925$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1f7ff44977ae2925$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1f7ff44977ae2925$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1f7ff44977ae2925$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1f7ff44977ae2925$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1f7ff44977ae2925$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1f7ff44977ae2925$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1f7ff44977ae2925$export$2e2bcd8739ae039 = {
    __extends: $1f7ff44977ae2925$export$a8ba968b8961cb8a,
    __assign: $1f7ff44977ae2925$export$18ce0697a983be9b,
    __rest: $1f7ff44977ae2925$export$3c9a16f847548506,
    __decorate: $1f7ff44977ae2925$export$29e00dfd3077644b,
    __param: $1f7ff44977ae2925$export$d5ad3fd78186038f,
    __metadata: $1f7ff44977ae2925$export$f1db080c865becb9,
    __awaiter: $1f7ff44977ae2925$export$1050f835b63b671e,
    __generator: $1f7ff44977ae2925$export$67ebef60e6f28a6,
    __createBinding: $1f7ff44977ae2925$export$45d3717a4c69092e,
    __exportStar: $1f7ff44977ae2925$export$f33643c0debef087,
    __values: $1f7ff44977ae2925$export$19a8beecd37a4c45,
    __read: $1f7ff44977ae2925$export$8d051b38c9118094,
    __spread: $1f7ff44977ae2925$export$afc72e2116322959,
    __spreadArrays: $1f7ff44977ae2925$export$6388937ca91ccae8,
    __spreadArray: $1f7ff44977ae2925$export$1216008129fb82ed,
    __await: $1f7ff44977ae2925$export$10c90e4f7922046c,
    __asyncGenerator: $1f7ff44977ae2925$export$e427f37a30a4de9b,
    __asyncDelegator: $1f7ff44977ae2925$export$bbd80228419bb833,
    __asyncValues: $1f7ff44977ae2925$export$e3b29a3d6162315f,
    __makeTemplateObject: $1f7ff44977ae2925$export$4fb47efe1390b86f,
    __importStar: $1f7ff44977ae2925$export$c21735bcef00d192,
    __importDefault: $1f7ff44977ae2925$export$da59b14a69baef04,
    __classPrivateFieldGet: $1f7ff44977ae2925$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1f7ff44977ae2925$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1f7ff44977ae2925$export$81fdc39f203e4e04,
    __addDisposableResource: $1f7ff44977ae2925$export$88ac25d8e944e405,
    __disposeResources: $1f7ff44977ae2925$export$8f076105dc360e92
};

});




parcelRequire.register("fJF4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74aec736ad510d1$export$2e2bcd8739ae039);
/* eslint-disable no-mixed-operators */ parcelRequire("2Jeaf");
var $joJRn = parcelRequire("joJRn");


var $8tL95 = parcelRequire("8tL95");

var $6h63x = parcelRequire("6h63x");
var $hqSdR = parcelRequire("hqSdR");
var $gC9zd = parcelRequire("gC9zd");
var $eaZFK = parcelRequire("eaZFK");

var $jDZyn = parcelRequire("jDZyn");

var $1B6c0 = parcelRequire("1B6c0");
var $b74aec736ad510d1$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $b74aec736ad510d1$var$isFreeFocus = function isFreeFocus() {
    return $b74aec736ad510d1$var$focusOnBody() || (0, $gC9zd.focusIsHidden)();
};
var $b74aec736ad510d1$var$lastActiveTrap = null;
var $b74aec736ad510d1$var$lastActiveFocus = null;
var $b74aec736ad510d1$var$lastPortaledElement = null;
var $b74aec736ad510d1$var$focusWasOutsideWindow = false;
var $b74aec736ad510d1$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $b74aec736ad510d1$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($b74aec736ad510d1$var$lastActiveTrap.whiteList || $b74aec736ad510d1$var$defaultWhitelist)(activeElement);
};
var $b74aec736ad510d1$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $b74aec736ad510d1$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $b74aec736ad510d1$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $b74aec736ad510d1$var$lastPortaledElement && $b74aec736ad510d1$var$lastPortaledElement.portaledElement === element;
};
function $b74aec736ad510d1$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) // we will tab to the next element
            return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $b74aec736ad510d1$var$extractRef = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $b74aec736ad510d1$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) // with cross frame return true for any value
    return Boolean($b74aec736ad510d1$var$focusWasOutsideWindow);
     // in other case return only of focus went a while aho
    return $b74aec736ad510d1$var$focusWasOutsideWindow === "meanwhile";
};
var $b74aec736ad510d1$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement) // dive up
    ) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $b74aec736ad510d1$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $b74aec736ad510d1$var$checkInHost(activeElement, area, area);
    });
};
var $b74aec736ad510d1$var$activateTrap = function activateTrap() {
    var result = false;
    if ($b74aec736ad510d1$var$lastActiveTrap) {
        var _lastActiveTrap = $b74aec736ad510d1$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $b74aec736ad510d1$var$lastPortaledElement && $b74aec736ad510d1$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map($b74aec736ad510d1$var$extractRef).filter(Boolean));
            if (!activeElement || $b74aec736ad510d1$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $b74aec736ad510d1$var$focusWasOutside(crossFrame) || !$b74aec736ad510d1$var$isFreeFocus() || !$b74aec736ad510d1$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $hqSdR.focusInside)(workingArea) || // check for shadow-dom contained elements
                    activeElement && $b74aec736ad510d1$var$withinHost(activeElement, workingArea) || $b74aec736ad510d1$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$b74aec736ad510d1$var$lastActiveFocus && activeElement && !autoFocus) {
                            // Check if blur() exists, which is missing on certain elements on IE
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $6h63x.default)(workingArea, $b74aec736ad510d1$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $b74aec736ad510d1$var$lastPortaledElement = {};
                        }
                    }
                    $b74aec736ad510d1$var$focusWasOutsideWindow = false;
                    $b74aec736ad510d1$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $eaZFK.getFocusabledIn)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    // remove old focus
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $b74aec736ad510d1$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $b74aec736ad510d1$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $b74aec736ad510d1$var$onTrap = function onTrap(event) {
    if ($b74aec736ad510d1$var$activateTrap() && event) {
        // prevent scroll jump
        event.stopPropagation();
        event.preventDefault();
    }
};
var $b74aec736ad510d1$var$onBlur = function onBlur() {
    return (0, $jDZyn.deferAction)($b74aec736ad510d1$var$activateTrap);
};
var $b74aec736ad510d1$var$onFocus = function onFocus(event) {
    // detect portal
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $b74aec736ad510d1$var$recordPortal(currentNode, source);
};
var $b74aec736ad510d1$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $b74aec736ad510d1$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $joJRn.createElement("div", {
        onBlur: $b74aec736ad510d1$var$onBlur,
        onFocus: $b74aec736ad510d1$var$onFocus
    }, children);
};
$b74aec736ad510d1$var$FocusTrap.propTypes = {};
var $b74aec736ad510d1$var$onWindowBlur = function onWindowBlur() {
    $b74aec736ad510d1$var$focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction
    setTimeout(function() {
        $b74aec736ad510d1$var$focusWasOutsideWindow = "meanwhile";
    }, 0);
};
var $b74aec736ad510d1$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $b74aec736ad510d1$var$onTrap);
    document.addEventListener("focusout", $b74aec736ad510d1$var$onBlur);
    window.addEventListener("blur", $b74aec736ad510d1$var$onWindowBlur);
};
var $b74aec736ad510d1$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $b74aec736ad510d1$var$onTrap);
    document.removeEventListener("focusout", $b74aec736ad510d1$var$onBlur);
    window.removeEventListener("blur", $b74aec736ad510d1$var$onWindowBlur);
};
function $b74aec736ad510d1$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
function $b74aec736ad510d1$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$b74aec736ad510d1$var$lastActiveTrap) $b74aec736ad510d1$var$attachHandler();
    var lastTrap = $b74aec736ad510d1$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $b74aec736ad510d1$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation(); // return focus only of last trap was removed
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) // allow defer is no other trap is awaiting restore
        lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $b74aec736ad510d1$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation();
        $b74aec736ad510d1$var$activateTrap(true);
        (0, $jDZyn.deferAction)($b74aec736ad510d1$var$activateTrap);
    } else {
        $b74aec736ad510d1$var$detachHandler();
        $b74aec736ad510d1$var$lastActiveFocus = null;
    }
} // bind medium
(0, $1B6c0.mediumFocus).assignSyncMedium($b74aec736ad510d1$var$onFocus);
(0, $1B6c0.mediumBlur).assignMedium($b74aec736ad510d1$var$onBlur);
(0, $1B6c0.mediumEffect).assignMedium(function(cb) {
    return cb({
        moveFocusInside: (0, $6h63x.default),
        focusInside: (0, $hqSdR.focusInside)
    });
});
var $b74aec736ad510d1$export$2e2bcd8739ae039 = (0, $8tL95.default)($b74aec736ad510d1$var$reducePropsToState, $b74aec736ad510d1$var$handleStateChangeOnClient)($b74aec736ad510d1$var$FocusWatcher);

});
parcelRequire.register("8tL95", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c59a4db52fe82d$export$2e2bcd8739ae039);

var $hvGW0 = parcelRequire("hvGW0");

var $kSWSi = parcelRequire("kSWSi");

var $2Jeaf = parcelRequire("2Jeaf");
function $62c59a4db52fe82d$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $hvGW0.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, $2Jeaf.default).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $2Jeaf.PureComponent));
        (0, $kSWSi.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $62c59a4db52fe82d$export$2e2bcd8739ae039 = $62c59a4db52fe82d$var$withSideEffect;

});
parcelRequire.register("hvGW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf6a2d002585f46$export$2e2bcd8739ae039);

var $fKeFY = parcelRequire("fKeFY");
function $cbf6a2d002585f46$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $fKeFY.default)(subClass, superClass);
}

});
parcelRequire.register("fKeFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7668937f19ec74f$export$2e2bcd8739ae039);
function $b7668937f19ec74f$export$2e2bcd8739ae039(o, p) {
    $b7668937f19ec74f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b7668937f19ec74f$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("kSWSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34685124f520331$export$2e2bcd8739ae039);

var $5wNsA = parcelRequire("5wNsA");
function $f34685124f520331$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $5wNsA.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("5wNsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $40664ea4534829c2$export$2e2bcd8739ae039);

var $kFWVC = parcelRequire("kFWVC");

var $lvLu9 = parcelRequire("lvLu9");
function $40664ea4534829c2$export$2e2bcd8739ae039(arg) {
    var key = (0, $lvLu9.default)(arg, "string");
    return (0, $kFWVC.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("kFWVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d558f08cfcf2e9$export$2e2bcd8739ae039);
function $f0d558f08cfcf2e9$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $f0d558f08cfcf2e9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f0d558f08cfcf2e9$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("lvLu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $040a9a204a5508d8$export$2e2bcd8739ae039);

var $kFWVC = parcelRequire("kFWVC");
function $040a9a204a5508d8$export$2e2bcd8739ae039(input, hint) {
    if ((0, $kFWVC.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $kFWVC.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});




parcelRequire.register("6h63x", function(module, exports) {

$parcel$export(module.exports, "default", () => $491907352b9f437c$export$2e2bcd8739ae039);


var $hqSdR = parcelRequire("hqSdR");

var $gC9zd = parcelRequire("gC9zd");


var $eaZFK = parcelRequire("eaZFK");

var $etOsD = parcelRequire("etOsD");




var $491907352b9f437c$export$2e2bcd8739ae039 //
 = (0, $etOsD.setFocus);

});
parcelRequire.register("hqSdR", function(module, exports) {

$parcel$export(module.exports, "focusInside", () => $cb0eecdbca15c7fe$export$20115f8da7baa6fa);

var $c8OcX = parcelRequire("c8OcX");

var $lunRs = parcelRequire("lunRs");

var $aZAoo = parcelRequire("aZAoo");

var $2hiIw = parcelRequire("2hiIw");
var $cb0eecdbca15c7fe$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $cb0eecdbca15c7fe$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $aZAoo.toArray)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $cb0eecdbca15c7fe$var$focusInFrame(node, activeElement);
    }));
};
var $cb0eecdbca15c7fe$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $2hiIw.getActiveElement)((0, $aZAoo.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $lunRs.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $c8OcX.contains)(node, activeElement) || $cb0eecdbca15c7fe$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRequire.register("c8OcX", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", () => $8d6d2da9d9779511$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $8d6d2da9d9779511$export$3738e313571e2ad2);
$parcel$export(module.exports, "getAllTabbableNodes", () => $8d6d2da9d9779511$export$23c79be8286a3b0c);
$parcel$export(module.exports, "parentAutofocusables", () => $8d6d2da9d9779511$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $8d6d2da9d9779511$export$2344b14b097df817);

var $aZAoo = parcelRequire("aZAoo");

var $h4bTR = parcelRequire("h4bTR");

var $6vog2 = parcelRequire("6vog2");

var $8nnZA = parcelRequire("8nnZA");
var $8d6d2da9d9779511$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $aZAoo.toArray)(nodes).filter(function(node) {
        return (0, $h4bTR.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $h4bTR.notHiddenInput)(node);
    });
};
var $8d6d2da9d9779511$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $aZAoo.toArray)(nodes).filter(function(node) {
        return (0, $h4bTR.isAutoFocusAllowedCached)(cache, node);
    });
};
var $8d6d2da9d9779511$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $6vog2.orderByTabIndex)($8d6d2da9d9779511$export$6266a5cd5915dc33((0, $8nnZA.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $8d6d2da9d9779511$export$23c79be8286a3b0c = function(topNodes, visibilityCache) {
    return (0, $6vog2.orderByTabIndex)($8d6d2da9d9779511$export$6266a5cd5915dc33((0, $8nnZA.getFocusables)(topNodes), visibilityCache), false);
};
var $8d6d2da9d9779511$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $8d6d2da9d9779511$export$6266a5cd5915dc33((0, $8nnZA.getParentAutofocusables)(topNode), visibilityCache);
};
var $8d6d2da9d9779511$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $8d6d2da9d9779511$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $aZAoo.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $8d6d2da9d9779511$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $8d6d2da9d9779511$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRequire.register("aZAoo", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $800bd4a9ac9e163a$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $800bd4a9ac9e163a$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $800bd4a9ac9e163a$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $800bd4a9ac9e163a$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $800bd4a9ac9e163a$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $800bd4a9ac9e163a$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRequire.register("h4bTR", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", () => $c6cc0a7b2f6881d3$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $c6cc0a7b2f6881d3$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $c6cc0a7b2f6881d3$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $c6cc0a7b2f6881d3$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $c6cc0a7b2f6881d3$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $c6cc0a7b2f6881d3$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $c6cc0a7b2f6881d3$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $c6cc0a7b2f6881d3$export$4e62c701997796c1);

var $9yErJ = parcelRequire("9yErJ");
var $c6cc0a7b2f6881d3$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $c6cc0a7b2f6881d3$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $c6cc0a7b2f6881d3$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $c6cc0a7b2f6881d3$var$isVisibleUncached = function(node, checkParent) {
    return !node || $c6cc0a7b2f6881d3$var$isTopNode(node) || !$c6cc0a7b2f6881d3$var$isElementHidden(node) && checkParent($c6cc0a7b2f6881d3$var$getParentNode(node));
};
var $c6cc0a7b2f6881d3$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $c6cc0a7b2f6881d3$var$isVisibleUncached(node, $c6cc0a7b2f6881d3$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $c6cc0a7b2f6881d3$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$c6cc0a7b2f6881d3$var$isTopNode(node) ? $c6cc0a7b2f6881d3$export$b8550e27de209d85(node) ? checkParent($c6cc0a7b2f6881d3$var$getParentNode(node)) : false : true;
};
var $c6cc0a7b2f6881d3$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $c6cc0a7b2f6881d3$var$isAutoFocusAllowedUncached(node, $c6cc0a7b2f6881d3$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $c6cc0a7b2f6881d3$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $c6cc0a7b2f6881d3$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $c6cc0a7b2f6881d3$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $c6cc0a7b2f6881d3$export$9d74f6fbc6f469d0 = function(node) {
    return $c6cc0a7b2f6881d3$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $c6cc0a7b2f6881d3$export$8197b0ea56b3b055 = function(node) {
    return !(($c6cc0a7b2f6881d3$export$88a6ceeed5737ba3(node) || $c6cc0a7b2f6881d3$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $c6cc0a7b2f6881d3$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $9yErJ.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $c6cc0a7b2f6881d3$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $c6cc0a7b2f6881d3$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $c6cc0a7b2f6881d3$export$602e5a0d338d7750 = function(node) {
    return !$c6cc0a7b2f6881d3$export$d94b8b58ec2f30eb(node);
};
var $c6cc0a7b2f6881d3$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRequire.register("6vog2", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", () => $4bc874684ef913d9$export$cb40ee071f0d5226);

var $aZAoo = parcelRequire("aZAoo");
var $4bc874684ef913d9$export$350ee6c095d98996 = function(a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) return 1;
        if (!b.tabIndex) return -1;
    }
    return tabDiff || indexDiff;
};
var $4bc874684ef913d9$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $aZAoo.toArray)(nodes).map(function(node, index) {
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($4bc874684ef913d9$export$350ee6c095d98996);
};

});

parcelRequire.register("8nnZA", function(module, exports) {

$parcel$export(module.exports, "getFocusables", () => $619315141e8f2b7e$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $619315141e8f2b7e$export$853fa94d922e78b9);

var $9yErJ = parcelRequire("9yErJ");

var $aZAoo = parcelRequire("aZAoo");

var $2yPEt = parcelRequire("2yPEt");
var $619315141e8f2b7e$var$queryTabbables = (0, $2yPEt.tabbables).join(",");
var $619315141e8f2b7e$var$queryGuardTabbables = "".concat($619315141e8f2b7e$var$queryTabbables, ", [data-focus-guard]");
var $619315141e8f2b7e$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $aZAoo.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $619315141e8f2b7e$var$queryGuardTabbables : $619315141e8f2b7e$var$queryTabbables) ? [
            child
        ] : [], $619315141e8f2b7e$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $619315141e8f2b7e$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $619315141e8f2b7e$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $619315141e8f2b7e$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $619315141e8f2b7e$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $619315141e8f2b7e$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $aZAoo.toArray)(parent.parentNode.querySelectorAll($619315141e8f2b7e$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $619315141e8f2b7e$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $9yErJ.FOCUS_AUTO), "]"));
    return (0, $aZAoo.toArray)(parentFocus).map(function(node) {
        return $619315141e8f2b7e$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRequire.register("2yPEt", function(module, exports) {

$parcel$export(module.exports, "tabbables", () => $1dd6d2ba92c826fe$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $1dd6d2ba92c826fe$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];

});



parcelRequire.register("lunRs", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", () => $fa4ee8aa08aea4ad$export$7e87c4720b9b279b);

var $9yErJ = parcelRequire("9yErJ");

var $aZAoo = parcelRequire("aZAoo");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $fa4ee8aa08aea4ad$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $fa4ee8aa08aea4ad$var$getTopParent = function(node) {
    return node.parentNode ? $fa4ee8aa08aea4ad$var$getTopParent(node.parentNode) : node;
};
var $fa4ee8aa08aea4ad$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $aZAoo.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $9yErJ.FOCUS_GROUP));
        acc.push.apply(acc, group ? $fa4ee8aa08aea4ad$var$filterNested((0, $aZAoo.toArray)($fa4ee8aa08aea4ad$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $9yErJ.FOCUS_GROUP), '="').concat(group, '"]:not([').concat((0, $9yErJ.FOCUS_DISABLED), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRequire.register("2hiIw", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $1a8bb02681699c23$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $vBU5t = parcelRequire("vBU5t");
var $1a8bb02681699c23$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $1a8bb02681699c23$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $vBU5t.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $1a8bb02681699c23$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRequire.register("vBU5t", function(module, exports) {

$parcel$export(module.exports, "safeProbe", () => $05f04c3cb8fa8e5f$export$78d20aae35adef88);
var $05f04c3cb8fa8e5f$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRequire.register("gC9zd", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", () => $c1879dc7bafeee15$export$be6b21806d3fd485);

var $9yErJ = parcelRequire("9yErJ");

var $c8OcX = parcelRequire("c8OcX");

var $aZAoo = parcelRequire("aZAoo");

var $2hiIw = parcelRequire("2hiIw");
var $c1879dc7bafeee15$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $2hiIw.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $aZAoo.toArray)(inDocument.querySelectorAll("[".concat((0, $9yErJ.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $c8OcX.contains)(node, activeElement);
    });
};

});

parcelRequire.register("eaZFK", function(module, exports) {

$parcel$export(module.exports, "getFocusabledIn", () => $a521d6b2485886da$export$30d9c643899a8835);

var $c8OcX = parcelRequire("c8OcX");

var $lunRs = parcelRequire("lunRs");

var $h4bTR = parcelRequire("h4bTR");

var $6CRYT = parcelRequire("6CRYT");
var $a521d6b2485886da$export$30d9c643899a8835 = function(topNode) {
    var entries = (0, $lunRs.getAllAffectedNodes)(topNode).filter((0, $h4bTR.isNotAGuard));
    var commonParent = (0, $6CRYT.getTopCommonParent)(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = (0, $c8OcX.getTabbableNodes)([
        commonParent
    ], visibilityCache, true);
    var innerElements = (0, $c8OcX.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $h4bTR.isNotAGuard)(node);
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $h4bTR.isGuard)(node)
        };
    });
};
var $a521d6b2485886da$export$5f246425711134ac = $a521d6b2485886da$export$30d9c643899a8835;

});
parcelRequire.register("6CRYT", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", () => $4d302a332159078f$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $4d302a332159078f$export$8f99714c70a37db1);

var $c8OcX = parcelRequire("c8OcX");

var $aZAoo = parcelRequire("aZAoo");
var $4d302a332159078f$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $4d302a332159078f$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $4d302a332159078f$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $4d302a332159078f$var$getParents(nodeA);
    var parentsB = $4d302a332159078f$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $4d302a332159078f$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $aZAoo.asArray)(baseActiveElement);
    var leftEntries = (0, $aZAoo.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $4d302a332159078f$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $4d302a332159078f$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $c8OcX.contains)(common, topCommon)) topCommon = common;
                else topCommon = $4d302a332159078f$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $4d302a332159078f$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $c8OcX.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRequire.register("etOsD", function(module, exports) {

$parcel$export(module.exports, "setFocus", () => $a8aaea9869c8761c$export$f06c444b0336b5d5);

var $fak7I = parcelRequire("fak7I");
var $a8aaea9869c8761c$export$c12b3da842c43a8 = function(target, focusOptions) {
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};
var $a8aaea9869c8761c$var$guardCount = 0;
var $a8aaea9869c8761c$var$lockDisabled = false;
var $a8aaea9869c8761c$export$f06c444b0336b5d5 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $fak7I.getFocusMerge)(topNode, lastNode);
    if ($a8aaea9869c8761c$var$lockDisabled) return;
    if (focusable) {
        if ($a8aaea9869c8761c$var$guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $a8aaea9869c8761c$var$lockDisabled = true;
            setTimeout(function() {
                $a8aaea9869c8761c$var$lockDisabled = false;
            }, 1);
            return;
        }
        $a8aaea9869c8761c$var$guardCount++;
        $a8aaea9869c8761c$export$c12b3da842c43a8(focusable.node, options.focusOptions);
        $a8aaea9869c8761c$var$guardCount--;
    }
};

});
parcelRequire.register("fak7I", function(module, exports) {

$parcel$export(module.exports, "getFocusMerge", () => $b0a76646b08b1425$export$82d3f62e3f171d1d);

var $1J63Y = parcelRequire("1J63Y");

var $c8OcX = parcelRequire("c8OcX");

var $lunRs = parcelRequire("lunRs");

var $aZAoo = parcelRequire("aZAoo");

var $3nvkY = parcelRequire("3nvkY");

var $2hiIw = parcelRequire("2hiIw");

var $h4bTR = parcelRequire("h4bTR");

var $6CRYT = parcelRequire("6CRYT");
var $b0a76646b08b1425$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $h4bTR.isDefined));
};
var $b0a76646b08b1425$export$82d3f62e3f171d1d = function(topNode, lastNode) {
    var activeElement = (0, $2hiIw.getActiveElement)((0, $aZAoo.asArray)(topNode).length > 0 ? document : (0, $aZAoo.getFirst)(topNode).ownerDocument);
    var entries = (0, $lunRs.getAllAffectedNodes)(topNode).filter((0, $h4bTR.isNotAGuard));
    var commonParent = (0, $6CRYT.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $c8OcX.getAllTabbableNodes)(entries, visibilityCache);
    var innerElements = (0, $c8OcX.getTabbableNodes)(entries, visibilityCache).filter(function(_a) {
        var node = _a.node;
        return (0, $h4bTR.isNotAGuard)(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) return undefined;
    }
    var outerNodes = (0, $c8OcX.getAllTabbableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $b0a76646b08b1425$var$reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $1J63Y.newFocus)(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === (0, $1J63Y.NEW_FOCUS)) {
        var focusNode = (0, $3nvkY.pickAutofocus)(anyFocusable, innerNodes, (0, $6CRYT.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRequire.register("1J63Y", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", () => $141eb26afac4ea0a$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $141eb26afac4ea0a$export$65842178e9bb4205);

var $41T4e = parcelRequire("41T4e");

var $jbbs0 = parcelRequire("jbbs0");

var $h4bTR = parcelRequire("h4bTR");
var $141eb26afac4ea0a$export$85710b12cf912438 = "NEW_FOCUS";
var $141eb26afac4ea0a$export$65842178e9bb4205 = function(innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $h4bTR.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $41T4e.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = (0, $jbbs0.pickFocusable)(innerNodes, 0);
    var returnLastNode = (0, $jbbs0.pickFocusable)(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) return $141eb26afac4ea0a$export$85710b12cf912438;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRequire.register("41T4e", function(module, exports) {

$parcel$export(module.exports, "correctNode", () => $2ef1f89f3e85ed23$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $2ef1f89f3e85ed23$export$4a5a72a7124e45f9);

var $h4bTR = parcelRequire("h4bTR");
var $2ef1f89f3e85ed23$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $h4bTR.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $2ef1f89f3e85ed23$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $h4bTR.isRadioElement)(node) && node.name) return $2ef1f89f3e85ed23$var$findSelectedRadio(node, nodes);
    return node;
};
var $2ef1f89f3e85ed23$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($2ef1f89f3e85ed23$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRequire.register("jbbs0", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", () => $df67ed413cd8c037$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $df67ed413cd8c037$export$e06728ee87c96122);

var $41T4e = parcelRequire("41T4e");
var $df67ed413cd8c037$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $41T4e.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $df67ed413cd8c037$export$e06728ee87c96122 = function(nodes, index) {
    if (nodes.length > 1) return nodes.indexOf((0, $41T4e.correctNode)(nodes[index], nodes));
    return index;
};

});


parcelRequire.register("3nvkY", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", () => $275bd40472eca5c5$export$cfb742983e257555);

var $c8OcX = parcelRequire("c8OcX");

var $jbbs0 = parcelRequire("jbbs0");

var $h4bTR = parcelRequire("h4bTR");
var $275bd40472eca5c5$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $h4bTR.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $275bd40472eca5c5$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $c8OcX.filterAutoFocusable)(nodes.filter($275bd40472eca5c5$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $jbbs0.pickFirstFocus)(autoFocusable);
    return (0, $jbbs0.pickFirstFocus)((0, $c8OcX.filterAutoFocusable)(orderedNodes));
};

});




parcelRequire.register("jDZyn", function(module, exports) {

$parcel$export(module.exports, "deferAction", () => $e4d16812a1dd0dae$export$6523025722806278);
$parcel$export(module.exports, "inlineProp", () => $e4d16812a1dd0dae$export$db10c343af3f20fa);
function $e4d16812a1dd0dae$export$6523025722806278(action) {
    // Hidding setImmediate from Webpack to avoid inserting polyfill
    var _window = window, setImmediate = _window.setImmediate;
    if (typeof setImmediate !== "undefined") setImmediate(action);
    else setTimeout(action, 1);
}
var $e4d16812a1dd0dae$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};

});



parcelRequire.register("jTbuX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e7ac12b37a6f3f9f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AutoFocusInside", () => (parcelRequire("djw9C")).default);
$parcel$export(module.exports, "MoveFocusInside", () => (parcelRequire("4W7Ae")).default);
$parcel$export(module.exports, "FreeFocusInside", () => (parcelRequire("l8tGz")).default);
$parcel$export(module.exports, "InFocusGuard", () => (parcelRequire("lyfi4")).default);
$parcel$export(module.exports, "FocusLockUI", () => (parcelRequire("8Qimm")).default);
$parcel$export(module.exports, "useFocusInside", () => (parcelRequire("4W7Ae")).useFocusInside);

var $8Qimm = parcelRequire("8Qimm");

var $djw9C = parcelRequire("djw9C");

var $4W7Ae = parcelRequire("4W7Ae");

var $l8tGz = parcelRequire("l8tGz");

var $lyfi4 = parcelRequire("lyfi4");
var $e7ac12b37a6f3f9f$export$2e2bcd8739ae039 = (0, $8Qimm.default);

});
parcelRequire.register("djw9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b15fde016854ca6$export$2e2bcd8739ae039);

var $bX8Xg = parcelRequire("bX8Xg");
parcelRequire("2Jeaf");
var $joJRn = parcelRequire("joJRn");


var $9yErJ = parcelRequire("9yErJ");

var $jDZyn = parcelRequire("jDZyn");
var $9b15fde016854ca6$var$AutoFocusInside = function AutoFocusInside(_ref) {
    var _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? undefined : _ref$className;
    return /*#__PURE__*/ $joJRn.createElement("div", (0, $bX8Xg.default)({}, (0, $jDZyn.inlineProp)($9yErJ.FOCUS_AUTO, !disabled), {
        className: className
    }), children);
};
$9b15fde016854ca6$var$AutoFocusInside.propTypes = {};
var $9b15fde016854ca6$export$2e2bcd8739ae039 = $9b15fde016854ca6$var$AutoFocusInside;

});

parcelRequire.register("4W7Ae", function(module, exports) {

$parcel$export(module.exports, "useFocusInside", () => $3982761fde34b2c5$export$729dec1d3bf84074);
$parcel$export(module.exports, "default", () => $3982761fde34b2c5$export$2e2bcd8739ae039);

var $bX8Xg = parcelRequire("bX8Xg");
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
var $joJRn = parcelRequire("joJRn");


var $9yErJ = parcelRequire("9yErJ");

var $jDZyn = parcelRequire("jDZyn");

var $1B6c0 = parcelRequire("1B6c0");
var $3982761fde34b2c5$export$729dec1d3bf84074 = function useFocusInside(observedRef) {
    $iJ7ah.useEffect(function() {
        var enabled = true;
        (0, $1B6c0.mediumEffect).useMedium(function(car) {
            var observed = observedRef && observedRef.current;
            if (enabled && observed) {
                if (!car.focusInside(observed)) car.moveFocusInside(observed, null);
            }
        });
        return function() {
            enabled = false;
        };
    }, [
        observedRef
    ]);
};
function $3982761fde34b2c5$var$MoveFocusInside(_ref) {
    var isDisabled = _ref.disabled, className = _ref.className, children = _ref.children;
    var ref = $iJ7ah.useRef(null);
    $3982761fde34b2c5$export$729dec1d3bf84074(isDisabled ? undefined : ref);
    return /*#__PURE__*/ $joJRn.createElement("div", (0, $bX8Xg.default)({}, (0, $jDZyn.inlineProp)($9yErJ.FOCUS_AUTO, !isDisabled), {
        ref: ref,
        className: className
    }), children);
}
$3982761fde34b2c5$var$MoveFocusInside.propTypes = {};
$3982761fde34b2c5$var$MoveFocusInside.defaultProps = {
    disabled: false,
    className: undefined
};
var $3982761fde34b2c5$export$2e2bcd8739ae039 = $3982761fde34b2c5$var$MoveFocusInside;

});

parcelRequire.register("l8tGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6315f49b0534ca3$export$2e2bcd8739ae039);

var $bX8Xg = parcelRequire("bX8Xg");
parcelRequire("2Jeaf");
var $joJRn = parcelRequire("joJRn");


var $9yErJ = parcelRequire("9yErJ");

var $jDZyn = parcelRequire("jDZyn");
var $f6315f49b0534ca3$var$FreeFocusInside = function FreeFocusInside(_ref) {
    var children = _ref.children, className = _ref.className;
    return /*#__PURE__*/ $joJRn.createElement("div", (0, $bX8Xg.default)({}, (0, $jDZyn.inlineProp)($9yErJ.FOCUS_ALLOW, true), {
        className: className
    }), children);
};
$f6315f49b0534ca3$var$FreeFocusInside.propTypes = {};
$f6315f49b0534ca3$var$FreeFocusInside.defaultProps = {
    className: undefined
};
var $f6315f49b0534ca3$export$2e2bcd8739ae039 = $f6315f49b0534ca3$var$FreeFocusInside;

});



parcelRequire.register("hTItt", function(module, exports) {

$parcel$export(module.exports, "releaseBody", () => $d07a126ce151ef92$export$80f0e0a114f823d0);
$parcel$export(module.exports, "enter", () => $d07a126ce151ef92$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "escFunction", () => $d07a126ce151ef92$export$8956bc22b4d5fb67);
$parcel$export(module.exports, "onBackdropClick", () => $d07a126ce151ef92$export$21e7b9f4635e7aa6);
$parcel$export(module.exports, "handleAnimationEnd", () => $d07a126ce151ef92$export$3373caf2c90f72f5);
$parcel$export(module.exports, "onVisibleChanged", () => $d07a126ce151ef92$export$3f093399b9ae7cee);

var $d2pCB = parcelRequire("d2pCB");

var $3evsw = parcelRequire("3evsw");
const $d07a126ce151ef92$export$18583d4255708396 = (prefix)=>{
    const body = document.body;
    (0, $d2pCB.default).push(true);
    if (body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) === -1) {
        const scrollCache = window.pageYOffset || window.scrollY;
        body.setAttribute("data-skapa--scroll", scrollCache.toString());
        const paddingCache = body.style.paddingRight;
        body.setAttribute("data-skapa--pad", paddingCache);
        let scrollbarWidth = body.clientWidth;
        body.classList.add(`${prefix}prevent-scroll-y`);
        scrollbarWidth = body.clientWidth - scrollbarWidth;
        body.style.top = `-${scrollCache}px`;
        if (scrollbarWidth) body.style.paddingRight = `calc(${paddingCache || "0px"} + ${scrollbarWidth}px)`;
        window.scrollTo(0, 0);
    }
};
const $d07a126ce151ef92$export$80f0e0a114f823d0 = (prefix)=>{
    const body = document.body;
    (0, $d2pCB.default).pop();
    if ((0, $d2pCB.default).length === 0 && body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) > -1) {
        const scrollCache = Number(body.getAttribute("data-skapa--scroll"));
        const paddingCache = body.getAttribute("data-skapa--pad");
        body.classList.remove(`${prefix}prevent-scroll-y`);
        body.style.paddingRight = paddingCache;
        window.scrollTo(0, scrollCache);
        body.style.top = "";
        body.removeAttribute("data-skapa--scroll");
        body.removeAttribute("data-skapa--pad");
        if (!body.style.length) body.removeAttribute("style");
    }
    return true;
};
const $d07a126ce151ef92$export$33993f1ec7a2167a = (setIsOpen, setAnimationMountHelper)=>{
    setIsOpen(false);
    setAnimationMountHelper(true);
};
const $d07a126ce151ef92$export$e668df1bcd81e4d2 = (setIsOpen, scrollLock, prefix)=>{
    setIsOpen(true);
    if (scrollLock) $d07a126ce151ef92$export$18583d4255708396(prefix);
};
const $d07a126ce151ef92$export$8956bc22b4d5fb67 = (e, baseClass, escapable, handleCloseBtn, setIsOpen, setAnimationMountHelper)=>{
    const escapeCalledOnThisModal = !e.target.closest || e.target.closest(`.${baseClass}`) === e.currentTarget;
    if (escapeCalledOnThisModal && escapable && e.key === "Escape") {
        if (handleCloseBtn) handleCloseBtn(e);
        $d07a126ce151ef92$export$33993f1ec7a2167a(setIsOpen, setAnimationMountHelper);
    }
};
const $d07a126ce151ef92$export$21e7b9f4635e7aa6 = (event, escapable, handleCloseBtn)=>{
    if (escapable && event.target === event.currentTarget) handleCloseBtn(event);
};
const $d07a126ce151ef92$export$3373caf2c90f72f5 = (event, animationFrameRef, isOpen, onModalOpened, onModalClosed, scrollLock, animationMountHelper, setAnimationMountHelper, prefix)=>{
    cancelAnimationFrame(animationFrameRef);
    if (isOpen) // Modal opening animation is finished
    {
        if (onModalOpened) animationFrameRef = requestAnimationFrame(()=>{
            onModalOpened(event);
        }); // animationFrame prevents multiple triggers
    } else if (animationMountHelper) {
        // Modal closing animation is finished
        if (scrollLock) $d07a126ce151ef92$export$80f0e0a114f823d0(prefix);
        setAnimationMountHelper(false);
        if (onModalClosed) animationFrameRef = requestAnimationFrame(()=>{
            onModalClosed(event);
        }); // animationFrame prevents multiple triggers
    }
};
const $d07a126ce151ef92$export$3f093399b9ae7cee = (prefix, visible, scrollLock, isOpen, setIsOpen, setAnimationMountHelper)=>{
    if (visible !== isOpen) {
        if (visible) $d07a126ce151ef92$export$e668df1bcd81e4d2(setIsOpen, scrollLock, prefix);
        else $d07a126ce151ef92$export$33993f1ec7a2167a(setIsOpen, setAnimationMountHelper);
    }
};

});
parcelRequire.register("d2pCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $97df56309d315186$export$2e2bcd8739ae039);
const $97df56309d315186$var$openModals = [];
var $97df56309d315186$export$2e2bcd8739ae039 = $97df56309d315186$var$openModals;

});

parcelRequire.register("3evsw", function(module, exports) {
const $25ab1500d33290fa$var$ShouldAutoFocus = (refElement)=>{
    if (!refElement) return false;
    const autoFocusSet = Boolean(refElement.querySelectorAll("*[data-autofocus],*[autofocus]").length);
    return !autoFocusSet;
};
var $25ab1500d33290fa$export$2e2bcd8739ae039 = $25ab1500d33290fa$var$ShouldAutoFocus;

});






parcelRequire.register("4FbPx", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $4CQU2 = parcelRequire("4CQU2");

var $emgOe = parcelRequire("emgOe");

var $lHbGx = parcelRequire("lHbGx");

var $4cwFP = parcelRequire("4cwFP");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $36542b051de6b288$var$createInstance(defaultConfig) {
    var context = new $emgOe(defaultConfig);
    var instance = $4CQU2($emgOe.prototype.request, context);
    // Copy axios.prototype to instance
    $3W5kq.extend(instance, $emgOe.prototype, context);
    // Copy context to instance
    $3W5kq.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $36542b051de6b288$var$axios = $36542b051de6b288$var$createInstance($4cwFP);
// Expose Axios class to allow class inheritance
$36542b051de6b288$var$axios.Axios = $emgOe;
// Factory for creating new instances
$36542b051de6b288$var$axios.create = function create(instanceConfig) {
    return $36542b051de6b288$var$createInstance($lHbGx($36542b051de6b288$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$36542b051de6b288$var$axios.Cancel = (parcelRequire("6Tinf"));

$36542b051de6b288$var$axios.CancelToken = (parcelRequire("WDw9T"));

$36542b051de6b288$var$axios.isCancel = (parcelRequire("ggqxH"));
// Expose all/spread
$36542b051de6b288$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$36542b051de6b288$var$axios.spread = (parcelRequire("fEIML"));

// Expose isAxiosError
$36542b051de6b288$var$axios.isAxiosError = (parcelRequire("arXh5"));
module.exports = $36542b051de6b288$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $36542b051de6b288$var$axios;

});
parcelRequire.register("3W5kq", function(module, exports) {
"use strict";

var $4CQU2 = parcelRequire("4CQU2");
// utils is a library of generic helper functions non-specific to axios
var $2ddaebfaa733d902$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $2ddaebfaa733d902$var$isArray(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $2ddaebfaa733d902$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $2ddaebfaa733d902$var$isBuffer(val) {
    return val !== null && !$2ddaebfaa733d902$var$isUndefined(val) && val.constructor !== null && !$2ddaebfaa733d902$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $2ddaebfaa733d902$var$isArrayBuffer(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $2ddaebfaa733d902$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $2ddaebfaa733d902$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $2ddaebfaa733d902$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $2ddaebfaa733d902$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $2ddaebfaa733d902$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $2ddaebfaa733d902$var$isPlainObject(val) {
    if ($2ddaebfaa733d902$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $2ddaebfaa733d902$var$isDate(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $2ddaebfaa733d902$var$isFile(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $2ddaebfaa733d902$var$isBlob(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $2ddaebfaa733d902$var$isFunction(val) {
    return $2ddaebfaa733d902$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $2ddaebfaa733d902$var$isStream(val) {
    return $2ddaebfaa733d902$var$isObject(val) && $2ddaebfaa733d902$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $2ddaebfaa733d902$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $2ddaebfaa733d902$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $2ddaebfaa733d902$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $2ddaebfaa733d902$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($2ddaebfaa733d902$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $2ddaebfaa733d902$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($2ddaebfaa733d902$var$isPlainObject(result[key]) && $2ddaebfaa733d902$var$isPlainObject(val)) result[key] = $2ddaebfaa733d902$var$merge(result[key], val);
        else if ($2ddaebfaa733d902$var$isPlainObject(val)) result[key] = $2ddaebfaa733d902$var$merge({}, val);
        else if ($2ddaebfaa733d902$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$2ddaebfaa733d902$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $2ddaebfaa733d902$var$extend(a, b, thisArg) {
    $2ddaebfaa733d902$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $4CQU2(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $2ddaebfaa733d902$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $2ddaebfaa733d902$var$isArray,
    isArrayBuffer: $2ddaebfaa733d902$var$isArrayBuffer,
    isBuffer: $2ddaebfaa733d902$var$isBuffer,
    isFormData: $2ddaebfaa733d902$var$isFormData,
    isArrayBufferView: $2ddaebfaa733d902$var$isArrayBufferView,
    isString: $2ddaebfaa733d902$var$isString,
    isNumber: $2ddaebfaa733d902$var$isNumber,
    isObject: $2ddaebfaa733d902$var$isObject,
    isPlainObject: $2ddaebfaa733d902$var$isPlainObject,
    isUndefined: $2ddaebfaa733d902$var$isUndefined,
    isDate: $2ddaebfaa733d902$var$isDate,
    isFile: $2ddaebfaa733d902$var$isFile,
    isBlob: $2ddaebfaa733d902$var$isBlob,
    isFunction: $2ddaebfaa733d902$var$isFunction,
    isStream: $2ddaebfaa733d902$var$isStream,
    isURLSearchParams: $2ddaebfaa733d902$var$isURLSearchParams,
    isStandardBrowserEnv: $2ddaebfaa733d902$var$isStandardBrowserEnv,
    forEach: $2ddaebfaa733d902$var$forEach,
    merge: $2ddaebfaa733d902$var$merge,
    extend: $2ddaebfaa733d902$var$extend,
    trim: $2ddaebfaa733d902$var$trim,
    stripBOM: $2ddaebfaa733d902$var$stripBOM
};

});
parcelRequire.register("4CQU2", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("emgOe", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $3ndEn = parcelRequire("3ndEn");

var $DK1A9 = parcelRequire("DK1A9");

var $9OxlO = parcelRequire("9OxlO");

var $lHbGx = parcelRequire("lHbGx");

var $5Efje = parcelRequire("5Efje");
var $a74028b38e5a0a5a$var$validators = $5Efje.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a74028b38e5a0a5a$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $DK1A9(),
        response: new $DK1A9()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a74028b38e5a0a5a$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lHbGx(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $5Efje.assertOptions(transitional, {
        silentJSONParsing: $a74028b38e5a0a5a$var$validators.transitional($a74028b38e5a0a5a$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $a74028b38e5a0a5a$var$validators.transitional($a74028b38e5a0a5a$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $a74028b38e5a0a5a$var$validators.transitional($a74028b38e5a0a5a$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $9OxlO,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $9OxlO(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a74028b38e5a0a5a$var$Axios.prototype.getUri = function getUri(config) {
    config = $lHbGx(this.defaults, config);
    return $3ndEn(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$3W5kq.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a74028b38e5a0a5a$var$Axios.prototype[method] = function(url, config) {
        return this.request($lHbGx(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$3W5kq.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a74028b38e5a0a5a$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lHbGx(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a74028b38e5a0a5a$var$Axios;

});
parcelRequire.register("3ndEn", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
function $274e1bb6a6f6f7ac$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($3W5kq.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $3W5kq.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($3W5kq.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $3W5kq.forEach(val, function parseValue(v) {
                if ($3W5kq.isDate(v)) v = v.toISOString();
                else if ($3W5kq.isObject(v)) v = JSON.stringify(v);
                parts.push($274e1bb6a6f6f7ac$var$encode(key) + "=" + $274e1bb6a6f6f7ac$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("DK1A9", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
function $07775824d0cad506$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $07775824d0cad506$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $07775824d0cad506$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $07775824d0cad506$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $3W5kq.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $07775824d0cad506$var$InterceptorManager;

});

parcelRequire.register("9OxlO", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $iLAc8 = parcelRequire("iLAc8");

var $ggqxH = parcelRequire("ggqxH");

var $4cwFP = parcelRequire("4cwFP");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $7252a75d31f8c6d2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $7252a75d31f8c6d2$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $iLAc8.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $3W5kq.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $3W5kq.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $4cwFP.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $7252a75d31f8c6d2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $iLAc8.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$ggqxH(reason)) {
            $7252a75d31f8c6d2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $iLAc8.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("iLAc8", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $4cwFP = parcelRequire("4cwFP");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $4cwFP;
    /*eslint no-param-reassign:0*/ $3W5kq.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("4cwFP", function(module, exports) {

var $3oReb = parcelRequire("3oReb");
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $15sFj = parcelRequire("15sFj");

var $1o5Ll = parcelRequire("1o5Ll");
var $30f1a0bbe61633c4$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $30f1a0bbe61633c4$var$setContentTypeIfUnset(headers, value) {
    if (!$3W5kq.isUndefined(headers) && $3W5kq.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $30f1a0bbe61633c4$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("5L187"));
    else if (typeof $3oReb !== "undefined" && Object.prototype.toString.call($3oReb) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("5L187"));
    return adapter;
}
function $30f1a0bbe61633c4$var$stringifySafely(rawValue, parser, encoder) {
    if ($3W5kq.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $3W5kq.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $30f1a0bbe61633c4$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $30f1a0bbe61633c4$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $15sFj(headers, "Accept");
            $15sFj(headers, "Content-Type");
            if ($3W5kq.isFormData(data) || $3W5kq.isArrayBuffer(data) || $3W5kq.isBuffer(data) || $3W5kq.isStream(data) || $3W5kq.isFile(data) || $3W5kq.isBlob(data)) return data;
            if ($3W5kq.isArrayBufferView(data)) return data.buffer;
            if ($3W5kq.isURLSearchParams(data)) {
                $30f1a0bbe61633c4$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($3W5kq.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $30f1a0bbe61633c4$var$setContentTypeIfUnset(headers, "application/json");
                return $30f1a0bbe61633c4$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $3W5kq.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $1o5Ll(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$30f1a0bbe61633c4$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$3W5kq.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $30f1a0bbe61633c4$var$defaults.headers[method] = {};
});
$3W5kq.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $30f1a0bbe61633c4$var$defaults.headers[method] = $3W5kq.merge($30f1a0bbe61633c4$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $30f1a0bbe61633c4$var$defaults;

});
parcelRequire.register("3oReb", function(module, exports) {
// shim for using process in browser
var $279ce6ee3a39b7dd$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $279ce6ee3a39b7dd$var$cachedSetTimeout;
var $279ce6ee3a39b7dd$var$cachedClearTimeout;
function $279ce6ee3a39b7dd$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $279ce6ee3a39b7dd$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $279ce6ee3a39b7dd$var$cachedSetTimeout = setTimeout;
        else $279ce6ee3a39b7dd$var$cachedSetTimeout = $279ce6ee3a39b7dd$var$defaultSetTimout;
    } catch (e) {
        $279ce6ee3a39b7dd$var$cachedSetTimeout = $279ce6ee3a39b7dd$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $279ce6ee3a39b7dd$var$cachedClearTimeout = clearTimeout;
        else $279ce6ee3a39b7dd$var$cachedClearTimeout = $279ce6ee3a39b7dd$var$defaultClearTimeout;
    } catch (e) {
        $279ce6ee3a39b7dd$var$cachedClearTimeout = $279ce6ee3a39b7dd$var$defaultClearTimeout;
    }
})();
function $279ce6ee3a39b7dd$var$runTimeout(fun) {
    if ($279ce6ee3a39b7dd$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($279ce6ee3a39b7dd$var$cachedSetTimeout === $279ce6ee3a39b7dd$var$defaultSetTimout || !$279ce6ee3a39b7dd$var$cachedSetTimeout) && setTimeout) {
        $279ce6ee3a39b7dd$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $279ce6ee3a39b7dd$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $279ce6ee3a39b7dd$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $279ce6ee3a39b7dd$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $279ce6ee3a39b7dd$var$runClearTimeout(marker) {
    if ($279ce6ee3a39b7dd$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($279ce6ee3a39b7dd$var$cachedClearTimeout === $279ce6ee3a39b7dd$var$defaultClearTimeout || !$279ce6ee3a39b7dd$var$cachedClearTimeout) && clearTimeout) {
        $279ce6ee3a39b7dd$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $279ce6ee3a39b7dd$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $279ce6ee3a39b7dd$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $279ce6ee3a39b7dd$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $279ce6ee3a39b7dd$var$queue = [];
var $279ce6ee3a39b7dd$var$draining = false;
var $279ce6ee3a39b7dd$var$currentQueue;
var $279ce6ee3a39b7dd$var$queueIndex = -1;
function $279ce6ee3a39b7dd$var$cleanUpNextTick() {
    if (!$279ce6ee3a39b7dd$var$draining || !$279ce6ee3a39b7dd$var$currentQueue) return;
    $279ce6ee3a39b7dd$var$draining = false;
    if ($279ce6ee3a39b7dd$var$currentQueue.length) $279ce6ee3a39b7dd$var$queue = $279ce6ee3a39b7dd$var$currentQueue.concat($279ce6ee3a39b7dd$var$queue);
    else $279ce6ee3a39b7dd$var$queueIndex = -1;
    if ($279ce6ee3a39b7dd$var$queue.length) $279ce6ee3a39b7dd$var$drainQueue();
}
function $279ce6ee3a39b7dd$var$drainQueue() {
    if ($279ce6ee3a39b7dd$var$draining) return;
    var timeout = $279ce6ee3a39b7dd$var$runTimeout($279ce6ee3a39b7dd$var$cleanUpNextTick);
    $279ce6ee3a39b7dd$var$draining = true;
    var len = $279ce6ee3a39b7dd$var$queue.length;
    while(len){
        $279ce6ee3a39b7dd$var$currentQueue = $279ce6ee3a39b7dd$var$queue;
        $279ce6ee3a39b7dd$var$queue = [];
        while(++$279ce6ee3a39b7dd$var$queueIndex < len)if ($279ce6ee3a39b7dd$var$currentQueue) $279ce6ee3a39b7dd$var$currentQueue[$279ce6ee3a39b7dd$var$queueIndex].run();
        $279ce6ee3a39b7dd$var$queueIndex = -1;
        len = $279ce6ee3a39b7dd$var$queue.length;
    }
    $279ce6ee3a39b7dd$var$currentQueue = null;
    $279ce6ee3a39b7dd$var$draining = false;
    $279ce6ee3a39b7dd$var$runClearTimeout(timeout);
}
$279ce6ee3a39b7dd$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $279ce6ee3a39b7dd$var$queue.push(new $279ce6ee3a39b7dd$var$Item(fun, args));
    if ($279ce6ee3a39b7dd$var$queue.length === 1 && !$279ce6ee3a39b7dd$var$draining) $279ce6ee3a39b7dd$var$runTimeout($279ce6ee3a39b7dd$var$drainQueue);
};
// v8 likes predictible objects
function $279ce6ee3a39b7dd$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$279ce6ee3a39b7dd$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$279ce6ee3a39b7dd$var$process.title = "browser";
$279ce6ee3a39b7dd$var$process.browser = true;
$279ce6ee3a39b7dd$var$process.env = {};
$279ce6ee3a39b7dd$var$process.argv = [];
$279ce6ee3a39b7dd$var$process.version = ""; // empty string to avoid regexp issues
$279ce6ee3a39b7dd$var$process.versions = {};
function $279ce6ee3a39b7dd$var$noop() {}
$279ce6ee3a39b7dd$var$process.on = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.addListener = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.once = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.off = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.removeListener = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.removeAllListeners = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.emit = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.prependListener = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.prependOnceListener = $279ce6ee3a39b7dd$var$noop;
$279ce6ee3a39b7dd$var$process.listeners = function(name) {
    return [];
};
$279ce6ee3a39b7dd$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$279ce6ee3a39b7dd$var$process.cwd = function() {
    return "/";
};
$279ce6ee3a39b7dd$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$279ce6ee3a39b7dd$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("15sFj", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $3W5kq.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("1o5Ll", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("5L187", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");

var $jfBNb = parcelRequire("jfBNb");

var $32mjy = parcelRequire("32mjy");

var $3ndEn = parcelRequire("3ndEn");

var $9KI2x = parcelRequire("9KI2x");

var $9KyJt = parcelRequire("9KyJt");

var $cCDja = parcelRequire("cCDja");

var $YNV5Z = parcelRequire("YNV5Z");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($3W5kq.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $9KI2x(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $3ndEn(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $9KyJt(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $jfBNb(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($YNV5Z("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($YNV5Z("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($YNV5Z(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($3W5kq.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $cCDja(fullPath)) && config.xsrfCookieName ? $32mjy.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $3W5kq.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$3W5kq.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("jfBNb", function(module, exports) {
"use strict";

var $YNV5Z = parcelRequire("YNV5Z");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($YNV5Z("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("YNV5Z", function(module, exports) {
"use strict";

var $1o5Ll = parcelRequire("1o5Ll");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $1o5Ll(error, config, code, request, response);
};

});


parcelRequire.register("32mjy", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
module.exports = $3W5kq.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($3W5kq.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($3W5kq.isString(path)) cookie.push("path=" + path);
            if ($3W5kq.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("9KI2x", function(module, exports) {
"use strict";

var $9Mv7C = parcelRequire("9Mv7C");

var $02sRo = parcelRequire("02sRo");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$9Mv7C(requestedURL)) return $02sRo(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("9Mv7C", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("02sRo", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("9KyJt", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $71935a16be6996d3$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $3W5kq.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $3W5kq.trim(line.substr(0, i)).toLowerCase();
        val = $3W5kq.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $71935a16be6996d3$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("cCDja", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
module.exports = $3W5kq.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $3W5kq.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("ggqxH", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("lHbGx", function(module, exports) {
"use strict";

var $3W5kq = parcelRequire("3W5kq");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($3W5kq.isPlainObject(target) && $3W5kq.isPlainObject(source)) return $3W5kq.merge(target, source);
        else if ($3W5kq.isPlainObject(source)) return $3W5kq.merge({}, source);
        else if ($3W5kq.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$3W5kq.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$3W5kq.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $3W5kq.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$3W5kq.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $3W5kq.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $3W5kq.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$3W5kq.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$3W5kq.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $3W5kq.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $3W5kq.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("5Efje", function(module, exports) {
"use strict";

var $3hJzP = parcelRequire("3hJzP");
var $41cc903e5069aa81$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $41cc903e5069aa81$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $41cc903e5069aa81$var$deprecatedWarnings = {};
var $41cc903e5069aa81$var$currentVerArr = $3hJzP.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $41cc903e5069aa81$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $41cc903e5069aa81$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $41cc903e5069aa81$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $41cc903e5069aa81$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $3hJzP.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$41cc903e5069aa81$var$deprecatedWarnings[opt]) {
            $41cc903e5069aa81$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $41cc903e5069aa81$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $41cc903e5069aa81$var$isOlderVersion,
    assertOptions: $41cc903e5069aa81$var$assertOptions,
    validators: $41cc903e5069aa81$var$validators
};

});
parcelRequire.register("3hJzP", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("6Tinf", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $504621ccebecd950$var$Cancel(message) {
    this.message = message;
}
$504621ccebecd950$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$504621ccebecd950$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $504621ccebecd950$var$Cancel;

});

parcelRequire.register("WDw9T", function(module, exports) {
"use strict";

var $6Tinf = parcelRequire("6Tinf");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $0b04124897cd8f7b$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $6Tinf(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $0b04124897cd8f7b$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $0b04124897cd8f7b$var$CancelToken.source = function source() {
    var cancel;
    var token = new $0b04124897cd8f7b$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $0b04124897cd8f7b$var$CancelToken;

});

parcelRequire.register("fEIML", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("arXh5", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRequire.register("i706F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f8f6983b46f968$var$_react = $d2f8f6983b46f968$var$_interopRequireWildcard((parcelRequire("2Jeaf")));


var $d2f8f6983b46f968$var$_classnames = $d2f8f6983b46f968$var$_interopRequireDefault((parcelRequire("grfkD")));
function $d2f8f6983b46f968$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d2f8f6983b46f968$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d2f8f6983b46f968$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d2f8f6983b46f968$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d2f8f6983b46f968$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d2f8f6983b46f968$var$_extends() {
    $d2f8f6983b46f968$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2f8f6983b46f968$var$_extends.apply(this, arguments);
}
const $d2f8f6983b46f968$var$Loading = (_ref)=>{
    let { className: className, prefix: prefix, children: child, text: text, labelTransitions: labelTransitions, labelPosition: labelPosition, ...otherProps } = _ref;
    const baseClass = `${prefix}loading`;
    const [displayText, setDisplayText] = (0, $d2f8f6983b46f968$var$_react.useState)(text);
    const [fadeOut, setFadeOut] = (0, $d2f8f6983b46f968$var$_react.useState)(false);
    const [fadeIn, setFadeIn] = (0, $d2f8f6983b46f968$var$_react.useState)(false);
    (0, $d2f8f6983b46f968$var$_react.useEffect)(()=>{
        let fadeOutTimer = 0;
        let fadeInTimer = 0;
        if (labelTransitions && text !== displayText) {
            setFadeIn(false);
            setFadeOut(true);
            fadeOutTimer = setTimeout(()=>{
                setFadeOut(false);
                fadeInTimer = setTimeout(()=>{
                    setFadeIn(true);
                    setDisplayText(text);
                }, 100);
            }, 100);
        } else {
            setFadeIn(true);
            setDisplayText(text);
        }
        return ()=>{
            clearTimeout(fadeOutTimer);
            clearTimeout(fadeInTimer);
        };
    }, [
        text
    ]);
    const loadingClass = (0, $d2f8f6983b46f968$var$_classnames.default)(baseClass, `${baseClass}--label-${labelPosition}`, className);
    const loadingTextClasses = (0, $d2f8f6983b46f968$var$_classnames.default)(`${baseClass}__text`, fadeOut && `${baseClass}__text--fade-out`, fadeIn && `${baseClass}__text--fade-in`);
    const shouldRenderLabel = child && !child.props.size || child && child.props.size === "large";
    return $d2f8f6983b46f968$var$_react.default.createElement("span", $d2f8f6983b46f968$var$_extends({}, otherProps, {
        className: loadingClass,
        "aria-live": "polite"
    }), child && (0, $d2f8f6983b46f968$var$_react.cloneElement)(child, {
        prefix: prefix
    }), shouldRenderLabel && $d2f8f6983b46f968$var$_react.default.createElement("span", {
        "aria-hidden": true,
        className: loadingTextClasses
    }, displayText), $d2f8f6983b46f968$var$_react.default.createElement("span", {
        className: `${baseClass}__sr-only-text`
    }, text));
};
$d2f8f6983b46f968$var$Loading.defaultProps = {
    prefix: "",
    text: "Loading…",
    labelTransitions: false,
    labelPosition: "center"
};
var $d2f8f6983b46f968$var$_default = $d2f8f6983b46f968$var$Loading;
module.exports.default = $d2f8f6983b46f968$var$_default;

});

parcelRequire.register("i0P3O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1cfd5a138468e5b$var$_react = $d1cfd5a138468e5b$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $d1cfd5a138468e5b$var$_classnames = $d1cfd5a138468e5b$var$_interopRequireDefault((parcelRequire("grfkD")));
function $d1cfd5a138468e5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d1cfd5a138468e5b$var$_extends() {
    $d1cfd5a138468e5b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1cfd5a138468e5b$var$_extends.apply(this, arguments);
}
const $d1cfd5a138468e5b$var$LoadingBall = (_ref)=>{
    let { className: className, prefix: prefix, size: size, color: color, ...otherProps } = _ref;
    const baseClass = `${prefix}loading__ball`;
    const loadingBallClass = (0, $d1cfd5a138468e5b$var$_classnames.default)(baseClass, `${baseClass}--${size}`, `${baseClass}--${color}`);
    return $d1cfd5a138468e5b$var$_react.default.createElement("span", $d1cfd5a138468e5b$var$_extends({}, otherProps, {
        className: loadingBallClass,
        "aria-hidden": true
    }));
};
$d1cfd5a138468e5b$var$LoadingBall.defaultProps = {
    prefix: "",
    size: "large",
    color: "emphasised"
};
var $d1cfd5a138468e5b$var$_default = $d1cfd5a138468e5b$var$LoadingBall;
module.exports.default = $d1cfd5a138468e5b$var$_default;

});

parcelRequire.register("kqGxE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edf73c440dedc93f$var$_react = $edf73c440dedc93f$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $edf73c440dedc93f$var$_classnames = $edf73c440dedc93f$var$_interopRequireDefault((parcelRequire("grfkD")));
function $edf73c440dedc93f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edf73c440dedc93f$var$_extends() {
    $edf73c440dedc93f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $edf73c440dedc93f$var$_extends.apply(this, arguments);
}
const $edf73c440dedc93f$var$LoadingLinear = (_ref)=>{
    let { className: className, prefix: prefix, loadingValue: loadingValue, loadingMax: loadingMax, loadingLabel: loadingLabel, ...otherProps } = _ref;
    const baseClass = `${prefix}loading__linear`;
    const linearWrapperClasses = (0, $edf73c440dedc93f$var$_classnames.default)(`${baseClass}-wrapper`, className);
    const currentValue = loadingValue > loadingMax ? loadingMax : loadingValue;
    return $edf73c440dedc93f$var$_react.default.createElement("span", $edf73c440dedc93f$var$_extends({}, otherProps, {
        className: linearWrapperClasses
    }), $edf73c440dedc93f$var$_react.default.createElement("label", {
        className: `${baseClass}-label`
    }, loadingLabel), $edf73c440dedc93f$var$_react.default.createElement("progress", {
        className: `${baseClass}-progress`,
        value: currentValue,
        max: loadingMax,
        "aria-valuemin": "0",
        "aria-valuenow": currentValue,
        "aria-valuemax": loadingMax
    }));
};
$edf73c440dedc93f$var$LoadingLinear.defaultProps = {
    prefix: "",
    loadingValue: 0,
    loadingMax: 100
};
var $edf73c440dedc93f$var$_default = $edf73c440dedc93f$var$LoadingLinear;
module.exports.default = $edf73c440dedc93f$var$_default;

});

parcelRequire.register("jdDIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfde0aa1e979643d$var$_react = $dfde0aa1e979643d$var$_interopRequireWildcard((parcelRequire("2Jeaf")));


var $i7P1Y = parcelRequire("i7P1Y");

var $cI9t9 = parcelRequire("cI9t9");

var $dfde0aa1e979643d$var$_classnames = $dfde0aa1e979643d$var$_interopRequireDefault((parcelRequire("grfkD")));

var $dfde0aa1e979643d$var$_button = $dfde0aa1e979643d$var$_interopRequireDefault((parcelRequire("dcraR")));
function $dfde0aa1e979643d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dfde0aa1e979643d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dfde0aa1e979643d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dfde0aa1e979643d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dfde0aa1e979643d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dfde0aa1e979643d$var$_extends() {
    $dfde0aa1e979643d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfde0aa1e979643d$var$_extends.apply(this, arguments);
}
const $dfde0aa1e979643d$var$Expander = (_ref)=>{
    let { children: children, targetId: targetId, labelOpen: labelOpen, labelClosed: labelClosed, generic: generic, open: open, prefix: prefix, duration: duration, onToggle: onToggle, ...other } = _ref;
    const contentWrapper = (0, $dfde0aa1e979643d$var$_react.useRef)();
    const contentElement = (0, $dfde0aa1e979643d$var$_react.useRef)();
    const animationFrameID = (0, $dfde0aa1e979643d$var$_react.useRef)(null);
    const [expanded, setExpanded] = (0, $dfde0aa1e979643d$var$_react.useState)(open);
    const isSSR = typeof window === "undefined";
    const [animationState, setAnimationState] = (0, $dfde0aa1e979643d$var$_react.useState)($cI9t9.animationStates.EXPANDED);
    if (!isSSR) (0, $dfde0aa1e979643d$var$_react.useLayoutEffect)(()=>{
        if (!expanded) setAnimationState($cI9t9.animationStates.COLLAPSED);
    }, []);
    (0, $dfde0aa1e979643d$var$_react.useEffect)(()=>{
        if (animationState === $cI9t9.animationStates.EXPANDED && expanded || animationState === $cI9t9.animationStates.COLLAPSED && !expanded) return;
        setAnimationState(expanded ? $cI9t9.animationStates.PREPARE_ANIMATE_FROM_COLLAPSED : $cI9t9.animationStates.PREPARE_ANIMATE_FROM_EXPANDED);
        return ()=>{
            cancelAnimationFrame(animationFrameID.current);
        };
    }, [
        expanded
    ]);
    (0, $dfde0aa1e979643d$var$_react.useEffect)(()=>{
        if (animationState === $cI9t9.animationStates.PREPARE_ANIMATE_FROM_COLLAPSED) setAnimationState($cI9t9.animationStates.ANIMATING_TO_EXPANDED);
        else if (animationState === $cI9t9.animationStates.PREPARE_ANIMATE_FROM_EXPANDED) setAnimationState($cI9t9.animationStates.ANIMATING_TO_COLLAPSED);
    }, [
        animationState
    ]);
    (0, $dfde0aa1e979643d$var$_react.useEffect)(()=>{
        setAnimationState(expanded ? $cI9t9.animationStates.EXPANDED : $cI9t9.animationStates.COLLAPSED);
        cancelAnimationFrame(animationFrameID.current);
    }, []);
    const toggleTarget = (e)=>{
        e.preventDefault();
        const nextExpandedState = !expanded;
        if (nextExpandedState) contentWrapper.current.focus();
        setExpanded(nextExpandedState);
        if (onToggle) onToggle(e, nextExpandedState);
    };
    const ExpanderButton = ()=>{
        if (generic) return $dfde0aa1e979643d$var$_react.default.createElement($dfde0aa1e979643d$var$_button.default, $dfde0aa1e979643d$var$_extends({
            className: btnClasses,
            "aria-expanded": expanded,
            "aria-controls": targetId,
            text: expanded ? labelOpen : labelClosed,
            prefix: prefix,
            type: "secondary",
            onClick: toggleTarget
        }, other));
        return $dfde0aa1e979643d$var$_react.default.createElement("button", $dfde0aa1e979643d$var$_extends({
            className: btnClasses,
            "aria-expanded": expanded,
            "aria-controls": targetId,
            onClick: toggleTarget
        }, other), expanded ? labelOpen : labelClosed);
    };
    const baseClass = `${prefix}expander`;
    const rootClass = (0, $dfde0aa1e979643d$var$_classnames.default)(baseClass);
    const btnClasses = (0, $dfde0aa1e979643d$var$_classnames.default)(`${baseClass}__btn`, generic && `${baseClass}__btn--generic`);
    const classes = (0, $dfde0aa1e979643d$var$_classnames.default)(`${baseClass}__content`);
    const marginBottom = generic ? "2rem" : "1.5rem";
    const isCollapsed = animationState === $cI9t9.animationStates.COLLAPSED;
    return $dfde0aa1e979643d$var$_react.default.createElement("div", {
        className: rootClass
    }, $dfde0aa1e979643d$var$_react.default.createElement("div", {
        className: classes,
        id: targetId,
        style: $cI9t9.getStyles[animationState](marginBottom, duration, contentElement.current ? contentElement.current.scrollHeight : null),
        onTransitionEnd: ()=>setAnimationState(expanded ? $cI9t9.animationStates.EXPANDED : $cI9t9.animationStates.COLLAPSED),
        "aria-hidden": isCollapsed,
        role: "region",
        tabIndex: expanded ? "0" : "-1",
        ref: contentWrapper
    }, $dfde0aa1e979643d$var$_react.default.createElement("div", {
        style: {
            display: isCollapsed ? "none" : null
        },
        ref: contentElement
    }, children)), $dfde0aa1e979643d$var$_react.default.createElement(ExpanderButton, null));
};
$dfde0aa1e979643d$var$Expander.defaultProps = {
    duration: parseInt($i7P1Y.durationSlowWeb, 10),
    labelOpen: "Read less",
    labelClosed: "Read more",
    generic: false,
    open: false,
    prefix: ""
};
var $dfde0aa1e979643d$var$_default = $dfde0aa1e979643d$var$Expander;
module.exports.default = $dfde0aa1e979643d$var$_default;

});
parcelRequire.register("cI9t9", function(module, exports) {

$parcel$export(module.exports, "animationStates", () => $9410f0782c107569$export$7548fbf422c2e57b);
$parcel$export(module.exports, "getStyles", () => $9410f0782c107569$export$ffd58b7f6f099a57);

var $i7P1Y = parcelRequire("i7P1Y");
const $9410f0782c107569$export$7548fbf422c2e57b = {
    EXPANDED: "EXPANDED",
    ANIMATING_TO_EXPANDED: "ANIMATING_TO_EXPANDED",
    PREPARE_ANIMATE_FROM_EXPANDED: "PREPARE_ANIMATE_FROM_EXPANDED",
    COLLAPSED: "COLLAPSED",
    ANIMATING_TO_COLLAPSED: "ANIMATING_TO_COLLAPSED",
    PREPARE_ANIMATE_FROM_COLLAPSED: "PREPARE_ANIMATE_FROM_COLLAPSED"
};
const $9410f0782c107569$var$collapsedStyles = {
    height: 0,
    marginBottom: "0"
};
const $9410f0782c107569$export$ffd58b7f6f099a57 = {
    [$9410f0782c107569$export$7548fbf422c2e57b.EXPANDED]: (marginBottom)=>{
        return {
            marginBottom: marginBottom
        };
    },
    [$9410f0782c107569$export$7548fbf422c2e57b.ANIMATING_TO_EXPANDED]: (marginBottom, duration, height)=>{
        return {
            height: `${height || 0}px`,
            marginBottom: marginBottom,
            transition: `all ${duration}ms ${0, $i7P1Y.easeEasy}`
        };
    },
    [$9410f0782c107569$export$7548fbf422c2e57b.PREPARE_ANIMATE_FROM_EXPANDED]: (marginBottom, _, height)=>{
        return {
            height: `${height || 0}px`,
            marginBottom: marginBottom
        };
    },
    [$9410f0782c107569$export$7548fbf422c2e57b.COLLAPSED]: ()=>$9410f0782c107569$var$collapsedStyles,
    [$9410f0782c107569$export$7548fbf422c2e57b.ANIMATING_TO_COLLAPSED]: (_, duration)=>{
        return {
            height: 0,
            marginBottom: "0",
            transition: `all ${duration}ms ${0, $i7P1Y.easeEasy}`
        };
    },
    [$9410f0782c107569$export$7548fbf422c2e57b.PREPARE_ANIMATE_FROM_COLLAPSED]: ()=>$9410f0782c107569$var$collapsedStyles
};

});


parcelRequire.register("iR1bu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $db9e186c4876fd00$var$_react = $db9e186c4876fd00$var$_interopRequireWildcard((parcelRequire("2Jeaf")));

var $db9e186c4876fd00$var$_classnames = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("grfkD")));

var $db9e186c4876fd00$var$_ssrIcon = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("9UDiX")));

var $db9e186c4876fd00$var$_button = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("dcraR")));

var $db9e186c4876fd00$var$_magnifyingGlass = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("cKpax")));

var $db9e186c4876fd00$var$_crossSmall = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("cBLLV")));

var $db9e186c4876fd00$var$_chevronDownSmall = $db9e186c4876fd00$var$_interopRequireDefault((parcelRequire("jyM1I")));
function $db9e186c4876fd00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $db9e186c4876fd00$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($db9e186c4876fd00$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $db9e186c4876fd00$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $db9e186c4876fd00$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $db9e186c4876fd00$var$_extends() {
    $db9e186c4876fd00$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $db9e186c4876fd00$var$_extends.apply(this, arguments);
}
const $db9e186c4876fd00$var$Search = (0, $db9e186c4876fd00$var$_react.forwardRef)((props, ref)=>{
    const { actions: actions, ariaLabel: ariaLabel, className: className, clearBtnText: clearBtnText, submitBtnText: submitBtnText, describedById: describedById, disabled: disabled, id: id, onSearch: onSearch, onClear: onClear, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onKeyUp: onKeyUp, prefix: prefix, placeholder: placeholder, scope: scope, scopeSelectProps: scopeSelectProps, ...other } = props;
    const { defaultValue: defaultValue, value: value } = other;
    const [isActive, setIsActive] = (0, $db9e186c4876fd00$var$_react.useState)(false);
    const [isFilled, setIsFilled] = (0, $db9e186c4876fd00$var$_react.useState)(Boolean(defaultValue || value));
    const inputRef = ref || (0, $db9e186c4876fd00$var$_react.useRef)(null);
    const selectRef = (0, $db9e186c4876fd00$var$_react.useRef)(null);
    const getState = ()=>({
            scope: selectRef.current && selectRef.current.value,
            value: inputRef.current.value
        });
    const handleFocus = (e)=>{
        setIsActive(true);
        if (onFocus) onFocus(e);
    };
    const handleBlur = (e)=>{
        setIsActive(false);
        if (onBlur) onBlur(e);
    };
    const handleValueChange = (e)=>{
        setIsFilled(Boolean(e.target.value.length));
        if (onChange) onChange(e, getState());
    };
    const handleClearValue = (e)=>{
        inputRef.current.value = "";
        inputRef.current.focus();
        setIsFilled(false);
        if (onClear) onClear(e);
    };
    const handleSearch = (e)=>{
        if (onSearch) onSearch(e, getState());
    };
    const handleKeyUp = (e)=>{
        if (onKeyUp) onKeyUp(e, getState());
        else if (e.key === "Enter") handleSearch(e);
    };
    const baseClass = `${prefix}search`;
    const searchClasses = (0, $db9e186c4876fd00$var$_classnames.default)(`${baseClass}`, isActive && `${baseClass}--active`, isFilled && `${baseClass}--filled`, disabled && `${baseClass}--disabled`, className);
    return $db9e186c4876fd00$var$_react.default.createElement("div", {
        className: searchClasses
    }, $db9e186c4876fd00$var$_react.default.createElement("label", {
        htmlFor: id,
        className: `${baseClass}__icon`
    }, $db9e186c4876fd00$var$_react.default.createElement($db9e186c4876fd00$var$_ssrIcon.default, {
        prefix: prefix,
        paths: $db9e186c4876fd00$var$_magnifyingGlass.default
    })), $db9e186c4876fd00$var$_react.default.createElement("div", {
        className: `${baseClass}__input-wrapper`
    }, $db9e186c4876fd00$var$_react.default.createElement("input", $db9e186c4876fd00$var$_extends({
        id: id,
        ref: inputRef,
        type: "search",
        className: `${baseClass}__input`,
        disabled: disabled,
        onChange: handleValueChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyUp: handleKeyUp,
        placeholder: placeholder,
        "aria-disabled": disabled,
        "aria-describedby": describedById,
        "aria-label": ariaLabel
    }, other)), isFilled && $db9e186c4876fd00$var$_react.default.createElement($db9e186c4876fd00$var$_button.default, {
        className: `${baseClass}__action ${baseClass}__clear`,
        prefix: prefix,
        type: "tertiary",
        small: true,
        iconOnly: true,
        ssrIcon: $db9e186c4876fd00$var$_crossSmall.default,
        text: clearBtnText,
        onClick: handleClearValue
    })), !isFilled && actions && actions.length > 0 && $db9e186c4876fd00$var$_react.default.createElement("div", {
        className: `${baseClass}__action-wrapper`
    }, actions.map((action, index)=>$db9e186c4876fd00$var$_react.default.createElement($db9e186c4876fd00$var$_button.default, {
            key: index,
            type: "tertiary",
            text: action.text,
            className: `${baseClass}__action`,
            small: true,
            iconOnly: true,
            prefix: prefix,
            ssrIcon: action.ssrIcon,
            onClick: action.onClick,
            disabled: action.disabled
        }))), scope && $db9e186c4876fd00$var$_react.default.createElement("div", {
        className: `${baseClass}__scope-wrapper`
    }, $db9e186c4876fd00$var$_react.default.createElement("span", {
        className: `${baseClass}__divider`,
        "aria-hidden": "true"
    }), $db9e186c4876fd00$var$_react.default.createElement("select", $db9e186c4876fd00$var$_extends({
        ref: selectRef,
        className: `${baseClass}__scope`
    }, scopeSelectProps), Object.keys(scope).map((scopeKey, index)=>$db9e186c4876fd00$var$_react.default.createElement("option", {
            key: `${scopeKey}--${index}`,
            value: scope[scopeKey]
        }, scopeKey))), $db9e186c4876fd00$var$_react.default.createElement($db9e186c4876fd00$var$_ssrIcon.default, {
        className: `${baseClass}__chevron-down`,
        prefix: prefix,
        paths: $db9e186c4876fd00$var$_chevronDownSmall.default
    })), isFilled && $db9e186c4876fd00$var$_react.default.createElement("div", {
        className: `${baseClass}__action-wrapper`
    }, $db9e186c4876fd00$var$_react.default.createElement("span", {
        className: `${baseClass}__divider`,
        "aria-hidden": "true"
    }), $db9e186c4876fd00$var$_react.default.createElement($db9e186c4876fd00$var$_button.default, {
        prefix: prefix,
        htmlType: "submit",
        type: "tertiary",
        className: `${baseClass}__action`,
        small: true,
        iconOnly: true,
        ssrIcon: $db9e186c4876fd00$var$_magnifyingGlass.default,
        text: submitBtnText,
        onClick: handleSearch
    })));
});
$db9e186c4876fd00$var$Search.defaultProps = {
    prefix: "",
    placeholder: "Search"
};
$db9e186c4876fd00$var$Search.displayName = "Search";
var $db9e186c4876fd00$var$_default = $db9e186c4876fd00$var$Search;
module.exports.default = $db9e186c4876fd00$var$_default;

});
parcelRequire.register("9UDiX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7377d5252dee5ae6$var$_SSRIcon = $7377d5252dee5ae6$var$_interopRequireDefault((parcelRequire("72HD0")));
function $7377d5252dee5ae6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7377d5252dee5ae6$var$_default = $7377d5252dee5ae6$var$_SSRIcon.default;
module.exports.default = $7377d5252dee5ae6$var$_default;

});
parcelRequire.register("72HD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $520a8ff3f37d2708$var$_react = $520a8ff3f37d2708$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $520a8ff3f37d2708$var$_classnames = $520a8ff3f37d2708$var$_interopRequireDefault((parcelRequire("grfkD")));
function $520a8ff3f37d2708$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $520a8ff3f37d2708$var$_extends() {
    $520a8ff3f37d2708$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $520a8ff3f37d2708$var$_extends.apply(this, arguments);
}
const $520a8ff3f37d2708$var$SSRIcon = (_ref)=>{
    let { prefix: prefix, viewBox: viewBox, paths: paths, className: className, modifier: modifier, alt: alt, ariaHidden: ariaHidden, ...otherProps } = _ref;
    const cssStyles = (0, $520a8ff3f37d2708$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $520a8ff3f37d2708$var$_react.default.createElement("svg", $520a8ff3f37d2708$var$_extends({
        focusable: "false",
        viewBox: viewBox
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $520a8ff3f37d2708$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
$520a8ff3f37d2708$var$SSRIcon.defaultProps = {
    prefix: "",
    viewBox: "0 0 24 24",
    ariaHidden: true
};
var $520a8ff3f37d2708$var$_default = $520a8ff3f37d2708$var$SSRIcon;
module.exports.default = $520a8ff3f37d2708$var$_default;

});


parcelRequire.register("cKpax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $947d4df88dd107b6$var$_react = $947d4df88dd107b6$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $947d4df88dd107b6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $947d4df88dd107b6$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $947d4df88dd107b6$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.9804 15.3946c-1.0361.7502-2.3099 1.1925-3.6869 1.1925C6.8177 16.5871 4 13.7694 4 10.2935 4 6.8177 6.8177 4 10.2935 4c3.4759 0 6.2936 2.8177 6.2936 6.2935 0 1.377-.4423 2.6508-1.1925 3.6869l4.6016 4.6016-1.4142 1.4142-4.6016-4.6016zm.6067-5.1011c0 2.3713-1.9223 4.2936-4.2936 4.2936C7.9223 14.5871 6 12.6648 6 10.2935 6 7.9223 7.9223 6 10.2935 6c2.3713 0 4.2936 1.9223 4.2936 4.2935z"
        })
    ];
};
module.exports.default = $947d4df88dd107b6$var$_default;

});

parcelRequire.register("cBLLV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ddff3c7f1d8f13$var$_react = $92ddff3c7f1d8f13$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $92ddff3c7f1d8f13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $92ddff3c7f1d8f13$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $92ddff3c7f1d8f13$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0006 13.4148 2.8283 2.8283 1.4142-1.4142-2.8283-2.8283 2.8283-2.8283-1.4142-1.4142-2.8283 2.8283L9.172 7.7578 7.7578 9.172l2.8286 2.8286-2.8286 2.8285 1.4142 1.4143 2.8286-2.8286z"
        })
    ];
};
module.exports.default = $92ddff3c7f1d8f13$var$_default;

});

parcelRequire.register("jyM1I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3d67269a7487c77$var$_react = $e3d67269a7487c77$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $e3d67269a7487c77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e3d67269a7487c77$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $e3d67269a7487c77$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0003 15.5996-5.7857-5.785 1.414-1.4143 4.3717 4.3711 4.3717-4.3711 1.4141 1.4143-5.7858 5.785z"
        })
    ];
};
module.exports.default = $e3d67269a7487c77$var$_default;

});


parcelRequire.register("kHTl8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;


var $f132c01f9d7501df$var$_react = $f132c01f9d7501df$var$_interopRequireWildcard((parcelRequire("2Jeaf")));

var $f132c01f9d7501df$var$_classnames = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("grfkD")));

var $f132c01f9d7501df$var$_ssrIcon = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("2Q7dU")));

var $f132c01f9d7501df$var$_button = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("dcraR")));

var $f132c01f9d7501df$var$_hyperlink = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("d62mC")));

var $f132c01f9d7501df$var$_crossSmall = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("20qIU")));

var $f132c01f9d7501df$var$_incorrect = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("fuJ8M")));

var $f132c01f9d7501df$var$_warningTriangle = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("jaTnI")));

var $f132c01f9d7501df$var$_checkmarkCircle = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("dUWp5")));

var $f132c01f9d7501df$var$_informationCircle = $f132c01f9d7501df$var$_interopRequireDefault((parcelRequire("Vr5MD")));
function $f132c01f9d7501df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f132c01f9d7501df$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f132c01f9d7501df$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f132c01f9d7501df$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f132c01f9d7501df$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f132c01f9d7501df$var$_extends() {
    $f132c01f9d7501df$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f132c01f9d7501df$var$_extends.apply(this, arguments);
}
const $f132c01f9d7501df$var$icons = {
    informative: $f132c01f9d7501df$var$_informationCircle.default,
    positive: $f132c01f9d7501df$var$_checkmarkCircle.default,
    cautionary: $f132c01f9d7501df$var$_warningTriangle.default,
    negative: $f132c01f9d7501df$var$_incorrect.default
};
const $f132c01f9d7501df$var$InlineMessage = (_ref)=>{
    let { className: className, headingLevel: headingLevel, actions: actions, prefix: prefix, link: link, newWindow: newWindow, linkLabel: linkLabel, body: body, ssrIcon: ssrIcon, title: title, labelCloseButton: labelCloseButton, subtle: subtle, variant: variant, dismissable: dismissable, onDismissClick: onDismissClick, collapseWhenClosed: collapseWhenClosed, ...other } = _ref;
    const wrapperRef = (0, $f132c01f9d7501df$var$_react.useRef)(null);
    const isInformative = variant === "informative";
    const hideIcon = isInformative && !ssrIcon;
    const [isMessageClosed, setMessageClose] = (0, $f132c01f9d7501df$var$_react.useState)(false);
    const [wrapperHeight, setWrapperHeight] = (0, $f132c01f9d7501df$var$_react.useState)(null);
    const [collapsed, setCollapsed] = (0, $f132c01f9d7501df$var$_react.useState)(false);
    const closeClick = ()=>{
        requestAnimationFrame(function() {
            setWrapperHeight(wrapperRef.current.scrollHeight);
            requestAnimationFrame(function() {
                setWrapperHeight(0);
            });
        });
        setMessageClose(true);
    };
    const handleTransitionEnd = (e)=>{
        if (e.propertyName !== "height") return;
        setCollapsed(true);
        if (onDismissClick) onDismissClick(e);
    };
    const baseClass = `${prefix}inline-message`;
    const classes = (0, $f132c01f9d7501df$var$_classnames.default)(baseClass, `${baseClass}--${variant}`, isMessageClosed && `${baseClass}--closed`, hideIcon && `${baseClass}--icon-hidden`, subtle && `${baseClass}--subtle`, collapseWhenClosed && collapsed && `${baseClass}--collapsed`, dismissable && `${baseClass}--dismissable`, className);
    const HeadingTag = `h${headingLevel}`;
    return $f132c01f9d7501df$var$_react.default.createElement("div", $f132c01f9d7501df$var$_extends({
        "aria-hidden": isMessageClosed ? "true" : "false",
        className: classes,
        ref: wrapperRef,
        style: {
            height: wrapperHeight
        },
        onTransitionEnd: handleTransitionEnd
    }, other), !hideIcon && $f132c01f9d7501df$var$_react.default.createElement($f132c01f9d7501df$var$_ssrIcon.default, {
        className: `${baseClass}__icon`,
        paths: ssrIcon ? ssrIcon : $f132c01f9d7501df$var$icons[variant],
        prefix: prefix
    }), $f132c01f9d7501df$var$_react.default.createElement("div", {
        className: `${baseClass}__content`
    }, title && !subtle && $f132c01f9d7501df$var$_react.default.createElement(HeadingTag, {
        className: `${baseClass}__title`
    }, title), $f132c01f9d7501df$var$_react.default.createElement("p", {
        className: `${baseClass}__body`
    }, body, " ", linkLabel && $f132c01f9d7501df$var$_react.default.createElement($f132c01f9d7501df$var$_hyperlink.default, {
        prefix: prefix,
        url: link,
        text: linkLabel,
        newWindow: newWindow
    })), !subtle && actions && $f132c01f9d7501df$var$_react.default.createElement("div", {
        className: `${baseClass}__actions`
    }, actions.map((action, i)=>{
        return $f132c01f9d7501df$var$_react.default.createElement($f132c01f9d7501df$var$_button.default, $f132c01f9d7501df$var$_extends({}, action, {
            type: "tertiary",
            small: true,
            key: i,
            prefix: prefix
        }));
    }))), dismissable && $f132c01f9d7501df$var$_react.default.createElement($f132c01f9d7501df$var$_button.default, {
        prefix: prefix,
        type: "tertiary",
        small: true,
        xsmallIconOnly: true,
        iconOnly: true,
        ssrIcon: $f132c01f9d7501df$var$_crossSmall.default,
        onClick: closeClick,
        className: `${baseClass}__close-button`,
        text: labelCloseButton
    }));
};
$f132c01f9d7501df$var$InlineMessage.defaultProps = {
    prefix: "",
    headingLevel: "6",
    variant: "informative"
};
var $f132c01f9d7501df$var$_default = $f132c01f9d7501df$var$InlineMessage;
module.exports.default = $f132c01f9d7501df$var$_default;

});
parcelRequire.register("2Q7dU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21160a81c4a72a7c$var$_SSRIcon = $21160a81c4a72a7c$var$_interopRequireDefault((parcelRequire("dFBFq")));
function $21160a81c4a72a7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $21160a81c4a72a7c$var$_default = $21160a81c4a72a7c$var$_SSRIcon.default;
module.exports.default = $21160a81c4a72a7c$var$_default;

});
parcelRequire.register("dFBFq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f3c529b110876b2$var$_react = $9f3c529b110876b2$var$_interopRequireDefault((parcelRequire("2Jeaf")));


var $9f3c529b110876b2$var$_classnames = $9f3c529b110876b2$var$_interopRequireDefault((parcelRequire("grfkD")));
function $9f3c529b110876b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9f3c529b110876b2$var$_extends() {
    $9f3c529b110876b2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9f3c529b110876b2$var$_extends.apply(this, arguments);
}
const $9f3c529b110876b2$var$SSRIcon = (_ref)=>{
    let { prefix: prefix, viewBox: viewBox, paths: paths, className: className, modifier: modifier, alt: alt, ariaHidden: ariaHidden, ...otherProps } = _ref;
    const cssStyles = (0, $9f3c529b110876b2$var$_classnames.default)(`${prefix}svg-icon`, className, modifier && `${prefix}svg-icon--${modifier}`);
    return paths ? $9f3c529b110876b2$var$_react.default.createElement("svg", $9f3c529b110876b2$var$_extends({
        focusable: "false",
        viewBox: viewBox
    }, otherProps, {
        className: cssStyles,
        "aria-hidden": ariaHidden
    }), paths().map((path, id)=>{
        return $9f3c529b110876b2$var$_react.default.cloneElement(path, {
            key: id
        });
    })) : null;
};
$9f3c529b110876b2$var$SSRIcon.defaultProps = {
    prefix: "",
    viewBox: "0 0 24 24",
    ariaHidden: true
};
var $9f3c529b110876b2$var$_default = $9f3c529b110876b2$var$SSRIcon;
module.exports.default = $9f3c529b110876b2$var$_default;

});


parcelRequire.register("d62mC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $988dab4e8629cd17$var$_Hyperlink = $988dab4e8629cd17$var$_interopRequireDefault((parcelRequire("i4hem")));
function $988dab4e8629cd17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $988dab4e8629cd17$var$_default = $988dab4e8629cd17$var$_Hyperlink.default;
module.exports.default = $988dab4e8629cd17$var$_default;

});
parcelRequire.register("i4hem", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d275f7626e8f7fae$var$_react = $d275f7626e8f7fae$var$_interopRequireWildcard((parcelRequire("2Jeaf")));


var $d275f7626e8f7fae$var$_classnames = $d275f7626e8f7fae$var$_interopRequireDefault((parcelRequire("grfkD")));
function $d275f7626e8f7fae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d275f7626e8f7fae$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d275f7626e8f7fae$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d275f7626e8f7fae$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d275f7626e8f7fae$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d275f7626e8f7fae$var$_extends() {
    $d275f7626e8f7fae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d275f7626e8f7fae$var$_extends.apply(this, arguments);
}
const $d275f7626e8f7fae$var$Hyperlink = (0, $d275f7626e8f7fae$var$_react.forwardRef)((props, ref)=>{
    const { prefix: prefix, children: children, text: text, url: url, subtle: subtle, disabled: disabled, button: button, colour: colour, className: className, onClick: onClick, newWindow: newWindow, ariaControls: ariaControls, ...otherProps } = props;
    function preventClick(e) {
        e.preventDefault();
    }
    const cssStyles = (0, $d275f7626e8f7fae$var$_classnames.default)(className, `${prefix}link`, colour && `${prefix}link--${colour}`, subtle && `${prefix}link--subtle`, disabled && `${prefix}link--disabled`);
    let role = button ? "button" : null;
    role = disabled ? "link" : role;
    return $d275f7626e8f7fae$var$_react.default.createElement("a", $d275f7626e8f7fae$var$_extends({
        ref: ref,
        target: newWindow ? "_blank" : null
    }, otherProps, {
        href: !disabled ? url : null,
        className: cssStyles,
        role: role,
        "aria-disabled": disabled && `${disabled}`,
        "aria-controls": ariaControls ? ariaControls : null,
        onClick: button && disabled ? preventClick : onClick
    }), text && text.length > 0 ? text : "", text && children ? " " : null, children);
});
$d275f7626e8f7fae$var$Hyperlink.defaultProps = {
    disabled: false,
    url: "#",
    button: false,
    newWindow: false,
    prefix: ""
};
$d275f7626e8f7fae$var$Hyperlink.displayName = "Hyperlink";
var $d275f7626e8f7fae$var$_default = $d275f7626e8f7fae$var$Hyperlink;
module.exports.default = $d275f7626e8f7fae$var$_default;

});


parcelRequire.register("20qIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17604f8c938cbd2d$var$_react = $17604f8c938cbd2d$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $17604f8c938cbd2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $17604f8c938cbd2d$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $17604f8c938cbd2d$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m12.0006 13.4148 2.8283 2.8283 1.4142-1.4142-2.8283-2.8283 2.8283-2.8283-1.4142-1.4142-2.8283 2.8283L9.172 7.7578 7.7578 9.172l2.8286 2.8286-2.8286 2.8285 1.4142 1.4143 2.8286-2.8286z"
        })
    ];
};
module.exports.default = $17604f8c938cbd2d$var$_default;

});

parcelRequire.register("fuJ8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b47cac5774c9b570$var$_react = $b47cac5774c9b570$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $b47cac5774c9b570$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b47cac5774c9b570$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $b47cac5774c9b570$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 12c0 4.4183-3.5817 8-8 8-1.8487 0-3.551-.6271-4.9056-1.6801L18.3199 7.0944C19.3729 8.449 20 10.1513 20 12zM5.6801 16.9056 16.9056 5.6801C15.551 4.6271 13.8487 4 12 4c-4.4183 0-8 3.5817-8 8 0 1.8487.627 3.551 1.6801 4.9056zM22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10z"
        })
    ];
};
module.exports.default = $b47cac5774c9b570$var$_default;

});

parcelRequire.register("jaTnI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df59e91f87796616$var$_react = $df59e91f87796616$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $df59e91f87796616$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $df59e91f87796616$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $df59e91f87796616$var$_react.default.createElement("path", {
            d: "M11.0036 14.1337h2v-6h-2v6zm1 1.5c-.6904 0-1.25.5597-1.25 1.25 0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25 0-.6903-.5597-1.25-1.25-1.25z"
        }),
        $df59e91f87796616$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m1.1152 20.418 10-19h1.7699l10 19-.8849 1.4657h-20l-.885-1.4657zm2.5413-.5343h16.6873L12.0002 4.0308 3.6565 19.8837z"
        })
    ];
};
module.exports.default = $df59e91f87796616$var$_default;

});

parcelRequire.register("dUWp5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21dcf0fc16542cb$var$_react = $a21dcf0fc16542cb$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $a21dcf0fc16542cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a21dcf0fc16542cb$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $a21dcf0fc16542cb$var$_react.default.createElement("path", {
            d: "M18 8.9608 16.5591 7.5l-5.9955 6.0784-3.1227-3.166L6 11.8732 10.5636 16.5 18 8.9608z"
        }),
        $a21dcf0fc16542cb$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10zm0-2c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8z"
        })
    ];
};
module.exports.default = $a21dcf0fc16542cb$var$_default;

});

parcelRequire.register("Vr5MD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aca56f2e63ec299$var$_react = $0aca56f2e63ec299$var$_interopRequireDefault((parcelRequire("2Jeaf")));
function $0aca56f2e63ec299$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0aca56f2e63ec299$var$_default = function _default() {
    let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        $0aca56f2e63ec299$var$_react.default.createElement("path", {
            d: "M12 9.5c.6904 0 1.25-.5596 1.25-1.25S12.6904 7 12 7s-1.25.5596-1.25 1.25S11.3096 9.5 12 9.5zM11 11v6h2v-6h-2z"
        }),
        $0aca56f2e63ec299$var$_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10zM4 12c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8z"
        })
    ];
};
module.exports.default = $0aca56f2e63ec299$var$_default;

});


parcelRequire("2Jeaf");

var $joJRn = parcelRequire("joJRn");
var $25a9db989c2486a1$var$o = 0;
function $25a9db989c2486a1$export$34b9dba7ce09269b(_, e, n, t, f) {
    var l, s, u = {};
    for(s in e)"ref" == s ? l = e[s] : u[s] = e[s];
    var a = {
        type: _,
        props: u,
        key: n,
        ref: l,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$25a9db989c2486a1$var$o,
        __source: f,
        __self: t
    };
    if ("function" == typeof _ && (l = _.defaultProps)) for(s in l)void 0 === u[s] && (u[s] = l[s]);
    return (0, $joJRn.options).vnode && (0, $joJRn.options).vnode(a), a;
}





var $joJRn = parcelRequire("joJRn");
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
var $4874ae5d6b48e5ee$exports = {};
"use strict";

$4874ae5d6b48e5ee$exports = (parcelRequire("jgC7D"));



var $2Jeaf = parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
var $joJRn = parcelRequire("joJRn");
var $6412395d825a1412$exports = {};
//
$6412395d825a1412$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $15410840ba209e95$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $15410840ba209e95$export$2e2bcd8739ae039 = $15410840ba209e95$var$stylis_min;


var $edb58663389f2554$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $edb58663389f2554$export$2e2bcd8739ae039 = $edb58663389f2554$var$unitlessKeys;


function $350e234e432be48d$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $350e234e432be48d$export$2e2bcd8739ae039 = $350e234e432be48d$var$memoize;


var $aa00f65b51933a12$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $aa00f65b51933a12$var$index = (0, $350e234e432be48d$export$2e2bcd8739ae039)(function(prop) {
    return $aa00f65b51933a12$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $aa00f65b51933a12$export$2e2bcd8739ae039 = $aa00f65b51933a12$var$index;


var $f4caa58b7a66ca1b$exports = {};
"use strict";
var $ed1ccc6c1b72d10b$exports = {};
"use strict";

$ed1ccc6c1b72d10b$exports = (parcelRequire("jVBOo"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f4caa58b7a66ca1b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f4caa58b7a66ca1b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f4caa58b7a66ca1b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f4caa58b7a66ca1b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f4caa58b7a66ca1b$var$TYPE_STATICS = {};
$f4caa58b7a66ca1b$var$TYPE_STATICS[$ed1ccc6c1b72d10b$exports.ForwardRef] = $f4caa58b7a66ca1b$var$FORWARD_REF_STATICS;
$f4caa58b7a66ca1b$var$TYPE_STATICS[$ed1ccc6c1b72d10b$exports.Memo] = $f4caa58b7a66ca1b$var$MEMO_STATICS;
function $f4caa58b7a66ca1b$var$getStatics(component) {
    // React v16.11 and below
    if ($ed1ccc6c1b72d10b$exports.isMemo(component)) return $f4caa58b7a66ca1b$var$MEMO_STATICS;
     // React v16.12 and above
    return $f4caa58b7a66ca1b$var$TYPE_STATICS[component["$$typeof"]] || $f4caa58b7a66ca1b$var$REACT_STATICS;
}
var $f4caa58b7a66ca1b$var$defineProperty = Object.defineProperty;
var $f4caa58b7a66ca1b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f4caa58b7a66ca1b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f4caa58b7a66ca1b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f4caa58b7a66ca1b$var$getPrototypeOf = Object.getPrototypeOf;
var $f4caa58b7a66ca1b$var$objectPrototype = Object.prototype;
function $f4caa58b7a66ca1b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($f4caa58b7a66ca1b$var$objectPrototype) {
            var inheritedComponent = $f4caa58b7a66ca1b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f4caa58b7a66ca1b$var$objectPrototype) $f4caa58b7a66ca1b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f4caa58b7a66ca1b$var$getOwnPropertyNames(sourceComponent);
        if ($f4caa58b7a66ca1b$var$getOwnPropertySymbols) keys = keys.concat($f4caa58b7a66ca1b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f4caa58b7a66ca1b$var$getStatics(targetComponent);
        var sourceStatics = $f4caa58b7a66ca1b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f4caa58b7a66ca1b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f4caa58b7a66ca1b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f4caa58b7a66ca1b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$f4caa58b7a66ca1b$exports = $f4caa58b7a66ca1b$var$hoistNonReactStatics;



var $3oReb = parcelRequire("3oReb");
function $724921cc79267cde$var$_extends() {
    $724921cc79267cde$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $724921cc79267cde$var$_extends.apply(this, arguments);
}
function $724921cc79267cde$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// 
var $724921cc79267cde$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $724921cc79267cde$var$isPlainObject = function(x) {
    return x !== null && typeof x === "object" && (x.toString ? x.toString() : Object.prototype.toString.call(x)) === "[object Object]" && !(0, $4874ae5d6b48e5ee$exports.typeOf)(x);
};
// 
var $724921cc79267cde$var$EMPTY_ARRAY = Object.freeze([]);
var $724921cc79267cde$var$EMPTY_OBJECT = Object.freeze({});
// 
function $724921cc79267cde$var$isFunction(test) {
    return typeof test === "function";
}
// 
function $724921cc79267cde$var$getComponentName(target) {
    return(// $FlowFixMe
    (0, target.displayName) || // $FlowFixMe
    target.name || "Component");
}
// 
function $724921cc79267cde$var$isStatelessFunction(test) {
    return typeof test === "function" && !(test.prototype && test.prototype.isReactComponent);
}
// 
function $724921cc79267cde$export$7ba318d8d2f06c76(target) {
    return target && typeof target.styledComponentId === "string";
}
// 
var $724921cc79267cde$var$SC_ATTR = (typeof $3oReb !== "undefined" && undefined, "data-styled");
var $724921cc79267cde$var$SC_ATTR_ACTIVE = "active";
var $724921cc79267cde$var$SC_ATTR_VERSION = "data-styled-version";
var $724921cc79267cde$var$SC_VERSION = "5.1.1";
var $724921cc79267cde$var$SPLITTER = "/*!sc*/\n";
var $724921cc79267cde$var$IS_BROWSER = typeof window !== "undefined" && "HTMLElement" in window;
var $724921cc79267cde$var$DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === "boolean" && SC_DISABLE_SPEEDY || typeof $3oReb !== "undefined" && undefined || false; // Shared empty execution context when generating static styles
var $724921cc79267cde$var$STATIC_EXECUTION_CONTEXT = {};
// 
/* eslint-disable camelcase, no-undef */ var $724921cc79267cde$var$getNonce = function getNonce() {
    return typeof __webpack_nonce__ !== "undefined" ? __webpack_nonce__ : null;
};
var $724921cc79267cde$var$errorMap = {
    "1": "Cannot create styled-component for component: %s.\n\n",
    "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    "7": 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    "8": 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    "9": "Missing document `<head>`\n\n",
    "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    "14": 'ThemeProvider: "theme" prop is required.\n\n',
    "15": "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    "16": "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    "17": "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
// 
var $724921cc79267cde$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $724921cc79267cde$var$format() {
    var a = arguments.length <= 0 ? undefined : arguments[0];
    var b = [];
    for(var c = 1, len = arguments.length; c < len; c += 1)b.push(c < 0 || arguments.length <= c ? undefined : arguments[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ function $724921cc79267cde$var$throwStyledComponentsError(code) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    throw new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + code + " for more information." + (interpolations.length > 0 ? " Additional arguments: " + interpolations.join(", ") : ""));
}
// 
var $724921cc79267cde$var$ELEMENT_TYPE = 1;
/* Node.ELEMENT_TYPE */ /** Find last style element if any inside target */ var $724921cc79267cde$var$findLastStyleTag = function findLastStyleTag(target) {
    var childNodes = target.childNodes;
    for(var i = childNodes.length; i >= 0; i--){
        var child = childNodes[i];
        if (child && child.nodeType === $724921cc79267cde$var$ELEMENT_TYPE && child.hasAttribute($724921cc79267cde$var$SC_ATTR)) return child;
    }
    return undefined;
};
/** Create a style element inside `target` or <head> after the last */ var $724921cc79267cde$var$makeStyleTag = function makeStyleTag(target) {
    var head = document.head;
    var parent = target || head;
    var style = document.createElement("style");
    var prevStyle = $724921cc79267cde$var$findLastStyleTag(parent);
    var nextSibling = prevStyle !== undefined ? prevStyle.nextSibling : null;
    style.setAttribute($724921cc79267cde$var$SC_ATTR, $724921cc79267cde$var$SC_ATTR_ACTIVE);
    style.setAttribute($724921cc79267cde$var$SC_ATTR_VERSION, $724921cc79267cde$var$SC_VERSION);
    var nonce = $724921cc79267cde$var$getNonce();
    if (nonce) style.setAttribute("nonce", nonce);
    parent.insertBefore(style, nextSibling);
    return style;
};
/** Get the CSSStyleSheet instance for a given style element */ var $724921cc79267cde$var$getSheet = function getSheet(tag) {
    if (tag.sheet) return tag.sheet;
     // Avoid Firefox quirk where the style element might not have a sheet property
    var _document = document, styleSheets = _document.styleSheets;
    for(var i = 0, l = styleSheets.length; i < l; i++){
        var sheet = styleSheets[i];
        if (sheet.ownerNode === tag) return sheet;
    }
    $724921cc79267cde$var$throwStyledComponentsError(17);
    return undefined;
};
// 
/** Create a CSSStyleSheet-like tag depending on the environment */ var $724921cc79267cde$var$makeTag = function makeTag(_ref) {
    var isServer = _ref.isServer, useCSSOMInjection = _ref.useCSSOMInjection, target = _ref.target;
    if (isServer) return new $724921cc79267cde$var$VirtualTag(target);
    else if (useCSSOMInjection) return new $724921cc79267cde$var$CSSOMTag(target);
    else return new $724921cc79267cde$var$TextTag(target);
};
var $724921cc79267cde$var$CSSOMTag = /*#__PURE__*/ function() {
    function CSSOMTag(target) {
        var element = this.element = $724921cc79267cde$var$makeStyleTag(target); // Avoid Edge bug where empty style elements don't create sheets
        element.appendChild(document.createTextNode(""));
        this.sheet = $724921cc79267cde$var$getSheet(element);
        this.length = 0;
    }
    var _proto = CSSOMTag.prototype;
    _proto.insertRule = function insertRule(index, rule) {
        try {
            this.sheet.insertRule(rule, index);
            this.length++;
            return true;
        } catch (_error) {
            return false;
        }
    };
    _proto.deleteRule = function deleteRule(index) {
        this.sheet.deleteRule(index);
        this.length--;
    };
    _proto.getRule = function getRule(index) {
        var rule = this.sheet.cssRules[index]; // Avoid IE11 quirk where cssText is inaccessible on some invalid rules
        if (rule !== undefined && typeof rule.cssText === "string") return rule.cssText;
        else return "";
    };
    return CSSOMTag;
}();
/** A Tag that emulates the CSSStyleSheet API but uses text nodes */ var $724921cc79267cde$var$TextTag = /*#__PURE__*/ function() {
    function TextTag(target) {
        var element = this.element = $724921cc79267cde$var$makeStyleTag(target);
        this.nodes = element.childNodes;
        this.length = 0;
    }
    var _proto2 = TextTag.prototype;
    _proto2.insertRule = function insertRule(index, rule) {
        if (index <= this.length && index >= 0) {
            var node = document.createTextNode(rule);
            var refNode = this.nodes[index];
            this.element.insertBefore(node, refNode || null);
            this.length++;
            return true;
        } else return false;
    };
    _proto2.deleteRule = function deleteRule(index) {
        this.element.removeChild(this.nodes[index]);
        this.length--;
    };
    _proto2.getRule = function getRule(index) {
        if (index < this.length) return this.nodes[index].textContent;
        else return "";
    };
    return TextTag;
}();
/** A completely virtual (server-side) Tag that doesn't manipulate the DOM */ var $724921cc79267cde$var$VirtualTag = /*#__PURE__*/ function() {
    function VirtualTag(_target) {
        this.rules = [];
        this.length = 0;
    }
    var _proto3 = VirtualTag.prototype;
    _proto3.insertRule = function insertRule(index, rule) {
        if (index <= this.length) {
            this.rules.splice(index, 0, rule);
            this.length++;
            return true;
        } else return false;
    };
    _proto3.deleteRule = function deleteRule(index) {
        this.rules.splice(index, 1);
        this.length--;
    };
    _proto3.getRule = function getRule(index) {
        if (index < this.length) return this.rules[index];
        else return "";
    };
    return VirtualTag;
}();
// 
/** Create a GroupedTag with an underlying Tag implementation */ var $724921cc79267cde$var$makeGroupedTag = function makeGroupedTag(tag) {
    return new $724921cc79267cde$var$DefaultGroupedTag(tag);
};
var $724921cc79267cde$var$BASE_SIZE = 512;
var $724921cc79267cde$var$DefaultGroupedTag = /*#__PURE__*/ function() {
    function DefaultGroupedTag(tag) {
        this.groupSizes = new Uint32Array($724921cc79267cde$var$BASE_SIZE);
        this.length = $724921cc79267cde$var$BASE_SIZE;
        this.tag = tag;
    }
    var _proto = DefaultGroupedTag.prototype;
    _proto.indexOfGroup = function indexOfGroup(group) {
        var index = 0;
        for(var i = 0; i < group; i++)index += this.groupSizes[i];
        return index;
    };
    _proto.insertRules = function insertRules(group, rules) {
        if (group >= this.groupSizes.length) {
            var oldBuffer = this.groupSizes;
            var oldSize = oldBuffer.length;
            var newSize = oldSize;
            while(group >= newSize){
                newSize <<= 1;
                if (newSize < 0) $724921cc79267cde$var$throwStyledComponentsError(16, "" + group);
            }
            this.groupSizes = new Uint32Array(newSize);
            this.groupSizes.set(oldBuffer);
            this.length = newSize;
            for(var i = oldSize; i < newSize; i++)this.groupSizes[i] = 0;
        }
        var ruleIndex = this.indexOfGroup(group + 1);
        for(var _i = 0, l = rules.length; _i < l; _i++)if (this.tag.insertRule(ruleIndex, rules[_i])) {
            this.groupSizes[group]++;
            ruleIndex++;
        }
    };
    _proto.clearGroup = function clearGroup(group) {
        if (group < this.length) {
            var length = this.groupSizes[group];
            var startIndex = this.indexOfGroup(group);
            var endIndex = startIndex + length;
            this.groupSizes[group] = 0;
            for(var i = startIndex; i < endIndex; i++)this.tag.deleteRule(startIndex);
        }
    };
    _proto.getGroup = function getGroup(group) {
        var css = "";
        if (group >= this.length || this.groupSizes[group] === 0) return css;
        var length = this.groupSizes[group];
        var startIndex = this.indexOfGroup(group);
        var endIndex = startIndex + length;
        for(var i = startIndex; i < endIndex; i++)css += "" + this.tag.getRule(i) + $724921cc79267cde$var$SPLITTER;
        return css;
    };
    return DefaultGroupedTag;
}();
// 
var $724921cc79267cde$var$MAX_SMI = 1073741824;
var $724921cc79267cde$var$groupIDRegister = new Map();
var $724921cc79267cde$var$reverseRegister = new Map();
var $724921cc79267cde$var$nextFreeGroup = 1;
var $724921cc79267cde$var$getGroupForId = function getGroupForId(id) {
    if ($724921cc79267cde$var$groupIDRegister.has(id)) return $724921cc79267cde$var$groupIDRegister.get(id);
    var group = $724921cc79267cde$var$nextFreeGroup++;
    $724921cc79267cde$var$groupIDRegister.set(id, group);
    $724921cc79267cde$var$reverseRegister.set(group, id);
    return group;
};
var $724921cc79267cde$var$getIdForGroup = function getIdForGroup(group) {
    return $724921cc79267cde$var$reverseRegister.get(group);
};
var $724921cc79267cde$var$setGroupForId = function setGroupForId(id, group) {
    if (group >= $724921cc79267cde$var$nextFreeGroup) $724921cc79267cde$var$nextFreeGroup = group + 1;
    $724921cc79267cde$var$groupIDRegister.set(id, group);
    $724921cc79267cde$var$reverseRegister.set(group, id);
};
// 
var $724921cc79267cde$var$SELECTOR = "style[" + $724921cc79267cde$var$SC_ATTR + "][" + $724921cc79267cde$var$SC_ATTR_VERSION + '="' + $724921cc79267cde$var$SC_VERSION + '"]';
var $724921cc79267cde$var$MARKER_RE = new RegExp("^" + $724921cc79267cde$var$SC_ATTR + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)');
var $724921cc79267cde$var$outputSheet = function outputSheet(sheet) {
    var tag = sheet.getTag();
    var length = tag.length;
    var css = "";
    for(var group = 0; group < length; group++){
        var id = $724921cc79267cde$var$getIdForGroup(group);
        if (id === undefined) continue;
        var names = sheet.names.get(id);
        var rules = tag.getGroup(group);
        if (names === undefined || rules.length === 0) continue;
        var selector = $724921cc79267cde$var$SC_ATTR + ".g" + group + '[id="' + id + '"]';
        var content = "";
        if (names !== undefined) names.forEach(function(name) {
            if (name.length > 0) content += name + ",";
        });
         // NOTE: It's easier to collect rules and have the marker
        // after the actual rules to simplify the rehydration
        css += "" + rules + selector + '{content:"' + content + '"}' + $724921cc79267cde$var$SPLITTER;
    }
    return css;
};
var $724921cc79267cde$var$rehydrateNamesFromContent = function rehydrateNamesFromContent(sheet, id, content) {
    var names = content.split(",");
    var name;
    for(var i = 0, l = names.length; i < l; i++)// eslint-disable-next-line
    if (name = names[i]) sheet.registerName(id, name);
};
var $724921cc79267cde$var$rehydrateSheetFromTag = function rehydrateSheetFromTag(sheet, style) {
    var parts = style.innerHTML.split($724921cc79267cde$var$SPLITTER);
    var rules = [];
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].trim();
        if (!part) continue;
        var marker = part.match($724921cc79267cde$var$MARKER_RE);
        if (marker) {
            var group = parseInt(marker[1], 10) | 0;
            var id = marker[2];
            if (group !== 0) {
                // Rehydrate componentId to group index mapping
                $724921cc79267cde$var$setGroupForId(id, group); // Rehydrate names and rules
                // looks like: data-styled.g11[id="idA"]{content:"nameA,"}
                $724921cc79267cde$var$rehydrateNamesFromContent(sheet, id, marker[3]);
                sheet.getTag().insertRules(group, rules);
            }
            rules.length = 0;
        } else rules.push(part);
    }
};
var $724921cc79267cde$var$rehydrateSheet = function rehydrateSheet(sheet) {
    var nodes = document.querySelectorAll($724921cc79267cde$var$SELECTOR);
    for(var i = 0, l = nodes.length; i < l; i++){
        var node = nodes[i];
        if (node && node.getAttribute($724921cc79267cde$var$SC_ATTR) !== $724921cc79267cde$var$SC_ATTR_ACTIVE) {
            $724921cc79267cde$var$rehydrateSheetFromTag(sheet, node);
            if (node.parentNode) node.parentNode.removeChild(node);
        }
    }
};
var $724921cc79267cde$var$SHOULD_REHYDRATE = $724921cc79267cde$var$IS_BROWSER;
var $724921cc79267cde$var$defaultOptions = {
    isServer: !$724921cc79267cde$var$IS_BROWSER,
    useCSSOMInjection: !$724921cc79267cde$var$DISABLE_SPEEDY
};
/** Contains the main stylesheet logic for stringification and caching */ var $724921cc79267cde$var$StyleSheet = /*#__PURE__*/ function() {
    /** Register a group ID to give it an index */ StyleSheet.registerId = function registerId(id) {
        return $724921cc79267cde$var$getGroupForId(id);
    };
    function StyleSheet(options, globalStyles, names) {
        if (options === void 0) options = $724921cc79267cde$var$defaultOptions;
        if (globalStyles === void 0) globalStyles = {};
        this.options = $724921cc79267cde$var$_extends({}, $724921cc79267cde$var$defaultOptions, {}, options);
        this.gs = globalStyles;
        this.names = new Map(names); // We rehydrate only once and use the sheet that is created first
        if (!this.options.isServer && $724921cc79267cde$var$IS_BROWSER && $724921cc79267cde$var$SHOULD_REHYDRATE) {
            $724921cc79267cde$var$SHOULD_REHYDRATE = false;
            $724921cc79267cde$var$rehydrateSheet(this);
        }
    }
    var _proto = StyleSheet.prototype;
    _proto.reconstructWithOptions = function reconstructWithOptions(options) {
        return new StyleSheet($724921cc79267cde$var$_extends({}, this.options, {}, options), this.gs, this.names);
    };
    _proto.allocateGSInstance = function allocateGSInstance(id) {
        return this.gs[id] = (this.gs[id] || 0) + 1;
    } /** Lazily initialises a GroupedTag for when it's actually needed */ ;
    _proto.getTag = function getTag() {
        return this.tag || (this.tag = $724921cc79267cde$var$makeGroupedTag($724921cc79267cde$var$makeTag(this.options)));
    } /** Check whether a name is known for caching */ ;
    _proto.hasNameForId = function hasNameForId(id, name) {
        return this.names.has(id) && this.names.get(id).has(name);
    } /** Mark a group's name as known for caching */ ;
    _proto.registerName = function registerName(id, name) {
        $724921cc79267cde$var$getGroupForId(id);
        if (!this.names.has(id)) {
            var groupNames = new Set();
            groupNames.add(name);
            this.names.set(id, groupNames);
        } else this.names.get(id).add(name);
    } /** Insert new rules which also marks the name as known */ ;
    _proto.insertRules = function insertRules(id, name, rules) {
        this.registerName(id, name);
        this.getTag().insertRules($724921cc79267cde$var$getGroupForId(id), rules);
    } /** Clears all cached names for a given group ID */ ;
    _proto.clearNames = function clearNames(id) {
        if (this.names.has(id)) this.names.get(id).clear();
    } /** Clears all rules for a given group ID */ ;
    _proto.clearRules = function clearRules(id) {
        this.getTag().clearGroup($724921cc79267cde$var$getGroupForId(id));
        this.clearNames(id);
    } /** Clears the entire tag which deletes all rules but not its names */ ;
    _proto.clearTag = function clearTag() {
        // NOTE: This does not clear the names, since it's only used during SSR
        // so that we can continuously output only new rules
        this.tag = undefined;
    } /** Outputs the current sheet as a CSS string with markers for SSR */ ;
    _proto.toString = function toString() {
        return $724921cc79267cde$var$outputSheet(this);
    };
    return StyleSheet;
}();
// 
/* eslint-disable */ var $724921cc79267cde$var$SEED = 5381; // When we have separate strings it's useful to run a progressive
// version of djb2 where we pretend that we're still looping over
// the same string
var $724921cc79267cde$var$phash = function phash(h, x) {
    var i = x.length;
    while(i)h = h * 33 ^ x.charCodeAt(--i);
    return h;
}; // This is a djb2 hashing function
var $724921cc79267cde$var$hash = function hash(x) {
    return $724921cc79267cde$var$phash($724921cc79267cde$var$SEED, x);
};
/**
 * MIT License
 *
 * Copyright (c) 2016 Sultan Tarimo
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR
 * IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /* eslint-disable */ function $724921cc79267cde$var$insertRulePlugin(insertRule) {
    var delimiter = "/*|*/";
    var needle = delimiter + "}";
    function toSheet(block) {
        if (block) try {
            insertRule(block + "}");
        } catch (e) {}
    }
    return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
        switch(context){
            // property
            case 1:
                // @import
                if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ";"), "";
                break;
            // selector
            case 2:
                if (ns === 0) return content + delimiter;
                break;
            // at-rule
            case 3:
                switch(ns){
                    // @font-face, @page
                    case 102:
                    case 112:
                        return insertRule(selectors[0] + content), "";
                    default:
                        return content + (at === 0 ? delimiter : "");
                }
            case -2:
                content.split(needle).forEach(toSheet);
        }
    };
}
var $724921cc79267cde$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
function $724921cc79267cde$var$createStylisInstance(_temp) {
    var _ref = _temp === void 0 ? $724921cc79267cde$var$EMPTY_OBJECT : _temp, _ref$options = _ref.options, options = _ref$options === void 0 ? $724921cc79267cde$var$EMPTY_OBJECT : _ref$options, _ref$plugins = _ref.plugins, plugins = _ref$plugins === void 0 ? $724921cc79267cde$var$EMPTY_ARRAY : _ref$plugins;
    var stylis = new (0, $15410840ba209e95$export$2e2bcd8739ae039)(options); // Wrap `insertRulePlugin to build a list of rules,
    // and then make our own plugin to return the rules. This
    // makes it easier to hook into the existing SSR architecture
    var parsingRules = []; // eslint-disable-next-line consistent-return
    var returnRulesPlugin = function returnRulesPlugin(context) {
        if (context === -2) {
            var parsedRules = parsingRules;
            parsingRules = [];
            return parsedRules;
        }
    };
    var parseRulesPlugin = $724921cc79267cde$var$insertRulePlugin(function(rule) {
        parsingRules.push(rule);
    });
    var _componentId;
    var _selector;
    var _selectorRegexp;
    var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
        if (offset > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
        string.slice(0, offset).indexOf(_selector) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
        string.slice(offset - _selector.length, offset) !== _selector) return "." + _componentId;
        return match;
    };
    /**
   * When writing a style like
   *
   * & + & {
   *   color: red;
   * }
   *
   * The second ampersand should be a reference to the static component class. stylis
   * has no knowledge of static class so we have to intelligently replace the base selector.
   *
   * https://github.com/thysultan/stylis.js#plugins <- more info about the context phase values
   * "2" means this plugin is taking effect at the very end after all other processing is complete
   */ var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
        if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) // eslint-disable-next-line no-param-reassign
        selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
    };
    stylis.use([].concat(plugins, [
        selfReferenceReplacementPlugin,
        parseRulesPlugin,
        returnRulesPlugin
    ]));
    function stringifyRules(css, selector, prefix, componentId) {
        if (componentId === void 0) componentId = "&";
        var flatCSS = css.replace($724921cc79267cde$var$COMMENT_REGEX, "");
        var cssStr = selector && prefix ? prefix + " " + selector + " { " + flatCSS + " }" : flatCSS; // stylis has no concept of state to be passed to plugins
        // but since JS is single=threaded, we can rely on that to ensure
        // these properties stay in sync with the current stylis run
        _componentId = componentId;
        _selector = selector;
        _selectorRegexp = new RegExp("\\" + _selector + "\\b", "g");
        return stylis(prefix || !selector ? "" : selector, cssStr);
    }
    stringifyRules.hash = plugins.length ? plugins.reduce(function(acc, plugin) {
        if (!plugin.name) $724921cc79267cde$var$throwStyledComponentsError(15);
        return $724921cc79267cde$var$phash(acc, plugin.name);
    }, $724921cc79267cde$var$SEED).toString() : "";
    return stringifyRules;
}
// 
var $724921cc79267cde$export$8c190ef828af4c86 = (0, $2Jeaf.default).createContext();
var $724921cc79267cde$export$91317688fc694efa = $724921cc79267cde$export$8c190ef828af4c86.Consumer;
var $724921cc79267cde$var$StylisContext = (0, $2Jeaf.default).createContext();
var $724921cc79267cde$var$StylisConsumer = $724921cc79267cde$var$StylisContext.Consumer;
var $724921cc79267cde$var$masterSheet = new $724921cc79267cde$var$StyleSheet();
var $724921cc79267cde$var$masterStylis = $724921cc79267cde$var$createStylisInstance();
function $724921cc79267cde$var$useStyleSheet() {
    return (0, $iJ7ah.useContext)($724921cc79267cde$export$8c190ef828af4c86) || $724921cc79267cde$var$masterSheet;
}
function $724921cc79267cde$var$useStylis() {
    return (0, $iJ7ah.useContext)($724921cc79267cde$var$StylisContext) || $724921cc79267cde$var$masterStylis;
}
function $724921cc79267cde$export$a473771da2f0ff7c(props) {
    var _useState = (0, $iJ7ah.useState)(props.stylisPlugins), plugins = _useState[0], setPlugins = _useState[1];
    var contextStyleSheet = $724921cc79267cde$var$useStyleSheet();
    var styleSheet = (0, $iJ7ah.useMemo)(function() {
        var sheet = contextStyleSheet;
        if (props.sheet) // eslint-disable-next-line prefer-destructuring
        sheet = props.sheet;
        else if (props.target) sheet = sheet.reconstructWithOptions({
            target: props.target
        });
        if (props.disableCSSOMInjection) sheet = sheet.reconstructWithOptions({
            useCSSOMInjection: false
        });
        return sheet;
    }, [
        props.disableCSSOMInjection,
        props.sheet,
        props.target
    ]);
    var stylis = (0, $iJ7ah.useMemo)(function() {
        return $724921cc79267cde$var$createStylisInstance({
            options: {
                prefix: !props.disableVendorPrefixes
            },
            plugins: plugins
        });
    }, [
        props.disableVendorPrefixes,
        plugins
    ]);
    (0, $iJ7ah.useEffect)(function() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6412395d825a1412$exports)))(plugins, props.stylisPlugins)) setPlugins(props.stylisPlugins);
    }, [
        props.stylisPlugins
    ]);
    return /*#__PURE__*/ (0, $2Jeaf.default).createElement($724921cc79267cde$export$8c190ef828af4c86.Provider, {
        value: styleSheet
    }, /*#__PURE__*/ (0, $2Jeaf.default).createElement($724921cc79267cde$var$StylisContext.Provider, {
        value: stylis
    }, (0, props.children)));
}
// 
var $724921cc79267cde$var$Keyframes = /*#__PURE__*/ function() {
    function Keyframes(name, stringifyArgs) {
        var _this = this;
        this.inject = function(styleSheet) {
            if (!styleSheet.hasNameForId(_this.id, _this.name)) styleSheet.insertRules(_this.id, _this.name, $724921cc79267cde$var$masterStylis.apply(void 0, _this.stringifyArgs));
        };
        this.toString = function() {
            return $724921cc79267cde$var$throwStyledComponentsError(12, String(_this.name));
        };
        this.name = name;
        this.id = "sc-keyframes-" + name;
        this.stringifyArgs = stringifyArgs;
    }
    var _proto = Keyframes.prototype;
    _proto.getName = function getName() {
        return this.name;
    };
    return Keyframes;
}();
// 
/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */ var $724921cc79267cde$var$uppercasePattern = /([A-Z])/g;
var $724921cc79267cde$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $724921cc79267cde$var$hyphenateStyleName(string) {
    return string.replace($724921cc79267cde$var$uppercasePattern, "-$1").toLowerCase().replace($724921cc79267cde$var$msPattern, "-ms-");
}
// 
function $724921cc79267cde$var$addUnitIfNeeded(name, value) {
    // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
    // $FlowFixMe
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !(name in (0, $edb58663389f2554$export$2e2bcd8739ae039))) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
    return String(value).trim();
}
// 
/**
 * It's falsish not falsy because 0 is allowed.
 */ var $724921cc79267cde$var$isFalsish = function isFalsish(chunk) {
    return chunk === undefined || chunk === null || chunk === false || chunk === "";
};
var $724921cc79267cde$var$objToCssArray = function objToCssArray(obj, prevKey) {
    var rules = [];
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        if (!$724921cc79267cde$var$isFalsish(obj[key])) {
            if ($724921cc79267cde$var$isPlainObject(obj[key])) {
                rules.push.apply(rules, objToCssArray(obj[key], key));
                return rules;
            } else if ($724921cc79267cde$var$isFunction(obj[key])) {
                rules.push($724921cc79267cde$var$hyphenateStyleName(key) + ":", obj[key], ";");
                return rules;
            }
            rules.push($724921cc79267cde$var$hyphenateStyleName(key) + ": " + $724921cc79267cde$var$addUnitIfNeeded(key, obj[key]) + ";");
        }
        return rules;
    });
    return prevKey ? [
        prevKey + " {"
    ].concat(rules, [
        "}"
    ]) : rules;
};
function $724921cc79267cde$var$flatten(chunk, executionContext, styleSheet) {
    if (Array.isArray(chunk)) {
        var ruleSet = [];
        for(var i = 0, len = chunk.length, result; i < len; i += 1){
            result = $724921cc79267cde$var$flatten(chunk[i], executionContext, styleSheet);
            if (result === "") continue;
            else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);
            else ruleSet.push(result);
        }
        return ruleSet;
    }
    if ($724921cc79267cde$var$isFalsish(chunk)) return "";
    /* Handle other components */ if ($724921cc79267cde$export$7ba318d8d2f06c76(chunk)) return "." + chunk.styledComponentId;
    /* Either execute or defer the function */ if ($724921cc79267cde$var$isFunction(chunk)) {
        if ($724921cc79267cde$var$isStatelessFunction(chunk) && executionContext) {
            var _result = chunk(executionContext);
            return $724921cc79267cde$var$flatten(_result, executionContext, styleSheet);
        } else return chunk;
    }
    if (chunk instanceof $724921cc79267cde$var$Keyframes) {
        if (styleSheet) {
            chunk.inject(styleSheet);
            return chunk.getName();
        } else return chunk;
    }
    /* Handle objects */ return $724921cc79267cde$var$isPlainObject(chunk) ? $724921cc79267cde$var$objToCssArray(chunk) : chunk.toString();
}
// 
function $724921cc79267cde$export$dbf350e5966cf602(styles) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if ($724921cc79267cde$var$isFunction(styles) || $724921cc79267cde$var$isPlainObject(styles)) // $FlowFixMe
    return $724921cc79267cde$var$flatten($724921cc79267cde$var$interleave($724921cc79267cde$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    if (interpolations.length === 0 && styles.length === 1 && typeof styles[0] === "string") // $FlowFixMe
    return styles;
     // $FlowFixMe
    return $724921cc79267cde$var$flatten($724921cc79267cde$var$interleave(styles, interpolations));
}
function $724921cc79267cde$var$constructWithOptions(componentConstructor, tag, options) {
    if (options === void 0) options = $724921cc79267cde$var$EMPTY_OBJECT;
    if (!(0, $4874ae5d6b48e5ee$exports.isValidElementType)(tag)) return $724921cc79267cde$var$throwStyledComponentsError(1, String(tag));
    /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
        return componentConstructor(tag, options, $724921cc79267cde$export$dbf350e5966cf602.apply(void 0, arguments));
    };
    /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
        return $724921cc79267cde$var$constructWithOptions(componentConstructor, tag, $724921cc79267cde$var$_extends({}, options, {}, config));
    };
    /* Modify/inject new props at runtime */ templateFunction.attrs = function(attrs) {
        return $724921cc79267cde$var$constructWithOptions(componentConstructor, tag, $724921cc79267cde$var$_extends({}, options, {
            attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
        }));
    };
    return templateFunction;
}
/* eslint-disable */ /**
  mixin-deep; https://github.com/jonschlinkert/mixin-deep
  Inlined such that it will be consistently transpiled to an IE-compatible syntax.

  The MIT License (MIT)

  Copyright (c) 2014-present, Jon Schlinkert.

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/ var $724921cc79267cde$var$isObject = function isObject(val) {
    return typeof val === "function" || typeof val === "object" && val !== null && !Array.isArray(val);
};
var $724921cc79267cde$var$isValidKey = function isValidKey(key) {
    return key !== "__proto__" && key !== "constructor" && key !== "prototype";
};
function $724921cc79267cde$var$mixin(target, val, key) {
    var obj = target[key];
    if ($724921cc79267cde$var$isObject(val) && $724921cc79267cde$var$isObject(obj)) $724921cc79267cde$var$mixinDeep(obj, val);
    else target[key] = val;
}
function $724921cc79267cde$var$mixinDeep(target) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    for(var _i = 0, _rest = rest; _i < _rest.length; _i++){
        var obj = _rest[_i];
        if ($724921cc79267cde$var$isObject(obj)) {
            for(var key in obj)if ($724921cc79267cde$var$isValidKey(key)) $724921cc79267cde$var$mixin(target, obj[key], key);
        }
    }
    return target;
}
// 
/* eslint-disable no-bitwise */ var $724921cc79267cde$var$AD_REPLACER_R = /(a)(d)/gi;
/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $724921cc79267cde$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $724921cc79267cde$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ function $724921cc79267cde$var$generateAlphabeticName(code) {
    var name = "";
    var x;
    /* get a char and divide by alphabet-length */ for(x = Math.abs(code); x > $724921cc79267cde$var$charsLength; x = x / $724921cc79267cde$var$charsLength | 0)name = $724921cc79267cde$var$getAlphabeticChar(x % $724921cc79267cde$var$charsLength) + name;
    return ($724921cc79267cde$var$getAlphabeticChar(x % $724921cc79267cde$var$charsLength) + name).replace($724921cc79267cde$var$AD_REPLACER_R, "$1-$2");
}
// 
function $724921cc79267cde$var$isStaticRules(rules) {
    for(var i = 0; i < rules.length; i += 1){
        var rule = rules[i];
        if ($724921cc79267cde$var$isFunction(rule) && !$724921cc79267cde$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    return true;
}
// 
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $724921cc79267cde$var$ComponentStyle = /*#__PURE__*/ function() {
    function ComponentStyle(rules, componentId) {
        this.rules = rules;
        this.staticRulesId = "";
        this.isStatic = $724921cc79267cde$var$isStaticRules(rules);
        this.componentId = componentId;
        this.baseHash = $724921cc79267cde$var$hash(componentId); // NOTE: This registers the componentId, which ensures a consistent order
        // for this component's styles compared to others
        $724921cc79267cde$var$StyleSheet.registerId(componentId);
    }
    /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */ var _proto = ComponentStyle.prototype;
    _proto.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet, stylis) {
        var componentId = this.componentId; // force dynamic classnames if user-supplied stylis plugins are in use
        if (this.isStatic && !stylis.hash) {
            if (this.staticRulesId && styleSheet.hasNameForId(componentId, this.staticRulesId)) return this.staticRulesId;
            var cssStatic = $724921cc79267cde$var$flatten(this.rules, executionContext, styleSheet).join("");
            var name = $724921cc79267cde$var$generateAlphabeticName($724921cc79267cde$var$phash(this.baseHash, cssStatic.length) >>> 0);
            if (!styleSheet.hasNameForId(componentId, name)) {
                var cssStaticFormatted = stylis(cssStatic, "." + name, undefined, componentId);
                styleSheet.insertRules(componentId, name, cssStaticFormatted);
            }
            this.staticRulesId = name;
            return name;
        } else {
            var length = this.rules.length;
            var dynamicHash = $724921cc79267cde$var$phash(this.baseHash, stylis.hash);
            var css = "";
            for(var i = 0; i < length; i++){
                var partRule = this.rules[i];
                if (typeof partRule === "string") css += partRule;
                else {
                    var partChunk = $724921cc79267cde$var$flatten(partRule, executionContext, styleSheet);
                    var partString = Array.isArray(partChunk) ? partChunk.join("") : partChunk;
                    dynamicHash = $724921cc79267cde$var$phash(dynamicHash, partString + i);
                    css += partString;
                }
            }
            var _name = $724921cc79267cde$var$generateAlphabeticName(dynamicHash >>> 0);
            if (!styleSheet.hasNameForId(componentId, _name)) {
                var cssFormatted = stylis(css, "." + _name, undefined, componentId);
                styleSheet.insertRules(componentId, _name, cssFormatted);
            }
            return _name;
        }
    };
    return ComponentStyle;
}();
// 
var $724921cc79267cde$var$LIMIT = 200;
var $724921cc79267cde$var$createWarnTooManyClasses = function(displayName, componentId) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $724921cc79267cde$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ var parsedIdString = componentId ? ' with the id of "' + componentId + '"' : "";
                console.warn("Over " + $724921cc79267cde$var$LIMIT + " classes were generated for component " + displayName + parsedIdString + ".\n" + "Consider using the attrs method, together with a style object for frequently changed styles.\n" + "Example:\n" + "  const Component = styled.div.attrs(props => ({\n" + "    style: {\n" + "      background: props.background,\n" + "    },\n" + "  }))`width: 100%;`\n\n" + "  <Component />");
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $724921cc79267cde$var$invalidHookCallRe = /invalid hook call/i;
var $724921cc79267cde$var$seen = new Set();
var $724921cc79267cde$var$checkDynamicCreation = function checkDynamicCreation(displayName, componentId) {
    var parsedIdString, message, error;
};
// 
var $724921cc79267cde$var$determineTheme = function(props, providedTheme, defaultProps) {
    if (defaultProps === void 0) defaultProps = $724921cc79267cde$var$EMPTY_OBJECT;
    return props.theme !== defaultProps.theme && props.theme || providedTheme || defaultProps.theme;
};
// 
// Source: https://www.w3.org/TR/cssom-1/#serialize-an-identifier
// Control characters and non-letter first symbols are not supported
var $724921cc79267cde$var$escapeRegex = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g;
var $724921cc79267cde$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $724921cc79267cde$var$escape(str) {
    return str // Replace all possible CSS selectors
    .replace($724921cc79267cde$var$escapeRegex, "-") // Remove extraneous hyphens at the start and end
    .replace($724921cc79267cde$var$dashesAtEnds, "");
}
// 
function $724921cc79267cde$var$isTag(target) {
    return typeof target === "string" && true;
}
// 
function $724921cc79267cde$var$generateDisplayName(target) {
    // $FlowFixMe
    return $724921cc79267cde$var$isTag(target) ? "styled." + target : "Styled(" + $724921cc79267cde$var$getComponentName(target) + ")";
}
// 
var $724921cc79267cde$var$generateComponentId = function(str) {
    return $724921cc79267cde$var$generateAlphabeticName($724921cc79267cde$var$hash(str) >>> 0);
};
/**
 * Convenience function for joining strings to form className chains
 */ function $724921cc79267cde$var$joinStrings(a, b) {
    return a && b ? a + " " + b : a || b;
}
var $724921cc79267cde$export$2c657da244d00bd6 = (0, $2Jeaf.default).createContext();
var $724921cc79267cde$export$b631efc24e9d5e2f = $724921cc79267cde$export$2c657da244d00bd6.Consumer;
function $724921cc79267cde$var$mergeTheme(theme, outerTheme) {
    if (!theme) return $724921cc79267cde$var$throwStyledComponentsError(14);
    if ($724921cc79267cde$var$isFunction(theme)) {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    if (Array.isArray(theme) || typeof theme !== "object") return $724921cc79267cde$var$throwStyledComponentsError(8);
    return outerTheme ? $724921cc79267cde$var$_extends({}, outerTheme, {}, theme) : theme;
}
/**
 * Provide a theme to an entire react component tree via context
 */ function $724921cc79267cde$export$d8964aec282183a3(props) {
    var outerTheme = (0, $iJ7ah.useContext)($724921cc79267cde$export$2c657da244d00bd6);
    var themeContext = (0, $iJ7ah.useMemo)(function() {
        return $724921cc79267cde$var$mergeTheme(props.theme, outerTheme);
    }, [
        props.theme,
        outerTheme
    ]);
    if (!props.children) return null;
    return /*#__PURE__*/ (0, $2Jeaf.default).createElement($724921cc79267cde$export$2c657da244d00bd6.Provider, {
        value: themeContext
    }, props.children);
}
/* global $Call */ var $724921cc79267cde$var$identifiers = {};
/* We depend on components having unique IDs */ function $724921cc79267cde$var$generateId(displayName, parentComponentId) {
    var name = typeof displayName !== "string" ? "sc" : $724921cc79267cde$var$escape(displayName); // Ensure that no displayName can lead to duplicate componentIds
    $724921cc79267cde$var$identifiers[name] = ($724921cc79267cde$var$identifiers[name] || 0) + 1;
    var componentId = name + "-" + $724921cc79267cde$var$generateComponentId(name + $724921cc79267cde$var$identifiers[name]);
    return parentComponentId ? parentComponentId + "-" + componentId : componentId;
}
function $724921cc79267cde$var$useResolvedAttrs(theme, props, attrs) {
    if (theme === void 0) theme = $724921cc79267cde$var$EMPTY_OBJECT;
    // NOTE: can't memoize this
    // returns [context, resolvedAttrs]
    // where resolvedAttrs is only the things injected by the attrs themselves
    var context = $724921cc79267cde$var$_extends({}, props, {
        theme: theme
    });
    var resolvedAttrs = {};
    attrs.forEach(function(attrDef) {
        var resolvedAttrDef = attrDef;
        var key;
        if ($724921cc79267cde$var$isFunction(resolvedAttrDef)) resolvedAttrDef = resolvedAttrDef(context);
        /* eslint-disable guard-for-in */ for(key in resolvedAttrDef)context[key] = resolvedAttrs[key] = key === "className" ? $724921cc79267cde$var$joinStrings(resolvedAttrs[key], resolvedAttrDef[key]) : resolvedAttrDef[key];
    /* eslint-enable guard-for-in */ });
    return [
        context,
        resolvedAttrs
    ];
}
function $724921cc79267cde$var$useInjectedStyle(componentStyle, hasAttrs, resolvedAttrs, warnTooManyClasses) {
    var styleSheet = $724921cc79267cde$var$useStyleSheet();
    var stylis = $724921cc79267cde$var$useStylis(); // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    var isStatic = componentStyle.isStatic && !hasAttrs;
    var className = isStatic ? componentStyle.generateAndInjectStyles($724921cc79267cde$var$EMPTY_OBJECT, styleSheet, stylis) : componentStyle.generateAndInjectStyles(resolvedAttrs, styleSheet, stylis);
    (0, $iJ7ah.useDebugValue)(className);
    return className;
}
function $724921cc79267cde$var$useStyledComponentImpl(forwardedComponent, props, forwardedRef) {
    var componentAttrs = forwardedComponent.attrs, componentStyle = forwardedComponent.componentStyle, defaultProps = forwardedComponent.defaultProps, foldedComponentIds = forwardedComponent.foldedComponentIds, shouldForwardProp = forwardedComponent.shouldForwardProp, styledComponentId = forwardedComponent.styledComponentId, target = forwardedComponent.target;
    (0, $iJ7ah.useDebugValue)(styledComponentId); // NOTE: the non-hooks version only subscribes to this when !componentStyle.isStatic,
    // but that'd be against the rules-of-hooks. We could be naughty and do it anyway as it
    // should be an immutable value, but behave for now.
    var theme = $724921cc79267cde$var$determineTheme(props, (0, $iJ7ah.useContext)($724921cc79267cde$export$2c657da244d00bd6), defaultProps);
    var _useResolvedAttrs = $724921cc79267cde$var$useResolvedAttrs(theme || $724921cc79267cde$var$EMPTY_OBJECT, props, componentAttrs), context = _useResolvedAttrs[0], attrs = _useResolvedAttrs[1];
    var generatedClassName = $724921cc79267cde$var$useInjectedStyle(componentStyle, componentAttrs.length > 0, context, undefined);
    var refToForward = forwardedRef;
    var elementToBeCreated = attrs.$as || props.$as || attrs.as || props.as || target;
    var isTargetTag = $724921cc79267cde$var$isTag(elementToBeCreated);
    var computedProps = attrs !== props ? $724921cc79267cde$var$_extends({}, props, {}, attrs) : props;
    var propFilterFn = shouldForwardProp || isTargetTag && (0, $aa00f65b51933a12$export$2e2bcd8739ae039);
    var propsForElement = {}; // eslint-disable-next-line guard-for-in
    for(var key in computedProps){
        if (key[0] === "$" || key === "as") continue;
        else if (key === "forwardedAs") propsForElement.as = computedProps[key];
        else if (!propFilterFn || propFilterFn(key, (0, $aa00f65b51933a12$export$2e2bcd8739ae039))) // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
    }
    if (props.style && attrs.style !== props.style) propsForElement.style = $724921cc79267cde$var$_extends({}, props.style, {}, attrs.style);
    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, props.className, attrs.className).filter(Boolean).join(" ");
    propsForElement.ref = refToForward;
    return (0, $joJRn.createElement)(elementToBeCreated, propsForElement);
}
function $724921cc79267cde$var$createStyledComponent(target, options, rules) {
    var isTargetStyledComp = $724921cc79267cde$export$7ba318d8d2f06c76(target);
    var isCompositeComponent = !$724921cc79267cde$var$isTag(target);
    var _options$displayName = options.displayName, displayName = _options$displayName === void 0 ? $724921cc79267cde$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === void 0 ? $724921cc79267cde$var$generateId(options.displayName, options.parentComponentId) : _options$componentId, _options$attrs = options.attrs, attrs = _options$attrs === void 0 ? $724921cc79267cde$var$EMPTY_ARRAY : _options$attrs;
    var styledComponentId = options.displayName && options.componentId ? $724921cc79267cde$var$escape(options.displayName) + "-" + options.componentId : options.componentId || componentId; // fold the underlying StyledComponent attrs up (implicit extend)
    var finalAttrs = isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs; // eslint-disable-next-line prefer-destructuring
    var shouldForwardProp = options.shouldForwardProp; // $FlowFixMe
    if (isTargetStyledComp && target.shouldForwardProp) {
        if (shouldForwardProp) // compose nested shouldForwardProp calls
        shouldForwardProp = function shouldForwardProp(prop, filterFn) {
            return target.shouldForwardProp(prop, filterFn) && options.shouldForwardProp(prop, filterFn);
        };
        else // eslint-disable-next-line prefer-destructuring
        shouldForwardProp = target.shouldForwardProp;
    }
    var componentStyle = new $724921cc79267cde$var$ComponentStyle(isTargetStyledComp ? // $FlowFixMe
    target.componentStyle.rules.concat(rules) : rules, styledComponentId);
    /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */ var WrappedStyledComponent; // eslint-disable-next-line react-hooks/rules-of-hooks
    var forwardRef = function forwardRef(props, ref) {
        return $724921cc79267cde$var$useStyledComponentImpl(WrappedStyledComponent, props, ref);
    };
    forwardRef.displayName = displayName; // $FlowFixMe this is a forced cast to merge it StyledComponentWrapperProperties
    WrappedStyledComponent = (0, $2Jeaf.default).forwardRef(forwardRef);
    WrappedStyledComponent.attrs = finalAttrs;
    WrappedStyledComponent.componentStyle = componentStyle;
    WrappedStyledComponent.displayName = displayName;
    WrappedStyledComponent.shouldForwardProp = shouldForwardProp; // this static is used to preserve the cascade of static classes for component selector
    // purposes; this is especially important with usage of the css prop
    WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : $724921cc79267cde$var$EMPTY_ARRAY;
    WrappedStyledComponent.styledComponentId = styledComponentId; // fold the underlying StyledComponent target up since we folded the styles
    WrappedStyledComponent.target = isTargetStyledComp ? target.target : target; // $FlowFixMe
    WrappedStyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId, optionsToCopy = $724921cc79267cde$var$_objectWithoutPropertiesLoose(options, [
            "componentId"
        ]);
        var newComponentId = previousComponentId && previousComponentId + "-" + ($724921cc79267cde$var$isTag(tag) ? tag : $724921cc79267cde$var$escape($724921cc79267cde$var$getComponentName(tag)));
        var newOptions = $724921cc79267cde$var$_extends({}, optionsToCopy, {
            attrs: finalAttrs,
            componentId: newComponentId
        });
        return $724921cc79267cde$var$createStyledComponent(tag, newOptions, rules);
    }; // $FlowFixMe
    Object.defineProperty(WrappedStyledComponent, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(obj) {
            // $FlowFixMe
            this._foldedDefaultProps = isTargetStyledComp ? $724921cc79267cde$var$mixinDeep({}, target.defaultProps, obj) : obj;
        }
    });
    WrappedStyledComponent.toString = function() {
        return "." + WrappedStyledComponent.styledComponentId;
    };
    if (isCompositeComponent) (0, (/*@__PURE__*/$parcel$interopDefault($f4caa58b7a66ca1b$exports)))(WrappedStyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        foldedComponentIds: true,
        shouldForwardProp: true,
        self: true,
        styledComponentId: true,
        target: true,
        withComponent: true
    });
    return WrappedStyledComponent;
}
// 
// Thanks to ReactDOMFactories for this handy list!
var $724921cc79267cde$var$domElements = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// 
var $724921cc79267cde$var$styled = function styled(tag) {
    return $724921cc79267cde$var$constructWithOptions($724921cc79267cde$var$createStyledComponent, tag);
}; // Shorthands for all valid HTML Elements
$724921cc79267cde$var$domElements.forEach(function(domElement) {
    $724921cc79267cde$var$styled[domElement] = $724921cc79267cde$var$styled(domElement);
});
// 
var $724921cc79267cde$var$GlobalStyle = /*#__PURE__*/ function() {
    function GlobalStyle(rules, componentId) {
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = $724921cc79267cde$var$isStaticRules(rules);
    }
    var _proto = GlobalStyle.prototype;
    _proto.createStyles = function createStyles(instance, executionContext, styleSheet, stylis) {
        var flatCSS = $724921cc79267cde$var$flatten(this.rules, executionContext, styleSheet);
        var css = stylis(flatCSS.join(""), "");
        var id = this.componentId + instance; // NOTE: We use the id as a name as well, since these rules never change
        styleSheet.insertRules(id, id, css);
    };
    _proto.removeStyles = function removeStyles(instance, styleSheet) {
        styleSheet.clearRules(this.componentId + instance);
    };
    _proto.renderStyles = function renderStyles(instance, executionContext, styleSheet, stylis) {
        $724921cc79267cde$var$StyleSheet.registerId(this.componentId + instance); // NOTE: Remove old styles, then inject the new ones
        this.removeStyles(instance, styleSheet);
        this.createStyles(instance, executionContext, styleSheet, stylis);
    };
    return GlobalStyle;
}();
function $724921cc79267cde$export$f0f03736edb61697(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $724921cc79267cde$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations));
    var styledComponentId = "sc-global-" + $724921cc79267cde$var$generateComponentId(JSON.stringify(rules));
    var globalStyle = new $724921cc79267cde$var$GlobalStyle(rules, styledComponentId);
    function GlobalStyleComponent(props) {
        var styleSheet = $724921cc79267cde$var$useStyleSheet();
        var stylis = $724921cc79267cde$var$useStylis();
        var theme = (0, $iJ7ah.useContext)($724921cc79267cde$export$2c657da244d00bd6);
        var instanceRef = (0, $iJ7ah.useRef)(null);
        if (instanceRef.current === null) instanceRef.current = styleSheet.allocateGSInstance(styledComponentId);
        var instance = instanceRef.current;
        if (globalStyle.isStatic) globalStyle.renderStyles(instance, $724921cc79267cde$var$STATIC_EXECUTION_CONTEXT, styleSheet, stylis);
        else {
            var context = $724921cc79267cde$var$_extends({}, props, {
                theme: $724921cc79267cde$var$determineTheme(props, theme, GlobalStyleComponent.defaultProps)
            });
            globalStyle.renderStyles(instance, context, styleSheet, stylis);
        }
        (0, $iJ7ah.useEffect)(function() {
            return function() {
                return globalStyle.removeStyles(instance, styleSheet);
            };
        }, $724921cc79267cde$var$EMPTY_ARRAY);
        return null;
    } // $FlowFixMe
    return (0, $2Jeaf.default).memo(GlobalStyleComponent);
}
// 
function $724921cc79267cde$export$d25ddfdf17c3ad3e(strings) {
    for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    var rules = $724921cc79267cde$export$dbf350e5966cf602.apply(void 0, [
        strings
    ].concat(interpolations)).join("");
    var name = $724921cc79267cde$var$generateComponentId(rules);
    return new $724921cc79267cde$var$Keyframes(name, [
        rules,
        name,
        "@keyframes"
    ]);
}
var $724921cc79267cde$export$ae8c7d15c8b89a20 = /*#__PURE__*/ function() {
    function ServerStyleSheet() {
        var _this = this;
        this._emitSheetCSS = function() {
            var css = _this.instance.toString();
            var nonce = $724921cc79267cde$var$getNonce();
            var attrs = [
                nonce && 'nonce="' + nonce + '"',
                $724921cc79267cde$var$SC_ATTR + '="true"',
                $724921cc79267cde$var$SC_ATTR_VERSION + '="' + $724921cc79267cde$var$SC_VERSION + '"'
            ];
            var htmlAttr = attrs.filter(Boolean).join(" ");
            return "<style " + htmlAttr + ">" + css + "</style>";
        };
        this.getStyleTags = function() {
            if (_this.sealed) return $724921cc79267cde$var$throwStyledComponentsError(2);
            return _this._emitSheetCSS();
        };
        this.getStyleElement = function() {
            var _props;
            if (_this.sealed) return $724921cc79267cde$var$throwStyledComponentsError(2);
            var props = (_props = {}, _props[$724921cc79267cde$var$SC_ATTR] = "", _props[$724921cc79267cde$var$SC_ATTR_VERSION] = $724921cc79267cde$var$SC_VERSION, _props.dangerouslySetInnerHTML = {
                __html: _this.instance.toString()
            }, _props);
            var nonce = $724921cc79267cde$var$getNonce();
            if (nonce) props.nonce = nonce;
             // v4 returned an array for this fn, so we'll do the same for v5 for backward compat
            return [
                /*#__PURE__*/ (0, $2Jeaf.default).createElement("style", $724921cc79267cde$var$_extends({}, props, {
                    key: "sc-0-0"
                }))
            ];
        };
        this.seal = function() {
            _this.sealed = true;
        };
        this.instance = new $724921cc79267cde$var$StyleSheet({
            isServer: true
        });
        this.sealed = false;
    }
    var _proto = ServerStyleSheet.prototype;
    _proto.collectStyles = function collectStyles(children) {
        if (this.sealed) return $724921cc79267cde$var$throwStyledComponentsError(2);
        return /*#__PURE__*/ (0, $2Jeaf.default).createElement($724921cc79267cde$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    // eslint-disable-next-line consistent-return
    _proto.interleaveWithNodeStream = function interleaveWithNodeStream(input) {
        return $724921cc79267cde$var$throwStyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// export default <Config: { theme?: any }, Instance>(
//  Component: AbstractComponent<Config, Instance>
// ): AbstractComponent<$Diff<Config, { theme?: any }> & { theme?: any }, Instance>
//
// but the old build system tooling doesn't support the syntax
var $724921cc79267cde$export$e8748c6a27b910dc = function(Component) {
    // $FlowFixMe This should be React.forwardRef<Config, Instance>
    var WithTheme = (0, $2Jeaf.default).forwardRef(function(props, ref) {
        var theme = (0, $iJ7ah.useContext)($724921cc79267cde$export$2c657da244d00bd6); // $FlowFixMe defaultProps isn't declared so it can be inferrable
        var defaultProps = Component.defaultProps;
        var themeProp = $724921cc79267cde$var$determineTheme(props, theme, defaultProps);
        return /*#__PURE__*/ (0, $2Jeaf.default).createElement(Component, $724921cc79267cde$var$_extends({}, props, {
            theme: themeProp,
            ref: ref
        }));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($f4caa58b7a66ca1b$exports)))(WithTheme, Component);
    WithTheme.displayName = "WithTheme(" + $724921cc79267cde$var$getComponentName(Component) + ")";
    return WithTheme;
};
// 
var $724921cc79267cde$export$93d4e7f90805808f = function useTheme() {
    return (0, $iJ7ah.useContext)($724921cc79267cde$export$2c657da244d00bd6);
};
// 
var $724921cc79267cde$export$5c87cfe6c475f500 = {
    StyleSheet: $724921cc79267cde$var$StyleSheet,
    masterSheet: $724921cc79267cde$var$masterSheet
};
// 
/* Define bundle version for export */ var $724921cc79267cde$export$83d89fbfd8236492 = "5.1.1";
var $724921cc79267cde$export$2e2bcd8739ae039 = $724921cc79267cde$var$styled;



var $joJRn = parcelRequire("joJRn");

var $2Jeaf = parcelRequire("2Jeaf");

var $b903ce584385704c$exports = {};
"use strict";
Object.defineProperty($b903ce584385704c$exports, "__esModule", {
    value: true
});
$b903ce584385704c$exports.default = void 0;

var $b903ce584385704c$var$_Card = $b903ce584385704c$var$_interopRequireDefault((parcelRequire("aYNNv")));
function $b903ce584385704c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b903ce584385704c$var$_default = $b903ce584385704c$var$_Card.default;
$b903ce584385704c$exports.default = $b903ce584385704c$var$_default;


var $c3da6d6e6b27a3ce$exports = {};
$c3da6d6e6b27a3ce$exports = {
    colourTextAndIcon1: "rgb(var(--colour-text-and-icon-1, 17, 17, 17))",
    colourTextAndIcon1Rgb: "var(--colour-text-and-icon-1, 17, 17, 17)",
    colourTextAndIcon2: "rgb(var(--colour-text-and-icon-2, 72, 72, 72))",
    colourTextAndIcon2Rgb: "var(--colour-text-and-icon-2, 72, 72, 72)",
    colourTextAndIcon3: "rgb(var(--colour-text-and-icon-3, 118, 118, 118))",
    colourTextAndIcon3Rgb: "var(--colour-text-and-icon-3, 118, 118, 118)",
    colourTextAndIcon4: "rgb(var(--colour-text-and-icon-4, 146, 146, 146))",
    colourTextAndIcon4Rgb: "var(--colour-text-and-icon-4, 146, 146, 146)",
    colourTextAndIcon5: "rgb(var(--colour-text-and-icon-5, 255, 255, 255))",
    colourTextAndIcon5Rgb: "var(--colour-text-and-icon-5, 255, 255, 255)",
    colourNeutral1: "rgb(var(--colour-neutral-1, 255, 255, 255))",
    colourNeutral1Rgb: "var(--colour-neutral-1, 255, 255, 255)",
    colourNeutral2: "rgb(var(--colour-neutral-2, 245, 245, 245))",
    colourNeutral2Rgb: "var(--colour-neutral-2, 245, 245, 245)",
    colourNeutral3: "rgb(var(--colour-neutral-3, 223, 223, 223))",
    colourNeutral3Rgb: "var(--colour-neutral-3, 223, 223, 223)",
    colourNeutral4: "rgb(var(--colour-neutral-4, 204, 204, 204))",
    colourNeutral4Rgb: "var(--colour-neutral-4, 204, 204, 204)",
    colourNeutral5: "rgb(var(--colour-neutral-5, 146, 146, 146))",
    colourNeutral5Rgb: "var(--colour-neutral-5, 146, 146, 146)",
    colourNeutral6: "rgb(var(--colour-neutral-6, 72, 72, 72))",
    colourNeutral6Rgb: "var(--colour-neutral-6, 72, 72, 72)",
    colourNeutral7: "rgb(var(--colour-neutral-7, 17, 17, 17))",
    colourNeutral7Rgb: "var(--colour-neutral-7, 17, 17, 17)",
    colourSemanticInformative: "rgb(var(--colour-semantic-informative, 0, 88, 163))",
    colourSemanticInformativeRgb: "var(--colour-semantic-informative, 0, 88, 163)",
    colourSemanticPositive: "rgb(var(--colour-semantic-positive, 10, 138, 0))",
    colourSemanticPositiveRgb: "var(--colour-semantic-positive, 10, 138, 0)",
    colourSemanticCaution: "rgb(var(--colour-semantic-caution, 242, 106, 47))",
    colourSemanticCautionRgb: "var(--colour-semantic-caution, 242, 106, 47)",
    colourSemanticNegative: "rgb(var(--colour-semantic-negative, 224, 7, 81))",
    colourSemanticNegativeRgb: "var(--colour-semantic-negative, 224, 7, 81)",
    colourInteractivePrimaryBgDefault: "rgb(var(--colour-interactive-primary-bg-default, 17, 17, 17))",
    colourInteractivePrimaryBgDefaultRgb: "var(--colour-interactive-primary-bg-default, 17, 17, 17)",
    colourInteractivePrimaryBgHover: "rgb(var(--colour-interactive-primary-bg-hover, 51, 51, 51))",
    colourInteractivePrimaryBgHoverRgb: "var(--colour-interactive-primary-bg-hover, 51, 51, 51)",
    colourInteractivePrimaryBgPressed: "rgb(var(--colour-interactive-primary-bg-pressed, 0, 0, 0))",
    colourInteractivePrimaryBgPressedRgb: "var(--colour-interactive-primary-bg-pressed, 0, 0, 0)",
    colourInteractiveEmphasisedBgDefault: "rgb(var(--colour-interactive-emphasised-bg-default, 0, 88, 163))",
    colourInteractiveEmphasisedBgDefaultRgb: "var(--colour-interactive-emphasised-bg-default, 0, 88, 163)",
    colourInteractiveEmphasisedBgHover: "rgb(var(--colour-interactive-emphasised-bg-hover, 0, 79, 147))",
    colourInteractiveEmphasisedBgHoverRgb: "var(--colour-interactive-emphasised-bg-hover, 0, 79, 147)",
    colourInteractiveEmphasisedBgPressed: "rgb(var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114))",
    colourInteractiveEmphasisedBgPressedRgb: "var(--colour-interactive-emphasised-bg-pressed, 0, 62, 114)",
    colourInteractiveSecondaryBgDefault: "rgb(var(--colour-interactive-secondary-bg-default, 245, 245, 245))",
    colourInteractiveSecondaryBgDefaultRgb: "var(--colour-interactive-secondary-bg-default, 245, 245, 245)",
    colourInteractiveSecondaryBgHover: "rgb(var(--colour-interactive-secondary-bg-hover, 223, 223, 223))",
    colourInteractiveSecondaryBgHoverRgb: "var(--colour-interactive-secondary-bg-hover, 223, 223, 223)",
    colourInteractiveSecondaryBgPressed: "rgb(var(--colour-interactive-secondary-bg-pressed, 204, 204, 204))",
    colourInteractiveSecondaryBgPressedRgb: "var(--colour-interactive-secondary-bg-pressed, 204, 204, 204)",
    colourInteractiveSubtleBgDefault: "rgb(var(--colour-interactive-subtle-bg-default, 255, 255, 255))",
    colourInteractiveSubtleBgDefaultRgb: "var(--colour-interactive-subtle-bg-default, 255, 255, 255)",
    colourInteractiveSubtleBgHover: "rgb(var(--colour-interactive-subtle-bg-hover, 245, 245, 245))",
    colourInteractiveSubtleBgHoverRgb: "var(--colour-interactive-subtle-bg-hover, 245, 245, 245)",
    colourInteractiveSubtleBgPressed: "rgb(var(--colour-interactive-subtle-bg-pressed, 223, 223, 223))",
    colourInteractiveSubtleBgPressedRgb: "var(--colour-interactive-subtle-bg-pressed, 223, 223, 223)",
    colourInteractiveDestructiveBgDefault: "rgb(var(--colour-interactive-destructive-bg-default, 224, 7, 81))",
    colourInteractiveDestructiveBgDefaultRgb: "var(--colour-interactive-destructive-bg-default, 224, 7, 81)",
    colourInteractiveDestructiveBgHover: "rgb(var(--colour-interactive-destructive-bg-hover, 204, 0, 61))",
    colourInteractiveDestructiveBgHoverRgb: "var(--colour-interactive-destructive-bg-hover, 204, 0, 61)",
    colourInteractiveDestructiveBgPressed: "rgb(var(--colour-interactive-destructive-bg-pressed, 184, 0, 41))",
    colourInteractiveDestructiveBgPressedRgb: "var(--colour-interactive-destructive-bg-pressed, 184, 0, 41)",
    colourInteractiveDisabled1: "rgb(var(--colour-interactive-disabled-1, 223, 223, 223))",
    colourInteractiveDisabled1Rgb: "var(--colour-interactive-disabled-1, 223, 223, 223)",
    colourInteractiveDisabled2: "rgb(var(--colour-interactive-disabled-2, 146, 146, 146))",
    colourInteractiveDisabled2Rgb: "var(--colour-interactive-disabled-2, 146, 146, 146)",
    colourInteractiveDisabled3: "rgb(var(--colour-interactive-disabled-3, 255, 255, 255))",
    colourInteractiveDisabled3Rgb: "var(--colour-interactive-disabled-3, 255, 255, 255)",
    colourInteractiveEmphasisedBorderSelected: "rgb(var(--colour-interactive-emphasised-border-selected, 0, 88, 163))",
    colourInteractiveEmphasisedBorderSelectedRgb: "var(--colour-interactive-emphasised-border-selected, 0, 88, 163)",
    colourInteractiveSubtleBorderSelected: "rgb(var(--colour-interactive-subtle-border-selected, 17, 17, 17))",
    colourInteractiveSubtleBorderSelectedRgb: "var(--colour-interactive-subtle-border-selected, 17, 17, 17)",
    colourInteractiveSubtleBorderDefault: "rgb(var(--colour-interactive-subtle-border-default, 146, 146, 146))",
    colourInteractiveSubtleBorderDefaultRgb: "var(--colour-interactive-subtle-border-default, 146, 146, 146)",
    colourInteractiveSubtleBorderHover: "rgb(var(--colour-interactive-subtle-border-hover, 17, 17, 17))",
    colourInteractiveSubtleBorderHoverRgb: "var(--colour-interactive-subtle-border-hover, 17, 17, 17)",
    colourInteractiveSubtleBorderPressed: "rgb(var(--colour-interactive-subtle-border-pressed, 17, 17, 17))",
    colourInteractiveSubtleBorderPressedRgb: "var(--colour-interactive-subtle-border-pressed, 17, 17, 17)",
    colourStaticIkeaBrandBlue: "rgb(var(--colour-static-ikea-brand-blue, 0, 88, 163))",
    colourStaticIkeaBrandBlueRgb: "var(--colour-static-ikea-brand-blue, 0, 88, 163)",
    colourStaticIkeaBrandYellow: "rgb(var(--colour-static-ikea-brand-yellow, 255, 219, 0))",
    colourStaticIkeaBrandYellowRgb: "var(--colour-static-ikea-brand-yellow, 255, 219, 0)",
    colourStaticIkeaFamily: "rgb(var(--colour-static-ikea-family, 0, 124, 193))",
    colourStaticIkeaFamilyRgb: "var(--colour-static-ikea-family, 0, 124, 193)",
    colourStaticWhite: "rgb(var(--colour-static-white, 255, 255, 255))",
    colourStaticWhiteRgb: "var(--colour-static-white, 255, 255, 255)",
    colourStaticBlack: "rgb(var(--colour-static-black, 17, 17, 17))",
    colourStaticBlackRgb: "var(--colour-static-black, 17, 17, 17)",
    colourStaticDarkGrey: "rgb(var(--colour-static-dark-grey, 118, 118, 118))",
    colourStaticDarkGreyRgb: "var(--colour-static-dark-grey, 118, 118, 118)",
    colourStaticGrey: "rgb(var(--colour-static-grey, 223, 223, 223))",
    colourStaticGreyRgb: "var(--colour-static-grey, 223, 223, 223)",
    colourStaticLightGrey: "rgb(var(--colour-static-light-grey, 245, 245, 245))",
    colourStaticLightGreyRgb: "var(--colour-static-light-grey, 245, 245, 245)",
    colourElevation1: "rgb(var(--colour-elevation-1, 255, 255, 255))",
    colourElevation1Rgb: "var(--colour-elevation-1, 255, 255, 255)",
    colourElevation2: "rgb(var(--colour-elevation-2, 255, 255, 255))",
    colourElevation2Rgb: "var(--colour-elevation-2, 255, 255, 255)",
    colourElevation3: "rgb(var(--colour-elevation-3, 17, 17, 17))",
    colourElevation3Rgb: "var(--colour-elevation-3, 17, 17, 17)",
    colourElevation1Border: "rgb(var(--colour-elevation-1-border, 223, 223, 223))",
    colourElevation1BorderRgb: "var(--colour-elevation-1-border, 223, 223, 223)",
    colourElevation2Border: "rgb(var(--colour-elevation-2-border, 72, 72, 72))",
    colourElevation2BorderRgb: "var(--colour-elevation-2-border, 72, 72, 72)",
    colourCommercialMessageNew: "rgb(var(--colour-commercial-message-new, 202, 80, 8))",
    colourCommercialMessageNewRgb: "var(--colour-commercial-message-new, 202, 80, 8)",
    colourCommercialMessageNewLowerPrice: "rgb(var(--colour-commercial-message-new-lower-price, 204, 0, 8))",
    colourCommercialMessageNewLowerPriceRgb: "var(--colour-commercial-message-new-lower-price, 204, 0, 8)",
    colourCommercialMessageIkeaFamily: "rgb(var(--colour-commercial-message-ikea-family, 0, 124, 193))",
    colourCommercialMessageIkeaFamilyRgb: "var(--colour-commercial-message-ikea-family, 0, 124, 193)",
    colourCommercialMessageBtiYellow: "rgb(var(--colour-commercial-message-bti-yellow, 255, 219, 0))",
    colourCommercialMessageBtiYellowRgb: "var(--colour-commercial-message-bti-yellow, 255, 219, 0)",
    colourCommercialMessageBtiRed: "rgb(var(--colour-commercial-message-bti-red, 204, 0, 8))",
    colourCommercialMessageBtiRedRgb: "var(--colour-commercial-message-bti-red, 204, 0, 8)",
    colourCampaignSustainability: "rgb(var(--colour-campaign-sustainability, 0, 133, 62))",
    colourCampaignSustainabilityRgb: "var(--colour-campaign-sustainability, 0, 133, 62)"
};



const $443f25f0b235908f$export$c5b6f123b39cf573 = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;




const $5d8387a8e844302b$var$CardContainer = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  margin: 8px 0 !important;
  span{
    span{ 
      display: none;
    }
  }
`;
const $5d8387a8e844302b$var$TextDescription = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 220px;
  max-height: 220px;
`;
class $5d8387a8e844302b$var$TitleComp extends (0, $2Jeaf.default).Component {
    render() {
        return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)("a", {
            children: this.props.title
        });
    }
}
class $5d8387a8e844302b$var$CatComp extends (0, $2Jeaf.default).Component {
    render() {
        return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)("a", {
            children: this.props.category
        });
    }
}
// The conditional check for variant is used for A/B-test. 
const $5d8387a8e844302b$var$ArticleCard = ({ id: id, title: title, category: category, variant: variant, onClick: onClick, onKeyPress: onKeyPress, description: description })=>{
    return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($5d8387a8e844302b$var$CardContainer, {
        children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($b903ce584385704c$exports))), {
            label: category ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($5d8387a8e844302b$var$CatComp, {
                category: category.substring(category.lastIndexOf("/") + 1)
            }) : "",
            body: description,
            id: id,
            title: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($5d8387a8e844302b$var$TitleComp, {
                title: title
            }),
            tabIndex: 0,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($c3da6d6e6b27a3ce$exports))).colourNeutral2,
            buttonVariant: "icon-primary-inverse",
            emphasised: true,
            onClick: onClick,
            onKeyPress: onKeyPress,
            ctaLabel: "open article",
            children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $joJRn.Fragment), {
                children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $443f25f0b235908f$export$c5b6f123b39cf573), {
                    children: "press enter to open full article"
                })
            })
        })
    });
};
var $5d8387a8e844302b$export$2e2bcd8739ae039 = $5d8387a8e844302b$var$ArticleCard;




var $247fc30e2b510073$exports = {};
var $84c92ff180b7f110$exports = {};
function $84c92ff180b7f110$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$84c92ff180b7f110$exports = $84c92ff180b7f110$var$_arrayWithHoles, $84c92ff180b7f110$exports.__esModule = true, $84c92ff180b7f110$exports["default"] = $84c92ff180b7f110$exports;


var $084044820a98c5db$exports = {};
function $084044820a98c5db$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
$084044820a98c5db$exports = $084044820a98c5db$var$_iterableToArrayLimit, $084044820a98c5db$exports.__esModule = true, $084044820a98c5db$exports["default"] = $084044820a98c5db$exports;


var $05925eb28a162a65$exports = {};
var $7a562aedaf87b294$exports = {};
function $7a562aedaf87b294$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$7a562aedaf87b294$exports = $7a562aedaf87b294$var$_arrayLikeToArray, $7a562aedaf87b294$exports.__esModule = true, $7a562aedaf87b294$exports["default"] = $7a562aedaf87b294$exports;


function $05925eb28a162a65$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7a562aedaf87b294$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7a562aedaf87b294$exports(o, minLen);
}
$05925eb28a162a65$exports = $05925eb28a162a65$var$_unsupportedIterableToArray, $05925eb28a162a65$exports.__esModule = true, $05925eb28a162a65$exports["default"] = $05925eb28a162a65$exports;


var $09e0f8d80d8c7f1d$exports = {};
function $09e0f8d80d8c7f1d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$09e0f8d80d8c7f1d$exports = $09e0f8d80d8c7f1d$var$_nonIterableRest, $09e0f8d80d8c7f1d$exports.__esModule = true, $09e0f8d80d8c7f1d$exports["default"] = $09e0f8d80d8c7f1d$exports;


function $247fc30e2b510073$var$_slicedToArray(arr, i) {
    return $84c92ff180b7f110$exports(arr) || $084044820a98c5db$exports(arr, i) || $05925eb28a162a65$exports(arr, i) || $09e0f8d80d8c7f1d$exports();
}
$247fc30e2b510073$exports = $247fc30e2b510073$var$_slicedToArray, $247fc30e2b510073$exports.__esModule = true, $247fc30e2b510073$exports["default"] = $247fc30e2b510073$exports;


var $cac291ee2e9f6ac9$exports = {};
var $212534becf6e536f$exports = {};
var $beb2eb1337631a17$exports = {};
function $beb2eb1337631a17$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $beb2eb1337631a17$exports = $beb2eb1337631a17$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $beb2eb1337631a17$exports.__esModule = true, $beb2eb1337631a17$exports["default"] = $beb2eb1337631a17$exports, $beb2eb1337631a17$var$_typeof(obj);
}
$beb2eb1337631a17$exports = $beb2eb1337631a17$var$_typeof, $beb2eb1337631a17$exports.__esModule = true, $beb2eb1337631a17$exports["default"] = $beb2eb1337631a17$exports;


var $212534becf6e536f$var$_typeof = $beb2eb1337631a17$exports.default;
var $30a671abbb0043ac$exports = {};

var $30a671abbb0043ac$var$_typeof = $beb2eb1337631a17$exports.default;
function $30a671abbb0043ac$var$_toPrimitive(input, hint) {
    if ($30a671abbb0043ac$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($30a671abbb0043ac$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$30a671abbb0043ac$exports = $30a671abbb0043ac$var$_toPrimitive, $30a671abbb0043ac$exports.__esModule = true, $30a671abbb0043ac$exports["default"] = $30a671abbb0043ac$exports;


function $212534becf6e536f$var$_toPropertyKey(arg) {
    var key = $30a671abbb0043ac$exports(arg, "string");
    return $212534becf6e536f$var$_typeof(key) === "symbol" ? key : String(key);
}
$212534becf6e536f$exports = $212534becf6e536f$var$_toPropertyKey, $212534becf6e536f$exports.__esModule = true, $212534becf6e536f$exports["default"] = $212534becf6e536f$exports;


function $cac291ee2e9f6ac9$var$_defineProperty(obj, key, value) {
    key = $212534becf6e536f$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$cac291ee2e9f6ac9$exports = $cac291ee2e9f6ac9$var$_defineProperty, $cac291ee2e9f6ac9$exports.__esModule = true, $cac291ee2e9f6ac9$exports["default"] = $cac291ee2e9f6ac9$exports;


parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
var $08777ea9e451b4a1$exports = {};
function $08777ea9e451b4a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$08777ea9e451b4a1$exports = $08777ea9e451b4a1$var$_classCallCheck, $08777ea9e451b4a1$exports.__esModule = true, $08777ea9e451b4a1$exports["default"] = $08777ea9e451b4a1$exports;


var $959134ad10cc646f$exports = {};

function $959134ad10cc646f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $212534becf6e536f$exports(descriptor.key), descriptor);
    }
}
function $959134ad10cc646f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $959134ad10cc646f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $959134ad10cc646f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$959134ad10cc646f$exports = $959134ad10cc646f$var$_createClass, $959134ad10cc646f$exports.__esModule = true, $959134ad10cc646f$exports["default"] = $959134ad10cc646f$exports;




var $2Jeaf = parcelRequire("2Jeaf");
function $6f8629dd51647a0e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f8629dd51647a0e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6f8629dd51647a0e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cac291ee2e9f6ac9$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6f8629dd51647a0e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6f8629dd51647a0e$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true
};
var $6f8629dd51647a0e$var$i18nInstance;
var $6f8629dd51647a0e$export$5603ab5ced17ce64 = (0, $2Jeaf.default).createContext();
function $6f8629dd51647a0e$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $6f8629dd51647a0e$var$defaultOptions = $6f8629dd51647a0e$var$_objectSpread($6f8629dd51647a0e$var$_objectSpread({}, $6f8629dd51647a0e$var$defaultOptions), options);
}
function $6f8629dd51647a0e$export$212bb2fc580a90a8() {
    return $6f8629dd51647a0e$var$defaultOptions;
}
var $6f8629dd51647a0e$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($08777ea9e451b4a1$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($959134ad10cc646f$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $6f8629dd51647a0e$export$a039134f2fc7e0(instance) {
    $6f8629dd51647a0e$var$i18nInstance = instance;
}
function $6f8629dd51647a0e$export$64af334f494c2f47() {
    return $6f8629dd51647a0e$var$i18nInstance;
}
var $6f8629dd51647a0e$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        $6f8629dd51647a0e$export$2e2366488d12e20d(instance.options.react);
        $6f8629dd51647a0e$export$a039134f2fc7e0(instance);
    }
};
function $6f8629dd51647a0e$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $6f8629dd51647a0e$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($6f8629dd51647a0e$var$_objectSpread($6f8629dd51647a0e$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $6f8629dd51647a0e$export$704200e5d0b9e8f() {
    var i18n = $6f8629dd51647a0e$export$64af334f494c2f47();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $c9b82160fc60ea69$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $c9b82160fc60ea69$var$alreadyWarned = {};
function $c9b82160fc60ea69$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $c9b82160fc60ea69$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $c9b82160fc60ea69$var$alreadyWarned[args[0]] = new Date();
    $c9b82160fc60ea69$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $c9b82160fc60ea69$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $c9b82160fc60ea69$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $c9b82160fc60ea69$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $c9b82160fc60ea69$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


function $cc94a242f86bed6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc94a242f86bed6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cc94a242f86bed6e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cac291ee2e9f6ac9$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cc94a242f86bed6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cc94a242f86bed6e$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $iJ7ah.useContext)((0, $6f8629dd51647a0e$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $6f8629dd51647a0e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $6f8629dd51647a0e$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $c9b82160fc60ea69$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k) {
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $c9b82160fc60ea69$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $cc94a242f86bed6e$var$_objectSpread($cc94a242f86bed6e$var$_objectSpread($cc94a242f86bed6e$var$_objectSpread({}, (0, $6f8629dd51647a0e$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $c9b82160fc60ea69$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0]);
    }
    var _useState = (0, $iJ7ah.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($247fc30e2b510073$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var isMounted = (0, $iJ7ah.useRef)(true);
    (0, $iJ7ah.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) (0, $c9b82160fc60ea69$export$83be934b53fff43b)(i18n, namespaces, function() {
            if (isMounted.current) setT(getT);
        });
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        namespaces.join()
    ]);
    var isInitial = (0, $iJ7ah.useRef)(true);
    (0, $iJ7ah.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        (0, $c9b82160fc60ea69$export$83be934b53fff43b)(i18n, namespaces, function() {
            resolve();
        });
    });
}



var $9CtqL = parcelRequire("9CtqL");

var $dcraR = parcelRequire("dcraR");
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");
const $e8bd861091c10b8c$var$useAnalytics = ()=>{
    const [loaded, setLoaded] = (0, $iJ7ah.useState)(false);
    const consent = window.ikea?.cookieConsent?.hasConsent(2);
    (0, $iJ7ah.useEffect)(()=>{
        if (!$e8bd861091c10b8c$var$canUseGA) // throw Error('Analytics library not loaded');
        console.warn("Analytics library not loaded: will not send analytics");
        else console.log("Analytics library loaded");
    }, [
        consent
    ]);
    const send = (0, $iJ7ah.useCallback)((eventName)=>{
        if ($e8bd861091c10b8c$var$canUseGA || consent) send(eventName);
    }, [
        consent
    ]);
    return {
        loaded: loaded,
        send: send
    };
};
const $e8bd861091c10b8c$var$canUseGA = ()=>{
    if (window.ikea?.cookieConsent?.hasConsent(2)) return true;
    return false;
};
const $e8bd861091c10b8c$export$f42fbd1cc833b8f7 = ({ results: results, query: query, guid: guid, action: action, pos: pos, variant: variant, page: page, topArts: topArts, loadTimeMs: loadTimeMs, backend: backend, correlationId: correlationId, activity: activity, articlesDisplayed: articlesDisplayed, redirect: redirect })=>{
    if ($e8bd861091c10b8c$var$canUseGA()) {
        let analyticsObject = null;
        switch(action){
            //pass along a collection of id's of the first five articles.
            case "search":
                analyticsObject = {
                    event_category: "customer_service",
                    event_action: "vetaInfoReq",
                    event_label: JSON.stringify({
                        component: "search",
                        variant: variant,
                        results: results,
                        query: query,
                        load_time_ms: loadTimeMs,
                        backend: backend,
                        correlationId: correlationId,
                        activity: action,
                        redirect: redirect
                    })
                };
                break;
            case "articleOpen":
                analyticsObject = {
                    event_category: "customer_service",
                    event_action: "vetaInfoReq",
                    event_label: JSON.stringify({
                        component: "search",
                        guid: guid,
                        variant: variant,
                        pos: pos + 1,
                        query: query,
                        correlationId: correlationId,
                        activity: "readMoreArticle"
                    })
                };
                break;
            default:
                break;
        }
        if (analyticsObject) window.sendEvent(analyticsObject);
    //@ts-ignore
    } else console.log("Unable to sent GA event");
};
const $e8bd861091c10b8c$export$a65d69dd22caceda = ({ reaction: reaction, docGuid: docGuid, variant: variant })=>{
    if ($e8bd861091c10b8c$var$canUseGA() && docGuid) {
        let analyticsObject = null;
        analyticsObject = {
            event_category: "customer_service",
            event_action: "feedback",
            event_label: JSON.stringify({
                component: "search",
                guid: docGuid,
                variant: variant,
                reaction: reaction ? "positive" : "negative",
                message: ""
            })
        };
        if (analyticsObject) window.sendEvent(analyticsObject);
    //@ts-ignore
    } else console.log("not allowed ga event");
};
var $e8bd861091c10b8c$export$2e2bcd8739ae039 = $e8bd861091c10b8c$var$useAnalytics;











const $64e54fc71e534777$export$a0dba7a0070b1588 = "search";
const $64e54fc71e534777$export$64419dba853ac5 = (lang)=>{
    const langMap = {
        "nl-NL": "nl-NL",
        "nl-EN": "en-NL",
        "en-EN": "en-EN",
        "fr-FR": "fr-FR",
        "ca-FR": "fr-CA",
        "ca-EN": "en-CA",
        "se-SV": "sv-SE",
        "se-EN": "en-SE",
        "ch-DE": "de-CH",
        "ch-FR": "fr-CH",
        "ch-IT": "it-CH",
        "ch-EN": "en-CH",
        "pl-PL": "pl-PL",
        "ro-RO": "ro-RO",
        "rs-SR": "sr-RS",
        "sk-SK": "sk-SK",
        "cz-CS": "cs-CZ",
        "hr-HR": "hr-HR",
        "si-SL": "sl-SI",
        "de-DE": "de-DE",
        "de-EN": "en-DE",
        "dk-DA": "da-DK",
        "no-NO": "no-NO",
        "no-EN": "en-NO",
        "jp-JA": "ja-JP",
        "jp-EN": "en-JP",
        "fi-FI": "fi-FI",
        "fi-EN": "en-FI",
        "pt-PT": "pt-PT",
        "pt-EN": "en-PT",
        "at-DE": "de-AT",
        "at-EN": "en-AT",
        "it-IT": "it-IT",
        "kr-KO": "ko-KR",
        "kr-EN": "en-KR",
        "us-EN": "en-US",
        "us-ES": "es-US",
        "gb-EN": "en-GB",
        "au-EN": "en-AU",
        "in-EN": "en-IN",
        "ie-EN": "en-IE",
        "es-EN": "en-ES",
        "es-ES": "es-ES",
        "es-GL": "gl-ES",
        "es-EU": "eu-ES",
        "es-CA": "ca-ES",
        "be-FR": "fr-BE",
        "be-EN": "en-BE",
        "be-NL": "nl-BE",
        "ua-UK": "uk-UA",
        "hu-HU": "hu-HU",
        "ru-RU": "ru-RU",
        "r1-EN": "en-R1",
        "re-RV": "rv-RE",
        "nz-EN": "en-NZ"
    };
    if (lang in langMap) return langMap[lang];
    return lang;
};


const $f91de8dbf30ded37$var$LISA_SEARCH_PROD = "https://web-api.ikea.com/customer-service/knowledge/search-gql";
const $f91de8dbf30ded37$var$LISA_SEARCH_INT = "https://web-api.cte.ikeadt.com/customer-service/knowledge/search-gql";
const $f91de8dbf30ded37$var$LISA_DOC_PROD = "https://web-api.ikea.com/customer-service/knowledge/document-gql";
const $f91de8dbf30ded37$var$LISA_DOC_INT = "https://web-api.cte.ikeadt.com/customer-service/knowledge/document-gql";
const $f91de8dbf30ded37$var$CLIENT_ID_PROD = "dde333e7-6433-46a4-aef5-34532aec4a88";
const $f91de8dbf30ded37$var$CLIENT_ID_INT = "d00c771f-5d86-449f-bff9-e9bf42729e68";
const $f91de8dbf30ded37$export$7759221db3edc8c1 = async (params)=>{
    const start = new Date().getTime();
    params.setLoading(true);
    const lang = $f91de8dbf30ded37$var$getValFromLocale(params.locale, "lang");
    const cb = $f91de8dbf30ded37$var$getValFromLocale(params.locale, "cb");
    const data = JSON.stringify({
        "query": `query{search(query:"${params.query}",lang:"${lang}",categoryBranch:"${cb}", origin:"${(0, $64e54fc71e534777$export$a0dba7a0070b1588)}"){ documents{ description, title, content, vetaGuid }}}`,
        "variables": null
    });
    await fetch(params.isProd ? $f91de8dbf30ded37$var$LISA_SEARCH_PROD : $f91de8dbf30ded37$var$LISA_SEARCH_INT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-client-id": params.isProd ? $f91de8dbf30ded37$var$CLIENT_ID_PROD : $f91de8dbf30ded37$var$CLIENT_ID_INT
        },
        body: data
    }).then((response)=>{
        const elapsed = new Date().getTime() - start;
        if (response.status !== 200) return {
            error: true
        };
        response.json().then((data)=>{
            let res = $f91de8dbf30ded37$var$mapLisaToVetaBody(data);
            if (res !== undefined) {
                params.setReady(true);
                params.setLoading(false);
                params.setResults(res.entries);
                if (res.entries.length <= 0) params.setError(0);
                const serializedArray = JSON.stringify(res);
                sessionStorage.setItem("queryString", serializedArray);
            }
            const redirectPage = $f91de8dbf30ded37$var$redirect(params.query);
            if (redirectPage) {
                (0, $e8bd861091c10b8c$export$f42fbd1cc833b8f7)({
                    action: "search",
                    query: params.query,
                    loadTimeMs: elapsed,
                    variant: params.variant,
                    backend: params.backend,
                    correlationId: params.correlationId,
                    redirect: redirectPage
                });
                params.setResults([]);
                params.setRedirect(true);
            } else (0, $e8bd861091c10b8c$export$f42fbd1cc833b8f7)({
                results: res === undefined ? 0 : res.entries.length,
                action: "search",
                query: params.query,
                loadTimeMs: elapsed,
                variant: params.variant,
                backend: params.backend,
                correlationId: params.correlationId
            });
        });
    }).catch((err)=>{
        params.setLoading(false);
        params.setError(err.request.status > 0 ? err.request.status : 500);
        params.setReady(true);
    });
};
const $f91de8dbf30ded37$export$647b0f0838f655fd = async (params)=>{
    const start = new Date().getTime();
    const lang = $f91de8dbf30ded37$var$getValFromLocale(params.locale, "lang");
    const data = JSON.stringify({
        "query": `query{GetDoc(vetaGuid:"${params.docGuid}",lang:"${lang}", origin:"${(0, $64e54fc71e534777$export$a0dba7a0070b1588)}"){ description, title, content, docMetaData{changeDate, publishDate, categories{branch, branchText}}}}`,
        "variables": null
    });
    await fetch(params.isProd ? $f91de8dbf30ded37$var$LISA_DOC_PROD : $f91de8dbf30ded37$var$LISA_DOC_INT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-client-id": params.isProd ? $f91de8dbf30ded37$var$CLIENT_ID_PROD : $f91de8dbf30ded37$var$CLIENT_ID_INT
        },
        body: data
    }).then((response)=>{
        const elapsed = new Date().getTime() - start;
        if (response.status !== 200) return {
            error: true
        };
        response.json().then((data)=>{
            if (data !== undefined) {
                const document = data.data?.GetDoc;
                params.setVetaDoc({
                    title: document.title,
                    description: document.description,
                    content: document.content
                });
            }
            (0, $e8bd861091c10b8c$export$f42fbd1cc833b8f7)({
                action: "articleOpen",
                query: params.query,
                guid: params.docGuid,
                pos: params.pos,
                loadTimeMs: elapsed,
                variant: "standard",
                backend: params.backend,
                correlationId: params.correlationId
            });
            params.setModalOpen(true);
        });
    }).catch((err)=>{});
};
const $f91de8dbf30ded37$var$getValFromLocale = (locale, val)=>{
    let startIdx = locale.indexOf(val) + val.length + 1;
    let endIdx = locale.indexOf("&", startIdx);
    let res = locale.substring(startIdx, endIdx);
    return res;
};
const $f91de8dbf30ded37$var$mapLisaToVetaBody = (lisaRes)=>{
    let res = {
        count: 0,
        entries: new Array()
    };
    if (lisaRes === undefined) return undefined;
    if (lisaRes.data === undefined) return undefined;
    if (lisaRes.data === null) return res;
    res.count = lisaRes?.data?.search?.documents?.length;
    lisaRes.data.search.documents.forEach((doc)=>{
        res.entries.push({
            content: doc.content,
            title: doc.title,
            description: doc.description,
            metadata: {
                docGUID: doc.vetaGuid
            }
        });
    });
    return res;
};
const $f91de8dbf30ded37$var$redirect = (query)=>{
    const productRegex = /(\d+\.\d+\.\d+)|\b\d{8}\b/g;
    const orderNumbRegex = /\b\d{9,10}\b/g;
    const sparePartRegex = /\b\d{6}\b/g;
    const productMatch = query.match(productRegex);
    const orderMatch = query.match(orderNumbRegex);
    const sparePartMatch = query.match(sparePartRegex);
    if (productMatch) return "productNumber";
    else if (orderMatch) return "orderNumber";
    else if (sparePartMatch) return "sparePartNumber";
};


var $f8966ba10bba7dbd$exports = {};
$f8966ba10bba7dbd$exports = JSON.parse('{"archived_Desc_Key":"Weitere Informationen findest du hier.","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"War der Inhalt nicht hilfreich f\xfcr dich? Versuche eines der folgenden Dokumente.","click_prompt_Text_Key":"Klicke hier","close_Text_Key":"schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Irgendetwas ist schief gelaufen","feedback_Option1_Text_Key":"Der Text ist verwirrend.","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht von Bedeutung.","feedback_Option3_Text_Key":"Der Text ist relevant aber nicht hilfreich.","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz.","feedback_Question_1_Text_Key":"Welche Abschnitte unserer Antwort findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"Wissensinhalte","link_prod_error_Text_Key":"https://www.ikea.com/de/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"Deutschland","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns dabei helfen, uns zu verbessern?","no_results_Text_Key":"Wir haben keine Ergebnisse f\xfcr den Suchbegriff gefunden: {{query}}","product_error_Text_Key":"Leider wurden keine Ergebnisse gefunden. Wenn du Produktinformationen ben\xf6tigst nutze die Suchleiste weiter oben. Wenn du den Status deiner Bestellung \xfcberpr\xfcfen willst, klicke bitte hier.","read_more_button_Text_Key":"Read more","results_Text_Key":"Wir haben {{number}} Ergebnisse gefunden: {{query}}","retrieving_Text_Key":"Abrufen von","searchbar_Text_Key":"Gib ein Stichwort oder Thema ein, um eine Antwort zu finden.","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuche andere Begriffe oder \xfcberpr\xfcfe, ob du alles richtig geschrieben hast.","submit_Text_Key":"Absenden","try_again_Text_Key":"Versuche es bitte sp\xe4ter noch einmal."}');


var $922eccef1347026d$exports = {};
$922eccef1347026d$exports = JSON.parse('{"archived_Desc_Key":"Puedes encontrar m\xe1s ayuda aqu\xed","archived_Redirection_Key":"atenci\xf3n al cliente/cont\xe1ctanos/","archived_Title_Key":"Este documento ha sido archivado","carousel_Text_Key":"\xbfEl art\xedculo no te ha resultado \xfatil? Prueba uno de los art\xedculos relacionados a continuaci\xf3n.","click_prompt_Text_Key":"aqu\xed","close_Text_Key":"Cerrar","customerService_Text_Key":"Atenci\xf3n al cliente","error_Text_Key":"Algo sali\xf3 mal","feedback_Option1_Text_Key":"El texto es confuso de entender","feedback_Option2_Text_Key":"El texto no es relevante para mi pregunta","feedback_Option3_Text_Key":"El texto es relevante pero no \xfatil","feedback_Option4_Text_Key":"El texto es demasiado largo o demasiado corto ","feedback_Question_1_Text_Key":"\xbfQu\xe9 partes concretas de nuestros art\xedculos te parecen insatisfactorias o poco \xfatiles?","feedback_Rec_Text_Key":"\xa1Gracias por tu opini\xf3n!","feedback_Text_Key":"\xbfTe result\xf3 \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Conocimientos","link_prod_error_Text_Key":"https://www.ikea.com/us/es/customer-service/track-manage-order","loading_Text_Key":"Cargando","market_Name_Key":"Reino Unido","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Sentimos que no hayas obtenido la respuesta que buscabas, \xbfte gustar\xeda ayudarnos a mejorar?","no_results_Text_Key":"No hay resultados para tu b\xfasqueda: {{query}}","product_error_Text_Key":"Lo sentimos, no hemos encontrado resultados. Este buscador solo permite una o m\xe1s palabras claves. Si deseas informaci\xf3n sobre nuestros productos, utiliza el buscador principal ubicado en la parte superior de la p\xe1gina. Si deseas consultar el estado de tu pedido, por favor, haz clic.","read_more_button_Text_Key":"M\xe1s informaci\xf3n","results_Text_Key":"Hemos encontrado {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"Recuperando datos","searchbar_Text_Key":"Escribe una palabra o frase, por ejemplo, pedido o modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Ver menos","showMore_Text_Key":"Ver m\xe1s","spellcheck_Text_Key":"Intenta revisar la ortograf\xeda o usar otras palabras.","submit_Text_Key":"Enviar","try_again_Text_Key":"Por favor, int\xe9ntalo de nuevo m\xe1s tarde"}');


var $230d3fff040badbc$exports = {};
$230d3fff040badbc$exports = JSON.parse('{"archived_Desc_Key":"Trobar\xe0 m\xe9s ajuda aqu\xed","archived_Title_Key":"Aquest document ha estat arxivat.","carousel_Text_Key":"No li ha resultat \xfatil aquest article? Provi amb un dels seg\xfcents articles relacionats.","click_prompt_Text_Key":"aqui","close_Text_Key":"Tanca","customerService_Text_Key":"Atenci\xf3 al client","error_Text_Key":"Alguna cosa ha anat malament","feedback_Option1_Text_Key":"El text \xe9s conf\xfas d\'entendre","feedback_Option2_Text_Key":"El text no \xe9s rellevant per a la meva pregunta","feedback_Option3_Text_Key":"El text \xe9s rellevant per\xf2 no \xe9s \xfatil","feedback_Option4_Text_Key":"El text \xe9s massa llarg o massa curt ","feedback_Question_1_Text_Key":"Quines parts dels nostres articles trobes que no s\xf3n satisfact\xf2ries o no s\xf3n \xfatils?","feedback_Rec_Text_Key":"Gr\xe0cies per la teva opini\xf3!","feedback_Text_Key":"T\'ha resultat \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Coneixement","link_prod_error_Text_Key":"https://www.ikea.com/es/ca/customer-service/track-manage-order/","loading_Text_Key":"S\xb4est\xe0 carregant","market_Name_Key":"Espanya","modal_button_Close_Text_Key":"Tanca","negative_feedback_Text_Key":"Lamentem que no hagis rebut la resposta que estaves buscant. Vols ajudar-nos a millorar?","no_results_Text_Key":"No s\xb4han trobat resultats per als termes de cerca que heu proporcionat: {{query}}","product_error_Text_Key":"Ho sentim, no hem trobat resultats. Aquest cercador nom\xe9s admet una o m\xe9s paraules claus. Si desitges informaci\xf3 sobre els nostres articles utilitza el cercador principal situat en la part superior de la web. Si desitges consultar l\xb4estat de la teva comanda, si us plau, fes clic","read_more_button_Text_Key":"Llegir m\xe9s","results_Text_Key":"Hem trobat {{number}} resultat(s) pera: {{query}}","retrieving_Text_Key":"Recuperaci\xf3","searchbar_Text_Key":"Escriu una paraula o frase, per exemple, comanda o modificar.","searching_Text_Key":"Cercant...","showLess_Text_Key":"Mostra\'n menys","showMore_Text_Key":"Mostra\'n m\xe9s","spellcheck_Text_Key":"Proveu de revisar l\xb4ortografia o d\xb4utilitzar paraules clau diferents","submit_Text_Key":"Envia\'l","try_again_Text_Key":"Si us plau, intenta-ho m\xe9s tard"}');


var $880d32b33610a524$exports = {};
$880d32b33610a524$exports = JSON.parse('{"archived_Desc_Key":"Dalš\xed n\xe1povědu naleznete zde","archived_Title_Key":"Tento dokument byl archivov\xe1n.","carousel_Text_Key":"Nebyl tento čl\xe1nek dostatečně užitečn\xfd? Vyzkoušejte podobn\xfd obsah zobrazen\xfd n\xedže.","click_prompt_Text_Key":"Klikněte zde","close_Text_Key":"Zavř\xedt","customerService_Text_Key":"Z\xe1kaznicky servis","error_Text_Key":"Něco se nepovedlo","feedback_Option1_Text_Key":"Čl\xe1nek je napsan\xfd nesrozumitelně.","feedback_Option2_Text_Key":"Čl\xe1nek neposkytuje relevantn\xed odpověď na mou ot\xe1zku.","feedback_Option3_Text_Key":"Čl\xe1nek odpov\xedd\xe1 na moji ot\xe1zku, ale nepomohl mi.","feedback_Option4_Text_Key":"Čl\xe1nek je př\xedliš dlouh\xfd/kr\xe1tk\xfd.","feedback_Question_1_Text_Key":"Co přesně bylo v čl\xe1nku špatně?","feedback_Rec_Text_Key":"Děkujeme za vaši zpětnou vazbu","feedback_Text_Key":"Bylo to pro v\xe1s užitečn\xe9?","here_Text_Key":"zde","knowledge_Text_Key":"Centrum znalost\xed","link_prod_error_Text_Key":"https://www.ikea.com/cz/cs/customer-service/track-manage-order/","loading_Text_Key":"Nač\xedt\xe1m","market_Name_Key":"Česk\xe1 republika","modal_button_Close_Text_Key":"Zavř\xedt","negative_feedback_Text_Key":"Je n\xe1m l\xedto, že jste nedostali odpověď, kterou jste hledali, chcete n\xe1m pomoci se zlepšen\xedm?","no_results_Text_Key":"Pro hledan\xfd v\xfdraz nebyly nalezeny ž\xe1dn\xe9 v\xfdsledky: {{query}}","product_error_Text_Key":"Toto pole slouž\xed pro vyhled\xe1v\xe1n\xed n\xe1povědy. Pokud chcete hledat v\xfdrobky na z\xe1kladě jejich č\xedsla, použijte hlavn\xed vyhled\xe1vac\xed pole na IKEA.cz.","read_more_button_Text_Key":"Přečtěte si v\xedce","results_Text_Key":"Našli jsme {{number}} v\xfdsledek/v\xfdsledků pro: {{query}}","retrieving_Text_Key":"Nač\xedt\xe1m","searchbar_Text_Key":"Napište, co hled\xe1te","searching_Text_Key":"Vyhled\xe1v\xe1m...","showLess_Text_Key":"Zobrazit m\xe9ně","showMore_Text_Key":"Zobrazit v\xedce","spellcheck_Text_Key":"Zkuste zkontrolovat pravopis nebo použ\xedt jin\xe1 kl\xedčov\xe1 slova","submit_Text_Key":"Odeslat","try_again_Text_Key":"Pros\xedm zkuste to znovu později"}');


var $046e1dcd8a463a54$exports = {};
$046e1dcd8a463a54$exports = JSON.parse('{"archived_Desc_Key":"Yderligere hj\xe6lp kan findes her.","archived_Title_Key":"Dette dokument er blevet arkiveret.","carousel_Text_Key":"Fandt du ikke svar? Pr\xf8v en af relaterede artikler nedenfor.","click_prompt_Text_Key":"klik her","close_Text_Key":"Luk","customerService_Text_Key":"Kundeservice","error_Text_Key":"Noget gik galt","feedback_Option1_Text_Key":"Teksten er forvirrende at forst\xe5","feedback_Option2_Text_Key":"Teksten er ikke relevant for mit sp\xf8rgsm\xe5l","feedback_Option3_Text_Key":"Teksten er relevant, men jeg fik ikke svar","feedback_Option4_Text_Key":"Teksten er for lang eller for kort ","feedback_Question_1_Text_Key":"Hvilke dele af artiklen, synes du, er uklare eller irrelevante?","feedback_Rec_Text_Key":"Tak for din feedback!","feedback_Text_Key":"Fandt du svar?","here_Text_Key":"her.","knowledge_Text_Key":"Information","link_prod_error_Text_Key":"https://www.ikea.com/dk/da/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Danmark","modal_button_Close_Text_Key":"Luk","negative_feedback_Text_Key":"Vi er kede af, at du ikke fik det svar, du ledte efter. Vil du hj\xe6lpe os med at blive bedre?","no_results_Text_Key":"Der er ingen s\xf8gninger som matcher s\xf8gning p\xe5: {{query}}","product_error_Text_Key":"Dette s\xf8gefelt er kun til support. Ved artikelnumre, pr\xf8v at s\xf8ge i s\xf8gefeltet \xf8verst p\xe5 IKEA.dk i stedet. Hvis du s\xf8ger efter information om din ordre,","read_more_button_Text_Key":"L\xe6s mere","results_Text_Key":"Der blev fundet {{number}} resultat(er) for: {{query}}","retrieving_Text_Key":"Modtager","searchbar_Text_Key":"Skriv dit sp\xf8rgsm\xe5l her","searching_Text_Key":"S\xf8ger....","showLess_Text_Key":"Vis mindre","showMore_Text_Key":"Vis mere","spellcheck_Text_Key":"Tjek for stavefejl eller pr\xf8v andre s\xf8geord.","submit_Text_Key":"Indsende","try_again_Text_Key":"Pr\xf8v venligst igen"}');


var $7d8b491eef37576b$exports = {};
$7d8b491eef37576b$exports = JSON.parse('{"archived_Desc_Key":"Hier findest du weitere Hilfe.","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"Brauchst du eine andere Information? Bestimmt hilft dir das weiter:","click_prompt_Text_Key":"Klick hier","close_Text_Key":"Schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Da ist etwas schiefgelaufen..","feedback_Option1_Text_Key":"Der Text ist verwirrend zu verstehen","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht relevant","feedback_Option3_Text_Key":"Der Text ist relevant, aber nicht hilfreich","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz ","feedback_Question_1_Text_Key":"Welche Abschnitte unserer Antwort findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"IKEA Wissen","link_prod_error_Text_Key":"https://www.ikea.com/at/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"\xd6sterreich","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns helfen, uns zu verbessern?","no_results_Text_Key":"Wir konnten keinen Treffer f\xfcr deine Suchanfrage finden: {{query}}","product_error_Text_Key":"Mit dieser Suchleiste kannst du Antworten auf Fragen finden. Produkte findest du \xfcber die Suchleiste oben. M\xf6chtest du deine Bestellung einsehen und bearbeiten?","read_more_button_Text_Key":"Mehr...","results_Text_Key":"Wir haben {{number}} Ergebnis(se) gefunden f\xfcr: {{query}}","retrieving_Text_Key":"Wir montieren dein Suchergebnis...","searchbar_Text_Key":"Suche","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuch es mit anderen Suchbegriffen oder \xfcberpr\xfcfe, ob alles richtig geschrieben ist.","submit_Text_Key":"Absenden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal."}');


var $915841f54ce3cf99$exports = {};
$915841f54ce3cf99$exports = JSON.parse('{"archived_Desc_Key":"Weitere Informationen findest du hier","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"War dieses Dokument nicht hilfreich f\xfcr dich? Probiere eines der folgenden Dokumente aus.","click_prompt_Text_Key":"hier","close_Text_Key":"Schliessen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Etwas hat nicht funktioniert","feedback_Option1_Text_Key":"Der Text ist verwirrend zu verstehen","feedback_Option2_Text_Key":"Der Text ist f\xfcr meine Frage nicht relevant","feedback_Option3_Text_Key":"Der Text ist relevant, aber nicht hilfreich","feedback_Option4_Text_Key":"Der Text ist zu lang oder zu kurz ","feedback_Question_1_Text_Key":"Welche Teile unserer Artikel findest du mangelhaft oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War dieser Beitrag hilfreich?","here_Text_Key":"hier","knowledge_Text_Key":"Enzyklop\xe4die","link_prod_error_Text_Key":"https://www.ikea.com/ch/de/customer-service/track-manage-order/","loading_Text_Key":"L\xe4dt","market_Name_Key":"Schweiz","modal_button_Close_Text_Key":"Schliessen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns dabei helfen, uns zu verbessern?","no_results_Text_Key":"Es wurden keine Ergebnisse f\xfcr deine angegebenen Suchw\xf6rter gefunden: {{query}}","product_error_Text_Key":"Leider wurden keine Ergebnisse gefunden. Diese Suchmaschine unterst\xfctzt nur einen oder mehrere Suchbegriffe. Wenn du Informationen \xfcber unsere Produkte suchst, verwende die Suchfunktion im oberen Bereich der Website. Wenn du den Status deiner Bestellung \xfcberpr\xfcfen willst, klicke bitte hier.","read_more_button_Text_Key":"Mehr erfahren","results_Text_Key":"Wir haben {{number}} Ergebnisse f\xfcr {{query}} gefunden","retrieving_Text_Key":"Am Abrufen","searchbar_Text_Key":"z.B.: Lieferung, R\xfcckgabe (Keine Nummer)","searching_Text_Key":"Am Suchen...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Showing","spellcheck_Text_Key":"Probier mal, die Rechtschreibung zu \xfcberpr\xfcfen oder andere Schl\xfcsselw\xf6rter zu verwenden","submit_Text_Key":"Senden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal"}');


var $d88b600fe3223f5d$exports = {};
$d88b600fe3223f5d$exports = JSON.parse('{"archived_Desc_Key":"Hier findest du weitere Hilfe.","archived_Title_Key":"Dieses Dokument wurde archiviert.","carousel_Text_Key":"Brauchst du eine andere Information? Bestimmt hilft dir das weiter:","click_prompt_Text_Key":"Klick hier","close_Text_Key":"Schlie\xdfen","customerService_Text_Key":"Kundenservice","error_Text_Key":"Da ist etwas schiefgelaufen..","feedback_Option1_Text_Key":"Der Inhalt ist verwirrend.","feedback_Option2_Text_Key":"Der Inhalt beantwortet nicht meine Frage.","feedback_Option3_Text_Key":"Der Inhalt passt ist aber nicht hilfreich.","feedback_Option4_Text_Key":"Der Inhalt ist zu lang beziehungsweise zu kurz.","feedback_Question_1_Text_Key":"Welche speziellen Bereiche dieses Dokumentes sind f\xfcr dich nicht ausreichend oder nicht hilfreich?","feedback_Rec_Text_Key":"Danke f\xfcr dein Feedback!","feedback_Text_Key":"War das hilfreich?","here_Text_Key":"Hier","knowledge_Text_Key":"IKEA Wissen","link_prod_error_Text_Key":"https://www.ikea.com/de/de/customer-service/track-manage-order/","loading_Text_Key":"Laden...","market_Name_Key":"Deutschland","modal_button_Close_Text_Key":"Schlie\xdfen","negative_feedback_Text_Key":"Es tut uns leid, dass du nicht die Antwort bekommen hast, nach der du gesucht hast. M\xf6chtest du uns helfen, uns zu verbessern?","no_results_Text_Key":"Wir konnten keinen Treffer f\xfcr deine Suchanfrage finden: {{query}}","product_error_Text_Key":"Mit dieser Suchleiste kannst du Antworten auf Fragen finden. Produkte findest du \xfcber die Suchleiste oben. M\xf6chtest du deine Bestellung einsehen und bearbeiten?","read_more_button_Text_Key":"Mehr...","results_Text_Key":"Wir haben {{number}} Ergebnis(se) gefunden f\xfcr: {{query}}","retrieving_Text_Key":"Wir montieren dein Suchergebnis...","searchbar_Text_Key":"Stichwort/Thema   Bei Fragen zu Produkten oder Angeboten nutze bitte die Suchleiste ganz oben auf der Seite.","searching_Text_Key":"Suche...","showLess_Text_Key":"Weniger anzeigen","showMore_Text_Key":"Mehr anzeigen","spellcheck_Text_Key":"Versuch es mit anderen Suchbegriffen oder \xfcberpr\xfcfe, ob alles richtig geschrieben ist.","submit_Text_Key":"Absenden","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal."}');


var $b3dd1d29cb681d8c$exports = {};
$b3dd1d29cb681d8c$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/at/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Austria","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $af46bd9ec7e4ee50$exports = {};
$af46bd9ec7e4ee50$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/au/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Australia","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $c435cb592892ef97$exports = {};
$c435cb592892ef97$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Click here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/be/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Belgium","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Loading","searchbar_Text_Key":"Search","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $b232dd46805f42c9$exports = {};
$b232dd46805f42c9$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing and hard to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/ca/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Canada","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This search bar is only for information documents. For article numbers, please type them in the search bar at the top of the page. To track your order, please click","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Enter your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $df5028a35aea820d$exports = {};
$df5028a35aea820d$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the document not helpful? Try one of the related documents below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our documents do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Encyclopedia","link_prod_error_Text_Key":"https://www.ikea.com/ch/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Switzerland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Here you find encyclopedia documents only. For product search, please type the article number in the search bar at the top. For order search, please go to","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Ex: delivery, return (no number)","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Send","try_again_Text_Key":"Please try again later"}');


var $f12ebce42eae8540$exports = {};
$f12ebce42eae8540$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/cz/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Czech","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $f6a114b3bda0d399$exports = {};
$f6a114b3bda0d399$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/es/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Spain","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $0b041c9fdfaff7ab$exports = {};
$0b041c9fdfaff7ab$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/fi/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Finland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"What do you need information about? Type for example exchange, order tracking.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $7d8d18e80d5f7473$exports = {};
$7d8d18e80d5f7473$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our answer do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United kingdom","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $1c8f1faf325519a5$exports = {};
$1c8f1faf325519a5$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Click here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our answer do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/ie/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Ireland","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $1961402b40d12800$exports = {};
$1961402b40d12800$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/in/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"India","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Search","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $cdcaeed6fcae93a9$exports = {};
$cdcaeed6fcae93a9$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"hhttps://www.ikea.com/jp/en/","loading_Text_Key":"Loading","market_Name_Key":"Japan","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"If you want to search for product information, please use the search bar at the top of the IKEA website.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Search inquiry by keyword","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $a73992b107ac1b2a$exports = {};
$a73992b107ac1b2a$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Oops, something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/nl/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Netherlands","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any results for: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} result(s) for: {{query}}","retrieving_Text_Key":"Loading","searchbar_Text_Key":"Search","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $bd508efc153373be$exports = {};
$bd508efc153373be$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/pt/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Portugal","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"This searchbar is for IKEA knowledge documents only. For products, try searching with the searchbar on top of IKEA.nl. Looking for information about your order?","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Try for example: return or click and collect","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $5bfe5aad6e2a0fb8$exports = {};
$5bfe5aad6e2a0fb8$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/se/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Sweden","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $899cba527d8dde37$exports = {};
$899cba527d8dde37$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/us/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"United States","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"If you are looking for information on products, please use the search bar at the top. If you want to track and manage your order click: ","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type your question here (no numbers)","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $27dd3cc381f46ceb$exports = {};
$27dd3cc381f46ceb$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/no/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"Norway","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Type a word or phrase, for example, order or modify.","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more ","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


var $c5f3cf2b3680850c$exports = {};
$c5f3cf2b3680850c$exports = JSON.parse('{"archived_Desc_Key":"Puedes encontrar m\xe1s ayuda aqu\xed","archived_Title_Key":"Este documento ha sido archivado","carousel_Text_Key":"\xbfEl art\xedculo no te ha resultado \xfatil? Prueba alguno de los art\xedculos relacionados que aparecen a continuaci\xf3n.","click_prompt_Text_Key":"click aqu\xed","close_Text_Key":"Cerrar","customerService_Text_Key":"Atenci\xf3n al cliente","error_Text_Key":"Algo ha salido mal…","feedback_Option1_Text_Key":"La respuesta es confusa y dif\xedcil de entender","feedback_Option2_Text_Key":"La respuesta no es relevante para mi pregunta","feedback_Option3_Text_Key":"La respuesta es relevante pero no es \xfatil","feedback_Option4_Text_Key":"La respuesta es demasiado larga o demasiado corta ","feedback_Question_1_Text_Key":"\xbfQu\xe9 parte concreta de nuestra respuesta te ha resultado insatisfactoria o poco \xfatil?","feedback_Rec_Text_Key":"\xa1Gracias por tu opini\xf3n!","feedback_Text_Key":"\xbfTe ha resultado \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Conocimientos","link_prod_error_Text_Key":"https://www.ikea.com/gb/en/customer-service/track-manage-order/","loading_Text_Key":"Cargando","market_Name_Key":"Espa\xf1a","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Sentimos que no hayas obtenido la respuesta que buscabas, \xbfquieres ayudarnos a mejorar?","no_results_Text_Key":"No hay resultados para tu busqueda: {{query}}","product_error_Text_Key":"Lo sentimos, no hemos encontrado resultados. Este buscador s\xf3lo admite una o m\xe1s palabras claves. Si deseas informaci\xf3n sobre nuestros art\xedculos utiliza el buscador principal ubicado en la parte superior de la web. Si deseas consultar el estado de tu pedido, por favor, haz ","read_more_button_Text_Key":"Leer m\xe1s","results_Text_Key":"Hemos encontrado {{number}} resultado (s) para: {{query}}","retrieving_Text_Key":"Recuperando","searchbar_Text_Key":"Escribe una palabra o frase, por ejemplo, pedido o modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Ver menos","showMore_Text_Key":"Ver m\xe1s","spellcheck_Text_Key":"Int\xe9ntalo de nuevo usado otras palabras.","submit_Text_Key":"Env\xeda","try_again_Text_Key":"Por favor, intentalo de nuevo un poco m\xe1s tarde"}');


var $291035aa9c4a42a2$exports = {};
$291035aa9c4a42a2$exports = JSON.parse('{"archived_Desc_Key":"Laguntza gehiago aurkituko duzu hemen","archived_Title_Key":"Dokumentu hau artxibatu egin da.","carousel_Text_Key":"Artikulu hau ez al zaizu lagungarria izan? Saiatu erlazionatutako artikulu hauetako bat.","click_prompt_Text_Key":"hemen klikatu mesedez","close_Text_Key":"Itxi","customerService_Text_Key":"Bezeroarentzako Arreta","error_Text_Key":"Zerbitzua ez dago erabilgarri","feedback_Option1_Text_Key":"Testua ez da ondo ulertzen","feedback_Option2_Text_Key":"Testuak ez dio nire galderari erantzuten","feedback_Option3_Text_Key":"Testua nire galderari erantzuten dio, baina ez da lagungarria","feedback_Option4_Text_Key":"Testua luzeegia edo laburregia da ","feedback_Question_1_Text_Key":"Zure ustez, gure artikuluen zein zati dira desegokiak edo ez oso lagungarriak?","feedback_Rec_Text_Key":"Eskerrik asko zure iritziagatik!","feedback_Text_Key":"Baliagarria iruditu al zaizu?","here_Text_Key":"hemen","knowledge_Text_Key":"Ezagutza","link_prod_error_Text_Key":"https://www.ikea.com/es/eu/customer-service/track-manage-order/","loading_Text_Key":"Deskargatzen","market_Name_Key":"Espainia","modal_button_Close_Text_Key":"Itxi","negative_feedback_Text_Key":"Sentitzen dugu bilatzen ari zinen erantzuna ez jaso izana, hobetzen lagundu nahi diguzu?","no_results_Text_Key":"Ez da emaitzarik aurkitu eskatutako bilaketa terminoetarako: {{query}}","product_error_Text_Key":"Ez dugu erresultadorik aurkitu, sentitzen dugu. Bilatzaite honek bat edo hainbeste hitz gakoak onartzen ditu. Gure artikuluei buruzko informazioa nahi baduzu, web-aren goialdean dagoen bilatzaile nagusia erabili ezazu. Zure eskariaren egoera kontsultatu nahi baduzu, ","read_more_button_Text_Key":"Irakurri gehiago","results_Text_Key":"{{number}} emaitza aurkitu dugu honetarako: {{query}}","retrieving_Text_Key":"Berreskuratzen","searchbar_Text_Key":"Hitz edo esaldi bat idatzi ezazu, eskaria edo aldatu adibidez.","searching_Text_Key":"Bilatzen","showLess_Text_Key":"Gutxiago erakuts","showMore_Text_Key":"Gehiago ikusi","spellcheck_Text_Key":"Saiatu ortografia egiaztatzen edo gako-hitzak erabiltzen","submit_Text_Key":"Bidali","try_again_Text_Key":"Mesedez, saiatu berriro geroago"}');


var $49a31b82af711e9b$exports = {};
$49a31b82af711e9b$exports = JSON.parse('{"archived_Desc_Key":"Lis\xe4apua l\xf6ytyy t\xe4\xe4lt\xe4","archived_Title_Key":"T\xe4m\xe4 asiakirja on arkistoitu.","carousel_Text_Key":"Eik\xf6 artikkelista ollut apua? Kokeile alla n\xe4kyvi\xe4 artikkeleita.","click_prompt_Text_Key":"t\xe4\xe4lt\xe4","close_Text_Key":"Sulje","customerService_Text_Key":"Asiakaspalvelu","error_Text_Key":"Jotakin meni pieleen","feedback_Option1_Text_Key":"Teksti\xe4 on vaikea ymm\xe4rt\xe4\xe4","feedback_Option2_Text_Key":"Sis\xe4lt\xf6 ei liity kysymykseeni","feedback_Option3_Text_Key":"Sis\xe4lt\xf6 liittyy asiaan, muttei vastaa kysymykseeni","feedback_Option4_Text_Key":"Sis\xe4lt\xf6 on liian pitk\xe4 tai liian lyhyt ","feedback_Question_1_Text_Key":"Mitk\xe4 osat sis\xe4ll\xf6ist\xe4 eiv\xe4t mielest\xe4si ole hy\xf6dyllisi\xe4 tai toimivia?","feedback_Rec_Text_Key":"Kiitos palautteestasi!","feedback_Text_Key":"Oliko t\xe4m\xe4 hy\xf6dyksesi?","here_Text_Key":"t\xe4ss\xe4","knowledge_Text_Key":"Tietoa","link_prod_error_Text_Key":"https://www.ikea.com/fi/fi/customer-service/track-manage-order/","loading_Text_Key":"Ladataan","market_Name_Key":"Suomi","modal_button_Close_Text_Key":"Sulje","negative_feedback_Text_Key":"Olemme pahoillamme, ettet saanut etsim\xe4\xe4si vastausta, haluaisitko auttaa meit\xe4 parantamaan?","no_results_Text_Key":"Hakutermille: {{query}} ei l\xf6ytynyt yht\xe4\xe4n tulosta","product_error_Text_Key":"T\xe4st\xe4 l\xf6yd\xe4t vastauksia usein kysyttyihin kysymyksiin. Tuotenumerolla hakeminen onnistuu ylimm\xe4st\xe4 hakukent\xe4st\xe4 ja tilausnumerolla voit hakea.","read_more_button_Text_Key":"Lue lis\xe4\xe4","results_Text_Key":"L\xf6ysimme {{number}} tulosta(s) haulle: {{query}}","retrieving_Text_Key":"Haetaan","searchbar_Text_Key":"Mist\xe4 kaipaat tietoa? Kirjoita esimerkiksi vaihtaminen, tilauksen seuranta.","searching_Text_Key":"Etsit\xe4\xe4n...","showLess_Text_Key":"N\xe4yt\xe4 v\xe4hemm\xe4n","showMore_Text_Key":"N\xe4yt\xe4 enemm\xe4n","spellcheck_Text_Key":"Ole hyv\xe4 ja tarkista oikeinkirjoitus tai kokeile toista hakusanaa. Tuotteen nimell\xe4/artikkelinumerolla voit hakea tietoa ylemm\xe4st\xe4 Mit\xe4 etsit? hakupalkista.","submit_Text_Key":"L\xe4het\xe4","try_again_Text_Key":"Ole hyv\xe4 ja yrit\xe4 my\xf6hemmin uudelleen"}');


var $15061c87903685c5$exports = {};
$15061c87903685c5$exports = JSON.parse('{"archived_Desc_Key":"Vous trouverez plus d\'informations en cliquant ici.","archived_Title_Key":"Ce document a \xe9t\xe9 supprim\xe9.","carousel_Text_Key":"Cette information n\'\xe9tait pas utile? Essayez l\'un des documents ci-dessous","click_prompt_Text_Key":"cliquez ici","close_Text_Key":"Fermer","customerService_Text_Key":"Informations pratiques","error_Text_Key":"Une erreur s\'est produite.","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte n\'est pas pertinent par rapport \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais il n\'est pas utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles sont les parties de nos documents que nous pourrions am\xe9liorer ?","feedback_Rec_Text_Key":"Merci pour votre retour","feedback_Text_Key":"Avez-vous trouv\xe9 cette information utile?","here_Text_Key":"ici.","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://www.ikea.com/be/fr/customer-service/track-manage-order/","loading_Text_Key":"En cours de chargement","market_Name_Key":"Belgique","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n’ayez pas obtenu la r\xe9ponse que vous cherchiez, souhaitez-vous nous aider \xe0 nous am\xe9liorer ?","no_results_Text_Key":"Nous ne trouvons aucun r\xe9sultat pour: {{query}}","product_error_Text_Key":"Cette recherche ne concerne que la Foire aux questions. Pour les num\xe9ros d\'articles, employez plut\xf4t la barre de recherche situ\xe9e en haut des pages IKEA.be. Pour des informations sur votre commande, ","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultats pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration de donn\xe9es en cours","searchbar_Text_Key":"Exemple: Livraison, retour d’article, click & collect","searching_Text_Key":"En cours de recherche...","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"Essayez avec une autre orthographe ou d\'autres mots-cl\xe9s.","submit_Text_Key":"Envoyer","try_again_Text_Key":"Bitte versuche es sp\xe4ter noch einmal."}');


var $b3a6dd3ab922d0b9$exports = {};
$b3a6dd3ab922d0b9$exports = JSON.parse('{"archived_Desc_Key":"Vous trouverez plus d\'informations en cliquant ici.","archived_Title_Key":"Ce document a \xe9t\xe9 supprim\xe9.","carousel_Text_Key":"Cette information n\'\xe9tait pas utile? Essayez l\'un des documents ci-dessous","click_prompt_Text_Key":"cliquez ici","close_Text_Key":"Fermer","customerService_Text_Key":"Service \xe0 la client\xe8le","error_Text_Key":"Quelque chose ne va pas","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte n’est pas pertinent par rapport \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais il n’est pas utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quels \xe9l\xe9ments particuliers de nos articles trouvez-vous insatisfaisants ou inutiles\xa0?","feedback_Rec_Text_Key":"Merci pour votre retour","feedback_Text_Key":"Avez-vous trouv\xe9 cette information utile?","here_Text_Key":"ici.","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://www.ikea.com/ca/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement","market_Name_Key":"Canada","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n’ayez pas obtenu la r\xe9ponse que vous cherchiez, souhaitez-vous nous aider \xe0 nous am\xe9liorer ?","no_results_Text_Key":"Aucun r\xe9sultat n’a \xe9t\xe9 trouv\xe9 avec vos termes de recherche! {{query}}","product_error_Text_Key":"Cette barre de recherche sert uniquement aux documents d\'information. Pour les num\xe9ros d\'article, veuillez les taper dans la barre de recherche en haut de la page. Pour un suivi de votre commande,","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration","searchbar_Text_Key":"Posez votre question ici.","searching_Text_Key":"Recherche en cours de…","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"V\xe9rifiez l’orthographe ou utilisez d’autres mots clef","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci r\xe9essayer ult\xe9rieurement"}');


var $2ec104d9fcfe67af$exports = {};
$2ec104d9fcfe67af$exports = JSON.parse('{"archived_Desc_Key":"Plus d\'informations disponibles ici","archived_Title_Key":"Ce document a \xe9t\xe9 archiv\xe9.","carousel_Text_Key":"Ce document n\'a pas \xe9t\xe9 utile ? Tu peux essayer l\'un des documents ci-dessous.","click_prompt_Text_Key":"ici","close_Text_Key":"Fermer","customerService_Text_Key":"Service client\xe8le","error_Text_Key":"Quelque chose n\'a pas fonctionn\xe9","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte ne correspond pas \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent mais inutile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles parties de nos documents trouves-tu insatisfaisantes ou inutiles ?","feedback_Rec_Text_Key":"Merci pour ton opinion !","feedback_Text_Key":"Est-ce que cette information \xe9tait utile ?","here_Text_Key":"ici","knowledge_Text_Key":"Encyclop\xe9die","link_prod_error_Text_Key":"https://www.ikea.com/ch/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement en cours","market_Name_Key":"Suisse","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que tu n’aies pas obtenu la r\xe9ponse que tu cherchais. Veux-tu nous aider \xe0 nous am\xe9liorer?","no_results_Text_Key":"Nous n’avons pas trouv\xe9 de r\xe9sultat pour: {{query}}","product_error_Text_Key":"Tu trouves ici seulement des informations venant de notre encyclop\xe9die. Pour des informations sur un produit, inscris le num\xe9ro d\'article dans la barre de recherche en-haut. Pour des informations sur ta commande, cherche-la dans","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration en cours","searchbar_Text_Key":"Ex.: livraison, retour (pas de num\xe9ro)","searching_Text_Key":"Recherche en cours…","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Montrer plus","spellcheck_Text_Key":"V\xe9rifie l’orthographe ou utilise d’autres mots-cl\xe9s","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci de r\xe9essayer ult\xe9rieurement"}');


var $8d419095d4c426f6$exports = {};
$8d419095d4c426f6$exports = JSON.parse('{"archived_Desc_Key":"Vous trouverez plus d\'informations en cliquant ici.","archived_Title_Key":"Ce document a \xe9t\xe9 supprim\xe9.","carousel_Text_Key":"Cette information n\'\xe9tait pas utile? Essayez l\'un des documents ci-dessous","click_prompt_Text_Key":"ici","close_Text_Key":"Fermer","customerService_Text_Key":"Informations pratiques","error_Text_Key":"Quelque chose ne va pas","feedback_Option1_Text_Key":"Le texte est difficile \xe0 comprendre","feedback_Option2_Text_Key":"Le texte n\'est pas pertinent par rapport \xe0 ma question","feedback_Option3_Text_Key":"Le texte est pertinent, mais il n\'est pas utile","feedback_Option4_Text_Key":"Le texte est trop long ou trop court ","feedback_Question_1_Text_Key":"Quelles sont les parties de nos documents que nous pourrions am\xe9liorer ?","feedback_Rec_Text_Key":"Merci pour votre retour","feedback_Text_Key":"Avez-vous trouv\xe9 cette information utile?","here_Text_Key":"ici.","knowledge_Text_Key":"Base de connaissance","link_prod_error_Text_Key":"https://www.ikea.com/fr/fr/customer-service/track-manage-order/","loading_Text_Key":"Chargement","market_Name_Key":"France","modal_button_Close_Text_Key":"Fermer","negative_feedback_Text_Key":"Nous sommes d\xe9sol\xe9s que vous n’ayez pas obtenu la r\xe9ponse que vous cherchiez, souhaitez-vous nous aider \xe0 nous am\xe9liorer ?","no_results_Text_Key":"Nous n’avons pas trouv\xe9 de r\xe9sultat pour: {{query}}","product_error_Text_Key":"Vous cherchez un produit ? Merci d\'utiliser le moteur de recherche situ\xe9 en haut de page. Si vous souhaitez suivre l\'\xe9tat d\'avancement de votre commande, c\'est par","read_more_button_Text_Key":"En savoir plus","results_Text_Key":"Nous avons trouv\xe9 {{number}} r\xe9sultat(s) pour: {{query}}","retrieving_Text_Key":"R\xe9cup\xe9ration","searchbar_Text_Key":"Posez votre question ici","searching_Text_Key":"En cours de recherche…","showLess_Text_Key":"Afficher moins","showMore_Text_Key":"Afficher plus","spellcheck_Text_Key":"V\xe9rifiez l’orthographe ou utilisez d’autres mots clef","submit_Text_Key":"Envoyer","try_again_Text_Key":"Merci de r\xe9essayer ult\xe9rieurement"}');


var $726a17740c34e581$exports = {};
$726a17740c34e581$exports = JSON.parse('{"archived_Desc_Key":"Aqu\xed atopar\xe1 m\xe1is axuda","archived_Title_Key":"Este documento foi arquivado","carousel_Text_Key":"Non lle resultou \xfatil o artigo? Proba cun dos artigos relacionados a continuaci\xf3n","click_prompt_Text_Key":"aqu\xed","close_Text_Key":"Pechar","customerService_Text_Key":"Atenci\xf3n ao cliente","error_Text_Key":"Algo foi mal","feedback_Option1_Text_Key":"O texto non se entende ben","feedback_Option2_Text_Key":"O texto non ten que ver coa mi\xf1a pregunta","feedback_Option3_Text_Key":"O texto ten que ver coa mi\xf1a pregunta pero non \xe9 \xfatil","feedback_Option4_Text_Key":"O texto \xe9 demasiado longo ou demasiado curto ","feedback_Question_1_Text_Key":"Exactamente, que partes dos nosos artigos consideras insatisfactorias ou pouco \xfatiles?","feedback_Rec_Text_Key":"Grazas pola t\xfaa opini\xf3n!","feedback_Text_Key":"Cres que foi \xfatil?","here_Text_Key":"aqu\xed","knowledge_Text_Key":"Co\xf1ecemento","link_prod_error_Text_Key":"https://www.ikea.com/es/gl/customer-service/track-manage-order/","loading_Text_Key":"En proceso de descarga","market_Name_Key":"Espa\xf1a","modal_button_Close_Text_Key":"Cerrar","negative_feedback_Text_Key":"Lamentamos que non obtiveses a resposta que buscabas, queres axudarnos a mellorar?","no_results_Text_Key":"Non atopamos ningunha coincidencia cos resultados da busca:  {{query}}","product_error_Text_Key":"Sent\xedmolo, non atopamos resultados. Este buscador s\xf3 admite unha ou mais plalabras claves. Se desexas informaci\xf3n sobre os nosos artigos utiliza o buscador principal ubicado na parte superior da web. Se desexas consultar o estado do teu pedido, por favor, fai click","read_more_button_Text_Key":"Ler m\xe1is","results_Text_Key":"Atopamos {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"Estamos a recuperar a informaci\xf3n","searchbar_Text_Key":"Escribe unha plabra ou frase, por exemplo, pedido ou modificar.","searching_Text_Key":"Buscando...","showLess_Text_Key":"Mostrar menos","showMore_Text_Key":"Mostrar m\xe1is","spellcheck_Text_Key":"Comproba a ortograf\xeda ou emprega diferentes palabras clave","submit_Text_Key":"Enviar","try_again_Text_Key":"Si us plau, intenta-ho m\xe9s tard"}');


var $ceb54bc6a2520847$exports = {};
$ceb54bc6a2520847$exports = JSON.parse('{"archived_Desc_Key":"Dodatnu pomoć možeš pronaći ovdje.","archived_Title_Key":"Ovaj članak je arhiviran.","carousel_Text_Key":"Ovaj članak nije odgovorio na sva tvoja pitanja? Odgovore potraži u jednom od povezanih članaka u nastavku.","click_prompt_Text_Key":"ovdje","close_Text_Key":"Zatvori","customerService_Text_Key":"Služba za kupce","error_Text_Key":"Došlo je do greške","feedback_Option1_Text_Key":"Tekst je zbunjujući i teško ga je razumjeti","feedback_Option2_Text_Key":"Tekst nije relevantan za moje pitanje","feedback_Option3_Text_Key":"Tekst je relevantan, ali nije koristan","feedback_Option4_Text_Key":"Tekst je predugačak ili prekratak ","feedback_Question_1_Text_Key":"Koji dio našeg članaka nije zadovoljavajući ili nije koristan?","feedback_Rec_Text_Key":"Hvala ti na povratnoj informaciji!","feedback_Text_Key":"Je li ti ovo bilo korisno?","here_Text_Key":"ovdje.","knowledge_Text_Key":"Baza znanja","link_prod_error_Text_Key":"https://www.ikea.com/hr/hr/customer-service/track-manage-order/","loading_Text_Key":"Učitavanje","market_Name_Key":"Hrvatska","modal_button_Close_Text_Key":"Zatvori","negative_feedback_Text_Key":"Žao nam je što nisi dobio/la odgovor koji si želio/željela. Želiš li nam pomoći da se poboljšamo?","no_results_Text_Key":"Nismo pronašli nijedan rezultat za tvoj unos: {{query}}","product_error_Text_Key":"Ako tražiš proizvod, molimo te da upotrijebiš traku za pretraživanje na vrhu stranice. Ako tražiš informacije o svojoj narudžbi, molimo te da klikneš","read_more_button_Text_Key":"Pročitaj više","results_Text_Key":"Pronašli smo {{number}} rezultat/a za: {{query}}","retrieving_Text_Key":"Prikupljanje","searchbar_Text_Key":"Pokušaj upisati na primjer: dostava ili reklamacija","searching_Text_Key":"Pretraživanje...","showLess_Text_Key":"Prikaži manje","showMore_Text_Key":"Prikaži više","spellcheck_Text_Key":"Provjeri je li unos ispravan ili koristi druge ključne riječi","submit_Text_Key":"Pošalji","try_again_Text_Key":"Pokušaj ponovo kasnije"}');


var $d6c8f66d5bf1c059$exports = {};
$d6c8f66d5bf1c059$exports = JSON.parse('{"archived_Desc_Key":"Tov\xe1bbi seg\xedts\xe9g itt tal\xe1lhat\xf3","archived_Title_Key":"Ezt a dokumentumot archiv\xe1ltuk.","carousel_Text_Key":"Nem volt hasznos a cikk? Pr\xf3b\xe1ld ki az al\xe1bbi kapcsol\xf3d\xf3 cikkek egyik\xe9t.","click_prompt_Text_Key":"itt","close_Text_Key":"Bez\xe1r\xe1s","customerService_Text_Key":"\xdcgyf\xe9lszolg\xe1lat","error_Text_Key":"Hupsz! Valami","feedback_Option1_Text_Key":"A sz\xf6veg zavaros, nehezen \xe9rthető","feedback_Option2_Text_Key":"A sz\xf6veg nem relev\xe1ns a k\xe9rd\xe9sem szempontj\xe1b\xf3l","feedback_Option3_Text_Key":"A sz\xf6veg relev\xe1ns, de nem hasznos a k\xe9rd\xe9sem szempontj\xe1b\xf3l","feedback_Option4_Text_Key":"A sz\xf6veg t\xfal hossz\xfa vagy t\xfal r\xf6vid ","feedback_Question_1_Text_Key":"A cikk melyik r\xe9szeit nem tal\xe1lod megfelelőnek vagy hasznosnak?","feedback_Rec_Text_Key":"K\xf6sz\xf6nj\xfck a visszajelz\xe9sedet!","feedback_Text_Key":"Hasznosnak tal\xe1ltad ezt a cikket?","here_Text_Key":"itt","knowledge_Text_Key":"Tud\xe1s","link_prod_error_Text_Key":"https://www.ikea.com/hu/hu/customer-service/","loading_Text_Key":"Bet\xf6lt\xe9s...","market_Name_Key":"Magyarorsz\xe1g","modal_button_Close_Text_Key":"Bez\xe1r\xe1s","negative_feedback_Text_Key":"Sajn\xe1ljuk, hogy nem kaptad meg a v\xe1laszt, amit kerest\xe9l – szeretn\xe9l seg\xedteni, hogy jobb\xe1 v\xe1ljunk?","no_results_Text_Key":"Nincs tal\xe1lat erre a keresősz\xf3ra: {{query}}","product_error_Text_Key":"Ez a kereső csak seg\xedtő inform\xe1ci\xf3k \xe9s cikkek megjelen\xedt\xe9s\xe9re szolg\xe1l. Term\xe9kinform\xe1ci\xf3\xe9rt k\xe9rj\xfck haszn\xe1ld a IKEA.com/hu főoldal\xe1n tal\xe1lhat\xf3 keresőt.","read_more_button_Text_Key":"Bővebben","results_Text_Key":"{{number}} tal\xe1lat ezekre a keresőszavakra: {{query}}","retrieving_Text_Key":"Visszakeres\xe9s","searchbar_Text_Key":"Tal\xe1ld meg a v\xe1laszt a k\xe9rd\xe9seidre","searching_Text_Key":"Keres\xe9s...","showLess_Text_Key":"Mutass kevesebbet","showMore_Text_Key":"Mutass t\xf6bbet","spellcheck_Text_Key":"Ellenőrizd az elg\xe9pel\xe9seket, vagy pr\xf3b\xe1lj meg m\xe1s keresősz\xf3t haszn\xe1lni.","submit_Text_Key":"Beny\xfajtja","try_again_Text_Key":"K\xe9rlek pr\xf3b\xe1ld \xfajra"}');


var $9d7af6600473ab94$exports = {};
$9d7af6600473ab94$exports = JSON.parse('{"archived_Desc_Key":"Per maggiori informazioni, clicca qui.","archived_Title_Key":"Questo documento \xe8 stato archiviato.","carousel_Text_Key":"L\'articolo non \xe8 stato utile? Prova a leggere uno dei documenti correlati qui sotto.","click_prompt_Text_Key":"qui","close_Text_Key":"Chiudere","customerService_Text_Key":"Servizio clienti","error_Text_Key":"Qualcosa non ha funzionato","feedback_Option1_Text_Key":"Il testo \xe8 difficile da capire","feedback_Option2_Text_Key":"Il testo non \xe8 pertinente alla mia domanda","feedback_Option3_Text_Key":"Il testo \xe8 pertinente ma non utile","feedback_Option4_Text_Key":"Il testo \xe8 troppo lungo o troppo corto ","feedback_Question_1_Text_Key":"Quali parti particolari dei nostri documenti trovi insoddisfacenti o poco utili?","feedback_Rec_Text_Key":"Grazie per il tuo feedback!","feedback_Text_Key":"Ti \xe8 stato utile?","here_Text_Key":"qui","knowledge_Text_Key":"Enciclopedia","link_prod_error_Text_Key":"https://www.ikea.com/ch/it/customer-service/track-manage-order/","loading_Text_Key":"Caricamento","market_Name_Key":"Svizzera","modal_button_Close_Text_Key":"Chiudere","negative_feedback_Text_Key":"Ci dispiace che tu non abbia trovato la risposta che cercavi, vuoi aiutarci a migliorare?","no_results_Text_Key":"Non \xe8 stato trovato nessun risultato di ricerca per il seguente termine: {{query}}","product_error_Text_Key":"Spiacente, non sono stati trovati risultati. Questo motore di ricerca supporta solo una o pi\xf9 parole chiave. Se desideri informazioni sui nostri prodotti, utilizza il motore di ricerca principale che si trova nella parte superiore del sito. Se vuoi controllare lo stato del tuo ordine, clicca qui.","read_more_button_Text_Key":"Per saperne di pi\xf9","results_Text_Key":"Abbiamo trovato {{number}} risultati per: {{query}}","retrieving_Text_Key":"Recuperare","searchbar_Text_Key":"Es.: consegna, reso (nessun numero)","searching_Text_Key":"Sta cercando...","showLess_Text_Key":"Mostra di meno","showMore_Text_Key":"Mostra di pi\xf9","spellcheck_Text_Key":"Prova a controllare l\'ortografia o a usare parole chiave diverse.","submit_Text_Key":"Invia","try_again_Text_Key":"Ti preghiamo di riprovare pi\xf9 tardi"}');


var $f133b62eb028ab02$exports = {};
$f133b62eb028ab02$exports = JSON.parse('{"archived_Desc_Key":"Clicca qui per trovare il supporto di cui hai bisogno.","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"Il contenuto relativo alla tua richiesta non \xe8 pi\xf9 disponibile.","carousel_Text_Key":"Il documento non \xe8 stato utile? Scopri di pi\xf9 sullo stesso argomento qui sotto:","click_prompt_Text_Key":"Clicca qui Verifica la consegna del tuo ordine - IKEA IT","close_Text_Key":"Chiudi","customerService_Text_Key":"Servizio Clienti","error_Text_Key":"Ops! Qualcosa \xe8 andato storto!","feedback_Option1_Text_Key":"E\' difficile da capire","feedback_Option2_Text_Key":"Non risponde alla mia domanda","feedback_Option3_Text_Key":"Risponde alla domanda ma non \xe8 esauriente","feedback_Option4_Text_Key":"Il testo \xe8 troppo lungo o troppo corto ","feedback_Question_1_Text_Key":"In particolare, perch\xe9 non lo trovi utile?","feedback_Rec_Text_Key":"Grazie per il tuo feedback!","feedback_Text_Key":"Hai trovato questo documento utile?","here_Text_Key":"qui","knowledge_Text_Key":"Domande Frequenti","link_prod_error_Text_Key":"https://www.ikea.com/it/it/customer-service/track-manage-order/","loading_Text_Key":"Ricerca in corso...","market_Name_Key":"Italia","modal_button_Close_Text_Key":"Chiudere","negative_feedback_Text_Key":"Ci dispiace che tu non abbia trovato la risposta che cercavi, vuoi aiutarci a migliorare?","no_results_Text_Key":"Nessun risultato disponibile per: {{query}}","product_error_Text_Key":"Qui puoi esplorare le FAQ pensate per te. Se stai cercando un prodotto specifico, digita il codice in alto nella barra di ricerca del sito. Se vuoi tracciare o gestire il tuo ordine.","read_more_button_Text_Key":"Per saperne di pi\xf9","results_Text_Key":"Sono stati trovati {{number}} risultati per: {{query}}","retrieving_Text_Key":"Recupero","searchbar_Text_Key":"Scrivi qui la tua domanda","searching_Text_Key":"Ricerca in corso...","showLess_Text_Key":"Mostra di meno","showMore_Text_Key":"Mostra di pi\xf9","spellcheck_Text_Key":"Prova a riformulare la tua ricerca con altre parole o a scrivere una frase meno complessa. Ricorda di digitare i codici dei prodotti senza inserire . o ,","submit_Text_Key":"Invia","try_again_Text_Key":"Riprova pi\xf9 tardi"}');


var $763a607fe555c9e5$exports = {};
$763a607fe555c9e5$exports = JSON.parse('{"archived_Desc_Key":"この他のサポートはこちらをご確認ください。","archived_Title_Key":"お探しの質問が見つかりません。","carousel_Text_Key":"お役に立ちませんでしたか？以下もご参考ください。","click_prompt_Text_Key":"Here","close_Text_Key":"閉じる","customerService_Text_Key":"カスタマーサービス","error_Text_Key":"問題が発生しました。","feedback_Option1_Text_Key":"文章がわかりにくい","feedback_Option2_Text_Key":"探している質問に関連していない","feedback_Option3_Text_Key":"探している質問だが情報が足りない","feedback_Option4_Text_Key":"文章が長すぎる、または短すぎる ","feedback_Question_1_Text_Key":"よくなかった理由を教えてください。","feedback_Rec_Text_Key":"ご意見ありがとうございます。","feedback_Text_Key":"お役に立ちましたか？","here_Text_Key":"こちら","knowledge_Text_Key":"よくある質問","link_prod_error_Text_Key":"https://www.ikea.com/jp/ja/","loading_Text_Key":"Loading","market_Name_Key":"日本","modal_button_Close_Text_Key":"閉じる","negative_feedback_Text_Key":"お探しの回答が得られず申し訳ございません。改善にご協力いただけますか？","no_results_Text_Key":"{{query}} 該当するものがありません。","product_error_Text_Key":"ここの検索バーは、よくある質問内での検索となります。商品番号は、このウェブページ上部にある検索バーでの検索をお試しください。","read_more_button_Text_Key":"もっと見る","results_Text_Key":"{{query}} の検索結果 {{number}}件","retrieving_Text_Key":"Loading","searchbar_Text_Key":"質問をキーワードで検索","searching_Text_Key":"検索中","showLess_Text_Key":"表示を減らす","showMore_Text_Key":"もっと見る","spellcheck_Text_Key":"違うキーワードをお試しください。","submit_Text_Key":"送信する","try_again_Text_Key":"しばらくたってから、またお試しください。"}');


var $4a3b60fb4a4f2d70$exports = {};
$4a3b60fb4a4f2d70$exports = JSON.parse('{"archived_Desc_Key":"고객지원 페이지에서 더 많은 정보를 확인해보세요.","archived_Title_Key":"문제가 발생했습니다. 다른 정보를 확인해주세요.","carousel_Text_Key":"원하는 정보를 찾지 못하셨다면 아래에 있는 연관 정보들을 확인해보세요.","click_prompt_Text_Key":"주문 조회 및 관리","close_Text_Key":"종료","customerService_Text_Key":"고객지원","error_Text_Key":"예기치 못한 오류가 발생했습니다. 나중에 다시 시도해 주세요.","feedback_Option1_Text_Key":"이 정보는 이해하기 어렵습니다","feedback_Option2_Text_Key":"이 정보는 내 질문과 관련이 없습니다","feedback_Option3_Text_Key":"이 정보는 관련이 있지만 도움은 되지 않습니다","feedback_Option4_Text_Key":"이 정보는 너무 길거나 너무 짧습니다 ","feedback_Question_1_Text_Key":"이 정보의 특정 부분이 만족스럽지 않거나 도움이 되지 않았나요?","feedback_Rec_Text_Key":"소중한 피드백 감사드려요!","feedback_Text_Key":"이 정보가 도움이 되었나요?","here_Text_Key":"고객지원 페이지","knowledge_Text_Key":"문의사항","link_prod_error_Text_Key":"https://order.ikea.com/kr/ko/purchases/lookup/","loading_Text_Key":"처리중","market_Name_Key":"대한민국","modal_button_Close_Text_Key":"종료","negative_feedback_Text_Key":"원하는 답변을 드리지 못해 죄송합니다. 개선을 위해 도와주시겠어요?","no_results_Text_Key":"검색 조건에 맞는 결과를 찾지 못했습니다.","product_error_Text_Key":"제품 정보 검색을 원하신다면 IKEA 웹사이트 상단 검색 바를 이용해주세요.","read_more_button_Text_Key":"더 보기","results_Text_Key":"{{query}} 을(를) 통해 {{number}} 개의 결과를 찾았습니다.","retrieving_Text_Key":"검색","searchbar_Text_Key":"검색 예시 : 교환환불, 배송약관 등","searching_Text_Key":"검색중","showLess_Text_Key":"간략히","showMore_Text_Key":"더 보기","spellcheck_Text_Key":"명칭이 올바른지 한번 더 확인해주세요.","submit_Text_Key":"제출","try_again_Text_Key":"다시 시도해 주세요."}');


var $eeff45b04fb26100$exports = {};
$eeff45b04fb26100$exports = JSON.parse('{"archived_Desc_Key":"Du kan f\xe5 mer hjelp her.","archived_Title_Key":"Denne artikkelen er arkivert.","carousel_Text_Key":"Hjalp ikke denne artikkelen deg? Pr\xf8v en av de lignende artiklene under.","click_prompt_Text_Key":"Klikk her","close_Text_Key":"Lukk","customerService_Text_Key":"Kundeservice","error_Text_Key":"Oops! Noe gikk galt.","feedback_Option1_Text_Key":"Teksten er uklar og vanskelig \xe5 forst\xe5","feedback_Option2_Text_Key":"Teksten er ikke relevant for sp\xf8rsm\xe5let mitt","feedback_Option3_Text_Key":"Teksten er relevant, men ikke nyttig","feedback_Option4_Text_Key":"Teksten er for lang eller for kort ","feedback_Question_1_Text_Key":"Hva gjorde at artikkelen ikke var nyttig for deg?","feedback_Rec_Text_Key":"Takk for tilbakemeldingen!","feedback_Text_Key":"Var dette nyttig?","here_Text_Key":"her.","knowledge_Text_Key":"Informasjon","link_prod_error_Text_Key":"https://order.ikea.com/no/no/purchases/lookup/","loading_Text_Key":"Laster...","market_Name_Key":"Norge","modal_button_Close_Text_Key":"Lukk","negative_feedback_Text_Key":"Vi beklager at du ikke fikk svaret du lette etter. Vil du hjelpe oss med \xe5 forbedre oss?","no_results_Text_Key":"Vi fant ingen treff n\xe5r vi s\xf8kte p\xe5: {{query}}","product_error_Text_Key":"Ingen treff p\xe5: {{query}} Her finner du informasjon og svar p\xe5 sp\xf8rsm\xe5l. Bruk s\xf8kefeltet \xf8verst for \xe5 s\xf8ke etter produkter. Ser du etter informasjon om ordren din,","read_more_button_Text_Key":"Les mer","results_Text_Key":"Vi fant {{number}} resultat(er) for: {{query}}","retrieving_Text_Key":"Laster inn...","searchbar_Text_Key":"Fortell oss hva du trenger hjelp med...","searching_Text_Key":"Leter etter svar...","showLess_Text_Key":"Vis mindre","showMore_Text_Key":"Vis mer","spellcheck_Text_Key":"Sjekk stavingen eller fors\xf8k gjerne andre s\xf8keord.","submit_Text_Key":"Send inn","try_again_Text_Key":"Vennligst pr\xf8v igjen senere."}');


var $c7d6ab9e2af5259e$exports = {};
$c7d6ab9e2af5259e$exports = JSON.parse('{"archived_Desc_Key":"We helpen je graag verder via deze pagina","archived_Title_Key":"Dit document is gearchiveerd.","carousel_Text_Key":"Kunnen we je verder helpen?","click_prompt_Text_Key":"Klik hier","close_Text_Key":"Sluiten","customerService_Text_Key":"Klantenservice","error_Text_Key":"Er ging iets mis","feedback_Option1_Text_Key":"De tekst is verwarrend om te begrijpen","feedback_Option2_Text_Key":"De tekst is niet relevant voor mijn vraag","feedback_Option3_Text_Key":"De tekst is relevant maar niet nuttig","feedback_Option4_Text_Key":"De tekst is te lang of te kort ","feedback_Question_1_Text_Key":"Welke specifieke onderdelen van onze artikelen vind je onbevredigend of niet behulpzaam?","feedback_Rec_Text_Key":"Bedankt voor je feedback!","feedback_Text_Key":"Vond je dit nuttig?","here_Text_Key":"via deze pagina","knowledge_Text_Key":"Kennis","link_prod_error_Text_Key":"https://www.ikea.com/be/nl/customer-service/track-manage-order/","loading_Text_Key":"Laden","market_Name_Key":"Belgi\xeb","modal_button_Close_Text_Key":"Sluiten","negative_feedback_Text_Key":"Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?","no_results_Text_Key":"We vonden geen resultaten voor {{query}}","product_error_Text_Key":"Deze zoekopdracht is alleen voor ondersteunende artikelen. Voor artikelnummers, probeer te zoeken in de bovenste zoekbalk op IKEA.be. Zoek je naar informatie over je bestelling?","read_more_button_Text_Key":"Lees meer","results_Text_Key":"We vonden {{number}} resultaten voor: {{query}}","retrieving_Text_Key":"Gegevens ophalen","searchbar_Text_Key":"Bijvoorbeeld: Levering, Retourneren, click & collect","searching_Text_Key":"Zoeken...","showLess_Text_Key":"Lees minder","showMore_Text_Key":"Lees meer","spellcheck_Text_Key":"Probeer het opnieuw met een andere spelling of trefwoorden","submit_Text_Key":"Stuur  in","try_again_Text_Key":"Probeer later opnieuw"}');


var $4b33d00c15780ad6$exports = {};
$4b33d00c15780ad6$exports = JSON.parse('{"archived_Desc_Key":"We helpen je graag verder via deze pagina","archived_Title_Key":"Dit document is gearchiveerd.","carousel_Text_Key":"Kunnen we je verder helpen?","click_prompt_Text_Key":"Kliek hier","close_Text_Key":"Sluiten","customerService_Text_Key":"Klantenservice","error_Text_Key":"Oeps, er ging iets mis","feedback_Option1_Text_Key":"Ik begrijp de tekst niet of deze is verwarrend","feedback_Option2_Text_Key":"De tekst is niet relevant voor mijn vraag","feedback_Option3_Text_Key":"De tekst is relevant, maar niet nuttig voor mij","feedback_Option4_Text_Key":"De tekst is te lang of te kort ","feedback_Question_1_Text_Key":"Welke specifieke onderdelen van onze artikelen vind je niet nuttig of niet behulpzaam?","feedback_Rec_Text_Key":"Bedankt for je feedback!","feedback_Text_Key":"Vond je dit nuttig?","here_Text_Key":"via deze pagina","knowledge_Text_Key":"Kennis","link_prod_error_Text_Key":"https://www.ikea.com/nl/nl/customer-service/track-manage-order/","loading_Text_Key":"Laden","market_Name_Key":"Nederland","modal_button_Close_Text_Key":"Sluiten","negative_feedback_Text_Key":"Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?","no_results_Text_Key":"Geen resultaten gevonden voor: {{query}}","product_error_Text_Key":"Deze zoekbalk is voor ondersteunende informatie. Voor artikelnummers, probeer te zoeken in de bovenste zoekbalk op IKEA.nl. Zoek je naar informatie over je bestelling?","read_more_button_Text_Key":"Lees meer","results_Text_Key":"{{number}} resultaat/resultaten gevonden voor: {{query}}","retrieving_Text_Key":"Laden","searchbar_Text_Key":"Zoek","searching_Text_Key":"Zoeken...","showLess_Text_Key":"Lees minder","showMore_Text_Key":"Lees meer","spellcheck_Text_Key":"Controleer de spelling of gebruik andere zoektermen","submit_Text_Key":"Stuur  in","try_again_Text_Key":"Probeer het later nog een keer"}');


var $6ea8f6e1de0754ec$exports = {};
$6ea8f6e1de0754ec$exports = JSON.parse('{"archived_Desc_Key":"Dalsze wsparcie znajdziesz tutaj.","archived_Title_Key":"Ten dokument został zarchiwizowany.","carousel_Text_Key":"Ten artykuł nie był pomocny? Sprawdź inne artykuły poniżej.","click_prompt_Text_Key":"kliknij tutaj","close_Text_Key":"Zamknij","customerService_Text_Key":"Obsługa klienta","error_Text_Key":"Coś poszło nie tak","feedback_Option1_Text_Key":"Tekst jest niezrozumiały","feedback_Option2_Text_Key":"Tekst nie ma związku z moim pytaniem","feedback_Option3_Text_Key":"Tekst ma związek, ale nie jest pomocny","feedback_Option4_Text_Key":"Tekst jest za długi lub za kr\xf3tki ","feedback_Question_1_Text_Key":"Kt\xf3re części naszych artykuł\xf3w uważasz za niezadowalające lub nieprzydatne?","feedback_Rec_Text_Key":"Dziękujemy za Twoją opinię!","feedback_Text_Key":"Czy powyższa informacja okazała się być pomocna?","here_Text_Key":"tutaj.","knowledge_Text_Key":"Wiedza","link_prod_error_Text_Key":"https://www.ikea.com/pl/pl/customer-service/track-manage-order/","loading_Text_Key":"Ładowanie","market_Name_Key":"Polska","modal_button_Close_Text_Key":"Zamknij","negative_feedback_Text_Key":"Przykro nam, że nie otrzymałeś odpowiedzi, kt\xf3rej szukałeś. Czy chcesz nam pom\xf3c ją poprawić?","no_results_Text_Key":"Nie znaleźliśmy wynik\xf3w dla zapytania: {{query}}","product_error_Text_Key":"Brak wynik\xf3w dla... \\b Ta wyszukiwarka służy jedynie do wyszukiwania artykuł\xf3w pomocniczych. Jeśli szukasz naszego produktu, wpisz je jego numer w g\xf3rnym pasku wyszukiwania na stronie IKEA.pl Jeśli szukasz informacji o swoim zam\xf3wieniu,","read_more_button_Text_Key":"Więcej","results_Text_Key":"Wyniki znalezione dla zapytania \\"{{query}}\\": {{number}}","retrieving_Text_Key":"Odzyskiwanie","searchbar_Text_Key":"Tu wpisz hasło lub kr\xf3tkie pytanie","searching_Text_Key":"Wyszukiwanie...","showLess_Text_Key":"Pokaż mniej","showMore_Text_Key":"Pokaż więcej","spellcheck_Text_Key":"Sprawdź pisownię lub spr\xf3buj użyć innych sł\xf3w.","submit_Text_Key":"Prześlij","try_again_Text_Key":"Spr\xf3buj ponownie p\xf3źniej"}');


var $96d6461ae301d5e8$exports = {};
$96d6461ae301d5e8$exports = JSON.parse('{"archived_Desc_Key":"Pode encontrar mais ajuda aqui","archived_Title_Key":"Este documento foi arquivado.","carousel_Text_Key":"O artigo n\xe3o foi \xfatil? Veja um dos artigos relacionados abaixo.","click_prompt_Text_Key":"aqui","close_Text_Key":"Fechar","customerService_Text_Key":"Apoio ao Cliente","error_Text_Key":"Alguma coisa correu mal","feedback_Option1_Text_Key":"O texto \xe9 confuso","feedback_Option2_Text_Key":"O texto n\xe3o \xe9 relevante para a minha pergunta","feedback_Option3_Text_Key":"O texto \xe9 relevante, mas n\xe3o \xe9 \xfatil","feedback_Option4_Text_Key":"O texto \xe9 demasiado longo ou demasiado curto ","feedback_Question_1_Text_Key":"Que partes espec\xedficas dos nossos artigos considera pouco satisfat\xf3rias ou in\xfateis?","feedback_Rec_Text_Key":"Agradecemos a sua opini\xe3o!","feedback_Text_Key":"Esta informa\xe7\xe3o foi \xfatil?","here_Text_Key":"aqui","knowledge_Text_Key":"Saber mais","link_prod_error_Text_Key":"https://www.ikea.com/pt/pt/customer-service/","loading_Text_Key":"A carregar","market_Name_Key":"Portugal","modal_button_Close_Text_Key":"Fechar","negative_feedback_Text_Key":"Lamentamos que n\xe3o tenha obtido a resposta que procurava. Gostaria de nos ajudar a melhorar?","no_results_Text_Key":"N\xe3o encontr\xe1mos nenhum resultado para os termos da pesquisa: {{query}}","product_error_Text_Key":"Lamentamos, mas n\xe3o foram encontrados resultados. Este motor de pesquisa suporta apenas uma ou mais palavras-chave. Se quiser informa\xe7\xf5es sobre os nossos produtos, use o motor de busca principal localizado na parte superior da web. Se pretender verificar o estado da sua encomenda, clique.","read_more_button_Text_Key":"Ler mais","results_Text_Key":"Encontr\xe1mos {{number}} resultado(s) para: {{query}}","retrieving_Text_Key":"A obter informa\xe7\xe3o","searchbar_Text_Key":"Escreva uma palavra ou frase, exemplo encomendar ou alterar.","searching_Text_Key":"A pesquisar...","showLess_Text_Key":"Mostre menos","showMore_Text_Key":"Mostrar mais","spellcheck_Text_Key":"Verifique os termos da pesquisa ou, em alternativa para obter suporte, poder\xe1 contactar-nos atrav\xe9s do chat.","submit_Text_Key":"Enviar","try_again_Text_Key":"Por favor tente novamente mais tarde"}');


var $b2fc149c6efa1954$exports = {};
$b2fc149c6efa1954$exports = JSON.parse('{"archived_Desc_Key":"Puteți găsi aici ajutor suplimentar.","archived_Title_Key":"Acest document a fost arhivat.","carousel_Text_Key":"Articolul nu a fost util? \xcencearcă unul dintre articolele similare de mai jos.","click_prompt_Text_Key":"click aici","close_Text_Key":"\xcenchide","customerService_Text_Key":"Relații clienți","error_Text_Key":"A apărut o eroare","feedback_Option1_Text_Key":"Textul este derutant","feedback_Option2_Text_Key":"Textul nu este relevant pentru \xeentrebarea mea","feedback_Option3_Text_Key":"Textul este relevant, dar nu este util","feedback_Option4_Text_Key":"Textul este prea lung sau prea scurt ","feedback_Question_1_Text_Key":"Ce părți ale articolului nostru ți se par nesatisfăcătoare sau nefolositoare?","feedback_Rec_Text_Key":"\xceți mulțumim pentru feedback!","feedback_Text_Key":"Ți s-a părut utilă informația?","here_Text_Key":"aici","knowledge_Text_Key":"Informații","link_prod_error_Text_Key":"https://www.ikea.com/ro/ro/customer-service/track-manage-order/","loading_Text_Key":"\xcencărcare","market_Name_Key":"Rom\xe2nia","modal_button_Close_Text_Key":"\xcenchide","negative_feedback_Text_Key":"Ne pare rău că nu ai primit răspunsul pe care \xeel căutai, dorești să ne ajuți să ne \xeembunătățim?","no_results_Text_Key":"Nu am găsit niciun rezultat pentru termenul căutat: {{query}}","product_error_Text_Key":"Dacă \xeencerci să găsești un produs, te rog să folosești bara de căutare din partea de sus a paginii. Dacă dorești să afli informații despre comanda ta, te rog fă","read_more_button_Text_Key":"Citește mai mult","results_Text_Key":"Noi am găsit {{number}} rezultat pentru: {{query}}","retrieving_Text_Key":"Pridobivanje","searchbar_Text_Key":"Exemplu de căutare: livrare sau factură","searching_Text_Key":"Căutare...","showLess_Text_Key":"Arată mai puțin","showMore_Text_Key":"Arată mai mult","spellcheck_Text_Key":"Te rugăm să verifici că ai scris corect sau să \xeencerci alte cuvinte cheie","submit_Text_Key":"Trimite","try_again_Text_Key":"Te rugăm să \xeencerci din nou mai t\xe2rziu"}');


var $991f6af1124ce170$exports = {};
$991f6af1124ce170$exports = JSON.parse('{"archived_Desc_Key":"Dodatna pomoč je na voljo tukaj","archived_Title_Key":"Ta dokument je bil arhiviran.","carousel_Text_Key":"Nebol tento čl\xe1nok dostatočne užitočn\xfd? Vysk\xfašajte pr\xedbuzn\xfd obsah zobrazen\xfd nižšie.","click_prompt_Text_Key":"Kliknite tu","close_Text_Key":"Zavrieť","customerService_Text_Key":"Z\xe1kazn\xedcky servis","error_Text_Key":"Niečo sa nepodarilo","feedback_Option1_Text_Key":"Text je m\xe4t\xfaci a\xa0nepochopiteľn\xfd","feedback_Option2_Text_Key":"Text sa net\xfdka mojej ot\xe1zky","feedback_Option3_Text_Key":"Text sa t\xfdka mojej ot\xe1zky, ale nie je užitočn\xfd","feedback_Option4_Text_Key":"Text je pr\xedliš dlh\xfd alebo pr\xedliš kr\xe1tky ","feedback_Question_1_Text_Key":"Ktor\xe9 konkr\xe9tne časti našich čl\xe1nkov považujete za neuspokojiv\xe9 alebo neužitočn\xe9?","feedback_Rec_Text_Key":"Ďakujeme za vašu sp\xe4tn\xfa v\xe4zbu!","feedback_Text_Key":"Bolo to pre v\xe1s užitočn\xe9?","here_Text_Key":"tukaj","knowledge_Text_Key":"Centrum poznatkov","link_prod_error_Text_Key":"https://www.ikea.com/sk/sk/customer-service/track-manage-order/","loading_Text_Key":"Nač\xedtavam","market_Name_Key":"Slovensk\xe1 republika","modal_button_Close_Text_Key":"Zatvoriť","negative_feedback_Text_Key":"Je n\xe1m ľ\xfato, že ste nedostali odpoveď, ktor\xfa ste hľadali, chcete n\xe1m pom\xf4cť zlepšiť sa?","no_results_Text_Key":"Nenašli sme žiadne zhody pre hľadan\xfd v\xfdraz: {{query}}","product_error_Text_Key":"Toto pole sl\xfaži na vyhľadanie n\xe1povedy. Pokiaľ chcete hľadať v\xfdrobky na z\xe1klade ich č\xedsla, použite hlavn\xe9 vyhľad\xe1vacie pole na IKEA.sk","read_more_button_Text_Key":"Preč\xedtať viac","results_Text_Key":"Našli sme {{number}} v\xfdsledok/v\xfdsledky pre: {{query}}","retrieving_Text_Key":"Nač\xedtavam","searchbar_Text_Key":"Sem nap\xedšte, čo hľad\xe1te.","searching_Text_Key":"Vyhľad\xe1vam...","showLess_Text_Key":"Zobraziť menej","showMore_Text_Key":"Zobraziť viac","spellcheck_Text_Key":"Sk\xfaste skontrolovať pravopis alebo použite in\xe9 kľ\xfačov\xe9 slov\xe1","submit_Text_Key":"Odoslať","try_again_Text_Key":"Sk\xfaste to znovu nesk\xf4r pros\xedm"}');


var $792977e6b4259227$exports = {};
$792977e6b4259227$exports = JSON.parse('{"archived_Desc_Key":"Pomoč lahko najdeš tukaj.","archived_Title_Key":"Ta dokument je arhiviran.","carousel_Text_Key":"Ali članek ni bil koristen? Poskusi z enim od povezanih člankov spodaj.","click_prompt_Text_Key":"klikni tukaj","close_Text_Key":"Zapri","customerService_Text_Key":"Služba za pomoč kupcem","error_Text_Key":"Prišlo je do napake","feedback_Option1_Text_Key":"Besedilo ni jasno razumljivo","feedback_Option2_Text_Key":"Besedilo ni povezano z mojim vprašanjem","feedback_Option3_Text_Key":"Besedilo je relevantno, vendar ni koristno","feedback_Option4_Text_Key":"Besedilo je predolgo ali prekratko ","feedback_Question_1_Text_Key":"Kaj na našem članku se ti zdi pomanjkljivo ali nekoristno?","feedback_Rec_Text_Key":"Hvala za povratne informacije!","feedback_Text_Key":"Je bilo to uporabno?","here_Text_Key":"tukaj.","knowledge_Text_Key":"Zbirka znanja","link_prod_error_Text_Key":"https://www.ikea.com/si/sl/customer-service/track-manage-order/","loading_Text_Key":"Nalaganje","market_Name_Key":"Slovenija","modal_button_Close_Text_Key":"Zapri","negative_feedback_Text_Key":"Žal nam je, da nisi dobil/-a odgovora, ki si ga iskal/-a. Ali nam želiš pomagati pri izboljšivah?","no_results_Text_Key":"Ni bilo mogoče najti ujemanj za iskalne izraze: {{query}}","product_error_Text_Key":"Če iščeš izdelek, uporabi brskalnik na vrhu spletne strani. Če iščeš informacije o svojem naročilu,","read_more_button_Text_Key":"Preberi več","results_Text_Key":"Število zadetkov za \\"{{query}}\\": {{number}}","retrieving_Text_Key":"Pridobivanje","searchbar_Text_Key":"Preizkusi na primer: dostava ali prevzem","searching_Text_Key":"Iskanje...","showLess_Text_Key":"Prikaži manj","showMore_Text_Key":"Prikaži več","spellcheck_Text_Key":"Preveri zapis besede ali uporabi druge ključne besede","submit_Text_Key":"Pošlji","try_again_Text_Key":"Pokušaj ponovo kasnije"}');


var $1fc09605601c7f18$exports = {};
$1fc09605601c7f18$exports = JSON.parse('{"archived_Desc_Key":"Dodatnu pomoć možeš pronaći ovde.","archived_Title_Key":"Ovaj dokument je arhiviran.","carousel_Text_Key":"Ovaj članak ti nije bio od pomoći? Pogledaj jedan od sličnih članaka u nastavku.","click_prompt_Text_Key":"klikni ovde","close_Text_Key":"Zatvori","customerService_Text_Key":"Služba za kupce","error_Text_Key":"Došlo je do greške","feedback_Option1_Text_Key":"Tekst je zbunjujući i težak za razumevanje","feedback_Option2_Text_Key":"Tekst nije relevantan za moje pitanje","feedback_Option3_Text_Key":"Tekst je relevantan, ali nije od pomoći","feedback_Option4_Text_Key":"Tekst je predugačak ili prekratak ","feedback_Question_1_Text_Key":"Koji deo našeg članka smatraš nezadovoljavajućim ili nije koristan?","feedback_Rec_Text_Key":"Hvala na povratnoj informaciji!","feedback_Text_Key":"Da li ti je ovo bilo korisno?","here_Text_Key":"ovde.","knowledge_Text_Key":"Baza znanja","link_prod_error_Text_Key":"https://www.ikea.com/rs/sr/customer-service/track-manage-order/","loading_Text_Key":"Učitavanje","market_Name_Key":"Srbija","modal_button_Close_Text_Key":"Zatvori","negative_feedback_Text_Key":"Žao nam je što nisi dobio/la traženi odgovor, da li bi želeo/la da nam pomogneš da se poboljšamo?","no_results_Text_Key":"Nismo pronašli nijedan rezultat za tvoj unos: {{query}}","product_error_Text_Key":"Ako tražiš neki proizvod, koristi polje za pretragu na vrhu stranice. Ukoliko ti je potrebna informacija u vezi s tvojom narudžbinom,","read_more_button_Text_Key":"Pročitaj više","results_Text_Key":"Pronašli smo {{number}} rezultat(a) za: {{query}}","retrieving_Text_Key":"Prikupljanje","searchbar_Text_Key":"Pokušaj, recimo: isporuka ili radno vreme","searching_Text_Key":"Pretraga...","showLess_Text_Key":"Prikaži manje","showMore_Text_Key":"Prikaži više","spellcheck_Text_Key":"Proveri da li je unos ispravan ili koristi druge ključne reči","submit_Text_Key":"Pošalji","try_again_Text_Key":"Pokušaj ponovo kasnije"}');


var $dec50ce9508e68c7$exports = {};
$dec50ce9508e68c7$exports = JSON.parse('{"archived_Desc_Key":"F\xf6r support, g\xe5 till ikea.se/kundservice","archived_Title_Key":"Det h\xe4r dokumentet \xe4r inte l\xe4ngre tillg\xe4ngligt.","carousel_Text_Key":"Hittade du inte det du s\xf6kte? Ta en titt p\xe5 en av artiklarna i listan.","click_prompt_Text_Key":"Klicka h\xe4r","close_Text_Key":"St\xe4ng","customerService_Text_Key":"Kundservice","error_Text_Key":"N\xe5got gick fel","feedback_Option1_Text_Key":"Texten \xe4r f\xf6rvirrande och sv\xe5r att f\xf6rst\xe5","feedback_Option2_Text_Key":"Texten \xe4r inte relevant f\xf6r min fr\xe5ga","feedback_Option3_Text_Key":"Texten \xe4r relevant men inte till n\xe5gon hj\xe4lp","feedback_Option4_Text_Key":"Texten \xe4r f\xf6r l\xe5ng eller f\xf6r kort ","feedback_Question_1_Text_Key":"Vilken eller vilka delar av artikeln kan vi g\xf6ra b\xe4ttre?","feedback_Rec_Text_Key":"Tack f\xf6r din feedback!","feedback_Text_Key":"Hj\xe4lpte den h\xe4r artikeln dig?","here_Text_Key":"ikea.se/kundservice","knowledge_Text_Key":"Kunskapsportal","link_prod_error_Text_Key":"https://order.ikea.com/se/sv/purchases/lookup/","loading_Text_Key":"Letar efter svaret...","market_Name_Key":"Sverige","modal_button_Close_Text_Key":"St\xe4ng","negative_feedback_Text_Key":"Vi beklagar att du inte fick det svar du letade efter, vill du hj\xe4lpa oss att bli b\xe4ttre?","no_results_Text_Key":"Vi hittade inga resultat f\xf6r: {{query}}","product_error_Text_Key":"Anv\xe4nd ist\xe4llet s\xf6kf\xe4ltet h\xf6gst upp p\xe5 v\xe5r hemsida om du letar efter information om en specifik produkt. Vill du sp\xe5ra eller hantera din order,","read_more_button_Text_Key":"L\xe4s mer","results_Text_Key":"Vi hittade {{number}} resultat f\xf6r: {{query}}","retrieving_Text_Key":"Laddar...","searchbar_Text_Key":"Hur kan vi hj\xe4lpa dig? Skriv din fr\xe5ga h\xe4r","searching_Text_Key":"Letar efter svaret...","showLess_Text_Key":"Visa mindre","showMore_Text_Key":"Visa mer","spellcheck_Text_Key":"Testa att anv\xe4nda ett annat ord eller fras!","submit_Text_Key":"Skicka in","try_again_Text_Key":"Var sn\xe4ll och f\xf6rs\xf6k igen senare."}');


var $66f431be8497e5f1$exports = {};
$66f431be8497e5f1$exports = JSON.parse('{"archived_Desc_Key":"Додаткову допомогу можна знайти тут","archived_Title_Key":"Цей документ було архівовано.","carousel_Text_Key":"Чи не була стаття корисною? Спробуйте одну зі споріднених статей нижче.","click_prompt_Text_Key":"тут","close_Text_Key":"Закрити","customerService_Text_Key":"Служба підтримки клієнтів","error_Text_Key":"Сталась помилка","feedback_Option1_Text_Key":"Текст важко зрозуміти","feedback_Option2_Text_Key":"Текст не відповідає на моє питання","feedback_Option3_Text_Key":"Текст доречний, але не корисний","feedback_Option4_Text_Key":"Текст занадто довгий або занадто короткий ","feedback_Question_1_Text_Key":"Яку саме частину нашої статті ви вважаєте незадовільною чи некорисною?","feedback_Rec_Text_Key":"Дякуємо за ваш відгук!","feedback_Text_Key":"Чи була корисною ця інформація?","here_Text_Key":"тут","knowledge_Text_Key":"Знання","link_prod_error_Text_Key":"https://www.ikea.com/ua/uk/customer-service/","loading_Text_Key":"Завантаження","market_Name_Key":"Україна","modal_button_Close_Text_Key":"Закрити","negative_feedback_Text_Key":"Нам шкода, що ви не отримали потрібної відповіді, чи не хотіли б ви допомогти нам стати краще?","no_results_Text_Key":"Не знайдено збігів за запитом: {{query}}","product_error_Text_Key":"На жаль, результатів не знайдено. Ця пошукова система підтримує тільки одне або більше ключових слів. Якщо вам потрібна інформація про наші товари, використовуйте основну пошукову систему, розташовану у верхній частині мережі. Якщо ви хочете перевірити стан замовлення, натисніть кнопку.","read_more_button_Text_Key":"Докладніше","results_Text_Key":"Ми знайшли {{number}} результат(ів) для: {{query}}","retrieving_Text_Key":"Обробка","searchbar_Text_Key":"Спробуйте, наприклад: доставка, або оплата","searching_Text_Key":"Пошук...","showLess_Text_Key":"Показати менше","showMore_Text_Key":"Показати більше","spellcheck_Text_Key":"Перевір, чи правильно написане слово, або спробуй ввести інше","submit_Text_Key":"Представити","try_again_Text_Key":"Будь ласка, спробуй пізніше"}');


var $ddf666b2546be756$exports = {};
$ddf666b2546be756$exports = JSON.parse('{"archived_Desc_Key":"Further help can be found here","archived_Redirection_Key":"customer-service/contact-us/","archived_Title_Key":"This document has been archived.","carousel_Text_Key":"Was the article not helpful? Try one of the related articles below.","click_prompt_Text_Key":"Here","close_Text_Key":"Close","customerService_Text_Key":"Customer Service","error_Text_Key":"Something went wrong","feedback_Option1_Text_Key":"The text is confusing to understand","feedback_Option2_Text_Key":"The text is not relevant to my question","feedback_Option3_Text_Key":"The text is relevant but not helpful","feedback_Option4_Text_Key":"The text is too long or too short ","feedback_Question_1_Text_Key":"What particular parts of our articles do you find unsatisfactory or unhelpful?","feedback_Rec_Text_Key":"Thank you for your feedback!","feedback_Text_Key":"Did you find this useful?","here_Text_Key":"here","knowledge_Text_Key":"Knowledge","link_prod_error_Text_Key":"https://www.ikea.com/nz/en/customer-service/track-manage-order/","loading_Text_Key":"Loading","market_Name_Key":"New Zealand","modal_button_Close_Text_Key":"Close","negative_feedback_Text_Key":"We are sorry you didn’t get the answer you were looking for, would you like to help us improve?","no_results_Text_Key":"We did not find any matches for results for search term: {{query}}","product_error_Text_Key":"Sorry, no results found. This search engine only supports one or more keywords. If you want information about our products, use the main search engine located at the top of the web. If you want to check the status of your order, please click.","read_more_button_Text_Key":"Read more","results_Text_Key":"We found {{number}} results for: {{query}}","retrieving_Text_Key":"Retrieving","searchbar_Text_Key":"Find answers to your question here","searching_Text_Key":"Searching...","showLess_Text_Key":"Show less","showMore_Text_Key":"Show more","spellcheck_Text_Key":"Try checking the spelling or using different keywords","submit_Text_Key":"Submit","try_again_Text_Key":"Please try again later"}');


const $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4 = {
    "ca-ES": $230d3fff040badbc$exports,
    "cs-CZ": $880d32b33610a524$exports,
    "da-DK": $046e1dcd8a463a54$exports,
    "de-AT": $7d8b491eef37576b$exports,
    "de-CH": $915841f54ce3cf99$exports,
    "de-DE": $d88b600fe3223f5d$exports,
    "en-AT": $b3dd1d29cb681d8c$exports,
    "en-AU": $af46bd9ec7e4ee50$exports,
    "en-BE": $c435cb592892ef97$exports,
    "en-CA": $b232dd46805f42c9$exports,
    "en-CH": $df5028a35aea820d$exports,
    "en-CZ": $f12ebce42eae8540$exports,
    "en-DE": $f8966ba10bba7dbd$exports,
    "en-ES": $f6a114b3bda0d399$exports,
    "en-FI": $0b041c9fdfaff7ab$exports,
    "en-GB": $7d8d18e80d5f7473$exports,
    "en-IE": $1c8f1faf325519a5$exports,
    "en-IN": $1961402b40d12800$exports,
    "en-JP": $cdcaeed6fcae93a9$exports,
    "en-NL": $a73992b107ac1b2a$exports,
    "en-NO": $27dd3cc381f46ceb$exports,
    "en-NZ": $ddf666b2546be756$exports,
    "en-PT": $bd508efc153373be$exports,
    "en-SE": $5bfe5aad6e2a0fb8$exports,
    "en-US": $899cba527d8dde37$exports,
    "es-ES": $c5f3cf2b3680850c$exports,
    "es-US": $922eccef1347026d$exports,
    "eu-ES": $291035aa9c4a42a2$exports,
    "fi-FI": $49a31b82af711e9b$exports,
    "fr-BE": $15061c87903685c5$exports,
    "fr-CA": $b3a6dd3ab922d0b9$exports,
    "fr-CH": $2ec104d9fcfe67af$exports,
    "fr-FR": $8d419095d4c426f6$exports,
    "gl-ES": $726a17740c34e581$exports,
    "hr-HR": $ceb54bc6a2520847$exports,
    "hu-HU": $d6c8f66d5bf1c059$exports,
    "it-CH": $9d7af6600473ab94$exports,
    "it-IT": $f133b62eb028ab02$exports,
    "ja-JP": $763a607fe555c9e5$exports,
    "ko-KR": $4a3b60fb4a4f2d70$exports,
    "no-NO": $eeff45b04fb26100$exports,
    "nl-BE": $c7d6ab9e2af5259e$exports,
    "nl-NL": $4b33d00c15780ad6$exports,
    "pl-PL": $6ea8f6e1de0754ec$exports,
    "pt-PT": $96d6461ae301d5e8$exports,
    "ro-RO": $b2fc149c6efa1954$exports,
    "sk-SK": $991f6af1124ce170$exports,
    "sl-SI": $792977e6b4259227$exports,
    "sr-RS": $1fc09605601c7f18$exports,
    "sv-SE": $dec50ce9508e68c7$exports,
    "uk-UA": $66f431be8497e5f1$exports
};


const $95348539110c5f30$var$Container = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    max-width: 400px;
  }

  span:hover {
    cursor: pointer;
  }

  h2:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const $95348539110c5f30$var$OpenInNewWindow = (lang)=>{
    const articlePages = [
        "nl-NL",
        "en-NL",
        "fr-FR",
        "fr-CH",
        "it-CH",
        "de-CH",
        "en-CH",
        "fr-CA",
        "en-CA",
        "sv-SE",
        "en-SE",
        "pl-PL",
        "ro-RO",
        "sr-RS",
        "sk-SK",
        "cs-CZ",
        "hr-HR",
        "sl-SI",
        "de-DE",
        "da-DK",
        "no-NO",
        "en-NO",
        "ja-JP",
        "en-JP",
        "fi-FI",
        "en-FI",
        "pt-PT",
        "en-PT",
        "de-AT",
        "en-AT",
        "it-IT",
        "ko-KR",
        "en-KR",
        "en-GB",
        "en-AU",
        "en-US",
        "en-IN",
        "en-IE",
        "en-ES",
        "es-ES",
        "ca-ES",
        "eu-ES",
        "gl-ES",
        "hu-HU",
        "fr-BE",
        "nl-BE",
        "en-BE"
    ];
    if (articlePages.indexOf(lang) > -1) return true;
    else return false;
};
const $95348539110c5f30$var$ArticleList = ({ data: data, lang: lang, query: query, correlationId: correlationId, variant: variant })=>{
    const [modalOpen, setModalOpen] = (0, $iJ7ah.useState)(false);
    const [docGuid, setDocGuid] = (0, $iJ7ah.useState)(null);
    const [pos, setPos] = (0, $iJ7ah.useState)(null);
    const [vetaDoc, setVetaDoc] = (0, $iJ7ah.useState)({
        title: "",
        description: "",
        content: ""
    });
    const { t: t } = (0, $cc94a242f86bed6e$export$9fc83ad70ead8663)();
    const langKey = lang;
    const IsProduction = ()=>{
        const url = window.location.href;
        return url.includes("www.ikea.com");
    };
    (0, $iJ7ah.useEffect)(()=>{
        async function retrieveDocs() {
            if (docGuid) (0, $f91de8dbf30ded37$export$647b0f0838f655fd)({
                locale: t("locale"),
                query: query,
                docGuid: docGuid,
                correlationId: correlationId,
                backend: "lisa",
                isProd: IsProduction(),
                pos: pos,
                setModalOpen: setModalOpen,
                setVetaDoc: setVetaDoc
            });
        }
        if (docGuid) retrieveDocs();
    }, [
        data.content,
        data.length,
        docGuid,
        lang,
        pos,
        query,
        t
    ]);
    const UrlExists = (url)=>{
        if (window.location.hostname === "www.cte.ikeadt.com" || window.location.hostname === "localhost") return true;
        var http = new XMLHttpRequest();
        http.open("HEAD", url, false);
        http.send();
        if (http.status != 404) return true;
        else return false;
    };
    const closeFunc = ()=>{
        setModalOpen(false);
        setDocGuid("");
        setPos(null);
    };
    const renderItems = ()=>{
        const mapRows = data.map((item, index)=>{
            return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $joJRn.Fragment), {
                children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $5d8387a8e844302b$export$2e2bcd8739ae039), {
                    id: item.metadata.docGUID,
                    title: item.title,
                    category: item?.metadata?.categoryPath,
                    variant: variant,
                    onClick: ()=>{
                        setPos(index);
                        const langCombo = lang.split("-");
                        const market = langCombo[1];
                        const mLang = langCombo[0];
                        if ($95348539110c5f30$var$OpenInNewWindow(lang)) {
                            (0, $e8bd861091c10b8c$export$f42fbd1cc833b8f7)({
                                guid: `${item.metadata.docGUID}`,
                                action: "articleOpen",
                                query: query,
                                variant: variant,
                                pos: index,
                                correlationId: correlationId
                            });
                            window.location.href = `https://www.ikea.com/${market.toLowerCase()}/${mLang.toLowerCase()}/customer-service/knowledge/articles/${item.metadata.docGUID}.html`;
                        } else setDocGuid(item.metadata.docGUID);
                    },
                    onKeyPress: (e)=>{
                        if (e.key === "Enter") {
                            document.activeElement.blur();
                            setPos(index);
                            if ($95348539110c5f30$var$OpenInNewWindow(lang)) {
                                (0, $e8bd861091c10b8c$export$f42fbd1cc833b8f7)({
                                    guid: `${item.metadata.docGUID}`,
                                    action: "articleOpen",
                                    query: query,
                                    variant: variant,
                                    pos: index,
                                    correlationId: correlationId
                                });
                                const langCombo = lang.split("-");
                                const market = langCombo[1];
                                const mLang = langCombo[0];
                                window.location.href = `https://www.ikea.com/${market.toLowerCase()}/${mLang.toLowerCase()}/customer-service/knowledge/articles/${item.metadata.docGUID}.html`;
                            } else setDocGuid(item.metadata.docGUID);
                        }
                    },
                    description: item.description
                })
            });
        });
        return mapRows;
    };
    return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($95348539110c5f30$var$Container, {
        children: [
            /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($9CtqL))), {
                visible: modalOpen,
                handleCloseBtn: closeFunc,
                children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $9CtqL.Sheets), {
                    labelledById: vetaDoc.title,
                    alignment: "right",
                    preserveAlignment: false,
                    size: "medium",
                    header: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $9CtqL.ModalHeader), {
                        titleId: vetaDoc.title,
                        title: vetaDoc.title,
                        backBtnClick: closeFunc,
                        floating: false
                    }),
                    footer: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $9CtqL.ModalFooter), {
                        className: "veta-btn-alignment",
                        children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($dcraR))), {
                            text: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].close_Text_Key,
                            type: "primary",
                            onClick: closeFunc
                        })
                    }),
                    children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $9CtqL.ModalBody), {
                        children: [
                            /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)("p", {
                                children: vetaDoc.description
                            }),
                            /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: vetaDoc.content
                                }
                            })
                        ]
                    })
                })
            }),
            renderItems()
        ]
    });
};
var $95348539110c5f30$export$2e2bcd8739ae039 = $95348539110c5f30$var$ArticleList;





/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $joJRn = parcelRequire("joJRn");
parcelRequire("2Jeaf");
var $iJ7ah = parcelRequire("iJ7ah");

var $5bc14e451bc949c9$exports = {};

$5bc14e451bc949c9$exports = (parcelRequire("4FbPx"));




var $2e45648e03bac693$exports = {};
"use strict";
Object.defineProperty($2e45648e03bac693$exports, "__esModule", {
    value: true
});
Object.defineProperty($2e45648e03bac693$exports, "LoadingBall", {
    enumerable: true,
    get: function() {
        return $2e45648e03bac693$var$_LoadingBall.default;
    }
});
Object.defineProperty($2e45648e03bac693$exports, "LoadingLinear", {
    enumerable: true,
    get: function() {
        return $2e45648e03bac693$var$_LoadingLinear.default;
    }
});
Object.defineProperty($2e45648e03bac693$exports, "default", {
    enumerable: true,
    get: function() {
        return $2e45648e03bac693$var$_Loading.default;
    }
});

var $2e45648e03bac693$var$_Loading = $2e45648e03bac693$var$_interopRequireDefault((parcelRequire("i706F")));

var $2e45648e03bac693$var$_LoadingBall = $2e45648e03bac693$var$_interopRequireDefault((parcelRequire("i0P3O")));

var $2e45648e03bac693$var$_LoadingLinear = $2e45648e03bac693$var$_interopRequireDefault((parcelRequire("kqGxE")));
function $2e45648e03bac693$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $a6e281816f91ab77$export$1e511d4a378977f5;
var $a6e281816f91ab77$export$f6d5d4774149a3bf;
"use strict";
$a6e281816f91ab77$export$1e511d4a378977f5 = true;
var $a6e281816f91ab77$var$Guid = /** @class */ function() {
    function Guid(guid) {
        if (!guid) throw new TypeError("Invalid argument; `value` has no value.");
        this.value = Guid.EMPTY;
        if (guid && Guid.isGuid(guid)) this.value = guid;
    }
    Guid.isGuid = function(guid) {
        var value = guid.toString();
        return guid && (guid instanceof Guid || Guid.validator.test(value));
    };
    Guid.create = function() {
        return new Guid([
            Guid.gen(2),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(3)
        ].join("-"));
    };
    Guid.createEmpty = function() {
        return new Guid("emptyguid");
    };
    Guid.parse = function(guid) {
        return new Guid(guid);
    };
    Guid.raw = function() {
        return [
            Guid.gen(2),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(1),
            Guid.gen(3)
        ].join("-");
    };
    Guid.gen = function(count) {
        var out = "";
        for(var i = 0; i < count; i++)// tslint:disable-next-line:no-bitwise
        out += ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        return out;
    };
    Guid.prototype.equals = function(other) {
        // Comparing string `value` against provided `guid` will auto-call
        // toString on `guid` for comparison
        return Guid.isGuid(other) && this.value === other.toString();
    };
    Guid.prototype.isEmpty = function() {
        return this.value === Guid.EMPTY;
    };
    Guid.prototype.toString = function() {
        return this.value;
    };
    Guid.prototype.toJSON = function() {
        return {
            value: this.value
        };
    };
    Guid.validator = new RegExp("^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$", "i");
    Guid.EMPTY = "00000000-0000-0000-0000-000000000000";
    return Guid;
}();
$a6e281816f91ab77$export$f6d5d4774149a3bf = $a6e281816f91ab77$var$Guid;


var $4d51a1bf9a487843$exports = {};
"use strict";
Object.defineProperty($4d51a1bf9a487843$exports, "__esModule", {
    value: true
});
$4d51a1bf9a487843$exports.default = void 0;

var $4d51a1bf9a487843$var$_Expander = $4d51a1bf9a487843$var$_interopRequireDefault((parcelRequire("jdDIE")));
function $4d51a1bf9a487843$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4d51a1bf9a487843$var$_default = $4d51a1bf9a487843$var$_Expander.default;
$4d51a1bf9a487843$exports.default = $4d51a1bf9a487843$var$_default;









var $bf74a59f405e5694$exports = {};
"use strict";
Object.defineProperty($bf74a59f405e5694$exports, "__esModule", {
    value: true
});
$bf74a59f405e5694$exports.default = void 0;

var $bf74a59f405e5694$var$_Search = $bf74a59f405e5694$var$_interopRequireDefault((parcelRequire("iR1bu")));
function $bf74a59f405e5694$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf74a59f405e5694$var$_default = $bf74a59f405e5694$var$_Search.default;
$bf74a59f405e5694$exports.default = $bf74a59f405e5694$var$_default;



(0, (/*@__PURE__*/$parcel$interopDefault($5bc14e451bc949c9$exports))).defaults.timeout = 5000;
const $031dc0e3b16446aa$var$Container = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  width: 100%;
  font-family: Noto IKEA, Noto Sans, Roboto, Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;

  justify-content: center;

  @media (max-width: 480px) {
    font-size: 15px;
  }

  @media (max-width: 375px) {
    font-size: 15px;
  }

  @media (max-width: 320px) {
    font-size: 15px;
  }
`;
const $031dc0e3b16446aa$var$SearchBarContainer = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  width: 100%;
  min-width: inherit;
  margin-bottom: 1rem;

  input {
    font-family: Noto IKEA, Noto Sans, Roboto, Open Sans, sans-serif;
  }

  @media screen and (max-width: 480px) {
    font-size: 15px;
    min-width: unset;
  }

  @media (max-width: 320px) {
    font-size: 15px;
    min-width: unset;
  }
  .search__clear {
    position: absolute !important;
  }
`;
const $031dc0e3b16446aa$var$ResultsContainer = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (max-width: 480px) {
    width: 357px;
  }
`;
const $031dc0e3b16446aa$var$SearchResultContainer = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: row;
  margin-top: 8px;
  margin-left: 16px;
  margin-bottom: 24px;

  @media screen and (max-width: 480px) {
    margin-left: 0px;
    max-width: 358px;
  }
`;
const $031dc0e3b16446aa$var$LoadingContainer = (0, $724921cc79267cde$export$2e2bcd8739ae039).div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  margin-top: 8px;
  margin-left: 16px;
  margin-bottom: 24px;
`;
const $031dc0e3b16446aa$var$maxSearchResult = 15;
const $031dc0e3b16446aa$var$minSearchResult = 5;
const $031dc0e3b16446aa$var$iterateNumArticles = 5;
const $031dc0e3b16446aa$var$KnowledgeComponent = ({ lang: lang, variant: variant })=>{
    const langKey = lang;
    const IsProduction = ()=>{
        const url = window.location.href;
        return url.includes("www.ikea.com");
    };
    const queryString = JSON.parse(sessionStorage.getItem("queryString"));
    const storedResult = queryString ? queryString.entries : [];
    const [query, setQuery] = (0, $iJ7ah.useState)("");
    const [results, setResults] = (0, $iJ7ah.useState)(storedResult ? storedResult : []);
    const [resultsShown, setResultsShown] = (0, $iJ7ah.useState)($031dc0e3b16446aa$var$minSearchResult);
    const [ready, setReady] = (0, $iJ7ah.useState)(false);
    const [redirect, setRedirect] = (0, $iJ7ah.useState)(false);
    const [loading, setLoading] = (0, $iJ7ah.useState)(false);
    const [error, setError] = (0, $iJ7ah.useState)(undefined);
    const [regExError, setRegexError] = (0, $iJ7ah.useState)(false);
    const [numberRegex, setNumberRegex] = (0, $iJ7ah.useState)(false);
    // state for holding scope.
    const [correlationId, setCorrelationId] = (0, $iJ7ah.useState)("");
    const { i18n: i18n, t: t } = (0, $cc94a242f86bed6e$export$9fc83ad70ead8663)();
    const [language, market] = langKey.split("-");
    const invalidCharRegex = /[()"{}\=\\]/;
    const productRegex = /(\d+(\.\d+)?\.\d+\.\d+)|\b\d{8}\b/g;
    const orderNumbRegex = /\b\d{9,10}\b/g;
    const sparePartRegex = /\b\d{6}\b/g;
    (0, $iJ7ah.useEffect)(()=>{
        setRedirect(false);
        setResultsShown($031dc0e3b16446aa$var$minSearchResult);
        let backend = "lisa";
        async function runSearch() {
            setRegexError(false);
            if (query) await (0, $f91de8dbf30ded37$export$7759221db3edc8c1)({
                correlationId: correlationId,
                query: query,
                backend: backend,
                variant: variant,
                locale: t("locale"),
                isProd: IsProduction(),
                setResults: setResults,
                setLoading: setLoading,
                setError: setError,
                setReady: setReady,
                setRedirect: setRedirect
            });
        }
        runSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    (0, $iJ7ah.useEffect)(()=>{
        openRedirect(query);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        redirect
    ]);
    setTimeout(()=>{
        sessionStorage.removeItem("queryString");
    }, 60000);
    const searchFunc = async (e, data)=>{
        checkRedirect(data.value);
        if (invalidCharRegex.test(data.value)) setRegexError(true);
        setQuery(data.value);
    };
    const openRedirect = (query)=>{
        const productMatch = query.match(productRegex);
        const orderMatch = query.match(orderNumbRegex);
        const sparePartMatch = query.match(sparePartRegex);
        if (productMatch && redirect) window.location.href = `https://www.ikea.com/${market.toLowerCase()}/${language.toLowerCase()}/search/?q=${productMatch[0]}`;
        else if (orderMatch && redirect) window.location.href = `https://www.ikea.com/${market.toLowerCase()}/${language.toLocaleLowerCase()}/purchases/lookup/${orderMatch[0]}/`;
        else if (sparePartMatch && redirect) window.location.href = `https://www.ikea.com/${market.toLowerCase()}/${language.toLocaleLowerCase()}/customer-service/returns-claims/spareparts/`;
    };
    const checkRedirect = (query)=>{
        const productRegex = /(\d+\.\d+\.\d+)|\b\d{8}\b/g;
        const orderNumbRegex = /\b\d{9,10}\b/g;
        const sparePartRegex = /\b\d{6}\b/g;
        const productMatch = query.match(productRegex);
        const orderMatch = query.match(orderNumbRegex);
        const sparePartMatch = query.match(sparePartRegex);
        if (productMatch || orderMatch || sparePartMatch) setNumberRegex(true);
    };
    const showMoreArticles = async (data)=>{
        const articleResult = setNumberOfArticles();
        setResultsShown(data.target.textContent === (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].showMore_Text_Key ? articleResult : $031dc0e3b16446aa$var$minSearchResult);
    };
    const setLabelOnBtn = ()=>{
        return resultsShown >= results.length ? (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].showLess_Text_Key : (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].showMore_Text_Key;
    };
    const setNumberOfArticles = ()=>{
        const articleResult = resultsShown + $031dc0e3b16446aa$var$iterateNumArticles;
        return articleResult > results.length ? results.length : articleResult;
    };
    const canShowButton = ()=>{
        if (results.length > $031dc0e3b16446aa$var$minSearchResult) return true;
    };
    const articleToDisplay = ()=>{
        return results.slice(0, resultsShown);
    };
    (0, $iJ7ah.useEffect)(()=>{
        setCorrelationId((0, $a6e281816f91ab77$export$f6d5d4774149a3bf).create().toString());
        i18n.changeLanguage(lang);
    }, [
        i18n,
        lang
    ]);
    return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($031dc0e3b16446aa$var$Container, {
        children: [
            /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($031dc0e3b16446aa$var$SearchBarContainer, {
                children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($bf74a59f405e5694$exports))), {
                    className: "searchBar",
                    id: "search",
                    "aria-label": "Search",
                    placeholder: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].searchbar_Text_Key,
                    onSearch: searchFunc,
                    clearBtnText: "clear search field",
                    onClear: ()=>{
                        setQuery("");
                        setReady(false);
                        setResults([]);
                    }
                })
            }),
            regExError ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $eb0357eea78c60c6$export$2e2bcd8739ae039), {
                lang: lang,
                message: ""
            }) : query !== "" && query && lang !== "" && !loading ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($031dc0e3b16446aa$var$SearchResultContainer, {
                children: ready && error ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $eb0357eea78c60c6$export$2e2bcd8739ae039), {
                    lang: lang,
                    errorCode: error,
                    message: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].try_again_Text_Key
                }) : ready && results.length > 0 ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $joJRn.Fragment), {
                    children: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].results_Text_Key.replace("{{number}}", results.length > $031dc0e3b16446aa$var$maxSearchResult ? $031dc0e3b16446aa$var$maxSearchResult : results.length).replace("{{query}}", query)
                }) : ready && !numberRegex ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $eb0357eea78c60c6$export$2e2bcd8739ae039), {
                    lang: lang,
                    message: `${(0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].no_results_Text_Key.replace("{{query}}", query)}`
                }) : null
            }) : loading ? /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($031dc0e3b16446aa$var$LoadingContainer, {
                children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($2e45648e03bac693$exports))), {
                    labelTransitions: true,
                    text: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].loading_Text_Key,
                    children: /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $2e45648e03bac693$exports.LoadingBall), {})
                })
            }) : "",
            /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)($031dc0e3b16446aa$var$ResultsContainer, {
                children: results && lang !== "" && /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $joJRn.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $95348539110c5f30$export$2e2bcd8739ae039), {
                            data: articleToDisplay(),
                            lang: lang,
                            query: query,
                            variant: variant,
                            correlationId: correlationId
                        }),
                        canShowButton() && /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($4d51a1bf9a487843$exports))), {
                            generic: true,
                            onToggle: (e)=>{
                                showMoreArticles(e);
                            },
                            labelClosed: setLabelOnBtn(),
                            labelOpen: setLabelOnBtn(),
                            children: " "
                        })
                    ]
                })
            })
        ]
    });
};
var $031dc0e3b16446aa$export$2e2bcd8739ae039 = $031dc0e3b16446aa$var$KnowledgeComponent;





parcelRequire("2Jeaf");
var $85d40e247b2502c4$exports = {};
"use strict";
Object.defineProperty($85d40e247b2502c4$exports, "__esModule", {
    value: true
});
$85d40e247b2502c4$exports.default = void 0;

var $85d40e247b2502c4$var$_InlineMessage = $85d40e247b2502c4$var$_interopRequireDefault((parcelRequire("kHTl8")));
function $85d40e247b2502c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $85d40e247b2502c4$var$_default = $85d40e247b2502c4$var$_InlineMessage.default;
$85d40e247b2502c4$exports.default = $85d40e247b2502c4$var$_default;








const $eb0357eea78c60c6$var$CalculateVariant = (errorCode)=>{
    let firstChar = errorCode.toString();
    firstChar = firstChar.substr(0, 1);
    firstChar = parseInt(firstChar);
    if (firstChar === 5 || firstChar === 4) return "negative";
    else return "cautionary";
};
const $eb0357eea78c60c6$var$ErrorCard = ({ message: message = "", errorCode: errorCode = 0, lang: lang = "en_NL" })=>{
    const { t: t } = (0, $cc94a242f86bed6e$export$9fc83ad70ead8663)();
    const renderFunc = (errorCode)=>{
        const langKey = lang;
        if (errorCode && errorCode > 0 && errorCode !== 22) return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($85d40e247b2502c4$exports))), {
            variant: $eb0357eea78c60c6$var$CalculateVariant(errorCode),
            title: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].error_Text_Key,
            body: message
        });
        else if (errorCode && errorCode === 22) return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($85d40e247b2502c4$exports))), {
            variant: "cautionary",
            title: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].product_error_Text_Key,
            linkLabel: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].click_prompt_Text_Key,
            link: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].link_prod_error_Text_Key
        });
        else return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, (/*@__PURE__*/$parcel$interopDefault($85d40e247b2502c4$exports))), {
            variant: "cautionary",
            title: message,
            body: (0, $c3ce3fdb91b33aa9$export$93e4534b7d0af9d4)[langKey].spellcheck_Text_Key
        });
    };
    return renderFunc(errorCode);
};
var $eb0357eea78c60c6$export$2e2bcd8739ae039 = $eb0357eea78c60c6$var$ErrorCard;







var $joJRn = parcelRequire("joJRn");
function $f4dac32f84238c46$var$r() {
    return ($f4dac32f84238c46$var$r = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var n = arguments[e];
            for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
    }).apply(this, arguments);
}
function $f4dac32f84238c46$var$i(t) {
    this.getChildContext = function() {
        return t.context;
    };
    var e = t.children, n = function(t, e) {
        if (null == t) return {};
        var n, o, r = {}, i = Object.keys(t);
        for(o = 0; o < i.length; o++)e.indexOf(n = i[o]) >= 0 || (r[n] = t[n]);
        return r;
    }(t, [
        "context",
        "children"
    ]);
    return (0, $joJRn.cloneElement)(e, n);
}
function $f4dac32f84238c46$var$a() {
    var o = new CustomEvent("_preact", {
        detail: {},
        bubbles: !0,
        cancelable: !0
    });
    this.dispatchEvent(o), this._vdom = (0, $joJRn.h)($f4dac32f84238c46$var$i, $f4dac32f84238c46$var$r({}, this._props, {
        context: o.detail.context
    }), function e(n, o) {
        if (3 === n.nodeType) return n.data;
        if (1 !== n.nodeType) return null;
        var r = [], i = {}, a = 0, c = n.attributes, l = n.childNodes;
        for(a = c.length; a--;)"slot" !== c[a].name && (i[c[a].name] = c[a].value, i[$f4dac32f84238c46$var$s(c[a].name)] = c[a].value);
        for(a = l.length; a--;){
            var p = e(l[a], null), d = l[a].slot;
            d ? i[d] = (0, $joJRn.h)($f4dac32f84238c46$var$u, {
                name: d
            }, p) : r[a] = p;
        }
        var h = o ? (0, $joJRn.h)($f4dac32f84238c46$var$u, null, r) : r;
        return (0, $joJRn.h)(o || n.nodeName.toLowerCase(), i, h);
    }(this, this._vdomComponent)), (this.hasAttribute("hydrate") ? (0, $joJRn.hydrate) : (0, $joJRn.render))(this._vdom, this._root);
}
function $f4dac32f84238c46$var$s(t) {
    return t.replace(/-(\w)/g, function(t, e) {
        return e ? e.toUpperCase() : "";
    });
}
function $f4dac32f84238c46$var$c(t, e, r) {
    if (this._vdom) {
        var i = {};
        i[t] = r = null == r ? void 0 : r, i[$f4dac32f84238c46$var$s(t)] = r, this._vdom = (0, $joJRn.cloneElement)(this._vdom, i), (0, $joJRn.render)(this._vdom, this._root);
    }
}
function $f4dac32f84238c46$var$l() {
    (0, $joJRn.render)(this._vdom = null, this._root);
}
function $f4dac32f84238c46$var$u(e, n) {
    var o = this;
    return (0, $joJRn.h)("slot", $f4dac32f84238c46$var$r({}, e, {
        ref: function(t) {
            t ? (o.ref = t, o._listener || (o._listener = function(t) {
                t.stopPropagation(), t.detail.context = n;
            }, t.addEventListener("_preact", o._listener))) : o.ref.removeEventListener("_preact", o._listener);
        }
    }));
}
function $f4dac32f84238c46$export$2e2bcd8739ae039(t, e, n, o) {
    function r() {
        var e = Reflect.construct(HTMLElement, [], r);
        return e._vdomComponent = t, e._root = o && o.shadow ? e.attachShadow({
            mode: "open"
        }) : e, e;
    }
    return (r.prototype = Object.create(HTMLElement.prototype)).constructor = r, r.prototype.connectedCallback = $f4dac32f84238c46$var$a, r.prototype.attributeChangedCallback = $f4dac32f84238c46$var$c, r.prototype.disconnectedCallback = $f4dac32f84238c46$var$l, n = n || t.observedAttributes || Object.keys(t.propTypes || {}), r.observedAttributes = n, n.forEach(function(t) {
        Object.defineProperty(r.prototype, t, {
            get: function() {
                return this._vdom.props[t];
            },
            set: function(e) {
                this._vdom ? this.attributeChangedCallback(t, null, e) : (this._props || (this._props = {}), this._props[t] = e, this.connectedCallback());
                var n = typeof e;
                null != e && "string" !== n && "boolean" !== n && "number" !== n || this.setAttribute(t, e);
            }
        });
    }), customElements.define(e || t.tagName || t.displayName || t.name, r);
}



var $kFWVC = parcelRequire("kFWVC");

var $kSWSi = parcelRequire("kSWSi");
function $b4808d302a1ac175$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $kSWSi.default)(target, key, source[key]);
        });
    }
    return target;
}


function $069b08775dcf7ea0$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $5wNsA = parcelRequire("5wNsA");
function $ff89d637ac1c9d52$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $5wNsA.default)(descriptor.key), descriptor);
    }
}
function $ff89d637ac1c9d52$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $ff89d637ac1c9d52$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ff89d637ac1c9d52$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



var $kFWVC = parcelRequire("kFWVC");
function $e45699b79d77b344$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $acde5ff36518c6e7$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $kFWVC.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $e45699b79d77b344$export$2e2bcd8739ae039)(self);
}


function $e7da070b6017ece3$export$2e2bcd8739ae039(o) {
    $e7da070b6017ece3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e7da070b6017ece3$export$2e2bcd8739ae039(o);
}




var $fKeFY = parcelRequire("fKeFY");
function $2e0c56979c9e9e03$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $fKeFY.default)(subClass, superClass);
}


var $b1eae3ef79cbf726$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $b1eae3ef79cbf726$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $b1eae3ef79cbf726$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }, this.options));
            }
        }
    ]);
    return Logger;
}();
var $b1eae3ef79cbf726$var$baseLogger = new $b1eae3ef79cbf726$var$Logger();
var $b1eae3ef79cbf726$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $b1eae3ef79cbf726$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $b1eae3ef79cbf726$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $b1eae3ef79cbf726$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $b1eae3ef79cbf726$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $b1eae3ef79cbf726$var$setPath(object, path, newValue) {
    var _getLastOfPath = $b1eae3ef79cbf726$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $b1eae3ef79cbf726$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $b1eae3ef79cbf726$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $b1eae3ef79cbf726$var$getPath(object, path) {
    var _getLastOfPath3 = $b1eae3ef79cbf726$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $b1eae3ef79cbf726$var$getPathWithDefaults(data, defaultData, key) {
    var value = $b1eae3ef79cbf726$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b1eae3ef79cbf726$var$getPath(defaultData, key);
}
function $b1eae3ef79cbf726$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b1eae3ef79cbf726$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $b1eae3ef79cbf726$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $b1eae3ef79cbf726$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $b1eae3ef79cbf726$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $b1eae3ef79cbf726$var$_entityMap[s];
    });
    return data;
}
var $b1eae3ef79cbf726$var$isIE10 = typeof window !== "undefined" && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $b1eae3ef79cbf726$var$ResourceStore = function(_EventEmitter) {
    (0, $2e0c56979c9e9e03$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = (0, $acde5ff36518c6e7$export$2e2bcd8739ae039)(this, (0, $e7da070b6017ece3$export$2e2bcd8739ae039)(ResourceStore).call(this));
        if ($b1eae3ef79cbf726$var$isIE10) $b1eae3ef79cbf726$var$EventEmitter.call((0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        return _this;
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                return $b1eae3ef79cbf726$var$getPath(this.data, path);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $b1eae3ef79cbf726$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $b1eae3ef79cbf726$var$getPath(this.data, path) || {};
                if (deep) $b1eae3ef79cbf726$var$deepExtend(pack, resources, overwrite);
                else pack = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, pack, resources);
                $b1eae3ef79cbf726$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, {}, this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($b1eae3ef79cbf726$var$EventEmitter);
var $b1eae3ef79cbf726$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
var $b1eae3ef79cbf726$var$checkedLoadedFor = {};
var $b1eae3ef79cbf726$var$Translator = function(_EventEmitter) {
    (0, $2e0c56979c9e9e03$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, Translator);
        _this = (0, $acde5ff36518c6e7$export$2e2bcd8739ae039)(this, (0, $e7da070b6017ece3$export$2e2bcd8739ae039)(Translator).call(this));
        if ($b1eae3ef79cbf726$var$isIE10) $b1eae3ef79cbf726$var$EventEmitter.call((0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
        $b1eae3ef79cbf726$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $b1eae3ef79cbf726$var$baseLogger.create("translator");
        return _this;
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS;
                if (nsSeparator && key.indexOf(nsSeparator) > -1) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $kFWVC.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        return namespace + nsSeparator + key;
                    }
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, options, {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, options, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, fallbackValue) {
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init((0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, options, {
                        interpolation: (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, this.options.interpolation, options.interpolation)
                    }));
                    var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, this.options.interpolation.defaultVariables, data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $b1eae3ef79cbf726$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsContextHandling = options.context !== undefined && typeof options.context === "string" && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$b1eae3ef79cbf726$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $b1eae3ef79cbf726$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKey = key;
                            var finalKeys = [
                                finalKey
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
                                if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
                                if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
                                if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($b1eae3ef79cbf726$var$EventEmitter);
function $b1eae3ef79cbf726$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $b1eae3ef79cbf726$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.whitelist = this.options.supportedLngs || false;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b1eae3ef79cbf726$var$baseLogger.create("languageUtils");
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b1eae3ef79cbf726$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b1eae3ef79cbf726$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $b1eae3ef79cbf726$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isWhitelisted",
            value: function isWhitelisted(code) {
                this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
                return this.isSupportedCode(code);
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $b1eae3ef79cbf726$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $b1eae3ef79cbf726$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
function $b1eae3ef79cbf726$var$createRules() {
    var rules = {};
    $b1eae3ef79cbf726$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $b1eae3ef79cbf726$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $b1eae3ef79cbf726$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $b1eae3ef79cbf726$var$baseLogger.create("pluralResolver");
        this.rules = $b1eae3ef79cbf726$var$createRules();
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var rule = this.getRule(code);
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                return this.getSuffixes(code).map(function(suffix) {
                    return key + suffix;
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var rule = this.getRule(code);
                if (!rule) return [];
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var _this2 = this;
                var rule = this.getRule(code);
                if (rule) {
                    var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                    var suffix = rule.numbers[idx];
                    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                        if (suffix === 2) suffix = "plural";
                        else if (suffix === 1) suffix = "";
                    }
                    var returnSuffix = function returnSuffix() {
                        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                    };
                    if (this.options.compatibilityJSON === "v1") {
                        if (suffix === 1) return "";
                        if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                        return returnSuffix();
                    } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                    else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        }
    ]);
    return PluralResolver;
}();
var $b1eae3ef79cbf726$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $b1eae3ef79cbf726$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $b1eae3ef79cbf726$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $b1eae3ef79cbf726$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $b1eae3ef79cbf726$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $b1eae3ef79cbf726$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $b1eae3ef79cbf726$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $b1eae3ef79cbf726$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $b1eae3ef79cbf726$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $b1eae3ef79cbf726$var$getPathWithDefaults(data, defaultData, key);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($b1eae3ef79cbf726$var$getPathWithDefaults(data, defaultData, k), f, lng, options);
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        value = handleFormat(match[1].trim());
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $b1eae3ef79cbf726$var$makeString(value);
                        str = str.replace(match[0], todo.safeValue(value));
                        todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, options);
                clonedOptions.applyPostProcessor = false;
                delete clonedOptions.defaultValue;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, inheritedOptions, clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    var doReduce = false;
                    if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $b1eae3ef79cbf726$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, options);
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $b1eae3ef79cbf726$var$remove(arr, what) {
    var found = arr.indexOf(what);
    while(found !== -1){
        arr.splice(found, 1);
        found = arr.indexOf(what);
    }
}
var $b1eae3ef79cbf726$var$Connector = function(_EventEmitter) {
    (0, $2e0c56979c9e9e03$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, Connector);
        _this = (0, $acde5ff36518c6e7$export$2e2bcd8739ae039)(this, (0, $e7da070b6017ece3$export$2e2bcd8739ae039)(Connector).call(this));
        if ($b1eae3ef79cbf726$var$isIE10) $b1eae3ef79cbf726$var$EventEmitter.call((0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $b1eae3ef79cbf726$var$baseLogger.create("backendConnector");
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = [];
                var pending = [];
                var toLoadLanguages = [];
                var toLoadNamespaces = [];
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending.indexOf(name) < 0) pending.push(name);
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending.indexOf(name) < 0) pending.push(name);
                            if (toLoad.indexOf(name) < 0) toLoad.push(name);
                            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages.push(lng);
                });
                if (toLoad.length || pending.length) this.queue.push({
                    pending: pending,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: toLoad,
                    pending: pending,
                    toLoadLanguages: toLoadLanguages,
                    toLoadNamespaces: toLoadNamespaces
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $b1eae3ef79cbf726$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $b1eae3ef79cbf726$var$remove(q.pending, name);
                    if (err) q.errors.push(err);
                    if (q.pending.length === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = [];
                            if (q.loaded[l].length) q.loaded[l].forEach(function(ns) {
                                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                return this.backend[fcName](lng, ns, function(err, data) {
                    if (err && data && tried < 5) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                });
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue, null, (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, options, {
                    isUpdate: isUpdate
                }));
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($b1eae3ef79cbf726$var$EventEmitter);
function $b1eae3ef79cbf726$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        whitelist: false,
        nonExplicitWhitelist: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $kFWVC.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $kFWVC.default)(args[2]) === "object" || (0, $kFWVC.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: false
        }
    };
}
function $b1eae3ef79cbf726$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.whitelist) {
        if (options.whitelist && options.whitelist.indexOf("cimode") < 0) options.whitelist = options.whitelist.concat([
            "cimode"
        ]);
        options.supportedLngs = options.whitelist;
    }
    if (options.nonExplicitWhitelist) options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $b1eae3ef79cbf726$var$noop() {}
var $b1eae3ef79cbf726$var$I18n = function(_EventEmitter) {
    (0, $2e0c56979c9e9e03$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $069b08775dcf7ea0$export$2e2bcd8739ae039)(this, I18n);
        _this = (0, $acde5ff36518c6e7$export$2e2bcd8739ae039)(this, (0, $e7da070b6017ece3$export$2e2bcd8739ae039)(I18n).call(this));
        if ($b1eae3ef79cbf726$var$isIE10) $b1eae3ef79cbf726$var$EventEmitter.call((0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
        _this.options = $b1eae3ef79cbf726$var$transformOptions(options);
        _this.services = {};
        _this.logger = $b1eae3ef79cbf726$var$baseLogger;
        _this.modules = {
            external: []
        };
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $acde5ff36518c6e7$export$2e2bcd8739ae039)(_this, (0, $e45699b79d77b344$export$2e2bcd8739ae039)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $ff89d637ac1c9d52$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (options.whitelist && !options.supportedLngs) this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
                if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
                this.options = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, $b1eae3ef79cbf726$var$get(), this.options, $b1eae3ef79cbf726$var$transformOptions(options));
                this.format = this.options.interpolation.format;
                if (!callback) callback = $b1eae3ef79cbf726$var$noop;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $b1eae3ef79cbf726$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $b1eae3ef79cbf726$var$baseLogger.init(null, this.options);
                    var lu = new $b1eae3ef79cbf726$var$LanguageUtil(this.options);
                    this.store = new $b1eae3ef79cbf726$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $b1eae3ef79cbf726$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $b1eae3ef79cbf726$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    s.interpolator = new $b1eae3ef79cbf726$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $b1eae3ef79cbf726$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $b1eae3ef79cbf726$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $b1eae3ef79cbf726$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b1eae3ef79cbf726$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $b1eae3ef79cbf726$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $b1eae3ef79cbf726$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $b1eae3ef79cbf726$var$postProcessor.addPostProcessor(module);
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $b1eae3ef79cbf726$var$defer();
                this.emit("languageChanging", lng);
                var done = function done(err, l) {
                    if (l) {
                        _this4.language = l;
                        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) {
                            _this4.language = l;
                            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                        }
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) this.services.languageDetector.detect(setLng);
                else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $kFWVC.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    return _this5.t(key, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $b1eae3ef79cbf726$var$defer();
                if (!this.options.ns) {
                    callback && callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $b1eae3ef79cbf726$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam"
                ];
                return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? "rtl" : "ltr";
            }
        },
        {
            key: "createInstance",
            value: function createInstance() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                return new I18n(options, callback);
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b1eae3ef79cbf726$var$noop;
                var mergedOptions = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, this.options, options, {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = (0, $b4808d302a1ac175$export$2e2bcd8739ae039)({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $b1eae3ef79cbf726$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        }
    ]);
    return I18n;
}($b1eae3ef79cbf726$var$EventEmitter);
var $b1eae3ef79cbf726$var$i18next = new $b1eae3ef79cbf726$var$I18n();
var $b1eae3ef79cbf726$export$2e2bcd8739ae039 = $b1eae3ef79cbf726$var$i18next;



const $a3b079dcfa1b9c39$var$API_URL_DOC_EN = "https://veta.ingka.com/serviceconnector/swagger/../services/rest/documents";
const $a3b079dcfa1b9c39$var$API_URL_DOC_EN_INT = "https://veta-int.kcenter.usu.com/serviceconnector/swagger/../services/rest/documents";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_ES = "&cb=1_88&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_HU = "&cb=1_899&lang=hu&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_PT = "&cb=1_246&lang=pt&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_PT = "&cb=1_246&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_CZ = "&cb=1_951&lang=cs&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_SK = "&cb=1_847&lang=sk&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_NO = "&cb=1_1003&lang=no&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_NO = "&cb=1_1003&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_GB = "&cb=1_390&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_AU = "&cb=1_2127&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_IE = "&cb=1_766&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_IT = "&cb=1_342&lang=it&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
// Note Lang should be sv but due to USU bug it's se
const $a3b079dcfa1b9c39$var$API_LOCALE_SE = "&cb=1_628&lang=sv&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_SE = "&cb=1_628&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_AT = "&cb=1_1559&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_AT = "&cb=1_1559&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_BE = "&cb=1_571&lang=nl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_FR_BE = "&cb=1_571&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_BE = "&cb=1_571&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_DK = "&cb=1_294&lang=da&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_PL = "&cb=1_517&lang=pl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_DE = "&cb=1_1423&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_DE = "&cb=1_1423&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_FI = "&cb=1_1055&lang=fi&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_FI = "&cb=1_1055&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_FR = "&cb=1_1107&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_FR_CA = "&cb=1_147&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_CA = "&cb=1_147&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_RS = "&cb=1_1180&lang=sr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_SI = "&cb=1_1475&lang=sl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_UA = "&cb=1_1333&lang=uk&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_HR = "&cb=1_1282&lang=hr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_RO = "&cb=1_1231&lang=ro&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_DE_CH = "&cb=1_716&lang=de&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_FR_CH = "&cb=1_716&lang=fr&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_US = "&cb=1_1654&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_ES_US = "&cb=1_1654&lang=es&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_CH = "&cb=1_716&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_IT_CH = "&cb=1_716&lang=it&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_URL_SEARCH = "https://veta.ingka.com/serviceconnector/swagger/../services/rest/content/search";
const $a3b079dcfa1b9c39$var$API_URL_SEARCH_INT = "https://veta-int.kcenter.usu.com/serviceconnector/swagger/../services/rest/content/search";
const $a3b079dcfa1b9c39$var$API_URL_CATS_EN = "https://veta.ingka.com/serviceconnector/swagger/../services/rest/content/categories?";
const $a3b079dcfa1b9c39$var$API_URL_DOC = "https://veta.ingka.com/serviceconnector/swagger/../services/rest/documents";
const $a3b079dcfa1b9c39$var$API_LOCALE_ES = "&cb=1_88&lang=es&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EU_ES = "&cb=1_88&lang=eu&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_GL_ES = "&cb=1_88&lang=gl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_CA_ES = "&cb=1_88&lang=ca&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_NL = "&cb=1_438&lang=nl&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_NL = "&cb=1_438&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_RU = "&cb=1_1867&lang=ru&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_KR = "&cb=1_2016&lang=ko&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_KR = "&cb=1_2016&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_JP = "&cb=1_1810&lang=ja&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_JP = "&cb=1_1810&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_IN = "&cb=1_1941&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
const $a3b079dcfa1b9c39$var$API_LOCALE_EN_NZ = "&cb=1_3198&lang=en&docType=2g3f206g-b01f-4ggc-8dd5-d22e55gfe1f8";
(0, $b1eae3ef79cbf726$export$2e2bcd8739ae039).use((0, $6f8629dd51647a0e$export$ae7e14d40d89f296)).init({
    fallbackLng: "en-ES",
    interpolation: {
        escapeValue: false
    },
    detection: {
        order: [
            "htmlTag",
            "navigator",
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "path",
            "subdomain"
        ]
    },
    resources: {
        "en-ES": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-cats": $a3b079dcfa1b9c39$var$API_URL_CATS_EN,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_ES
            }
        },
        "it-IT": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_IT
            }
        },
        "en-GB": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_GB
            }
        },
        "en-IE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_IE
            }
        },
        "cs-CZ": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_CZ
            }
        },
        "sk-SK": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_SK
            }
        },
        "es-ES": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_ES
            }
        },
        "eu-ES": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-cats": $a3b079dcfa1b9c39$var$API_URL_CATS_EN,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EU_ES
            }
        },
        "ca-ES": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-cats": $a3b079dcfa1b9c39$var$API_URL_CATS_EN,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_CA_ES
            }
        },
        "gl-ES": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-cats": $a3b079dcfa1b9c39$var$API_URL_CATS_EN,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_GL_ES
            }
        },
        "nl-NL": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_NL
            }
        },
        "en-NL": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_NL
            }
        },
        "fr-FR": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_FR
            }
        },
        "fr-CH": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_FR_CH
            }
        },
        "en-CH": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_CH
            }
        },
        "it-CH": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_IT_CH
            }
        },
        "de-CH": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_DE_CH
            }
        },
        "sr-RS": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_RS
            }
        },
        "hr-HR": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_HR
            }
        },
        "sl-SI": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_SI
            }
        },
        "ro-RO": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_RO
            }
        },
        "uk-UA": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_UA
            }
        },
        "de-DE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_DE
            }
        },
        "en-DE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_DE
            }
        },
        "en-CA": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_CA
            }
        },
        "fr-CA": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_FR_CA
            }
        },
        "fi-FI": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_FI
            }
        },
        "en-FI": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_FI
            }
        },
        "da-DK": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_DK
            }
        },
        "pl-PL": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_PL
            }
        },
        "de-AT": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_AT
            }
        },
        "en-AT": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-cats": $a3b079dcfa1b9c39$var$API_URL_CATS_EN,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_AT
            }
        },
        "fr-BE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_FR_BE
            }
        },
        "nl-BE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_BE
            }
        },
        "en-BE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_BE
            }
        },
        "no-NO": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_NO
            }
        },
        "en-NO": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_NO
            }
        },
        "sv-SE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_SE
            }
        },
        "en-SE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_SE
            }
        },
        "hu-HU": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_HU
            }
        },
        "pt-PT": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_PT
            }
        },
        "en-PT": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_PT
            }
        },
        "en-US": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_US
            }
        },
        "es-US": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_ES_US
            }
        },
        "ru-RU": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_RU
            }
        },
        "en-R1": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH_INT,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC_EN_INT,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_NL
            }
        },
        "en-KR": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_KR
            }
        },
        "ko-KR": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_KR
            }
        },
        "ja-JP": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_JP
            }
        },
        "en-JP": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_JP
            }
        },
        "en-IN": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_IN
            }
        },
        "en-AU": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_AU
            }
        },
        "rv-RE": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_AU,
                searching: "Searching...",
                search: "Find answers to your question here",
                loading: "Loading",
                "no-results": "We did not find any matches for results for search term: {{query}}",
                "try-again": "Please try again later",
                results: "We found {{number}} results for: {{query}}",
                error: "Something went wrong",
                "spell-check": "Try checking the spelling or using different keywords.",
                close: "Close",
                showMore: "Show more",
                showLess: "Show less",
                retrieving: "Retrieving",
                "feedback-first": "Did you find this useful?",
                "feedback-second": "Thank you for your feedback!",
                "not-available": "	Service is currently not available, please try again later."
            }
        },
        "en-NZ": {
            translation: {
                "url-search": $a3b079dcfa1b9c39$var$API_URL_SEARCH,
                "url-doc": $a3b079dcfa1b9c39$var$API_URL_DOC,
                locale: $a3b079dcfa1b9c39$var$API_LOCALE_EN_NZ
            }
        }
    }
});
var $a3b079dcfa1b9c39$export$2e2bcd8739ae039 = (0, $b1eae3ef79cbf726$export$2e2bcd8739ae039);


var $b07a6dc308f86926$exports = {};
(function(global, factory) {
    factory();
})($b07a6dc308f86926$exports, function() {
    "use strict";
    /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */ function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;
        var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            "datetime-local": true
        };
        /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */ function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) return true;
            return false;
        }
        /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */ function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) return true;
            if (tagName === "TEXTAREA" && !el.readOnly) return true;
            if (el.isContentEditable) return true;
            return false;
        }
        /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */ function addFocusVisibleClass(el) {
            if (el.classList.contains("focus-visible")) return;
            el.classList.add("focus-visible");
            el.setAttribute("data-focus-visible-added", "");
        }
        /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */ function removeFocusVisibleClass(el) {
            if (!el.hasAttribute("data-focus-visible-added")) return;
            el.classList.remove("focus-visible");
            el.removeAttribute("data-focus-visible-added");
        }
        /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */ function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) return;
            if (isValidFocusTarget(scope.activeElement)) addFocusVisibleClass(scope.activeElement);
            hadKeyboardEvent = true;
        }
        /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */ function onPointerDown(e) {
            hadKeyboardEvent = false;
        }
        /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */ function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) return;
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) addFocusVisibleClass(e.target);
        }
        /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */ function onBlur(e) {
            if (!isValidFocusTarget(e.target)) return;
            if (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                }, 100);
                removeFocusVisibleClass(e.target);
            }
        }
        /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */ function onVisibilityChange(e) {
            if (document.visibilityState === "hidden") {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) hadKeyboardEvent = true;
                addInitialPointerMoveListeners();
            }
        }
        /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */ function addInitialPointerMoveListeners() {
            document.addEventListener("mousemove", onInitialPointerMove);
            document.addEventListener("mousedown", onInitialPointerMove);
            document.addEventListener("mouseup", onInitialPointerMove);
            document.addEventListener("pointermove", onInitialPointerMove);
            document.addEventListener("pointerdown", onInitialPointerMove);
            document.addEventListener("pointerup", onInitialPointerMove);
            document.addEventListener("touchmove", onInitialPointerMove);
            document.addEventListener("touchstart", onInitialPointerMove);
            document.addEventListener("touchend", onInitialPointerMove);
        }
        function removeInitialPointerMoveListeners() {
            document.removeEventListener("mousemove", onInitialPointerMove);
            document.removeEventListener("mousedown", onInitialPointerMove);
            document.removeEventListener("mouseup", onInitialPointerMove);
            document.removeEventListener("pointermove", onInitialPointerMove);
            document.removeEventListener("pointerdown", onInitialPointerMove);
            document.removeEventListener("pointerup", onInitialPointerMove);
            document.removeEventListener("touchmove", onInitialPointerMove);
            document.removeEventListener("touchstart", onInitialPointerMove);
            document.removeEventListener("touchend", onInitialPointerMove);
        }
        /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */ function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === "html") return;
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }
        // For some kinds of state, we are interested in changes at the global scope
        // only. For example, global pointer input, global key presses and global
        // visibility change should affect the state at every scope:
        document.addEventListener("keydown", onKeyDown, true);
        document.addEventListener("mousedown", onPointerDown, true);
        document.addEventListener("pointerdown", onPointerDown, true);
        document.addEventListener("touchstart", onPointerDown, true);
        document.addEventListener("visibilitychange", onVisibilityChange, true);
        addInitialPointerMoveListeners();
        // For focus and blur, we specifically care about state changes in the local
        // scope. This is because focus / blur events that originate from within a
        // shadow root are not re-dispatched from the host element if it was already
        // the active element in its own scope:
        scope.addEventListener("focus", onFocus, true);
        scope.addEventListener("blur", onBlur, true);
        // We detect that a node is a ShadowRoot by ensuring that it is a
        // DocumentFragment and also has a host property. This check covers native
        // implementation and polyfill implementation transparently. If we only cared
        // about the native implementation, we could just check if the scope was
        // an instance of a ShadowRoot.
        if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute("data-js-focus-visible", "");
        else if (scope.nodeType === Node.DOCUMENT_NODE) {
            document.documentElement.classList.add("js-focus-visible");
            document.documentElement.setAttribute("data-js-focus-visible", "");
        }
    }
    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        // Make the polyfill helper globally available. This can be used as a signal
        // to interested libraries that wish to coordinate with the polyfill for e.g.,
        // applying the polyfill to a shadow root:
        window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
        // Notify interested libraries of the polyfill's presence, in case the
        // polyfill was loaded lazily:
        var event;
        try {
            event = new CustomEvent("focus-visible-polyfill-ready");
        } catch (error) {
            // IE11 does not support using CustomEvent as a constructor directly:
            event = document.createEvent("CustomEvent");
            event.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
        }
        window.dispatchEvent(event);
    }
    if (typeof document !== "undefined") // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
});



const $e8ebdeb1a1bfb966$var$App = ({ lang: lang })=>{
    lang = (0, $64e54fc71e534777$export$64419dba853ac5)(lang);
    return /*#__PURE__*/ (0, $25a9db989c2486a1$export$34b9dba7ce09269b)((0, $031dc0e3b16446aa$export$2e2bcd8739ae039), {
        lang: lang,
        variant: "standard"
    });
//Keep below code for future A/B-tests
//
// let rand = Math.floor(Math.random() * 101);
// if(rand >= 50){
//   //@ts-ignore
//   return <KnowledgeComponent lang={lang} variant="standard"/>;
// }else{
//   return <KnowledgeComponent lang={lang} variant="standard"/>;
// } 
};
(0, $f4dac32f84238c46$export$2e2bcd8739ae039)($e8ebdeb1a1bfb966$var$App, "km-search-integration", [
    "lang"
], {
    shadow: false
});

})();
//# sourceMappingURL=searchBundle.js.map
